/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** GraphQL Scalar representing the Prisma.Decimal type, based on Decimal.js library. */
  Decimal: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export enum AcceptedCurrency {
  Aud = 'AUD',
  Cad = 'CAD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Nzd = 'NZD',
  Usd = 'USD'
}

export type ArticleCategoryArticleCategoryCompoundUniqueInput = {
  articleId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
};

export type ArticleCategoryAvgOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type ArticleCategoryCountOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ArticleCategoryCreateInput = {
  article: ArticleCreateNestedOneWithoutArticleCategoriesInput;
  category: CategoryCreateNestedOneWithoutCategoryArticlesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleCategoryCreateManyArticleInput = {
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleCategoryCreateManyArticleInputEnvelope = {
  data: Array<ArticleCategoryCreateManyArticleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleCategoryCreateManyCategoryInput = {
  articleId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleCategoryCreateManyCategoryInputEnvelope = {
  data: Array<ArticleCategoryCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleCategoryCreateManyInput = {
  articleId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleCategoryCreateNestedManyWithoutArticleInput = {
  connect?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleCategoryCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleCategoryCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleCategoryCreateManyArticleInputEnvelope>;
};

export type ArticleCategoryCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleCategoryCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<ArticleCategoryCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<ArticleCategoryCreateManyCategoryInputEnvelope>;
};

export type ArticleCategoryCreateOrConnectWithoutArticleInput = {
  create: ArticleCategoryCreateWithoutArticleInput;
  where: ArticleCategoryWhereUniqueInput;
};

export type ArticleCategoryCreateOrConnectWithoutCategoryInput = {
  create: ArticleCategoryCreateWithoutCategoryInput;
  where: ArticleCategoryWhereUniqueInput;
};

export type ArticleCategoryCreateWithoutArticleInput = {
  category: CategoryCreateNestedOneWithoutCategoryArticlesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleCategoryCreateWithoutCategoryInput = {
  article: ArticleCreateNestedOneWithoutArticleCategoriesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleCategoryListRelationFilter = {
  every?: InputMaybe<ArticleCategoryWhereInput>;
  none?: InputMaybe<ArticleCategoryWhereInput>;
  some?: InputMaybe<ArticleCategoryWhereInput>;
};

export type ArticleCategoryMaxOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ArticleCategoryMinOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ArticleCategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ArticleCategoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<ArticleCategoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<ArticleCategoryCountOrderByAggregateInput>;
  _max?: InputMaybe<ArticleCategoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<ArticleCategoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<ArticleCategorySumOrderByAggregateInput>;
  articleId?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ArticleCategoryOrderByWithRelationInput = {
  article?: InputMaybe<ArticleOrderByWithRelationInput>;
  articleId?: InputMaybe<SortOrder>;
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum ArticleCategoryScalarFieldEnum {
  ArticleId = 'articleId',
  CategoryId = 'categoryId',
  Created = 'created',
  Id = 'id',
  IsPinned = 'isPinned',
  IsRequired = 'isRequired',
  Modified = 'modified',
  SortOrder = 'sortOrder'
}

export type ArticleCategoryScalarWhereInput = {
  AND?: InputMaybe<Array<ArticleCategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<ArticleCategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<ArticleCategoryScalarWhereInput>>;
  articleId?: InputMaybe<StringFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type ArticleCategoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ArticleCategoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ArticleCategoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ArticleCategoryScalarWhereWithAggregatesInput>>;
  articleId?: InputMaybe<StringWithAggregatesFilter>;
  categoryId?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isPinned?: InputMaybe<BoolWithAggregatesFilter>;
  isRequired?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  sortOrder?: InputMaybe<IntWithAggregatesFilter>;
};

export type ArticleCategorySumOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type ArticleCategoryUpdateInput = {
  article?: InputMaybe<ArticleUpdateOneRequiredWithoutArticleCategoriesNestedInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutCategoryArticlesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ArticleCategoryUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ArticleCategoryUpdateManyWithWhereWithoutArticleInput = {
  data: ArticleCategoryUpdateManyMutationInput;
  where: ArticleCategoryScalarWhereInput;
};

export type ArticleCategoryUpdateManyWithWhereWithoutCategoryInput = {
  data: ArticleCategoryUpdateManyMutationInput;
  where: ArticleCategoryScalarWhereInput;
};

export type ArticleCategoryUpdateManyWithoutArticleNestedInput = {
  connect?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleCategoryCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleCategoryCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleCategoryCreateManyArticleInputEnvelope>;
  delete?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ArticleCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<ArticleCategoryUpdateWithWhereUniqueWithoutArticleInput>>;
  updateMany?: InputMaybe<Array<ArticleCategoryUpdateManyWithWhereWithoutArticleInput>>;
  upsert?: InputMaybe<Array<ArticleCategoryUpsertWithWhereUniqueWithoutArticleInput>>;
};

export type ArticleCategoryUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleCategoryCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<ArticleCategoryCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<ArticleCategoryCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ArticleCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<ArticleCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<ArticleCategoryUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<ArticleCategoryUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<ArticleCategoryUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type ArticleCategoryUpdateWithWhereUniqueWithoutArticleInput = {
  data: ArticleCategoryUpdateWithoutArticleInput;
  where: ArticleCategoryWhereUniqueInput;
};

export type ArticleCategoryUpdateWithWhereUniqueWithoutCategoryInput = {
  data: ArticleCategoryUpdateWithoutCategoryInput;
  where: ArticleCategoryWhereUniqueInput;
};

export type ArticleCategoryUpdateWithoutArticleInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutCategoryArticlesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ArticleCategoryUpdateWithoutCategoryInput = {
  article?: InputMaybe<ArticleUpdateOneRequiredWithoutArticleCategoriesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ArticleCategoryUpsertWithWhereUniqueWithoutArticleInput = {
  create: ArticleCategoryCreateWithoutArticleInput;
  update: ArticleCategoryUpdateWithoutArticleInput;
  where: ArticleCategoryWhereUniqueInput;
};

export type ArticleCategoryUpsertWithWhereUniqueWithoutCategoryInput = {
  create: ArticleCategoryCreateWithoutCategoryInput;
  update: ArticleCategoryUpdateWithoutCategoryInput;
  where: ArticleCategoryWhereUniqueInput;
};

export type ArticleCategoryWhereInput = {
  AND?: InputMaybe<Array<ArticleCategoryWhereInput>>;
  NOT?: InputMaybe<Array<ArticleCategoryWhereInput>>;
  OR?: InputMaybe<Array<ArticleCategoryWhereInput>>;
  article?: InputMaybe<ArticleScalarRelationFilter>;
  articleId?: InputMaybe<StringFilter>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type ArticleCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<ArticleCategoryWhereInput>>;
  NOT?: InputMaybe<Array<ArticleCategoryWhereInput>>;
  OR?: InputMaybe<Array<ArticleCategoryWhereInput>>;
  article?: InputMaybe<ArticleScalarRelationFilter>;
  articleCategory?: InputMaybe<ArticleCategoryArticleCategoryCompoundUniqueInput>;
  articleId?: InputMaybe<StringFilter>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type ArticleCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceTypeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ArticleCreateInput = {
  articleCategories?: InputMaybe<ArticleCategoryCreateNestedManyWithoutArticleInput>;
  articleTags?: InputMaybe<ArticleTagCreateNestedManyWithoutArticleInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutArticleInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  readBy?: InputMaybe<UserArticleCreateNestedManyWithoutArticleInput>;
  resourceType?: InputMaybe<ResourceTypeCreateNestedOneWithoutArticlesInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutArticleInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ArticleCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resourceTypeId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ArticleCreateManyResourceTypeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ArticleCreateManyResourceTypeInputEnvelope = {
  data: Array<ArticleCreateManyResourceTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleCreateNestedManyWithoutResourceTypeInput = {
  connect?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleCreateOrConnectWithoutResourceTypeInput>>;
  create?: InputMaybe<Array<ArticleCreateWithoutResourceTypeInput>>;
  createMany?: InputMaybe<ArticleCreateManyResourceTypeInputEnvelope>;
};

export type ArticleCreateNestedOneWithoutArticleCategoriesInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutArticleCategoriesInput>;
  create?: InputMaybe<ArticleCreateWithoutArticleCategoriesInput>;
};

export type ArticleCreateNestedOneWithoutArticleTagsInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutArticleTagsInput>;
  create?: InputMaybe<ArticleCreateWithoutArticleTagsInput>;
};

export type ArticleCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<ArticleCreateWithoutContentInput>;
};

export type ArticleCreateNestedOneWithoutReadByInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutReadByInput>;
  create?: InputMaybe<ArticleCreateWithoutReadByInput>;
};

export type ArticleCreateNestedOneWithoutSavedForLaterInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutSavedForLaterInput>;
  create?: InputMaybe<ArticleCreateWithoutSavedForLaterInput>;
};

export type ArticleCreateOrConnectWithoutArticleCategoriesInput = {
  create: ArticleCreateWithoutArticleCategoriesInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleCreateOrConnectWithoutArticleTagsInput = {
  create: ArticleCreateWithoutArticleTagsInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleCreateOrConnectWithoutContentInput = {
  create: ArticleCreateWithoutContentInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleCreateOrConnectWithoutReadByInput = {
  create: ArticleCreateWithoutReadByInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleCreateOrConnectWithoutResourceTypeInput = {
  create: ArticleCreateWithoutResourceTypeInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleCreateOrConnectWithoutSavedForLaterInput = {
  create: ArticleCreateWithoutSavedForLaterInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleCreateWithoutArticleCategoriesInput = {
  articleTags?: InputMaybe<ArticleTagCreateNestedManyWithoutArticleInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutArticleInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  readBy?: InputMaybe<UserArticleCreateNestedManyWithoutArticleInput>;
  resourceType?: InputMaybe<ResourceTypeCreateNestedOneWithoutArticlesInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutArticleInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ArticleCreateWithoutArticleTagsInput = {
  articleCategories?: InputMaybe<ArticleCategoryCreateNestedManyWithoutArticleInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutArticleInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  readBy?: InputMaybe<UserArticleCreateNestedManyWithoutArticleInput>;
  resourceType?: InputMaybe<ResourceTypeCreateNestedOneWithoutArticlesInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutArticleInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ArticleCreateWithoutContentInput = {
  articleCategories?: InputMaybe<ArticleCategoryCreateNestedManyWithoutArticleInput>;
  articleTags?: InputMaybe<ArticleTagCreateNestedManyWithoutArticleInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  readBy?: InputMaybe<UserArticleCreateNestedManyWithoutArticleInput>;
  resourceType?: InputMaybe<ResourceTypeCreateNestedOneWithoutArticlesInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutArticleInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ArticleCreateWithoutReadByInput = {
  articleCategories?: InputMaybe<ArticleCategoryCreateNestedManyWithoutArticleInput>;
  articleTags?: InputMaybe<ArticleTagCreateNestedManyWithoutArticleInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutArticleInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resourceType?: InputMaybe<ResourceTypeCreateNestedOneWithoutArticlesInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutArticleInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ArticleCreateWithoutResourceTypeInput = {
  articleCategories?: InputMaybe<ArticleCategoryCreateNestedManyWithoutArticleInput>;
  articleTags?: InputMaybe<ArticleTagCreateNestedManyWithoutArticleInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutArticleInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  readBy?: InputMaybe<UserArticleCreateNestedManyWithoutArticleInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutArticleInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ArticleCreateWithoutSavedForLaterInput = {
  articleCategories?: InputMaybe<ArticleCategoryCreateNestedManyWithoutArticleInput>;
  articleTags?: InputMaybe<ArticleTagCreateNestedManyWithoutArticleInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutArticleInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  readBy?: InputMaybe<UserArticleCreateNestedManyWithoutArticleInput>;
  resourceType?: InputMaybe<ResourceTypeCreateNestedOneWithoutArticlesInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ArticleListRelationFilter = {
  every?: InputMaybe<ArticleWhereInput>;
  none?: InputMaybe<ArticleWhereInput>;
  some?: InputMaybe<ArticleWhereInput>;
};

export type ArticleMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceTypeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ArticleMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceTypeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ArticleNullableScalarRelationFilter = {
  is?: InputMaybe<ArticleWhereInput>;
  isNot?: InputMaybe<ArticleWhereInput>;
};

export type ArticleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ArticleOrderByWithAggregationInput = {
  _count?: InputMaybe<ArticleCountOrderByAggregateInput>;
  _max?: InputMaybe<ArticleMaxOrderByAggregateInput>;
  _min?: InputMaybe<ArticleMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceTypeId?: InputMaybe<SortOrderInput>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ArticleOrderByWithRelationInput = {
  articleCategories?: InputMaybe<ArticleCategoryOrderByRelationAggregateInput>;
  articleTags?: InputMaybe<ArticleTagOrderByRelationAggregateInput>;
  content?: InputMaybe<ContentOrderByWithRelationInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  readBy?: InputMaybe<UserArticleOrderByRelationAggregateInput>;
  resourceType?: InputMaybe<ResourceTypeOrderByWithRelationInput>;
  resourceTypeId?: InputMaybe<SortOrderInput>;
  savedForLater?: InputMaybe<SavedForLaterOrderByRelationAggregateInput>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export enum ArticleScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  IsPublished = 'isPublished',
  Modified = 'modified',
  ResourceTypeId = 'resourceTypeId',
  Slug = 'slug',
  Title = 'title'
}

export type ArticleScalarRelationFilter = {
  is?: InputMaybe<ArticleWhereInput>;
  isNot?: InputMaybe<ArticleWhereInput>;
};

export type ArticleScalarWhereInput = {
  AND?: InputMaybe<Array<ArticleScalarWhereInput>>;
  NOT?: InputMaybe<Array<ArticleScalarWhereInput>>;
  OR?: InputMaybe<Array<ArticleScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  resourceTypeId?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type ArticleScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ArticleScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ArticleScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ArticleScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isPublished?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  resourceTypeId?: InputMaybe<StringNullableWithAggregatesFilter>;
  slug?: InputMaybe<StringWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type ArticleTagArticleTagCompoundUniqueInput = {
  articleId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type ArticleTagCountOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
};

export type ArticleTagCreateInput = {
  article: ArticleCreateNestedOneWithoutArticleTagsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  tag: TagCreateNestedOneWithoutArticleTagsInput;
};

export type ArticleTagCreateManyArticleInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  tagId: Scalars['String']['input'];
};

export type ArticleTagCreateManyArticleInputEnvelope = {
  data: Array<ArticleTagCreateManyArticleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleTagCreateManyInput = {
  articleId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  tagId: Scalars['String']['input'];
};

export type ArticleTagCreateManyTagInput = {
  articleId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleTagCreateManyTagInputEnvelope = {
  data: Array<ArticleTagCreateManyTagInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleTagCreateNestedManyWithoutArticleInput = {
  connect?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleTagCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleTagCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleTagCreateManyArticleInputEnvelope>;
};

export type ArticleTagCreateNestedManyWithoutTagInput = {
  connect?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleTagCreateOrConnectWithoutTagInput>>;
  create?: InputMaybe<Array<ArticleTagCreateWithoutTagInput>>;
  createMany?: InputMaybe<ArticleTagCreateManyTagInputEnvelope>;
};

export type ArticleTagCreateOrConnectWithoutArticleInput = {
  create: ArticleTagCreateWithoutArticleInput;
  where: ArticleTagWhereUniqueInput;
};

export type ArticleTagCreateOrConnectWithoutTagInput = {
  create: ArticleTagCreateWithoutTagInput;
  where: ArticleTagWhereUniqueInput;
};

export type ArticleTagCreateWithoutArticleInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  tag: TagCreateNestedOneWithoutArticleTagsInput;
};

export type ArticleTagCreateWithoutTagInput = {
  article: ArticleCreateNestedOneWithoutArticleTagsInput;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleTagListRelationFilter = {
  every?: InputMaybe<ArticleTagWhereInput>;
  none?: InputMaybe<ArticleTagWhereInput>;
  some?: InputMaybe<ArticleTagWhereInput>;
};

export type ArticleTagMaxOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
};

export type ArticleTagMinOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
};

export type ArticleTagOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ArticleTagOrderByWithAggregationInput = {
  _count?: InputMaybe<ArticleTagCountOrderByAggregateInput>;
  _max?: InputMaybe<ArticleTagMaxOrderByAggregateInput>;
  _min?: InputMaybe<ArticleTagMinOrderByAggregateInput>;
  articleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
};

export type ArticleTagOrderByWithRelationInput = {
  article?: InputMaybe<ArticleOrderByWithRelationInput>;
  articleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  tag?: InputMaybe<TagOrderByWithRelationInput>;
  tagId?: InputMaybe<SortOrder>;
};

export enum ArticleTagScalarFieldEnum {
  ArticleId = 'articleId',
  Id = 'id',
  TagId = 'tagId'
}

export type ArticleTagScalarWhereInput = {
  AND?: InputMaybe<Array<ArticleTagScalarWhereInput>>;
  NOT?: InputMaybe<Array<ArticleTagScalarWhereInput>>;
  OR?: InputMaybe<Array<ArticleTagScalarWhereInput>>;
  articleId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  tagId?: InputMaybe<StringFilter>;
};

export type ArticleTagScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ArticleTagScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ArticleTagScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ArticleTagScalarWhereWithAggregatesInput>>;
  articleId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  tagId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ArticleTagUpdateInput = {
  article?: InputMaybe<ArticleUpdateOneRequiredWithoutArticleTagsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  tag?: InputMaybe<TagUpdateOneRequiredWithoutArticleTagsNestedInput>;
};

export type ArticleTagUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ArticleTagUpdateManyWithWhereWithoutArticleInput = {
  data: ArticleTagUpdateManyMutationInput;
  where: ArticleTagScalarWhereInput;
};

export type ArticleTagUpdateManyWithWhereWithoutTagInput = {
  data: ArticleTagUpdateManyMutationInput;
  where: ArticleTagScalarWhereInput;
};

export type ArticleTagUpdateManyWithoutArticleNestedInput = {
  connect?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleTagCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleTagCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleTagCreateManyArticleInputEnvelope>;
  delete?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ArticleTagScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  set?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  update?: InputMaybe<Array<ArticleTagUpdateWithWhereUniqueWithoutArticleInput>>;
  updateMany?: InputMaybe<Array<ArticleTagUpdateManyWithWhereWithoutArticleInput>>;
  upsert?: InputMaybe<Array<ArticleTagUpsertWithWhereUniqueWithoutArticleInput>>;
};

export type ArticleTagUpdateManyWithoutTagNestedInput = {
  connect?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleTagCreateOrConnectWithoutTagInput>>;
  create?: InputMaybe<Array<ArticleTagCreateWithoutTagInput>>;
  createMany?: InputMaybe<ArticleTagCreateManyTagInputEnvelope>;
  delete?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ArticleTagScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  set?: InputMaybe<Array<ArticleTagWhereUniqueInput>>;
  update?: InputMaybe<Array<ArticleTagUpdateWithWhereUniqueWithoutTagInput>>;
  updateMany?: InputMaybe<Array<ArticleTagUpdateManyWithWhereWithoutTagInput>>;
  upsert?: InputMaybe<Array<ArticleTagUpsertWithWhereUniqueWithoutTagInput>>;
};

export type ArticleTagUpdateWithWhereUniqueWithoutArticleInput = {
  data: ArticleTagUpdateWithoutArticleInput;
  where: ArticleTagWhereUniqueInput;
};

export type ArticleTagUpdateWithWhereUniqueWithoutTagInput = {
  data: ArticleTagUpdateWithoutTagInput;
  where: ArticleTagWhereUniqueInput;
};

export type ArticleTagUpdateWithoutArticleInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  tag?: InputMaybe<TagUpdateOneRequiredWithoutArticleTagsNestedInput>;
};

export type ArticleTagUpdateWithoutTagInput = {
  article?: InputMaybe<ArticleUpdateOneRequiredWithoutArticleTagsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ArticleTagUpsertWithWhereUniqueWithoutArticleInput = {
  create: ArticleTagCreateWithoutArticleInput;
  update: ArticleTagUpdateWithoutArticleInput;
  where: ArticleTagWhereUniqueInput;
};

export type ArticleTagUpsertWithWhereUniqueWithoutTagInput = {
  create: ArticleTagCreateWithoutTagInput;
  update: ArticleTagUpdateWithoutTagInput;
  where: ArticleTagWhereUniqueInput;
};

export type ArticleTagWhereInput = {
  AND?: InputMaybe<Array<ArticleTagWhereInput>>;
  NOT?: InputMaybe<Array<ArticleTagWhereInput>>;
  OR?: InputMaybe<Array<ArticleTagWhereInput>>;
  article?: InputMaybe<ArticleScalarRelationFilter>;
  articleId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  tag?: InputMaybe<TagScalarRelationFilter>;
  tagId?: InputMaybe<StringFilter>;
};

export type ArticleTagWhereUniqueInput = {
  AND?: InputMaybe<Array<ArticleTagWhereInput>>;
  NOT?: InputMaybe<Array<ArticleTagWhereInput>>;
  OR?: InputMaybe<Array<ArticleTagWhereInput>>;
  article?: InputMaybe<ArticleScalarRelationFilter>;
  articleId?: InputMaybe<StringFilter>;
  articleTag?: InputMaybe<ArticleTagArticleTagCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<TagScalarRelationFilter>;
  tagId?: InputMaybe<StringFilter>;
};

export type ArticleUpdateInput = {
  articleCategories?: InputMaybe<ArticleCategoryUpdateManyWithoutArticleNestedInput>;
  articleTags?: InputMaybe<ArticleTagUpdateManyWithoutArticleNestedInput>;
  content?: InputMaybe<ContentUpdateOneWithoutArticleNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readBy?: InputMaybe<UserArticleUpdateManyWithoutArticleNestedInput>;
  resourceType?: InputMaybe<ResourceTypeUpdateOneWithoutArticlesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutArticleNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ArticleUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ArticleUpdateManyWithWhereWithoutResourceTypeInput = {
  data: ArticleUpdateManyMutationInput;
  where: ArticleScalarWhereInput;
};

export type ArticleUpdateManyWithoutResourceTypeNestedInput = {
  connect?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleCreateOrConnectWithoutResourceTypeInput>>;
  create?: InputMaybe<Array<ArticleCreateWithoutResourceTypeInput>>;
  createMany?: InputMaybe<ArticleCreateManyResourceTypeInputEnvelope>;
  delete?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ArticleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  set?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  update?: InputMaybe<Array<ArticleUpdateWithWhereUniqueWithoutResourceTypeInput>>;
  updateMany?: InputMaybe<Array<ArticleUpdateManyWithWhereWithoutResourceTypeInput>>;
  upsert?: InputMaybe<Array<ArticleUpsertWithWhereUniqueWithoutResourceTypeInput>>;
};

export type ArticleUpdateOneRequiredWithoutArticleCategoriesNestedInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutArticleCategoriesInput>;
  create?: InputMaybe<ArticleCreateWithoutArticleCategoriesInput>;
  update?: InputMaybe<ArticleUpdateToOneWithWhereWithoutArticleCategoriesInput>;
  upsert?: InputMaybe<ArticleUpsertWithoutArticleCategoriesInput>;
};

export type ArticleUpdateOneRequiredWithoutArticleTagsNestedInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutArticleTagsInput>;
  create?: InputMaybe<ArticleCreateWithoutArticleTagsInput>;
  update?: InputMaybe<ArticleUpdateToOneWithWhereWithoutArticleTagsInput>;
  upsert?: InputMaybe<ArticleUpsertWithoutArticleTagsInput>;
};

export type ArticleUpdateOneRequiredWithoutReadByNestedInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutReadByInput>;
  create?: InputMaybe<ArticleCreateWithoutReadByInput>;
  update?: InputMaybe<ArticleUpdateToOneWithWhereWithoutReadByInput>;
  upsert?: InputMaybe<ArticleUpsertWithoutReadByInput>;
};

export type ArticleUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<ArticleCreateWithoutContentInput>;
  delete?: InputMaybe<ArticleWhereInput>;
  disconnect?: InputMaybe<ArticleWhereInput>;
  update?: InputMaybe<ArticleUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<ArticleUpsertWithoutContentInput>;
};

export type ArticleUpdateOneWithoutSavedForLaterNestedInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutSavedForLaterInput>;
  create?: InputMaybe<ArticleCreateWithoutSavedForLaterInput>;
  delete?: InputMaybe<ArticleWhereInput>;
  disconnect?: InputMaybe<ArticleWhereInput>;
  update?: InputMaybe<ArticleUpdateToOneWithWhereWithoutSavedForLaterInput>;
  upsert?: InputMaybe<ArticleUpsertWithoutSavedForLaterInput>;
};

export type ArticleUpdateToOneWithWhereWithoutArticleCategoriesInput = {
  data: ArticleUpdateWithoutArticleCategoriesInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpdateToOneWithWhereWithoutArticleTagsInput = {
  data: ArticleUpdateWithoutArticleTagsInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpdateToOneWithWhereWithoutContentInput = {
  data: ArticleUpdateWithoutContentInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpdateToOneWithWhereWithoutReadByInput = {
  data: ArticleUpdateWithoutReadByInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpdateToOneWithWhereWithoutSavedForLaterInput = {
  data: ArticleUpdateWithoutSavedForLaterInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpdateWithWhereUniqueWithoutResourceTypeInput = {
  data: ArticleUpdateWithoutResourceTypeInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleUpdateWithoutArticleCategoriesInput = {
  articleTags?: InputMaybe<ArticleTagUpdateManyWithoutArticleNestedInput>;
  content?: InputMaybe<ContentUpdateOneWithoutArticleNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readBy?: InputMaybe<UserArticleUpdateManyWithoutArticleNestedInput>;
  resourceType?: InputMaybe<ResourceTypeUpdateOneWithoutArticlesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutArticleNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ArticleUpdateWithoutArticleTagsInput = {
  articleCategories?: InputMaybe<ArticleCategoryUpdateManyWithoutArticleNestedInput>;
  content?: InputMaybe<ContentUpdateOneWithoutArticleNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readBy?: InputMaybe<UserArticleUpdateManyWithoutArticleNestedInput>;
  resourceType?: InputMaybe<ResourceTypeUpdateOneWithoutArticlesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutArticleNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ArticleUpdateWithoutContentInput = {
  articleCategories?: InputMaybe<ArticleCategoryUpdateManyWithoutArticleNestedInput>;
  articleTags?: InputMaybe<ArticleTagUpdateManyWithoutArticleNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readBy?: InputMaybe<UserArticleUpdateManyWithoutArticleNestedInput>;
  resourceType?: InputMaybe<ResourceTypeUpdateOneWithoutArticlesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutArticleNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ArticleUpdateWithoutReadByInput = {
  articleCategories?: InputMaybe<ArticleCategoryUpdateManyWithoutArticleNestedInput>;
  articleTags?: InputMaybe<ArticleTagUpdateManyWithoutArticleNestedInput>;
  content?: InputMaybe<ContentUpdateOneWithoutArticleNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<ResourceTypeUpdateOneWithoutArticlesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutArticleNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ArticleUpdateWithoutResourceTypeInput = {
  articleCategories?: InputMaybe<ArticleCategoryUpdateManyWithoutArticleNestedInput>;
  articleTags?: InputMaybe<ArticleTagUpdateManyWithoutArticleNestedInput>;
  content?: InputMaybe<ContentUpdateOneWithoutArticleNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readBy?: InputMaybe<UserArticleUpdateManyWithoutArticleNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutArticleNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ArticleUpdateWithoutSavedForLaterInput = {
  articleCategories?: InputMaybe<ArticleCategoryUpdateManyWithoutArticleNestedInput>;
  articleTags?: InputMaybe<ArticleTagUpdateManyWithoutArticleNestedInput>;
  content?: InputMaybe<ContentUpdateOneWithoutArticleNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readBy?: InputMaybe<UserArticleUpdateManyWithoutArticleNestedInput>;
  resourceType?: InputMaybe<ResourceTypeUpdateOneWithoutArticlesNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ArticleUpsertWithWhereUniqueWithoutResourceTypeInput = {
  create: ArticleCreateWithoutResourceTypeInput;
  update: ArticleUpdateWithoutResourceTypeInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleUpsertWithoutArticleCategoriesInput = {
  create: ArticleCreateWithoutArticleCategoriesInput;
  update: ArticleUpdateWithoutArticleCategoriesInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpsertWithoutArticleTagsInput = {
  create: ArticleCreateWithoutArticleTagsInput;
  update: ArticleUpdateWithoutArticleTagsInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpsertWithoutContentInput = {
  create: ArticleCreateWithoutContentInput;
  update: ArticleUpdateWithoutContentInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpsertWithoutReadByInput = {
  create: ArticleCreateWithoutReadByInput;
  update: ArticleUpdateWithoutReadByInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpsertWithoutSavedForLaterInput = {
  create: ArticleCreateWithoutSavedForLaterInput;
  update: ArticleUpdateWithoutSavedForLaterInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleWhereInput = {
  AND?: InputMaybe<Array<ArticleWhereInput>>;
  NOT?: InputMaybe<Array<ArticleWhereInput>>;
  OR?: InputMaybe<Array<ArticleWhereInput>>;
  articleCategories?: InputMaybe<ArticleCategoryListRelationFilter>;
  articleTags?: InputMaybe<ArticleTagListRelationFilter>;
  content?: InputMaybe<ContentNullableScalarRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  readBy?: InputMaybe<UserArticleListRelationFilter>;
  resourceType?: InputMaybe<ResourceTypeNullableScalarRelationFilter>;
  resourceTypeId?: InputMaybe<StringNullableFilter>;
  savedForLater?: InputMaybe<SavedForLaterListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type ArticleWhereUniqueInput = {
  AND?: InputMaybe<Array<ArticleWhereInput>>;
  NOT?: InputMaybe<Array<ArticleWhereInput>>;
  OR?: InputMaybe<Array<ArticleWhereInput>>;
  articleCategories?: InputMaybe<ArticleCategoryListRelationFilter>;
  articleTags?: InputMaybe<ArticleTagListRelationFilter>;
  content?: InputMaybe<ContentNullableScalarRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  readBy?: InputMaybe<UserArticleListRelationFilter>;
  resourceType?: InputMaybe<ResourceTypeNullableScalarRelationFilter>;
  resourceTypeId?: InputMaybe<StringNullableFilter>;
  savedForLater?: InputMaybe<SavedForLaterListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export enum BrandingType {
  Bsb = 'BSB',
  DrPam = 'DR_PAM',
  Ndc = 'NDC',
  Psp = 'PSP',
  Sby = 'SBY'
}

export type CategoryAvgOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type CategoryCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type CategoryCreateInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  programmeId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryCreateManyParentCategoryInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  programmeId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryCreateManyParentCategoryInputEnvelope = {
  data: Array<CategoryCreateManyParentCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryCreateManyProgrammeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryCreateManyProgrammeInputEnvelope = {
  data: Array<CategoryCreateManyProgrammeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryCreateNestedManyWithoutParentCategoryInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutParentCategoryInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutParentCategoryInput>>;
  createMany?: InputMaybe<CategoryCreateManyParentCategoryInputEnvelope>;
};

export type CategoryCreateNestedManyWithoutProgrammeInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<CategoryCreateManyProgrammeInputEnvelope>;
};

export type CategoryCreateNestedOneWithoutCategoryArticlesInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutCategoryArticlesInput>;
  create?: InputMaybe<CategoryCreateWithoutCategoryArticlesInput>;
};

export type CategoryCreateNestedOneWithoutCategoryEventsInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutCategoryEventsInput>;
  create?: InputMaybe<CategoryCreateWithoutCategoryEventsInput>;
};

export type CategoryCreateNestedOneWithoutCategoryImageInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutCategoryImageInput>;
  create?: InputMaybe<CategoryCreateWithoutCategoryImageInput>;
};

export type CategoryCreateNestedOneWithoutCategoryQuizzesInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutCategoryQuizzesInput>;
  create?: InputMaybe<CategoryCreateWithoutCategoryQuizzesInput>;
};

export type CategoryCreateNestedOneWithoutCategoryResourcesInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutCategoryResourcesInput>;
  create?: InputMaybe<CategoryCreateWithoutCategoryResourcesInput>;
};

export type CategoryCreateNestedOneWithoutPrerequisiteForInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutPrerequisiteForInput>;
  create?: InputMaybe<CategoryCreateWithoutPrerequisiteForInput>;
};

export type CategoryCreateNestedOneWithoutPrerequisitesInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutPrerequisitesInput>;
  create?: InputMaybe<CategoryCreateWithoutPrerequisitesInput>;
};

export type CategoryCreateNestedOneWithoutSavedForLaterInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutSavedForLaterInput>;
  create?: InputMaybe<CategoryCreateWithoutSavedForLaterInput>;
};

export type CategoryCreateNestedOneWithoutSubCategoriesInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutSubCategoriesInput>;
  create?: InputMaybe<CategoryCreateWithoutSubCategoriesInput>;
};

export type CategoryCreateNestedOneWithoutUserQuizzesInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutUserQuizzesInput>;
  create?: InputMaybe<CategoryCreateWithoutUserQuizzesInput>;
};

export type CategoryCreateOrConnectWithoutCategoryArticlesInput = {
  create: CategoryCreateWithoutCategoryArticlesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutCategoryEventsInput = {
  create: CategoryCreateWithoutCategoryEventsInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutCategoryImageInput = {
  create: CategoryCreateWithoutCategoryImageInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutCategoryQuizzesInput = {
  create: CategoryCreateWithoutCategoryQuizzesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutCategoryResourcesInput = {
  create: CategoryCreateWithoutCategoryResourcesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutParentCategoryInput = {
  create: CategoryCreateWithoutParentCategoryInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutPrerequisiteForInput = {
  create: CategoryCreateWithoutPrerequisiteForInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutPrerequisitesInput = {
  create: CategoryCreateWithoutPrerequisitesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutProgrammeInput = {
  create: CategoryCreateWithoutProgrammeInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutSavedForLaterInput = {
  create: CategoryCreateWithoutSavedForLaterInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutSubCategoriesInput = {
  create: CategoryCreateWithoutSubCategoriesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutUserQuizzesInput = {
  create: CategoryCreateWithoutUserQuizzesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateWithoutCategoryArticlesInput = {
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutCategoryEventsInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutCategoryImageInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutCategoryQuizzesInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutCategoryResourcesInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutParentCategoryInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutPrerequisiteForInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutPrerequisitesInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutProgrammeInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutSavedForLaterInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutSubCategoriesInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  userQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutUserQuizzesInput = {
  categoryArticles?: InputMaybe<ArticleCategoryCreateNestedManyWithoutCategoryInput>;
  categoryEvents?: InputMaybe<EventCategoryCreateNestedManyWithoutCategoryInput>;
  categoryImage?: InputMaybe<SectionImageCategoryCreateNestedOneWithoutCategoryInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryCreateNestedManyWithoutCategoryInput>;
  categoryResources?: InputMaybe<ResourceCategoryCreateNestedManyWithoutCategoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteCreateNestedManyWithoutCategoryInput>;
  programme: ProgrammeCreateNestedOneWithoutCategoriesInput;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutCategoryInput>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
};

export type CategoryListRelationFilter = {
  every?: InputMaybe<CategoryWhereInput>;
  none?: InputMaybe<CategoryWhereInput>;
  some?: InputMaybe<CategoryWhereInput>;
};

export type CategoryMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type CategoryMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type CategoryNullableScalarRelationFilter = {
  is?: InputMaybe<CategoryWhereInput>;
  isNot?: InputMaybe<CategoryWhereInput>;
};

export type CategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CategoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<CategoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<CategoryCountOrderByAggregateInput>;
  _max?: InputMaybe<CategoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<CategoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<CategorySumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrderInput>;
  programmeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type CategoryOrderByWithRelationInput = {
  categoryArticles?: InputMaybe<ArticleCategoryOrderByRelationAggregateInput>;
  categoryEvents?: InputMaybe<EventCategoryOrderByRelationAggregateInput>;
  categoryImage?: InputMaybe<SectionImageCategoryOrderByWithRelationInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryOrderByRelationAggregateInput>;
  categoryResources?: InputMaybe<ResourceCategoryOrderByRelationAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentCategory?: InputMaybe<CategoryOrderByWithRelationInput>;
  parentId?: InputMaybe<SortOrderInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteOrderByRelationAggregateInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteOrderByRelationAggregateInput>;
  programme?: InputMaybe<ProgrammeOrderByWithRelationInput>;
  programmeId?: InputMaybe<SortOrder>;
  savedForLater?: InputMaybe<SavedForLaterOrderByRelationAggregateInput>;
  slug?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  subCategories?: InputMaybe<CategoryOrderByRelationAggregateInput>;
  userQuizzes?: InputMaybe<UserQuizOrderByRelationAggregateInput>;
};

export type CategoryPrerequisiteCategoryPrerequisiteCompoundUniqueInput = {
  categoryId: Scalars['String']['input'];
  prerequisiteId: Scalars['String']['input'];
};

export type CategoryPrerequisiteCountOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  prerequisiteId?: InputMaybe<SortOrder>;
};

export type CategoryPrerequisiteCreateInput = {
  category: CategoryCreateNestedOneWithoutPrerequisitesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  prerequisite: CategoryCreateNestedOneWithoutPrerequisiteForInput;
};

export type CategoryPrerequisiteCreateManyCategoryInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  prerequisiteId: Scalars['String']['input'];
};

export type CategoryPrerequisiteCreateManyCategoryInputEnvelope = {
  data: Array<CategoryPrerequisiteCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryPrerequisiteCreateManyInput = {
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  prerequisiteId: Scalars['String']['input'];
};

export type CategoryPrerequisiteCreateManyPrerequisiteInput = {
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryPrerequisiteCreateManyPrerequisiteInputEnvelope = {
  data: Array<CategoryPrerequisiteCreateManyPrerequisiteInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryPrerequisiteCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<CategoryPrerequisiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryPrerequisiteCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<CategoryPrerequisiteCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<CategoryPrerequisiteCreateManyCategoryInputEnvelope>;
};

export type CategoryPrerequisiteCreateNestedManyWithoutPrerequisiteInput = {
  connect?: InputMaybe<Array<CategoryPrerequisiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryPrerequisiteCreateOrConnectWithoutPrerequisiteInput>>;
  create?: InputMaybe<Array<CategoryPrerequisiteCreateWithoutPrerequisiteInput>>;
  createMany?: InputMaybe<CategoryPrerequisiteCreateManyPrerequisiteInputEnvelope>;
};

export type CategoryPrerequisiteCreateOrConnectWithoutCategoryInput = {
  create: CategoryPrerequisiteCreateWithoutCategoryInput;
  where: CategoryPrerequisiteWhereUniqueInput;
};

export type CategoryPrerequisiteCreateOrConnectWithoutPrerequisiteInput = {
  create: CategoryPrerequisiteCreateWithoutPrerequisiteInput;
  where: CategoryPrerequisiteWhereUniqueInput;
};

export type CategoryPrerequisiteCreateWithoutCategoryInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  prerequisite: CategoryCreateNestedOneWithoutPrerequisiteForInput;
};

export type CategoryPrerequisiteCreateWithoutPrerequisiteInput = {
  category: CategoryCreateNestedOneWithoutPrerequisitesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryPrerequisiteListRelationFilter = {
  every?: InputMaybe<CategoryPrerequisiteWhereInput>;
  none?: InputMaybe<CategoryPrerequisiteWhereInput>;
  some?: InputMaybe<CategoryPrerequisiteWhereInput>;
};

export type CategoryPrerequisiteMaxOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  prerequisiteId?: InputMaybe<SortOrder>;
};

export type CategoryPrerequisiteMinOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  prerequisiteId?: InputMaybe<SortOrder>;
};

export type CategoryPrerequisiteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CategoryPrerequisiteOrderByWithAggregationInput = {
  _count?: InputMaybe<CategoryPrerequisiteCountOrderByAggregateInput>;
  _max?: InputMaybe<CategoryPrerequisiteMaxOrderByAggregateInput>;
  _min?: InputMaybe<CategoryPrerequisiteMinOrderByAggregateInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  prerequisiteId?: InputMaybe<SortOrder>;
};

export type CategoryPrerequisiteOrderByWithRelationInput = {
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  prerequisite?: InputMaybe<CategoryOrderByWithRelationInput>;
  prerequisiteId?: InputMaybe<SortOrder>;
};

export enum CategoryPrerequisiteScalarFieldEnum {
  CategoryId = 'categoryId',
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  PrerequisiteId = 'prerequisiteId'
}

export type CategoryPrerequisiteScalarWhereInput = {
  AND?: InputMaybe<Array<CategoryPrerequisiteScalarWhereInput>>;
  NOT?: InputMaybe<Array<CategoryPrerequisiteScalarWhereInput>>;
  OR?: InputMaybe<Array<CategoryPrerequisiteScalarWhereInput>>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  prerequisiteId?: InputMaybe<StringFilter>;
};

export type CategoryPrerequisiteScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CategoryPrerequisiteScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CategoryPrerequisiteScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CategoryPrerequisiteScalarWhereWithAggregatesInput>>;
  categoryId?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  prerequisiteId?: InputMaybe<StringWithAggregatesFilter>;
};

export type CategoryPrerequisiteUpdateInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutPrerequisitesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  prerequisite?: InputMaybe<CategoryUpdateOneRequiredWithoutPrerequisiteForNestedInput>;
};

export type CategoryPrerequisiteUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryPrerequisiteUpdateManyWithWhereWithoutCategoryInput = {
  data: CategoryPrerequisiteUpdateManyMutationInput;
  where: CategoryPrerequisiteScalarWhereInput;
};

export type CategoryPrerequisiteUpdateManyWithWhereWithoutPrerequisiteInput = {
  data: CategoryPrerequisiteUpdateManyMutationInput;
  where: CategoryPrerequisiteScalarWhereInput;
};

export type CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<CategoryPrerequisiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryPrerequisiteCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<CategoryPrerequisiteCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<CategoryPrerequisiteCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<CategoryPrerequisiteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryPrerequisiteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryPrerequisiteWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryPrerequisiteWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryPrerequisiteUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<CategoryPrerequisiteUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<CategoryPrerequisiteUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput = {
  connect?: InputMaybe<Array<CategoryPrerequisiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryPrerequisiteCreateOrConnectWithoutPrerequisiteInput>>;
  create?: InputMaybe<Array<CategoryPrerequisiteCreateWithoutPrerequisiteInput>>;
  createMany?: InputMaybe<CategoryPrerequisiteCreateManyPrerequisiteInputEnvelope>;
  delete?: InputMaybe<Array<CategoryPrerequisiteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryPrerequisiteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryPrerequisiteWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryPrerequisiteWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryPrerequisiteUpdateWithWhereUniqueWithoutPrerequisiteInput>>;
  updateMany?: InputMaybe<Array<CategoryPrerequisiteUpdateManyWithWhereWithoutPrerequisiteInput>>;
  upsert?: InputMaybe<Array<CategoryPrerequisiteUpsertWithWhereUniqueWithoutPrerequisiteInput>>;
};

export type CategoryPrerequisiteUpdateWithWhereUniqueWithoutCategoryInput = {
  data: CategoryPrerequisiteUpdateWithoutCategoryInput;
  where: CategoryPrerequisiteWhereUniqueInput;
};

export type CategoryPrerequisiteUpdateWithWhereUniqueWithoutPrerequisiteInput = {
  data: CategoryPrerequisiteUpdateWithoutPrerequisiteInput;
  where: CategoryPrerequisiteWhereUniqueInput;
};

export type CategoryPrerequisiteUpdateWithoutCategoryInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  prerequisite?: InputMaybe<CategoryUpdateOneRequiredWithoutPrerequisiteForNestedInput>;
};

export type CategoryPrerequisiteUpdateWithoutPrerequisiteInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutPrerequisitesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryPrerequisiteUpsertWithWhereUniqueWithoutCategoryInput = {
  create: CategoryPrerequisiteCreateWithoutCategoryInput;
  update: CategoryPrerequisiteUpdateWithoutCategoryInput;
  where: CategoryPrerequisiteWhereUniqueInput;
};

export type CategoryPrerequisiteUpsertWithWhereUniqueWithoutPrerequisiteInput = {
  create: CategoryPrerequisiteCreateWithoutPrerequisiteInput;
  update: CategoryPrerequisiteUpdateWithoutPrerequisiteInput;
  where: CategoryPrerequisiteWhereUniqueInput;
};

export type CategoryPrerequisiteWhereInput = {
  AND?: InputMaybe<Array<CategoryPrerequisiteWhereInput>>;
  NOT?: InputMaybe<Array<CategoryPrerequisiteWhereInput>>;
  OR?: InputMaybe<Array<CategoryPrerequisiteWhereInput>>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  prerequisite?: InputMaybe<CategoryScalarRelationFilter>;
  prerequisiteId?: InputMaybe<StringFilter>;
};

export type CategoryPrerequisiteWhereUniqueInput = {
  AND?: InputMaybe<Array<CategoryPrerequisiteWhereInput>>;
  NOT?: InputMaybe<Array<CategoryPrerequisiteWhereInput>>;
  OR?: InputMaybe<Array<CategoryPrerequisiteWhereInput>>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  categoryPrerequisite?: InputMaybe<CategoryPrerequisiteCategoryPrerequisiteCompoundUniqueInput>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  prerequisite?: InputMaybe<CategoryScalarRelationFilter>;
  prerequisiteId?: InputMaybe<StringFilter>;
};

export type CategoryProductCategorySlugCompoundUniqueInput = {
  parentId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export enum CategoryScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  Name = 'name',
  ParentId = 'parentId',
  ProgrammeId = 'programmeId',
  Slug = 'slug',
  SortOrder = 'sortOrder'
}

export type CategoryScalarRelationFilter = {
  is?: InputMaybe<CategoryWhereInput>;
  isNot?: InputMaybe<CategoryWhereInput>;
};

export type CategoryScalarWhereInput = {
  AND?: InputMaybe<Array<CategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<CategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<CategoryScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  programmeId?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type CategoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  parentId?: InputMaybe<StringNullableWithAggregatesFilter>;
  programmeId?: InputMaybe<StringWithAggregatesFilter>;
  slug?: InputMaybe<StringWithAggregatesFilter>;
  sortOrder?: InputMaybe<IntWithAggregatesFilter>;
};

export type CategorySumOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type CategoryUpdateInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type CategoryUpdateManyWithWhereWithoutParentCategoryInput = {
  data: CategoryUpdateManyMutationInput;
  where: CategoryScalarWhereInput;
};

export type CategoryUpdateManyWithWhereWithoutProgrammeInput = {
  data: CategoryUpdateManyMutationInput;
  where: CategoryScalarWhereInput;
};

export type CategoryUpdateManyWithoutParentCategoryNestedInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutParentCategoryInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutParentCategoryInput>>;
  createMany?: InputMaybe<CategoryCreateManyParentCategoryInputEnvelope>;
  delete?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryUpdateWithWhereUniqueWithoutParentCategoryInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateManyWithWhereWithoutParentCategoryInput>>;
  upsert?: InputMaybe<Array<CategoryUpsertWithWhereUniqueWithoutParentCategoryInput>>;
};

export type CategoryUpdateManyWithoutProgrammeNestedInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<CategoryCreateManyProgrammeInputEnvelope>;
  delete?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryUpdateWithWhereUniqueWithoutProgrammeInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateManyWithWhereWithoutProgrammeInput>>;
  upsert?: InputMaybe<Array<CategoryUpsertWithWhereUniqueWithoutProgrammeInput>>;
};

export type CategoryUpdateOneRequiredWithoutCategoryArticlesNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutCategoryArticlesInput>;
  create?: InputMaybe<CategoryCreateWithoutCategoryArticlesInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutCategoryArticlesInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutCategoryArticlesInput>;
};

export type CategoryUpdateOneRequiredWithoutCategoryEventsNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutCategoryEventsInput>;
  create?: InputMaybe<CategoryCreateWithoutCategoryEventsInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutCategoryEventsInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutCategoryEventsInput>;
};

export type CategoryUpdateOneRequiredWithoutCategoryImageNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutCategoryImageInput>;
  create?: InputMaybe<CategoryCreateWithoutCategoryImageInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutCategoryImageInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutCategoryImageInput>;
};

export type CategoryUpdateOneRequiredWithoutCategoryQuizzesNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutCategoryQuizzesInput>;
  create?: InputMaybe<CategoryCreateWithoutCategoryQuizzesInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutCategoryQuizzesInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutCategoryQuizzesInput>;
};

export type CategoryUpdateOneRequiredWithoutCategoryResourcesNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutCategoryResourcesInput>;
  create?: InputMaybe<CategoryCreateWithoutCategoryResourcesInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutCategoryResourcesInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutCategoryResourcesInput>;
};

export type CategoryUpdateOneRequiredWithoutPrerequisiteForNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutPrerequisiteForInput>;
  create?: InputMaybe<CategoryCreateWithoutPrerequisiteForInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutPrerequisiteForInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutPrerequisiteForInput>;
};

export type CategoryUpdateOneRequiredWithoutPrerequisitesNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutPrerequisitesInput>;
  create?: InputMaybe<CategoryCreateWithoutPrerequisitesInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutPrerequisitesInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutPrerequisitesInput>;
};

export type CategoryUpdateOneRequiredWithoutSavedForLaterNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutSavedForLaterInput>;
  create?: InputMaybe<CategoryCreateWithoutSavedForLaterInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutSavedForLaterInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutSavedForLaterInput>;
};

export type CategoryUpdateOneRequiredWithoutUserQuizzesNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutUserQuizzesInput>;
  create?: InputMaybe<CategoryCreateWithoutUserQuizzesInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutUserQuizzesInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutUserQuizzesInput>;
};

export type CategoryUpdateOneWithoutSubCategoriesNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutSubCategoriesInput>;
  create?: InputMaybe<CategoryCreateWithoutSubCategoriesInput>;
  delete?: InputMaybe<CategoryWhereInput>;
  disconnect?: InputMaybe<CategoryWhereInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutSubCategoriesInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutSubCategoriesInput>;
};

export type CategoryUpdateToOneWithWhereWithoutCategoryArticlesInput = {
  data: CategoryUpdateWithoutCategoryArticlesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutCategoryEventsInput = {
  data: CategoryUpdateWithoutCategoryEventsInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutCategoryImageInput = {
  data: CategoryUpdateWithoutCategoryImageInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutCategoryQuizzesInput = {
  data: CategoryUpdateWithoutCategoryQuizzesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutCategoryResourcesInput = {
  data: CategoryUpdateWithoutCategoryResourcesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutPrerequisiteForInput = {
  data: CategoryUpdateWithoutPrerequisiteForInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutPrerequisitesInput = {
  data: CategoryUpdateWithoutPrerequisitesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutSavedForLaterInput = {
  data: CategoryUpdateWithoutSavedForLaterInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutSubCategoriesInput = {
  data: CategoryUpdateWithoutSubCategoriesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutUserQuizzesInput = {
  data: CategoryUpdateWithoutUserQuizzesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateWithWhereUniqueWithoutParentCategoryInput = {
  data: CategoryUpdateWithoutParentCategoryInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpdateWithWhereUniqueWithoutProgrammeInput = {
  data: CategoryUpdateWithoutProgrammeInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpdateWithoutCategoryArticlesInput = {
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutCategoryEventsInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutCategoryImageInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutCategoryQuizzesInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutCategoryResourcesInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutParentCategoryInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutPrerequisiteForInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutPrerequisitesInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutProgrammeInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutSavedForLaterInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutSubCategoriesInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  userQuizzes?: InputMaybe<UserQuizUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutUserQuizzesInput = {
  categoryArticles?: InputMaybe<ArticleCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryEvents?: InputMaybe<EventCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryImage?: InputMaybe<SectionImageCategoryUpdateOneWithoutCategoryNestedInput>;
  categoryQuizzes?: InputMaybe<QuizCategoryUpdateManyWithoutCategoryNestedInput>;
  categoryResources?: InputMaybe<ResourceCategoryUpdateManyWithoutCategoryNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesNestedInput>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutPrerequisiteNestedInput>;
  prerequisites?: InputMaybe<CategoryPrerequisiteUpdateManyWithoutCategoryNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutCategoryNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryNestedInput>;
};

export type CategoryUpsertWithWhereUniqueWithoutParentCategoryInput = {
  create: CategoryCreateWithoutParentCategoryInput;
  update: CategoryUpdateWithoutParentCategoryInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpsertWithWhereUniqueWithoutProgrammeInput = {
  create: CategoryCreateWithoutProgrammeInput;
  update: CategoryUpdateWithoutProgrammeInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpsertWithoutCategoryArticlesInput = {
  create: CategoryCreateWithoutCategoryArticlesInput;
  update: CategoryUpdateWithoutCategoryArticlesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutCategoryEventsInput = {
  create: CategoryCreateWithoutCategoryEventsInput;
  update: CategoryUpdateWithoutCategoryEventsInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutCategoryImageInput = {
  create: CategoryCreateWithoutCategoryImageInput;
  update: CategoryUpdateWithoutCategoryImageInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutCategoryQuizzesInput = {
  create: CategoryCreateWithoutCategoryQuizzesInput;
  update: CategoryUpdateWithoutCategoryQuizzesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutCategoryResourcesInput = {
  create: CategoryCreateWithoutCategoryResourcesInput;
  update: CategoryUpdateWithoutCategoryResourcesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutPrerequisiteForInput = {
  create: CategoryCreateWithoutPrerequisiteForInput;
  update: CategoryUpdateWithoutPrerequisiteForInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutPrerequisitesInput = {
  create: CategoryCreateWithoutPrerequisitesInput;
  update: CategoryUpdateWithoutPrerequisitesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutSavedForLaterInput = {
  create: CategoryCreateWithoutSavedForLaterInput;
  update: CategoryUpdateWithoutSavedForLaterInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutSubCategoriesInput = {
  create: CategoryCreateWithoutSubCategoriesInput;
  update: CategoryUpdateWithoutSubCategoriesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutUserQuizzesInput = {
  create: CategoryCreateWithoutUserQuizzesInput;
  update: CategoryUpdateWithoutUserQuizzesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryWhereInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  categoryArticles?: InputMaybe<ArticleCategoryListRelationFilter>;
  categoryEvents?: InputMaybe<EventCategoryListRelationFilter>;
  categoryImage?: InputMaybe<SectionImageCategoryNullableScalarRelationFilter>;
  categoryQuizzes?: InputMaybe<QuizCategoryListRelationFilter>;
  categoryResources?: InputMaybe<ResourceCategoryListRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  parentCategory?: InputMaybe<CategoryNullableScalarRelationFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteListRelationFilter>;
  prerequisites?: InputMaybe<CategoryPrerequisiteListRelationFilter>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
  savedForLater?: InputMaybe<SavedForLaterListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
  subCategories?: InputMaybe<CategoryListRelationFilter>;
  userQuizzes?: InputMaybe<UserQuizListRelationFilter>;
};

export type CategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  categoryArticles?: InputMaybe<ArticleCategoryListRelationFilter>;
  categoryEvents?: InputMaybe<EventCategoryListRelationFilter>;
  categoryImage?: InputMaybe<SectionImageCategoryNullableScalarRelationFilter>;
  categoryQuizzes?: InputMaybe<QuizCategoryListRelationFilter>;
  categoryResources?: InputMaybe<ResourceCategoryListRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  parentCategory?: InputMaybe<CategoryNullableScalarRelationFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  prerequisiteFor?: InputMaybe<CategoryPrerequisiteListRelationFilter>;
  prerequisites?: InputMaybe<CategoryPrerequisiteListRelationFilter>;
  productCategorySlug?: InputMaybe<CategoryProductCategorySlugCompoundUniqueInput>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
  savedForLater?: InputMaybe<SavedForLaterListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
  subCategories?: InputMaybe<CategoryListRelationFilter>;
  userQuizzes?: InputMaybe<UserQuizListRelationFilter>;
};

export type ContentAvgOrderByAggregateInput = {
  readTimeMinutes?: InputMaybe<SortOrder>;
};

export type ContentCountOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  bannerImageUrl?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  markdown?: InputMaybe<SortOrder>;
  markdownHash?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  publishedFrontmatter?: InputMaybe<SortOrder>;
  publishedHtml?: InputMaybe<SortOrder>;
  publishedMarkdown?: InputMaybe<SortOrder>;
  publishedMarkdownHash?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  readTimeMinutes?: InputMaybe<SortOrder>;
};

export type ContentCreateInput = {
  article?: InputMaybe<ArticleCreateNestedOneWithoutContentInput>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  markdown: Scalars['String']['input'];
  markdownHash?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  publishedHtml?: InputMaybe<Scalars['String']['input']>;
  publishedMarkdown?: InputMaybe<Scalars['String']['input']>;
  publishedMarkdownHash?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<QuizCreateNestedOneWithoutContentInput>;
  readTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentCreateManyInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  markdown: Scalars['String']['input'];
  markdownHash?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  publishedHtml?: InputMaybe<Scalars['String']['input']>;
  publishedMarkdown?: InputMaybe<Scalars['String']['input']>;
  publishedMarkdownHash?: InputMaybe<Scalars['String']['input']>;
  quizId?: InputMaybe<Scalars['String']['input']>;
  readTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentCreateNestedOneWithoutArticleInput = {
  connect?: InputMaybe<ContentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ContentCreateOrConnectWithoutArticleInput>;
  create?: InputMaybe<ContentCreateWithoutArticleInput>;
};

export type ContentCreateNestedOneWithoutQuizInput = {
  connect?: InputMaybe<ContentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ContentCreateOrConnectWithoutQuizInput>;
  create?: InputMaybe<ContentCreateWithoutQuizInput>;
};

export type ContentCreateOrConnectWithoutArticleInput = {
  create: ContentCreateWithoutArticleInput;
  where: ContentWhereUniqueInput;
};

export type ContentCreateOrConnectWithoutQuizInput = {
  create: ContentCreateWithoutQuizInput;
  where: ContentWhereUniqueInput;
};

export type ContentCreateWithoutArticleInput = {
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  markdown: Scalars['String']['input'];
  markdownHash?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  publishedHtml?: InputMaybe<Scalars['String']['input']>;
  publishedMarkdown?: InputMaybe<Scalars['String']['input']>;
  publishedMarkdownHash?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<QuizCreateNestedOneWithoutContentInput>;
  readTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentCreateWithoutQuizInput = {
  article?: InputMaybe<ArticleCreateNestedOneWithoutContentInput>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  markdown: Scalars['String']['input'];
  markdownHash?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  publishedHtml?: InputMaybe<Scalars['String']['input']>;
  publishedMarkdown?: InputMaybe<Scalars['String']['input']>;
  publishedMarkdownHash?: InputMaybe<Scalars['String']['input']>;
  readTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentMaxOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  bannerImageUrl?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  markdown?: InputMaybe<SortOrder>;
  markdownHash?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  publishedHtml?: InputMaybe<SortOrder>;
  publishedMarkdown?: InputMaybe<SortOrder>;
  publishedMarkdownHash?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  readTimeMinutes?: InputMaybe<SortOrder>;
};

export type ContentMinOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  bannerImageUrl?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  markdown?: InputMaybe<SortOrder>;
  markdownHash?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  publishedHtml?: InputMaybe<SortOrder>;
  publishedMarkdown?: InputMaybe<SortOrder>;
  publishedMarkdownHash?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  readTimeMinutes?: InputMaybe<SortOrder>;
};

export type ContentNullableScalarRelationFilter = {
  is?: InputMaybe<ContentWhereInput>;
  isNot?: InputMaybe<ContentWhereInput>;
};

export type ContentOrderByWithAggregationInput = {
  _avg?: InputMaybe<ContentAvgOrderByAggregateInput>;
  _count?: InputMaybe<ContentCountOrderByAggregateInput>;
  _max?: InputMaybe<ContentMaxOrderByAggregateInput>;
  _min?: InputMaybe<ContentMinOrderByAggregateInput>;
  _sum?: InputMaybe<ContentSumOrderByAggregateInput>;
  articleId?: InputMaybe<SortOrderInput>;
  bannerImageUrl?: InputMaybe<SortOrderInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  markdown?: InputMaybe<SortOrder>;
  markdownHash?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  publishedFrontmatter?: InputMaybe<SortOrderInput>;
  publishedHtml?: InputMaybe<SortOrderInput>;
  publishedMarkdown?: InputMaybe<SortOrderInput>;
  publishedMarkdownHash?: InputMaybe<SortOrderInput>;
  quizId?: InputMaybe<SortOrderInput>;
  readTimeMinutes?: InputMaybe<SortOrderInput>;
};

export type ContentOrderByWithRelationInput = {
  article?: InputMaybe<ArticleOrderByWithRelationInput>;
  articleId?: InputMaybe<SortOrderInput>;
  bannerImageUrl?: InputMaybe<SortOrderInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  markdown?: InputMaybe<SortOrder>;
  markdownHash?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  publishedFrontmatter?: InputMaybe<SortOrderInput>;
  publishedHtml?: InputMaybe<SortOrderInput>;
  publishedMarkdown?: InputMaybe<SortOrderInput>;
  publishedMarkdownHash?: InputMaybe<SortOrderInput>;
  quiz?: InputMaybe<QuizOrderByWithRelationInput>;
  quizId?: InputMaybe<SortOrderInput>;
  readTimeMinutes?: InputMaybe<SortOrderInput>;
};

export enum ContentScalarFieldEnum {
  ArticleId = 'articleId',
  BannerImageUrl = 'bannerImageUrl',
  Created = 'created',
  Id = 'id',
  Markdown = 'markdown',
  MarkdownHash = 'markdownHash',
  Modified = 'modified',
  PublishedFrontmatter = 'publishedFrontmatter',
  PublishedHtml = 'publishedHtml',
  PublishedMarkdown = 'publishedMarkdown',
  PublishedMarkdownHash = 'publishedMarkdownHash',
  QuizId = 'quizId',
  ReadTimeMinutes = 'readTimeMinutes'
}

export type ContentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ContentScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ContentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ContentScalarWhereWithAggregatesInput>>;
  articleId?: InputMaybe<StringNullableWithAggregatesFilter>;
  bannerImageUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  markdown?: InputMaybe<StringWithAggregatesFilter>;
  markdownHash?: InputMaybe<StringNullableWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  publishedFrontmatter?: InputMaybe<JsonNullableWithAggregatesFilter>;
  publishedHtml?: InputMaybe<StringNullableWithAggregatesFilter>;
  publishedMarkdown?: InputMaybe<StringNullableWithAggregatesFilter>;
  publishedMarkdownHash?: InputMaybe<StringNullableWithAggregatesFilter>;
  quizId?: InputMaybe<StringNullableWithAggregatesFilter>;
  readTimeMinutes?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type ContentSumOrderByAggregateInput = {
  readTimeMinutes?: InputMaybe<SortOrder>;
};

export type ContentUpdateInput = {
  article?: InputMaybe<ArticleUpdateOneWithoutContentNestedInput>;
  bannerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  markdown?: InputMaybe<StringFieldUpdateOperationsInput>;
  markdownHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  publishedHtml?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishedMarkdown?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishedMarkdownHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quiz?: InputMaybe<QuizUpdateOneWithoutContentNestedInput>;
  readTimeMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ContentUpdateManyMutationInput = {
  bannerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  markdown?: InputMaybe<StringFieldUpdateOperationsInput>;
  markdownHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  publishedHtml?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishedMarkdown?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishedMarkdownHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readTimeMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ContentUpdateOneWithoutArticleNestedInput = {
  connect?: InputMaybe<ContentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ContentCreateOrConnectWithoutArticleInput>;
  create?: InputMaybe<ContentCreateWithoutArticleInput>;
  delete?: InputMaybe<ContentWhereInput>;
  disconnect?: InputMaybe<ContentWhereInput>;
  update?: InputMaybe<ContentUpdateToOneWithWhereWithoutArticleInput>;
  upsert?: InputMaybe<ContentUpsertWithoutArticleInput>;
};

export type ContentUpdateOneWithoutQuizNestedInput = {
  connect?: InputMaybe<ContentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ContentCreateOrConnectWithoutQuizInput>;
  create?: InputMaybe<ContentCreateWithoutQuizInput>;
  delete?: InputMaybe<ContentWhereInput>;
  disconnect?: InputMaybe<ContentWhereInput>;
  update?: InputMaybe<ContentUpdateToOneWithWhereWithoutQuizInput>;
  upsert?: InputMaybe<ContentUpsertWithoutQuizInput>;
};

export type ContentUpdateToOneWithWhereWithoutArticleInput = {
  data: ContentUpdateWithoutArticleInput;
  where?: InputMaybe<ContentWhereInput>;
};

export type ContentUpdateToOneWithWhereWithoutQuizInput = {
  data: ContentUpdateWithoutQuizInput;
  where?: InputMaybe<ContentWhereInput>;
};

export type ContentUpdateWithoutArticleInput = {
  bannerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  markdown?: InputMaybe<StringFieldUpdateOperationsInput>;
  markdownHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  publishedHtml?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishedMarkdown?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishedMarkdownHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quiz?: InputMaybe<QuizUpdateOneWithoutContentNestedInput>;
  readTimeMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ContentUpdateWithoutQuizInput = {
  article?: InputMaybe<ArticleUpdateOneWithoutContentNestedInput>;
  bannerImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  markdown?: InputMaybe<StringFieldUpdateOperationsInput>;
  markdownHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  publishedHtml?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishedMarkdown?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishedMarkdownHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readTimeMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ContentUpsertWithoutArticleInput = {
  create: ContentCreateWithoutArticleInput;
  update: ContentUpdateWithoutArticleInput;
  where?: InputMaybe<ContentWhereInput>;
};

export type ContentUpsertWithoutQuizInput = {
  create: ContentCreateWithoutQuizInput;
  update: ContentUpdateWithoutQuizInput;
  where?: InputMaybe<ContentWhereInput>;
};

export type ContentWhereInput = {
  AND?: InputMaybe<Array<ContentWhereInput>>;
  NOT?: InputMaybe<Array<ContentWhereInput>>;
  OR?: InputMaybe<Array<ContentWhereInput>>;
  article?: InputMaybe<ArticleNullableScalarRelationFilter>;
  articleId?: InputMaybe<StringNullableFilter>;
  bannerImageUrl?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  markdown?: InputMaybe<StringFilter>;
  markdownHash?: InputMaybe<StringNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  publishedFrontmatter?: InputMaybe<JsonNullableFilter>;
  publishedHtml?: InputMaybe<StringNullableFilter>;
  publishedMarkdown?: InputMaybe<StringNullableFilter>;
  publishedMarkdownHash?: InputMaybe<StringNullableFilter>;
  quiz?: InputMaybe<QuizNullableScalarRelationFilter>;
  quizId?: InputMaybe<StringNullableFilter>;
  readTimeMinutes?: InputMaybe<IntNullableFilter>;
};

export type ContentWhereUniqueInput = {
  AND?: InputMaybe<Array<ContentWhereInput>>;
  NOT?: InputMaybe<Array<ContentWhereInput>>;
  OR?: InputMaybe<Array<ContentWhereInput>>;
  article?: InputMaybe<ArticleNullableScalarRelationFilter>;
  articleId?: InputMaybe<Scalars['String']['input']>;
  bannerImageUrl?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  markdown?: InputMaybe<StringFilter>;
  markdownHash?: InputMaybe<StringNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  publishedFrontmatter?: InputMaybe<JsonNullableFilter>;
  publishedHtml?: InputMaybe<StringNullableFilter>;
  publishedMarkdown?: InputMaybe<StringNullableFilter>;
  publishedMarkdownHash?: InputMaybe<StringNullableFilter>;
  quiz?: InputMaybe<QuizNullableScalarRelationFilter>;
  quizId?: InputMaybe<Scalars['String']['input']>;
  readTimeMinutes?: InputMaybe<IntNullableFilter>;
};

export type CouponAvgOrderByAggregateInput = {
  fixedAmountInCents?: InputMaybe<SortOrder>;
  maxUses?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
};

export type CouponCountOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discountType?: InputMaybe<SortOrder>;
  fixedAmountInCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isArchived?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  maxUses?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  validFrom?: InputMaybe<SortOrder>;
  validTo?: InputMaybe<SortOrder>;
};

export type CouponCreateInput = {
  code: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<CouponDiscountType>;
  fixedAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  restrictedToProducts?: InputMaybe<CouponProductRestrictionCreateNestedManyWithoutCouponInput>;
  usedInPayments?: InputMaybe<PaymentCreateNestedManyWithoutCouponInput>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CouponCreateManyInput = {
  code: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<CouponDiscountType>;
  fixedAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CouponCreateNestedOneWithoutRestrictedToProductsInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutRestrictedToProductsInput>;
  create?: InputMaybe<CouponCreateWithoutRestrictedToProductsInput>;
};

export type CouponCreateNestedOneWithoutUsedInPaymentsInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutUsedInPaymentsInput>;
  create?: InputMaybe<CouponCreateWithoutUsedInPaymentsInput>;
};

export type CouponCreateOrConnectWithoutRestrictedToProductsInput = {
  create: CouponCreateWithoutRestrictedToProductsInput;
  where: CouponWhereUniqueInput;
};

export type CouponCreateOrConnectWithoutUsedInPaymentsInput = {
  create: CouponCreateWithoutUsedInPaymentsInput;
  where: CouponWhereUniqueInput;
};

export type CouponCreateWithoutRestrictedToProductsInput = {
  code: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<CouponDiscountType>;
  fixedAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  usedInPayments?: InputMaybe<PaymentCreateNestedManyWithoutCouponInput>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CouponCreateWithoutUsedInPaymentsInput = {
  code: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<CouponDiscountType>;
  fixedAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  restrictedToProducts?: InputMaybe<CouponProductRestrictionCreateNestedManyWithoutCouponInput>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum CouponDiscountType {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type CouponMaxOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discountType?: InputMaybe<SortOrder>;
  fixedAmountInCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isArchived?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  maxUses?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  validFrom?: InputMaybe<SortOrder>;
  validTo?: InputMaybe<SortOrder>;
};

export type CouponMinOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discountType?: InputMaybe<SortOrder>;
  fixedAmountInCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isArchived?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  maxUses?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  validFrom?: InputMaybe<SortOrder>;
  validTo?: InputMaybe<SortOrder>;
};

export type CouponNullableScalarRelationFilter = {
  is?: InputMaybe<CouponWhereInput>;
  isNot?: InputMaybe<CouponWhereInput>;
};

export type CouponOrderByWithAggregationInput = {
  _avg?: InputMaybe<CouponAvgOrderByAggregateInput>;
  _count?: InputMaybe<CouponCountOrderByAggregateInput>;
  _max?: InputMaybe<CouponMaxOrderByAggregateInput>;
  _min?: InputMaybe<CouponMinOrderByAggregateInput>;
  _sum?: InputMaybe<CouponSumOrderByAggregateInput>;
  code?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  discountType?: InputMaybe<SortOrder>;
  fixedAmountInCents?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isArchived?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  maxUses?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrderInput>;
  validFrom?: InputMaybe<SortOrderInput>;
  validTo?: InputMaybe<SortOrderInput>;
};

export type CouponOrderByWithRelationInput = {
  code?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  discountType?: InputMaybe<SortOrder>;
  fixedAmountInCents?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isArchived?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  maxUses?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrderInput>;
  restrictedToProducts?: InputMaybe<CouponProductRestrictionOrderByRelationAggregateInput>;
  usedInPayments?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  validFrom?: InputMaybe<SortOrderInput>;
  validTo?: InputMaybe<SortOrderInput>;
};

export type CouponProductRestrictionCountOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type CouponProductRestrictionCouponProductRestrictionCompoundUniqueInput = {
  couponId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type CouponProductRestrictionCreateInput = {
  coupon: CouponCreateNestedOneWithoutRestrictedToProductsInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  product: ProductCreateNestedOneWithoutCouponProductRestrictionsInput;
};

export type CouponProductRestrictionCreateManyCouponInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['String']['input'];
};

export type CouponProductRestrictionCreateManyCouponInputEnvelope = {
  data: Array<CouponProductRestrictionCreateManyCouponInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CouponProductRestrictionCreateManyInput = {
  couponId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['String']['input'];
};

export type CouponProductRestrictionCreateManyProductInput = {
  couponId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CouponProductRestrictionCreateManyProductInputEnvelope = {
  data: Array<CouponProductRestrictionCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CouponProductRestrictionCreateNestedManyWithoutCouponInput = {
  connect?: InputMaybe<Array<CouponProductRestrictionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CouponProductRestrictionCreateOrConnectWithoutCouponInput>>;
  create?: InputMaybe<Array<CouponProductRestrictionCreateWithoutCouponInput>>;
  createMany?: InputMaybe<CouponProductRestrictionCreateManyCouponInputEnvelope>;
};

export type CouponProductRestrictionCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<CouponProductRestrictionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CouponProductRestrictionCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<CouponProductRestrictionCreateWithoutProductInput>>;
  createMany?: InputMaybe<CouponProductRestrictionCreateManyProductInputEnvelope>;
};

export type CouponProductRestrictionCreateOrConnectWithoutCouponInput = {
  create: CouponProductRestrictionCreateWithoutCouponInput;
  where: CouponProductRestrictionWhereUniqueInput;
};

export type CouponProductRestrictionCreateOrConnectWithoutProductInput = {
  create: CouponProductRestrictionCreateWithoutProductInput;
  where: CouponProductRestrictionWhereUniqueInput;
};

export type CouponProductRestrictionCreateWithoutCouponInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  product: ProductCreateNestedOneWithoutCouponProductRestrictionsInput;
};

export type CouponProductRestrictionCreateWithoutProductInput = {
  coupon: CouponCreateNestedOneWithoutRestrictedToProductsInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CouponProductRestrictionListRelationFilter = {
  every?: InputMaybe<CouponProductRestrictionWhereInput>;
  none?: InputMaybe<CouponProductRestrictionWhereInput>;
  some?: InputMaybe<CouponProductRestrictionWhereInput>;
};

export type CouponProductRestrictionMaxOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type CouponProductRestrictionMinOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type CouponProductRestrictionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CouponProductRestrictionOrderByWithAggregationInput = {
  _count?: InputMaybe<CouponProductRestrictionCountOrderByAggregateInput>;
  _max?: InputMaybe<CouponProductRestrictionMaxOrderByAggregateInput>;
  _min?: InputMaybe<CouponProductRestrictionMinOrderByAggregateInput>;
  couponId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type CouponProductRestrictionOrderByWithRelationInput = {
  coupon?: InputMaybe<CouponOrderByWithRelationInput>;
  couponId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
};

export enum CouponProductRestrictionScalarFieldEnum {
  CouponId = 'couponId',
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  ProductId = 'productId'
}

export type CouponProductRestrictionScalarWhereInput = {
  AND?: InputMaybe<Array<CouponProductRestrictionScalarWhereInput>>;
  NOT?: InputMaybe<Array<CouponProductRestrictionScalarWhereInput>>;
  OR?: InputMaybe<Array<CouponProductRestrictionScalarWhereInput>>;
  couponId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  productId?: InputMaybe<StringFilter>;
};

export type CouponProductRestrictionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CouponProductRestrictionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CouponProductRestrictionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CouponProductRestrictionScalarWhereWithAggregatesInput>>;
  couponId?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  productId?: InputMaybe<StringWithAggregatesFilter>;
};

export type CouponProductRestrictionUpdateInput = {
  coupon?: InputMaybe<CouponUpdateOneRequiredWithoutRestrictedToProductsNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutCouponProductRestrictionsNestedInput>;
};

export type CouponProductRestrictionUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CouponProductRestrictionUpdateManyWithWhereWithoutCouponInput = {
  data: CouponProductRestrictionUpdateManyMutationInput;
  where: CouponProductRestrictionScalarWhereInput;
};

export type CouponProductRestrictionUpdateManyWithWhereWithoutProductInput = {
  data: CouponProductRestrictionUpdateManyMutationInput;
  where: CouponProductRestrictionScalarWhereInput;
};

export type CouponProductRestrictionUpdateManyWithoutCouponNestedInput = {
  connect?: InputMaybe<Array<CouponProductRestrictionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CouponProductRestrictionCreateOrConnectWithoutCouponInput>>;
  create?: InputMaybe<Array<CouponProductRestrictionCreateWithoutCouponInput>>;
  createMany?: InputMaybe<CouponProductRestrictionCreateManyCouponInputEnvelope>;
  delete?: InputMaybe<Array<CouponProductRestrictionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CouponProductRestrictionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CouponProductRestrictionWhereUniqueInput>>;
  set?: InputMaybe<Array<CouponProductRestrictionWhereUniqueInput>>;
  update?: InputMaybe<Array<CouponProductRestrictionUpdateWithWhereUniqueWithoutCouponInput>>;
  updateMany?: InputMaybe<Array<CouponProductRestrictionUpdateManyWithWhereWithoutCouponInput>>;
  upsert?: InputMaybe<Array<CouponProductRestrictionUpsertWithWhereUniqueWithoutCouponInput>>;
};

export type CouponProductRestrictionUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<CouponProductRestrictionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CouponProductRestrictionCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<CouponProductRestrictionCreateWithoutProductInput>>;
  createMany?: InputMaybe<CouponProductRestrictionCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<CouponProductRestrictionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CouponProductRestrictionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CouponProductRestrictionWhereUniqueInput>>;
  set?: InputMaybe<Array<CouponProductRestrictionWhereUniqueInput>>;
  update?: InputMaybe<Array<CouponProductRestrictionUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<CouponProductRestrictionUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<CouponProductRestrictionUpsertWithWhereUniqueWithoutProductInput>>;
};

export type CouponProductRestrictionUpdateWithWhereUniqueWithoutCouponInput = {
  data: CouponProductRestrictionUpdateWithoutCouponInput;
  where: CouponProductRestrictionWhereUniqueInput;
};

export type CouponProductRestrictionUpdateWithWhereUniqueWithoutProductInput = {
  data: CouponProductRestrictionUpdateWithoutProductInput;
  where: CouponProductRestrictionWhereUniqueInput;
};

export type CouponProductRestrictionUpdateWithoutCouponInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutCouponProductRestrictionsNestedInput>;
};

export type CouponProductRestrictionUpdateWithoutProductInput = {
  coupon?: InputMaybe<CouponUpdateOneRequiredWithoutRestrictedToProductsNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CouponProductRestrictionUpsertWithWhereUniqueWithoutCouponInput = {
  create: CouponProductRestrictionCreateWithoutCouponInput;
  update: CouponProductRestrictionUpdateWithoutCouponInput;
  where: CouponProductRestrictionWhereUniqueInput;
};

export type CouponProductRestrictionUpsertWithWhereUniqueWithoutProductInput = {
  create: CouponProductRestrictionCreateWithoutProductInput;
  update: CouponProductRestrictionUpdateWithoutProductInput;
  where: CouponProductRestrictionWhereUniqueInput;
};

export type CouponProductRestrictionWhereInput = {
  AND?: InputMaybe<Array<CouponProductRestrictionWhereInput>>;
  NOT?: InputMaybe<Array<CouponProductRestrictionWhereInput>>;
  OR?: InputMaybe<Array<CouponProductRestrictionWhereInput>>;
  coupon?: InputMaybe<CouponScalarRelationFilter>;
  couponId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<StringFilter>;
};

export type CouponProductRestrictionWhereUniqueInput = {
  AND?: InputMaybe<Array<CouponProductRestrictionWhereInput>>;
  NOT?: InputMaybe<Array<CouponProductRestrictionWhereInput>>;
  OR?: InputMaybe<Array<CouponProductRestrictionWhereInput>>;
  coupon?: InputMaybe<CouponScalarRelationFilter>;
  couponId?: InputMaybe<StringFilter>;
  couponProductRestriction?: InputMaybe<CouponProductRestrictionCouponProductRestrictionCompoundUniqueInput>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<StringFilter>;
};

export enum CouponScalarFieldEnum {
  Code = 'code',
  Created = 'created',
  Description = 'description',
  DiscountType = 'discountType',
  FixedAmountInCents = 'fixedAmountInCents',
  Id = 'id',
  IsArchived = 'isArchived',
  IsPublished = 'isPublished',
  MaxUses = 'maxUses',
  Modified = 'modified',
  Percentage = 'percentage',
  ValidFrom = 'validFrom',
  ValidTo = 'validTo'
}

export type CouponScalarRelationFilter = {
  is?: InputMaybe<CouponWhereInput>;
  isNot?: InputMaybe<CouponWhereInput>;
};

export type CouponScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CouponScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CouponScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CouponScalarWhereWithAggregatesInput>>;
  code?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  discountType?: InputMaybe<EnumCouponDiscountTypeWithAggregatesFilter>;
  fixedAmountInCents?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isArchived?: InputMaybe<BoolWithAggregatesFilter>;
  isPublished?: InputMaybe<BoolWithAggregatesFilter>;
  maxUses?: InputMaybe<IntNullableWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  percentage?: InputMaybe<FloatNullableWithAggregatesFilter>;
  validFrom?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  validTo?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type CouponSumOrderByAggregateInput = {
  fixedAmountInCents?: InputMaybe<SortOrder>;
  maxUses?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
};

export type CouponUpdateInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumCouponDiscountTypeFieldUpdateOperationsInput>;
  fixedAmountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maxUses?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  percentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  restrictedToProducts?: InputMaybe<CouponProductRestrictionUpdateManyWithoutCouponNestedInput>;
  usedInPayments?: InputMaybe<PaymentUpdateManyWithoutCouponNestedInput>;
  validFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CouponUpdateManyMutationInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumCouponDiscountTypeFieldUpdateOperationsInput>;
  fixedAmountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maxUses?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  percentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  validFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CouponUpdateOneRequiredWithoutRestrictedToProductsNestedInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutRestrictedToProductsInput>;
  create?: InputMaybe<CouponCreateWithoutRestrictedToProductsInput>;
  update?: InputMaybe<CouponUpdateToOneWithWhereWithoutRestrictedToProductsInput>;
  upsert?: InputMaybe<CouponUpsertWithoutRestrictedToProductsInput>;
};

export type CouponUpdateOneWithoutUsedInPaymentsNestedInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutUsedInPaymentsInput>;
  create?: InputMaybe<CouponCreateWithoutUsedInPaymentsInput>;
  delete?: InputMaybe<CouponWhereInput>;
  disconnect?: InputMaybe<CouponWhereInput>;
  update?: InputMaybe<CouponUpdateToOneWithWhereWithoutUsedInPaymentsInput>;
  upsert?: InputMaybe<CouponUpsertWithoutUsedInPaymentsInput>;
};

export type CouponUpdateToOneWithWhereWithoutRestrictedToProductsInput = {
  data: CouponUpdateWithoutRestrictedToProductsInput;
  where?: InputMaybe<CouponWhereInput>;
};

export type CouponUpdateToOneWithWhereWithoutUsedInPaymentsInput = {
  data: CouponUpdateWithoutUsedInPaymentsInput;
  where?: InputMaybe<CouponWhereInput>;
};

export type CouponUpdateWithoutRestrictedToProductsInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumCouponDiscountTypeFieldUpdateOperationsInput>;
  fixedAmountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maxUses?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  percentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  usedInPayments?: InputMaybe<PaymentUpdateManyWithoutCouponNestedInput>;
  validFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CouponUpdateWithoutUsedInPaymentsInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumCouponDiscountTypeFieldUpdateOperationsInput>;
  fixedAmountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maxUses?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  percentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  restrictedToProducts?: InputMaybe<CouponProductRestrictionUpdateManyWithoutCouponNestedInput>;
  validFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CouponUpsertWithoutRestrictedToProductsInput = {
  create: CouponCreateWithoutRestrictedToProductsInput;
  update: CouponUpdateWithoutRestrictedToProductsInput;
  where?: InputMaybe<CouponWhereInput>;
};

export type CouponUpsertWithoutUsedInPaymentsInput = {
  create: CouponCreateWithoutUsedInPaymentsInput;
  update: CouponUpdateWithoutUsedInPaymentsInput;
  where?: InputMaybe<CouponWhereInput>;
};

export type CouponWhereInput = {
  AND?: InputMaybe<Array<CouponWhereInput>>;
  NOT?: InputMaybe<Array<CouponWhereInput>>;
  OR?: InputMaybe<Array<CouponWhereInput>>;
  code?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discountType?: InputMaybe<EnumCouponDiscountTypeFilter>;
  fixedAmountInCents?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  maxUses?: InputMaybe<IntNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  percentage?: InputMaybe<FloatNullableFilter>;
  restrictedToProducts?: InputMaybe<CouponProductRestrictionListRelationFilter>;
  usedInPayments?: InputMaybe<PaymentListRelationFilter>;
  validFrom?: InputMaybe<DateTimeNullableFilter>;
  validTo?: InputMaybe<DateTimeNullableFilter>;
};

export type CouponWhereUniqueInput = {
  AND?: InputMaybe<Array<CouponWhereInput>>;
  NOT?: InputMaybe<Array<CouponWhereInput>>;
  OR?: InputMaybe<Array<CouponWhereInput>>;
  code?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discountType?: InputMaybe<EnumCouponDiscountTypeFilter>;
  fixedAmountInCents?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<BoolFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  maxUses?: InputMaybe<IntNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  percentage?: InputMaybe<FloatNullableFilter>;
  restrictedToProducts?: InputMaybe<CouponProductRestrictionListRelationFilter>;
  usedInPayments?: InputMaybe<PaymentListRelationFilter>;
  validFrom?: InputMaybe<DateTimeNullableFilter>;
  validTo?: InputMaybe<DateTimeNullableFilter>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DecimalFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Decimal']['input']>;
  divide?: InputMaybe<Scalars['Decimal']['input']>;
  increment?: InputMaybe<Scalars['Decimal']['input']>;
  multiply?: InputMaybe<Scalars['Decimal']['input']>;
  set?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DecimalWithAggregatesFilter = {
  _avg?: InputMaybe<NestedDecimalFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDecimalFilter>;
  _min?: InputMaybe<NestedDecimalFilter>;
  _sum?: InputMaybe<NestedDecimalFilter>;
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type EnumAcceptedCurrencyFieldUpdateOperationsInput = {
  set?: InputMaybe<AcceptedCurrency>;
};

export type EnumAcceptedCurrencyFilter = {
  equals?: InputMaybe<AcceptedCurrency>;
  in?: InputMaybe<Array<AcceptedCurrency>>;
  not?: InputMaybe<NestedEnumAcceptedCurrencyFilter>;
  notIn?: InputMaybe<Array<AcceptedCurrency>>;
};

export type EnumAcceptedCurrencyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAcceptedCurrencyFilter>;
  _min?: InputMaybe<NestedEnumAcceptedCurrencyFilter>;
  equals?: InputMaybe<AcceptedCurrency>;
  in?: InputMaybe<Array<AcceptedCurrency>>;
  not?: InputMaybe<NestedEnumAcceptedCurrencyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AcceptedCurrency>>;
};

export type EnumBrandingTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<BrandingType>;
};

export type EnumBrandingTypeFilter = {
  equals?: InputMaybe<BrandingType>;
  in?: InputMaybe<Array<BrandingType>>;
  not?: InputMaybe<NestedEnumBrandingTypeFilter>;
  notIn?: InputMaybe<Array<BrandingType>>;
};

export type EnumBrandingTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBrandingTypeFilter>;
  _min?: InputMaybe<NestedEnumBrandingTypeFilter>;
  equals?: InputMaybe<BrandingType>;
  in?: InputMaybe<Array<BrandingType>>;
  not?: InputMaybe<NestedEnumBrandingTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BrandingType>>;
};

export type EnumCouponDiscountTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CouponDiscountType>;
};

export type EnumCouponDiscountTypeFilter = {
  equals?: InputMaybe<CouponDiscountType>;
  in?: InputMaybe<Array<CouponDiscountType>>;
  not?: InputMaybe<NestedEnumCouponDiscountTypeFilter>;
  notIn?: InputMaybe<Array<CouponDiscountType>>;
};

export type EnumCouponDiscountTypeNullableFilter = {
  equals?: InputMaybe<CouponDiscountType>;
  in?: InputMaybe<Array<CouponDiscountType>>;
  not?: InputMaybe<NestedEnumCouponDiscountTypeNullableFilter>;
  notIn?: InputMaybe<Array<CouponDiscountType>>;
};

export type EnumCouponDiscountTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCouponDiscountTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumCouponDiscountTypeNullableFilter>;
  equals?: InputMaybe<CouponDiscountType>;
  in?: InputMaybe<Array<CouponDiscountType>>;
  not?: InputMaybe<NestedEnumCouponDiscountTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CouponDiscountType>>;
};

export type EnumCouponDiscountTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCouponDiscountTypeFilter>;
  _min?: InputMaybe<NestedEnumCouponDiscountTypeFilter>;
  equals?: InputMaybe<CouponDiscountType>;
  in?: InputMaybe<Array<CouponDiscountType>>;
  not?: InputMaybe<NestedEnumCouponDiscountTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CouponDiscountType>>;
};

export type EnumLearningStyleFieldUpdateOperationsInput = {
  set?: InputMaybe<LearningStyle>;
};

export type EnumLearningStyleFilter = {
  equals?: InputMaybe<LearningStyle>;
  in?: InputMaybe<Array<LearningStyle>>;
  not?: InputMaybe<NestedEnumLearningStyleFilter>;
  notIn?: InputMaybe<Array<LearningStyle>>;
};

export type EnumLearningStyleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumLearningStyleFilter>;
  _min?: InputMaybe<NestedEnumLearningStyleFilter>;
  equals?: InputMaybe<LearningStyle>;
  in?: InputMaybe<Array<LearningStyle>>;
  not?: InputMaybe<NestedEnumLearningStyleWithAggregatesFilter>;
  notIn?: InputMaybe<Array<LearningStyle>>;
};

export type EnumPaymentDiscountSourceNullableFilter = {
  equals?: InputMaybe<PaymentDiscountSource>;
  in?: InputMaybe<Array<PaymentDiscountSource>>;
  not?: InputMaybe<NestedEnumPaymentDiscountSourceNullableFilter>;
  notIn?: InputMaybe<Array<PaymentDiscountSource>>;
};

export type EnumPaymentDiscountSourceNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPaymentDiscountSourceNullableFilter>;
  _min?: InputMaybe<NestedEnumPaymentDiscountSourceNullableFilter>;
  equals?: InputMaybe<PaymentDiscountSource>;
  in?: InputMaybe<Array<PaymentDiscountSource>>;
  not?: InputMaybe<NestedEnumPaymentDiscountSourceNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentDiscountSource>>;
};

export type EnumPromptFrequencyFieldUpdateOperationsInput = {
  set?: InputMaybe<PromptFrequency>;
};

export type EnumPromptFrequencyFilter = {
  equals?: InputMaybe<PromptFrequency>;
  in?: InputMaybe<Array<PromptFrequency>>;
  not?: InputMaybe<NestedEnumPromptFrequencyFilter>;
  notIn?: InputMaybe<Array<PromptFrequency>>;
};

export type EnumPromptFrequencyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPromptFrequencyFilter>;
  _min?: InputMaybe<NestedEnumPromptFrequencyFilter>;
  equals?: InputMaybe<PromptFrequency>;
  in?: InputMaybe<Array<PromptFrequency>>;
  not?: InputMaybe<NestedEnumPromptFrequencyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PromptFrequency>>;
};

export type EnumRoleFieldUpdateOperationsInput = {
  set?: InputMaybe<Role>;
};

export type EnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type EnumRoleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumRoleFilter>;
  _min?: InputMaybe<NestedEnumRoleFilter>;
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type EnumStripePaymentIntentStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<StripePaymentIntentStatus>;
};

export type EnumStripePaymentIntentStatusFilter = {
  equals?: InputMaybe<StripePaymentIntentStatus>;
  in?: InputMaybe<Array<StripePaymentIntentStatus>>;
  not?: InputMaybe<NestedEnumStripePaymentIntentStatusFilter>;
  notIn?: InputMaybe<Array<StripePaymentIntentStatus>>;
};

export type EnumStripePaymentIntentStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumStripePaymentIntentStatusFilter>;
  _min?: InputMaybe<NestedEnumStripePaymentIntentStatusFilter>;
  equals?: InputMaybe<StripePaymentIntentStatus>;
  in?: InputMaybe<Array<StripePaymentIntentStatus>>;
  not?: InputMaybe<NestedEnumStripePaymentIntentStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<StripePaymentIntentStatus>>;
};

export type EnumTemplateTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<TemplateType>;
};

export type EnumTemplateTypeFilter = {
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export type EnumTemplateTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumTemplateTypeFilter>;
  _min?: InputMaybe<NestedEnumTemplateTypeFilter>;
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export type EnumUpgradeDurationModeFieldUpdateOperationsInput = {
  set?: InputMaybe<UpgradeDurationMode>;
};

export type EnumUpgradeDurationModeFilter = {
  equals?: InputMaybe<UpgradeDurationMode>;
  in?: InputMaybe<Array<UpgradeDurationMode>>;
  not?: InputMaybe<NestedEnumUpgradeDurationModeFilter>;
  notIn?: InputMaybe<Array<UpgradeDurationMode>>;
};

export type EnumUpgradeDurationModeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUpgradeDurationModeFilter>;
  _min?: InputMaybe<NestedEnumUpgradeDurationModeFilter>;
  equals?: InputMaybe<UpgradeDurationMode>;
  in?: InputMaybe<Array<UpgradeDurationMode>>;
  not?: InputMaybe<NestedEnumUpgradeDurationModeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UpgradeDurationMode>>;
};

export type EnumUpgradePromptTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UpgradePromptType>;
};

export type EnumUpgradePromptTypeFilter = {
  equals?: InputMaybe<UpgradePromptType>;
  in?: InputMaybe<Array<UpgradePromptType>>;
  not?: InputMaybe<NestedEnumUpgradePromptTypeFilter>;
  notIn?: InputMaybe<Array<UpgradePromptType>>;
};

export type EnumUpgradePromptTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUpgradePromptTypeFilter>;
  _min?: InputMaybe<NestedEnumUpgradePromptTypeFilter>;
  equals?: InputMaybe<UpgradePromptType>;
  in?: InputMaybe<Array<UpgradePromptType>>;
  not?: InputMaybe<NestedEnumUpgradePromptTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UpgradePromptType>>;
};

export type EnumUpgradeTypeNullableFilter = {
  equals?: InputMaybe<UpgradeType>;
  in?: InputMaybe<Array<UpgradeType>>;
  not?: InputMaybe<NestedEnumUpgradeTypeNullableFilter>;
  notIn?: InputMaybe<Array<UpgradeType>>;
};

export type EnumUpgradeTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumUpgradeTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumUpgradeTypeNullableFilter>;
  equals?: InputMaybe<UpgradeType>;
  in?: InputMaybe<Array<UpgradeType>>;
  not?: InputMaybe<NestedEnumUpgradeTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UpgradeType>>;
};

export type EnumUserArticleActionFieldUpdateOperationsInput = {
  set?: InputMaybe<UserArticleAction>;
};

export type EnumUserArticleActionFilter = {
  equals?: InputMaybe<UserArticleAction>;
  in?: InputMaybe<Array<UserArticleAction>>;
  not?: InputMaybe<NestedEnumUserArticleActionFilter>;
  notIn?: InputMaybe<Array<UserArticleAction>>;
};

export type EnumUserArticleActionWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUserArticleActionFilter>;
  _min?: InputMaybe<NestedEnumUserArticleActionFilter>;
  equals?: InputMaybe<UserArticleAction>;
  in?: InputMaybe<Array<UserArticleAction>>;
  not?: InputMaybe<NestedEnumUserArticleActionWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UserArticleAction>>;
};

export type EventAttendanceAvgOrderByAggregateInput = {
  contributionsMade?: InputMaybe<SortOrder>;
};

export type EventAttendanceCountOrderByAggregateInput = {
  contributions?: InputMaybe<SortOrder>;
  contributionsMade?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type EventAttendanceCreateInput = {
  contributions: Scalars['JSON']['input'];
  contributionsMade?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventOccurrence?: InputMaybe<EventOccurrenceCreateNestedOneWithoutEventAttendeesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutEventAttendancesInput;
};

export type EventAttendanceCreateManyEventOccurrenceInput = {
  contributions: Scalars['JSON']['input'];
  contributionsMade?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type EventAttendanceCreateManyEventOccurrenceInputEnvelope = {
  data: Array<EventAttendanceCreateManyEventOccurrenceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventAttendanceCreateManyInput = {
  contributions: Scalars['JSON']['input'];
  contributionsMade?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventOccurrenceId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type EventAttendanceCreateManyUserInput = {
  contributions: Scalars['JSON']['input'];
  contributionsMade?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventOccurrenceId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventAttendanceCreateManyUserInputEnvelope = {
  data: Array<EventAttendanceCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventAttendanceCreateNestedManyWithoutEventOccurrenceInput = {
  connect?: InputMaybe<Array<EventAttendanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventAttendanceCreateOrConnectWithoutEventOccurrenceInput>>;
  create?: InputMaybe<Array<EventAttendanceCreateWithoutEventOccurrenceInput>>;
  createMany?: InputMaybe<EventAttendanceCreateManyEventOccurrenceInputEnvelope>;
};

export type EventAttendanceCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<EventAttendanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventAttendanceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<EventAttendanceCreateWithoutUserInput>>;
  createMany?: InputMaybe<EventAttendanceCreateManyUserInputEnvelope>;
};

export type EventAttendanceCreateOrConnectWithoutEventOccurrenceInput = {
  create: EventAttendanceCreateWithoutEventOccurrenceInput;
  where: EventAttendanceWhereUniqueInput;
};

export type EventAttendanceCreateOrConnectWithoutUserInput = {
  create: EventAttendanceCreateWithoutUserInput;
  where: EventAttendanceWhereUniqueInput;
};

export type EventAttendanceCreateWithoutEventOccurrenceInput = {
  contributions: Scalars['JSON']['input'];
  contributionsMade?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutEventAttendancesInput;
};

export type EventAttendanceCreateWithoutUserInput = {
  contributions: Scalars['JSON']['input'];
  contributionsMade?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventOccurrence?: InputMaybe<EventOccurrenceCreateNestedOneWithoutEventAttendeesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventAttendanceListRelationFilter = {
  every?: InputMaybe<EventAttendanceWhereInput>;
  none?: InputMaybe<EventAttendanceWhereInput>;
  some?: InputMaybe<EventAttendanceWhereInput>;
};

export type EventAttendanceMaxOrderByAggregateInput = {
  contributionsMade?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type EventAttendanceMinOrderByAggregateInput = {
  contributionsMade?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type EventAttendanceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventAttendanceOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventAttendanceAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventAttendanceCountOrderByAggregateInput>;
  _max?: InputMaybe<EventAttendanceMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventAttendanceMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventAttendanceSumOrderByAggregateInput>;
  contributions?: InputMaybe<SortOrder>;
  contributionsMade?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type EventAttendanceOrderByWithRelationInput = {
  contributions?: InputMaybe<SortOrder>;
  contributionsMade?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  eventOccurrence?: InputMaybe<EventOccurrenceOrderByWithRelationInput>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum EventAttendanceScalarFieldEnum {
  Contributions = 'contributions',
  ContributionsMade = 'contributionsMade',
  Created = 'created',
  EventOccurrenceId = 'eventOccurrenceId',
  Id = 'id',
  Modified = 'modified',
  UserId = 'userId'
}

export type EventAttendanceScalarWhereInput = {
  AND?: InputMaybe<Array<EventAttendanceScalarWhereInput>>;
  NOT?: InputMaybe<Array<EventAttendanceScalarWhereInput>>;
  OR?: InputMaybe<Array<EventAttendanceScalarWhereInput>>;
  contributions?: InputMaybe<JsonFilter>;
  contributionsMade?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeFilter>;
  eventOccurrenceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type EventAttendanceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EventAttendanceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EventAttendanceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EventAttendanceScalarWhereWithAggregatesInput>>;
  contributions?: InputMaybe<JsonWithAggregatesFilter>;
  contributionsMade?: InputMaybe<IntWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventOccurrenceId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type EventAttendanceSumOrderByAggregateInput = {
  contributionsMade?: InputMaybe<SortOrder>;
};

export type EventAttendanceUpdateInput = {
  contributions?: InputMaybe<Scalars['JSON']['input']>;
  contributionsMade?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventOccurrence?: InputMaybe<EventOccurrenceUpdateOneWithoutEventAttendeesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutEventAttendancesNestedInput>;
};

export type EventAttendanceUpdateManyMutationInput = {
  contributions?: InputMaybe<Scalars['JSON']['input']>;
  contributionsMade?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EventAttendanceUpdateManyWithWhereWithoutEventOccurrenceInput = {
  data: EventAttendanceUpdateManyMutationInput;
  where: EventAttendanceScalarWhereInput;
};

export type EventAttendanceUpdateManyWithWhereWithoutUserInput = {
  data: EventAttendanceUpdateManyMutationInput;
  where: EventAttendanceScalarWhereInput;
};

export type EventAttendanceUpdateManyWithoutEventOccurrenceNestedInput = {
  connect?: InputMaybe<Array<EventAttendanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventAttendanceCreateOrConnectWithoutEventOccurrenceInput>>;
  create?: InputMaybe<Array<EventAttendanceCreateWithoutEventOccurrenceInput>>;
  createMany?: InputMaybe<EventAttendanceCreateManyEventOccurrenceInputEnvelope>;
  delete?: InputMaybe<Array<EventAttendanceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventAttendanceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventAttendanceWhereUniqueInput>>;
  set?: InputMaybe<Array<EventAttendanceWhereUniqueInput>>;
  update?: InputMaybe<Array<EventAttendanceUpdateWithWhereUniqueWithoutEventOccurrenceInput>>;
  updateMany?: InputMaybe<Array<EventAttendanceUpdateManyWithWhereWithoutEventOccurrenceInput>>;
  upsert?: InputMaybe<Array<EventAttendanceUpsertWithWhereUniqueWithoutEventOccurrenceInput>>;
};

export type EventAttendanceUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<EventAttendanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventAttendanceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<EventAttendanceCreateWithoutUserInput>>;
  createMany?: InputMaybe<EventAttendanceCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<EventAttendanceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventAttendanceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventAttendanceWhereUniqueInput>>;
  set?: InputMaybe<Array<EventAttendanceWhereUniqueInput>>;
  update?: InputMaybe<Array<EventAttendanceUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<EventAttendanceUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<EventAttendanceUpsertWithWhereUniqueWithoutUserInput>>;
};

export type EventAttendanceUpdateWithWhereUniqueWithoutEventOccurrenceInput = {
  data: EventAttendanceUpdateWithoutEventOccurrenceInput;
  where: EventAttendanceWhereUniqueInput;
};

export type EventAttendanceUpdateWithWhereUniqueWithoutUserInput = {
  data: EventAttendanceUpdateWithoutUserInput;
  where: EventAttendanceWhereUniqueInput;
};

export type EventAttendanceUpdateWithoutEventOccurrenceInput = {
  contributions?: InputMaybe<Scalars['JSON']['input']>;
  contributionsMade?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutEventAttendancesNestedInput>;
};

export type EventAttendanceUpdateWithoutUserInput = {
  contributions?: InputMaybe<Scalars['JSON']['input']>;
  contributionsMade?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventOccurrence?: InputMaybe<EventOccurrenceUpdateOneWithoutEventAttendeesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EventAttendanceUpsertWithWhereUniqueWithoutEventOccurrenceInput = {
  create: EventAttendanceCreateWithoutEventOccurrenceInput;
  update: EventAttendanceUpdateWithoutEventOccurrenceInput;
  where: EventAttendanceWhereUniqueInput;
};

export type EventAttendanceUpsertWithWhereUniqueWithoutUserInput = {
  create: EventAttendanceCreateWithoutUserInput;
  update: EventAttendanceUpdateWithoutUserInput;
  where: EventAttendanceWhereUniqueInput;
};

export type EventAttendanceWhereInput = {
  AND?: InputMaybe<Array<EventAttendanceWhereInput>>;
  NOT?: InputMaybe<Array<EventAttendanceWhereInput>>;
  OR?: InputMaybe<Array<EventAttendanceWhereInput>>;
  contributions?: InputMaybe<JsonFilter>;
  contributionsMade?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeFilter>;
  eventOccurrence?: InputMaybe<EventOccurrenceNullableScalarRelationFilter>;
  eventOccurrenceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type EventAttendanceWhereUniqueInput = {
  AND?: InputMaybe<Array<EventAttendanceWhereInput>>;
  NOT?: InputMaybe<Array<EventAttendanceWhereInput>>;
  OR?: InputMaybe<Array<EventAttendanceWhereInput>>;
  contributions?: InputMaybe<JsonFilter>;
  contributionsMade?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeFilter>;
  eventOccurrence?: InputMaybe<EventOccurrenceNullableScalarRelationFilter>;
  eventOccurrenceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type EventAvgOrderByAggregateInput = {
  maxRegistrations?: InputMaybe<SortOrder>;
};

export type EventCategoryAvgOrderByAggregateInput = {
  minContributions?: InputMaybe<SortOrder>;
  minHours?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type EventCategoryCountOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  contributionName?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  minContributions?: InputMaybe<SortOrder>;
  minHours?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type EventCategoryCreateInput = {
  category: CategoryCreateNestedOneWithoutCategoryEventsInput;
  contributionName?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event: EventCreateNestedOneWithoutEventCategoriesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  minContributions?: InputMaybe<Scalars['Int']['input']>;
  minHours?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type EventCategoryCreateManyCategoryInput = {
  contributionName?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  minContributions?: InputMaybe<Scalars['Int']['input']>;
  minHours?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type EventCategoryCreateManyCategoryInputEnvelope = {
  data: Array<EventCategoryCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventCategoryCreateManyEventInput = {
  categoryId: Scalars['String']['input'];
  contributionName?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  minContributions?: InputMaybe<Scalars['Int']['input']>;
  minHours?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type EventCategoryCreateManyEventInputEnvelope = {
  data: Array<EventCategoryCreateManyEventInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventCategoryCreateManyInput = {
  categoryId: Scalars['String']['input'];
  contributionName?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  minContributions?: InputMaybe<Scalars['Int']['input']>;
  minHours?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type EventCategoryCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<EventCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventCategoryCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<EventCategoryCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<EventCategoryCreateManyCategoryInputEnvelope>;
};

export type EventCategoryCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<EventCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventCategoryCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<EventCategoryCreateWithoutEventInput>>;
  createMany?: InputMaybe<EventCategoryCreateManyEventInputEnvelope>;
};

export type EventCategoryCreateOrConnectWithoutCategoryInput = {
  create: EventCategoryCreateWithoutCategoryInput;
  where: EventCategoryWhereUniqueInput;
};

export type EventCategoryCreateOrConnectWithoutEventInput = {
  create: EventCategoryCreateWithoutEventInput;
  where: EventCategoryWhereUniqueInput;
};

export type EventCategoryCreateWithoutCategoryInput = {
  contributionName?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event: EventCreateNestedOneWithoutEventCategoriesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  minContributions?: InputMaybe<Scalars['Int']['input']>;
  minHours?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type EventCategoryCreateWithoutEventInput = {
  category: CategoryCreateNestedOneWithoutCategoryEventsInput;
  contributionName?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  minContributions?: InputMaybe<Scalars['Int']['input']>;
  minHours?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type EventCategoryEventCategoryCompoundUniqueInput = {
  categoryId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};

export type EventCategoryListRelationFilter = {
  every?: InputMaybe<EventCategoryWhereInput>;
  none?: InputMaybe<EventCategoryWhereInput>;
  some?: InputMaybe<EventCategoryWhereInput>;
};

export type EventCategoryMaxOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  contributionName?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  minContributions?: InputMaybe<SortOrder>;
  minHours?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type EventCategoryMinOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  contributionName?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  minContributions?: InputMaybe<SortOrder>;
  minHours?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type EventCategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventCategoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventCategoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventCategoryCountOrderByAggregateInput>;
  _max?: InputMaybe<EventCategoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventCategoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventCategorySumOrderByAggregateInput>;
  categoryId?: InputMaybe<SortOrder>;
  contributionName?: InputMaybe<SortOrderInput>;
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  minContributions?: InputMaybe<SortOrderInput>;
  minHours?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type EventCategoryOrderByWithRelationInput = {
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  contributionName?: InputMaybe<SortOrderInput>;
  created?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  minContributions?: InputMaybe<SortOrderInput>;
  minHours?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum EventCategoryScalarFieldEnum {
  CategoryId = 'categoryId',
  ContributionName = 'contributionName',
  Created = 'created',
  EventId = 'eventId',
  Id = 'id',
  IsPinned = 'isPinned',
  IsRequired = 'isRequired',
  MinContributions = 'minContributions',
  MinHours = 'minHours',
  Modified = 'modified',
  SortOrder = 'sortOrder'
}

export type EventCategoryScalarWhereInput = {
  AND?: InputMaybe<Array<EventCategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<EventCategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<EventCategoryScalarWhereInput>>;
  categoryId?: InputMaybe<StringFilter>;
  contributionName?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  minContributions?: InputMaybe<IntNullableFilter>;
  minHours?: InputMaybe<FloatNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type EventCategoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EventCategoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EventCategoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EventCategoryScalarWhereWithAggregatesInput>>;
  categoryId?: InputMaybe<StringWithAggregatesFilter>;
  contributionName?: InputMaybe<StringNullableWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isPinned?: InputMaybe<BoolWithAggregatesFilter>;
  isRequired?: InputMaybe<BoolWithAggregatesFilter>;
  minContributions?: InputMaybe<IntNullableWithAggregatesFilter>;
  minHours?: InputMaybe<FloatNullableWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  sortOrder?: InputMaybe<IntWithAggregatesFilter>;
};

export type EventCategorySumOrderByAggregateInput = {
  minContributions?: InputMaybe<SortOrder>;
  minHours?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type EventCategoryUpdateInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutCategoryEventsNestedInput>;
  contributionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventCategoriesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minContributions?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minHours?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EventCategoryUpdateManyMutationInput = {
  contributionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minContributions?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minHours?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EventCategoryUpdateManyWithWhereWithoutCategoryInput = {
  data: EventCategoryUpdateManyMutationInput;
  where: EventCategoryScalarWhereInput;
};

export type EventCategoryUpdateManyWithWhereWithoutEventInput = {
  data: EventCategoryUpdateManyMutationInput;
  where: EventCategoryScalarWhereInput;
};

export type EventCategoryUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<EventCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventCategoryCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<EventCategoryCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<EventCategoryCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<EventCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EventCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EventCategoryUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<EventCategoryUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<EventCategoryUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type EventCategoryUpdateManyWithoutEventNestedInput = {
  connect?: InputMaybe<Array<EventCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventCategoryCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<EventCategoryCreateWithoutEventInput>>;
  createMany?: InputMaybe<EventCategoryCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<EventCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EventCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EventCategoryUpdateWithWhereUniqueWithoutEventInput>>;
  updateMany?: InputMaybe<Array<EventCategoryUpdateManyWithWhereWithoutEventInput>>;
  upsert?: InputMaybe<Array<EventCategoryUpsertWithWhereUniqueWithoutEventInput>>;
};

export type EventCategoryUpdateWithWhereUniqueWithoutCategoryInput = {
  data: EventCategoryUpdateWithoutCategoryInput;
  where: EventCategoryWhereUniqueInput;
};

export type EventCategoryUpdateWithWhereUniqueWithoutEventInput = {
  data: EventCategoryUpdateWithoutEventInput;
  where: EventCategoryWhereUniqueInput;
};

export type EventCategoryUpdateWithoutCategoryInput = {
  contributionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventCategoriesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minContributions?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minHours?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EventCategoryUpdateWithoutEventInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutCategoryEventsNestedInput>;
  contributionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minContributions?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minHours?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EventCategoryUpsertWithWhereUniqueWithoutCategoryInput = {
  create: EventCategoryCreateWithoutCategoryInput;
  update: EventCategoryUpdateWithoutCategoryInput;
  where: EventCategoryWhereUniqueInput;
};

export type EventCategoryUpsertWithWhereUniqueWithoutEventInput = {
  create: EventCategoryCreateWithoutEventInput;
  update: EventCategoryUpdateWithoutEventInput;
  where: EventCategoryWhereUniqueInput;
};

export type EventCategoryWhereInput = {
  AND?: InputMaybe<Array<EventCategoryWhereInput>>;
  NOT?: InputMaybe<Array<EventCategoryWhereInput>>;
  OR?: InputMaybe<Array<EventCategoryWhereInput>>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  contributionName?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  event?: InputMaybe<EventScalarRelationFilter>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  minContributions?: InputMaybe<IntNullableFilter>;
  minHours?: InputMaybe<FloatNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type EventCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<EventCategoryWhereInput>>;
  NOT?: InputMaybe<Array<EventCategoryWhereInput>>;
  OR?: InputMaybe<Array<EventCategoryWhereInput>>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  contributionName?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  event?: InputMaybe<EventScalarRelationFilter>;
  eventCategory?: InputMaybe<EventCategoryEventCategoryCompoundUniqueInput>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  minContributions?: InputMaybe<IntNullableFilter>;
  minHours?: InputMaybe<FloatNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type EventContentAvgOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type EventContentCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type EventContentCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  event: EventCreateNestedOneWithoutEventContentsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventContentCreateManyEventInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventContentCreateManyEventInputEnvelope = {
  data: Array<EventContentCreateManyEventInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventContentCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventContentCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<EventContentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventContentCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<EventContentCreateWithoutEventInput>>;
  createMany?: InputMaybe<EventContentCreateManyEventInputEnvelope>;
};

export type EventContentCreateOrConnectWithoutEventInput = {
  create: EventContentCreateWithoutEventInput;
  where: EventContentWhereUniqueInput;
};

export type EventContentCreateWithoutEventInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventContentListRelationFilter = {
  every?: InputMaybe<EventContentWhereInput>;
  none?: InputMaybe<EventContentWhereInput>;
  some?: InputMaybe<EventContentWhereInput>;
};

export type EventContentMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type EventContentMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type EventContentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventContentOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventContentAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventContentCountOrderByAggregateInput>;
  _max?: InputMaybe<EventContentMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventContentMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventContentSumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
};

export type EventContentOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
};

export enum EventContentScalarFieldEnum {
  Created = 'created',
  Description = 'description',
  EventId = 'eventId',
  Id = 'id',
  ImageUrl = 'imageUrl',
  Modified = 'modified',
  SortOrder = 'sortOrder',
  Subtitle = 'subtitle',
  Title = 'title'
}

export type EventContentScalarWhereInput = {
  AND?: InputMaybe<Array<EventContentScalarWhereInput>>;
  NOT?: InputMaybe<Array<EventContentScalarWhereInput>>;
  OR?: InputMaybe<Array<EventContentScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
  subtitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type EventContentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EventContentScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EventContentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EventContentScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  eventId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imageUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  sortOrder?: InputMaybe<IntWithAggregatesFilter>;
  subtitle?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type EventContentSumOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type EventContentUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventContentsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventContentUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventContentUpdateManyWithWhereWithoutEventInput = {
  data: EventContentUpdateManyMutationInput;
  where: EventContentScalarWhereInput;
};

export type EventContentUpdateManyWithoutEventNestedInput = {
  connect?: InputMaybe<Array<EventContentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventContentCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<EventContentCreateWithoutEventInput>>;
  createMany?: InputMaybe<EventContentCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<EventContentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventContentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventContentWhereUniqueInput>>;
  set?: InputMaybe<Array<EventContentWhereUniqueInput>>;
  update?: InputMaybe<Array<EventContentUpdateWithWhereUniqueWithoutEventInput>>;
  updateMany?: InputMaybe<Array<EventContentUpdateManyWithWhereWithoutEventInput>>;
  upsert?: InputMaybe<Array<EventContentUpsertWithWhereUniqueWithoutEventInput>>;
};

export type EventContentUpdateWithWhereUniqueWithoutEventInput = {
  data: EventContentUpdateWithoutEventInput;
  where: EventContentWhereUniqueInput;
};

export type EventContentUpdateWithoutEventInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventContentUpsertWithWhereUniqueWithoutEventInput = {
  create: EventContentCreateWithoutEventInput;
  update: EventContentUpdateWithoutEventInput;
  where: EventContentWhereUniqueInput;
};

export type EventContentWhereInput = {
  AND?: InputMaybe<Array<EventContentWhereInput>>;
  NOT?: InputMaybe<Array<EventContentWhereInput>>;
  OR?: InputMaybe<Array<EventContentWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  event?: InputMaybe<EventScalarRelationFilter>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
  subtitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type EventContentWhereUniqueInput = {
  AND?: InputMaybe<Array<EventContentWhereInput>>;
  NOT?: InputMaybe<Array<EventContentWhereInput>>;
  OR?: InputMaybe<Array<EventContentWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  event?: InputMaybe<EventScalarRelationFilter>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
  subtitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type EventCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxRegistrations?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type EventCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  eventCategories?: InputMaybe<EventCategoryCreateNestedManyWithoutEventInput>;
  eventContents?: InputMaybe<EventContentCreateNestedManyWithoutEventInput>;
  eventOccurrences?: InputMaybe<EventOccurrenceCreateNestedManyWithoutEventInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productEvents?: InputMaybe<ProductEventCreateNestedManyWithoutEventInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type EventCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type EventCreateNestedOneWithoutEventCategoriesInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventCategoriesInput>;
  create?: InputMaybe<EventCreateWithoutEventCategoriesInput>;
};

export type EventCreateNestedOneWithoutEventContentsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventContentsInput>;
  create?: InputMaybe<EventCreateWithoutEventContentsInput>;
};

export type EventCreateNestedOneWithoutEventOccurrencesInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventOccurrencesInput>;
  create?: InputMaybe<EventCreateWithoutEventOccurrencesInput>;
};

export type EventCreateNestedOneWithoutProductEventsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutProductEventsInput>;
  create?: InputMaybe<EventCreateWithoutProductEventsInput>;
};

export type EventCreateOrConnectWithoutEventCategoriesInput = {
  create: EventCreateWithoutEventCategoriesInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutEventContentsInput = {
  create: EventCreateWithoutEventContentsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutEventOccurrencesInput = {
  create: EventCreateWithoutEventOccurrencesInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutProductEventsInput = {
  create: EventCreateWithoutProductEventsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateWithoutEventCategoriesInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  eventContents?: InputMaybe<EventContentCreateNestedManyWithoutEventInput>;
  eventOccurrences?: InputMaybe<EventOccurrenceCreateNestedManyWithoutEventInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productEvents?: InputMaybe<ProductEventCreateNestedManyWithoutEventInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type EventCreateWithoutEventContentsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  eventCategories?: InputMaybe<EventCategoryCreateNestedManyWithoutEventInput>;
  eventOccurrences?: InputMaybe<EventOccurrenceCreateNestedManyWithoutEventInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productEvents?: InputMaybe<ProductEventCreateNestedManyWithoutEventInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type EventCreateWithoutEventOccurrencesInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  eventCategories?: InputMaybe<EventCategoryCreateNestedManyWithoutEventInput>;
  eventContents?: InputMaybe<EventContentCreateNestedManyWithoutEventInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productEvents?: InputMaybe<ProductEventCreateNestedManyWithoutEventInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type EventCreateWithoutProductEventsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  eventCategories?: InputMaybe<EventCategoryCreateNestedManyWithoutEventInput>;
  eventContents?: InputMaybe<EventContentCreateNestedManyWithoutEventInput>;
  eventOccurrences?: InputMaybe<EventOccurrenceCreateNestedManyWithoutEventInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type EventMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxRegistrations?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type EventMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxRegistrations?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type EventOccurrenceAvgOrderByAggregateInput = {
  maxRegistrations?: InputMaybe<SortOrder>;
};

export type EventOccurrenceContentAvgOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type EventOccurrenceContentCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
};

export type EventOccurrenceContentCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventOccurrence: EventOccurrenceCreateNestedOneWithoutEventOccurrenceContentsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
};

export type EventOccurrenceContentCreateManyEventOccurrenceInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
};

export type EventOccurrenceContentCreateManyEventOccurrenceInputEnvelope = {
  data: Array<EventOccurrenceContentCreateManyEventOccurrenceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventOccurrenceContentCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventOccurrenceId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
};

export type EventOccurrenceContentCreateNestedManyWithoutEventOccurrenceInput = {
  connect?: InputMaybe<Array<EventOccurrenceContentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventOccurrenceContentCreateOrConnectWithoutEventOccurrenceInput>>;
  create?: InputMaybe<Array<EventOccurrenceContentCreateWithoutEventOccurrenceInput>>;
  createMany?: InputMaybe<EventOccurrenceContentCreateManyEventOccurrenceInputEnvelope>;
};

export type EventOccurrenceContentCreateOrConnectWithoutEventOccurrenceInput = {
  create: EventOccurrenceContentCreateWithoutEventOccurrenceInput;
  where: EventOccurrenceContentWhereUniqueInput;
};

export type EventOccurrenceContentCreateWithoutEventOccurrenceInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
};

export type EventOccurrenceContentListRelationFilter = {
  every?: InputMaybe<EventOccurrenceContentWhereInput>;
  none?: InputMaybe<EventOccurrenceContentWhereInput>;
  some?: InputMaybe<EventOccurrenceContentWhereInput>;
};

export type EventOccurrenceContentMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
};

export type EventOccurrenceContentMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
};

export type EventOccurrenceContentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventOccurrenceContentOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventOccurrenceContentAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventOccurrenceContentCountOrderByAggregateInput>;
  _max?: InputMaybe<EventOccurrenceContentMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventOccurrenceContentMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventOccurrenceContentSumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrderInput>;
};

export type EventOccurrenceContentOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  eventOccurrence?: InputMaybe<EventOccurrenceOrderByWithRelationInput>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrderInput>;
};

export enum EventOccurrenceContentScalarFieldEnum {
  Created = 'created',
  Description = 'description',
  EventOccurrenceId = 'eventOccurrenceId',
  Id = 'id',
  ImageUrl = 'imageUrl',
  Modified = 'modified',
  SortOrder = 'sortOrder',
  Subtitle = 'subtitle'
}

export type EventOccurrenceContentScalarWhereInput = {
  AND?: InputMaybe<Array<EventOccurrenceContentScalarWhereInput>>;
  NOT?: InputMaybe<Array<EventOccurrenceContentScalarWhereInput>>;
  OR?: InputMaybe<Array<EventOccurrenceContentScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  eventOccurrenceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
  subtitle?: InputMaybe<StringNullableFilter>;
};

export type EventOccurrenceContentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EventOccurrenceContentScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EventOccurrenceContentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EventOccurrenceContentScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  eventOccurrenceId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imageUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  sortOrder?: InputMaybe<IntWithAggregatesFilter>;
  subtitle?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type EventOccurrenceContentSumOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type EventOccurrenceContentUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventOccurrence?: InputMaybe<EventOccurrenceUpdateOneRequiredWithoutEventOccurrenceContentsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventOccurrenceContentUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventOccurrenceContentUpdateManyWithWhereWithoutEventOccurrenceInput = {
  data: EventOccurrenceContentUpdateManyMutationInput;
  where: EventOccurrenceContentScalarWhereInput;
};

export type EventOccurrenceContentUpdateManyWithoutEventOccurrenceNestedInput = {
  connect?: InputMaybe<Array<EventOccurrenceContentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventOccurrenceContentCreateOrConnectWithoutEventOccurrenceInput>>;
  create?: InputMaybe<Array<EventOccurrenceContentCreateWithoutEventOccurrenceInput>>;
  createMany?: InputMaybe<EventOccurrenceContentCreateManyEventOccurrenceInputEnvelope>;
  delete?: InputMaybe<Array<EventOccurrenceContentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventOccurrenceContentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventOccurrenceContentWhereUniqueInput>>;
  set?: InputMaybe<Array<EventOccurrenceContentWhereUniqueInput>>;
  update?: InputMaybe<Array<EventOccurrenceContentUpdateWithWhereUniqueWithoutEventOccurrenceInput>>;
  updateMany?: InputMaybe<Array<EventOccurrenceContentUpdateManyWithWhereWithoutEventOccurrenceInput>>;
  upsert?: InputMaybe<Array<EventOccurrenceContentUpsertWithWhereUniqueWithoutEventOccurrenceInput>>;
};

export type EventOccurrenceContentUpdateWithWhereUniqueWithoutEventOccurrenceInput = {
  data: EventOccurrenceContentUpdateWithoutEventOccurrenceInput;
  where: EventOccurrenceContentWhereUniqueInput;
};

export type EventOccurrenceContentUpdateWithoutEventOccurrenceInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventOccurrenceContentUpsertWithWhereUniqueWithoutEventOccurrenceInput = {
  create: EventOccurrenceContentCreateWithoutEventOccurrenceInput;
  update: EventOccurrenceContentUpdateWithoutEventOccurrenceInput;
  where: EventOccurrenceContentWhereUniqueInput;
};

export type EventOccurrenceContentWhereInput = {
  AND?: InputMaybe<Array<EventOccurrenceContentWhereInput>>;
  NOT?: InputMaybe<Array<EventOccurrenceContentWhereInput>>;
  OR?: InputMaybe<Array<EventOccurrenceContentWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  eventOccurrence?: InputMaybe<EventOccurrenceScalarRelationFilter>;
  eventOccurrenceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
  subtitle?: InputMaybe<StringNullableFilter>;
};

export type EventOccurrenceContentWhereUniqueInput = {
  AND?: InputMaybe<Array<EventOccurrenceContentWhereInput>>;
  NOT?: InputMaybe<Array<EventOccurrenceContentWhereInput>>;
  OR?: InputMaybe<Array<EventOccurrenceContentWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  eventOccurrence?: InputMaybe<EventOccurrenceScalarRelationFilter>;
  eventOccurrenceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sortOrder?: InputMaybe<IntFilter>;
  subtitle?: InputMaybe<StringNullableFilter>;
};

export type EventOccurrenceCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  end?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxRegistrations?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  start?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type EventOccurrenceCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  event: EventCreateNestedOneWithoutEventOccurrencesInput;
  eventAttendees?: InputMaybe<EventAttendanceCreateNestedManyWithoutEventOccurrenceInput>;
  eventOccurrenceContents?: InputMaybe<EventOccurrenceContentCreateNestedManyWithoutEventOccurrenceInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutEventOccurrenceInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventOccurrenceCreateManyEventInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventOccurrenceCreateManyEventInputEnvelope = {
  data: Array<EventOccurrenceCreateManyEventInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventOccurrenceCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  eventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventOccurrenceCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<EventOccurrenceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventOccurrenceCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<EventOccurrenceCreateWithoutEventInput>>;
  createMany?: InputMaybe<EventOccurrenceCreateManyEventInputEnvelope>;
};

export type EventOccurrenceCreateNestedOneWithoutEventAttendeesInput = {
  connect?: InputMaybe<EventOccurrenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventOccurrenceCreateOrConnectWithoutEventAttendeesInput>;
  create?: InputMaybe<EventOccurrenceCreateWithoutEventAttendeesInput>;
};

export type EventOccurrenceCreateNestedOneWithoutEventOccurrenceContentsInput = {
  connect?: InputMaybe<EventOccurrenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventOccurrenceCreateOrConnectWithoutEventOccurrenceContentsInput>;
  create?: InputMaybe<EventOccurrenceCreateWithoutEventOccurrenceContentsInput>;
};

export type EventOccurrenceCreateNestedOneWithoutEventRegistrationsInput = {
  connect?: InputMaybe<EventOccurrenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventOccurrenceCreateOrConnectWithoutEventRegistrationsInput>;
  create?: InputMaybe<EventOccurrenceCreateWithoutEventRegistrationsInput>;
};

export type EventOccurrenceCreateOrConnectWithoutEventAttendeesInput = {
  create: EventOccurrenceCreateWithoutEventAttendeesInput;
  where: EventOccurrenceWhereUniqueInput;
};

export type EventOccurrenceCreateOrConnectWithoutEventInput = {
  create: EventOccurrenceCreateWithoutEventInput;
  where: EventOccurrenceWhereUniqueInput;
};

export type EventOccurrenceCreateOrConnectWithoutEventOccurrenceContentsInput = {
  create: EventOccurrenceCreateWithoutEventOccurrenceContentsInput;
  where: EventOccurrenceWhereUniqueInput;
};

export type EventOccurrenceCreateOrConnectWithoutEventRegistrationsInput = {
  create: EventOccurrenceCreateWithoutEventRegistrationsInput;
  where: EventOccurrenceWhereUniqueInput;
};

export type EventOccurrenceCreateWithoutEventAttendeesInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  event: EventCreateNestedOneWithoutEventOccurrencesInput;
  eventOccurrenceContents?: InputMaybe<EventOccurrenceContentCreateNestedManyWithoutEventOccurrenceInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutEventOccurrenceInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventOccurrenceCreateWithoutEventInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  eventAttendees?: InputMaybe<EventAttendanceCreateNestedManyWithoutEventOccurrenceInput>;
  eventOccurrenceContents?: InputMaybe<EventOccurrenceContentCreateNestedManyWithoutEventOccurrenceInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutEventOccurrenceInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventOccurrenceCreateWithoutEventOccurrenceContentsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  event: EventCreateNestedOneWithoutEventOccurrencesInput;
  eventAttendees?: InputMaybe<EventAttendanceCreateNestedManyWithoutEventOccurrenceInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutEventOccurrenceInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventOccurrenceCreateWithoutEventRegistrationsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  event: EventCreateNestedOneWithoutEventOccurrencesInput;
  eventAttendees?: InputMaybe<EventAttendanceCreateNestedManyWithoutEventOccurrenceInput>;
  eventOccurrenceContents?: InputMaybe<EventOccurrenceContentCreateNestedManyWithoutEventOccurrenceInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<Scalars['Int']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventOccurrenceListRelationFilter = {
  every?: InputMaybe<EventOccurrenceWhereInput>;
  none?: InputMaybe<EventOccurrenceWhereInput>;
  some?: InputMaybe<EventOccurrenceWhereInput>;
};

export type EventOccurrenceMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  end?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxRegistrations?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  start?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type EventOccurrenceMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  end?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxRegistrations?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  start?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type EventOccurrenceNullableScalarRelationFilter = {
  is?: InputMaybe<EventOccurrenceWhereInput>;
  isNot?: InputMaybe<EventOccurrenceWhereInput>;
};

export type EventOccurrenceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventOccurrenceOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventOccurrenceAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventOccurrenceCountOrderByAggregateInput>;
  _max?: InputMaybe<EventOccurrenceMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventOccurrenceMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventOccurrenceSumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  end?: InputMaybe<SortOrderInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxRegistrations?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  start?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrderInput>;
};

export type EventOccurrenceOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  end?: InputMaybe<SortOrderInput>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventAttendees?: InputMaybe<EventAttendanceOrderByRelationAggregateInput>;
  eventId?: InputMaybe<SortOrder>;
  eventOccurrenceContents?: InputMaybe<EventOccurrenceContentOrderByRelationAggregateInput>;
  eventRegistrations?: InputMaybe<EventRegistrationOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  maxRegistrations?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  start?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrderInput>;
};

export enum EventOccurrenceScalarFieldEnum {
  Created = 'created',
  End = 'end',
  EventId = 'eventId',
  Id = 'id',
  MaxRegistrations = 'maxRegistrations',
  Modified = 'modified',
  Start = 'start',
  Title = 'title'
}

export type EventOccurrenceScalarRelationFilter = {
  is?: InputMaybe<EventOccurrenceWhereInput>;
  isNot?: InputMaybe<EventOccurrenceWhereInput>;
};

export type EventOccurrenceScalarWhereInput = {
  AND?: InputMaybe<Array<EventOccurrenceScalarWhereInput>>;
  NOT?: InputMaybe<Array<EventOccurrenceScalarWhereInput>>;
  OR?: InputMaybe<Array<EventOccurrenceScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  end?: InputMaybe<DateTimeNullableFilter>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  maxRegistrations?: InputMaybe<IntNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  start?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type EventOccurrenceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EventOccurrenceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EventOccurrenceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EventOccurrenceScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  end?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  eventId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  maxRegistrations?: InputMaybe<IntNullableWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  start?: InputMaybe<DateTimeWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type EventOccurrenceSumOrderByAggregateInput = {
  maxRegistrations?: InputMaybe<SortOrder>;
};

export type EventOccurrenceUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  end?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventOccurrencesNestedInput>;
  eventAttendees?: InputMaybe<EventAttendanceUpdateManyWithoutEventOccurrenceNestedInput>;
  eventOccurrenceContents?: InputMaybe<EventOccurrenceContentUpdateManyWithoutEventOccurrenceNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutEventOccurrenceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  start?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventOccurrenceUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  end?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  start?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventOccurrenceUpdateManyWithWhereWithoutEventInput = {
  data: EventOccurrenceUpdateManyMutationInput;
  where: EventOccurrenceScalarWhereInput;
};

export type EventOccurrenceUpdateManyWithoutEventNestedInput = {
  connect?: InputMaybe<Array<EventOccurrenceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventOccurrenceCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<EventOccurrenceCreateWithoutEventInput>>;
  createMany?: InputMaybe<EventOccurrenceCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<EventOccurrenceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventOccurrenceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventOccurrenceWhereUniqueInput>>;
  set?: InputMaybe<Array<EventOccurrenceWhereUniqueInput>>;
  update?: InputMaybe<Array<EventOccurrenceUpdateWithWhereUniqueWithoutEventInput>>;
  updateMany?: InputMaybe<Array<EventOccurrenceUpdateManyWithWhereWithoutEventInput>>;
  upsert?: InputMaybe<Array<EventOccurrenceUpsertWithWhereUniqueWithoutEventInput>>;
};

export type EventOccurrenceUpdateOneRequiredWithoutEventOccurrenceContentsNestedInput = {
  connect?: InputMaybe<EventOccurrenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventOccurrenceCreateOrConnectWithoutEventOccurrenceContentsInput>;
  create?: InputMaybe<EventOccurrenceCreateWithoutEventOccurrenceContentsInput>;
  update?: InputMaybe<EventOccurrenceUpdateToOneWithWhereWithoutEventOccurrenceContentsInput>;
  upsert?: InputMaybe<EventOccurrenceUpsertWithoutEventOccurrenceContentsInput>;
};

export type EventOccurrenceUpdateOneWithoutEventAttendeesNestedInput = {
  connect?: InputMaybe<EventOccurrenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventOccurrenceCreateOrConnectWithoutEventAttendeesInput>;
  create?: InputMaybe<EventOccurrenceCreateWithoutEventAttendeesInput>;
  delete?: InputMaybe<EventOccurrenceWhereInput>;
  disconnect?: InputMaybe<EventOccurrenceWhereInput>;
  update?: InputMaybe<EventOccurrenceUpdateToOneWithWhereWithoutEventAttendeesInput>;
  upsert?: InputMaybe<EventOccurrenceUpsertWithoutEventAttendeesInput>;
};

export type EventOccurrenceUpdateOneWithoutEventRegistrationsNestedInput = {
  connect?: InputMaybe<EventOccurrenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventOccurrenceCreateOrConnectWithoutEventRegistrationsInput>;
  create?: InputMaybe<EventOccurrenceCreateWithoutEventRegistrationsInput>;
  delete?: InputMaybe<EventOccurrenceWhereInput>;
  disconnect?: InputMaybe<EventOccurrenceWhereInput>;
  update?: InputMaybe<EventOccurrenceUpdateToOneWithWhereWithoutEventRegistrationsInput>;
  upsert?: InputMaybe<EventOccurrenceUpsertWithoutEventRegistrationsInput>;
};

export type EventOccurrenceUpdateToOneWithWhereWithoutEventAttendeesInput = {
  data: EventOccurrenceUpdateWithoutEventAttendeesInput;
  where?: InputMaybe<EventOccurrenceWhereInput>;
};

export type EventOccurrenceUpdateToOneWithWhereWithoutEventOccurrenceContentsInput = {
  data: EventOccurrenceUpdateWithoutEventOccurrenceContentsInput;
  where?: InputMaybe<EventOccurrenceWhereInput>;
};

export type EventOccurrenceUpdateToOneWithWhereWithoutEventRegistrationsInput = {
  data: EventOccurrenceUpdateWithoutEventRegistrationsInput;
  where?: InputMaybe<EventOccurrenceWhereInput>;
};

export type EventOccurrenceUpdateWithWhereUniqueWithoutEventInput = {
  data: EventOccurrenceUpdateWithoutEventInput;
  where: EventOccurrenceWhereUniqueInput;
};

export type EventOccurrenceUpdateWithoutEventAttendeesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  end?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventOccurrencesNestedInput>;
  eventOccurrenceContents?: InputMaybe<EventOccurrenceContentUpdateManyWithoutEventOccurrenceNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutEventOccurrenceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  start?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventOccurrenceUpdateWithoutEventInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  end?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventAttendees?: InputMaybe<EventAttendanceUpdateManyWithoutEventOccurrenceNestedInput>;
  eventOccurrenceContents?: InputMaybe<EventOccurrenceContentUpdateManyWithoutEventOccurrenceNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutEventOccurrenceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  start?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventOccurrenceUpdateWithoutEventOccurrenceContentsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  end?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventOccurrencesNestedInput>;
  eventAttendees?: InputMaybe<EventAttendanceUpdateManyWithoutEventOccurrenceNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutEventOccurrenceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  start?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventOccurrenceUpdateWithoutEventRegistrationsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  end?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventOccurrencesNestedInput>;
  eventAttendees?: InputMaybe<EventAttendanceUpdateManyWithoutEventOccurrenceNestedInput>;
  eventOccurrenceContents?: InputMaybe<EventOccurrenceContentUpdateManyWithoutEventOccurrenceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  start?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventOccurrenceUpsertWithWhereUniqueWithoutEventInput = {
  create: EventOccurrenceCreateWithoutEventInput;
  update: EventOccurrenceUpdateWithoutEventInput;
  where: EventOccurrenceWhereUniqueInput;
};

export type EventOccurrenceUpsertWithoutEventAttendeesInput = {
  create: EventOccurrenceCreateWithoutEventAttendeesInput;
  update: EventOccurrenceUpdateWithoutEventAttendeesInput;
  where?: InputMaybe<EventOccurrenceWhereInput>;
};

export type EventOccurrenceUpsertWithoutEventOccurrenceContentsInput = {
  create: EventOccurrenceCreateWithoutEventOccurrenceContentsInput;
  update: EventOccurrenceUpdateWithoutEventOccurrenceContentsInput;
  where?: InputMaybe<EventOccurrenceWhereInput>;
};

export type EventOccurrenceUpsertWithoutEventRegistrationsInput = {
  create: EventOccurrenceCreateWithoutEventRegistrationsInput;
  update: EventOccurrenceUpdateWithoutEventRegistrationsInput;
  where?: InputMaybe<EventOccurrenceWhereInput>;
};

export type EventOccurrenceWhereInput = {
  AND?: InputMaybe<Array<EventOccurrenceWhereInput>>;
  NOT?: InputMaybe<Array<EventOccurrenceWhereInput>>;
  OR?: InputMaybe<Array<EventOccurrenceWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  end?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventScalarRelationFilter>;
  eventAttendees?: InputMaybe<EventAttendanceListRelationFilter>;
  eventId?: InputMaybe<StringFilter>;
  eventOccurrenceContents?: InputMaybe<EventOccurrenceContentListRelationFilter>;
  eventRegistrations?: InputMaybe<EventRegistrationListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  maxRegistrations?: InputMaybe<IntNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  start?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type EventOccurrenceWhereUniqueInput = {
  AND?: InputMaybe<Array<EventOccurrenceWhereInput>>;
  NOT?: InputMaybe<Array<EventOccurrenceWhereInput>>;
  OR?: InputMaybe<Array<EventOccurrenceWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  end?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventScalarRelationFilter>;
  eventAttendees?: InputMaybe<EventAttendanceListRelationFilter>;
  eventId?: InputMaybe<StringFilter>;
  eventOccurrenceContents?: InputMaybe<EventOccurrenceContentListRelationFilter>;
  eventRegistrations?: InputMaybe<EventRegistrationListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<IntNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  start?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type EventOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventCountOrderByAggregateInput>;
  _max?: InputMaybe<EventMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventSumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxRegistrations?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type EventOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  eventCategories?: InputMaybe<EventCategoryOrderByRelationAggregateInput>;
  eventContents?: InputMaybe<EventContentOrderByRelationAggregateInput>;
  eventOccurrences?: InputMaybe<EventOccurrenceOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  maxRegistrations?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  productEvents?: InputMaybe<ProductEventOrderByRelationAggregateInput>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type EventRegistrationCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  userTimezone?: InputMaybe<SortOrder>;
};

export type EventRegistrationCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventOccurrence?: InputMaybe<EventOccurrenceCreateNestedOneWithoutEventRegistrationsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutEventRegistrationsInput;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type EventRegistrationCreateManyEventOccurrenceInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type EventRegistrationCreateManyEventOccurrenceInputEnvelope = {
  data: Array<EventRegistrationCreateManyEventOccurrenceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventRegistrationCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventOccurrenceId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type EventRegistrationCreateManyUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventOccurrenceId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type EventRegistrationCreateManyUserInputEnvelope = {
  data: Array<EventRegistrationCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventRegistrationCreateNestedManyWithoutEventOccurrenceInput = {
  connect?: InputMaybe<Array<EventRegistrationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventRegistrationCreateOrConnectWithoutEventOccurrenceInput>>;
  create?: InputMaybe<Array<EventRegistrationCreateWithoutEventOccurrenceInput>>;
  createMany?: InputMaybe<EventRegistrationCreateManyEventOccurrenceInputEnvelope>;
};

export type EventRegistrationCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<EventRegistrationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventRegistrationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<EventRegistrationCreateWithoutUserInput>>;
  createMany?: InputMaybe<EventRegistrationCreateManyUserInputEnvelope>;
};

export type EventRegistrationCreateOrConnectWithoutEventOccurrenceInput = {
  create: EventRegistrationCreateWithoutEventOccurrenceInput;
  where: EventRegistrationWhereUniqueInput;
};

export type EventRegistrationCreateOrConnectWithoutUserInput = {
  create: EventRegistrationCreateWithoutUserInput;
  where: EventRegistrationWhereUniqueInput;
};

export type EventRegistrationCreateWithoutEventOccurrenceInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutEventRegistrationsInput;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type EventRegistrationCreateWithoutUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventOccurrence?: InputMaybe<EventOccurrenceCreateNestedOneWithoutEventRegistrationsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type EventRegistrationListRelationFilter = {
  every?: InputMaybe<EventRegistrationWhereInput>;
  none?: InputMaybe<EventRegistrationWhereInput>;
  some?: InputMaybe<EventRegistrationWhereInput>;
};

export type EventRegistrationMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  userTimezone?: InputMaybe<SortOrder>;
};

export type EventRegistrationMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  userTimezone?: InputMaybe<SortOrder>;
};

export type EventRegistrationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventRegistrationOrderByWithAggregationInput = {
  _count?: InputMaybe<EventRegistrationCountOrderByAggregateInput>;
  _max?: InputMaybe<EventRegistrationMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventRegistrationMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  userTimezone?: InputMaybe<SortOrderInput>;
};

export type EventRegistrationOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  eventOccurrence?: InputMaybe<EventOccurrenceOrderByWithRelationInput>;
  eventOccurrenceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  userTimezone?: InputMaybe<SortOrderInput>;
};

export enum EventRegistrationScalarFieldEnum {
  Created = 'created',
  EventOccurrenceId = 'eventOccurrenceId',
  Id = 'id',
  Modified = 'modified',
  UserId = 'userId',
  UserTimezone = 'userTimezone'
}

export type EventRegistrationScalarWhereInput = {
  AND?: InputMaybe<Array<EventRegistrationScalarWhereInput>>;
  NOT?: InputMaybe<Array<EventRegistrationScalarWhereInput>>;
  OR?: InputMaybe<Array<EventRegistrationScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  eventOccurrenceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
  userTimezone?: InputMaybe<StringNullableFilter>;
};

export type EventRegistrationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EventRegistrationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EventRegistrationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EventRegistrationScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventOccurrenceId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
  userTimezone?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type EventRegistrationUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventOccurrence?: InputMaybe<EventOccurrenceUpdateOneWithoutEventRegistrationsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutEventRegistrationsNestedInput>;
  userTimezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventRegistrationUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userTimezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventRegistrationUpdateManyWithWhereWithoutEventOccurrenceInput = {
  data: EventRegistrationUpdateManyMutationInput;
  where: EventRegistrationScalarWhereInput;
};

export type EventRegistrationUpdateManyWithWhereWithoutUserInput = {
  data: EventRegistrationUpdateManyMutationInput;
  where: EventRegistrationScalarWhereInput;
};

export type EventRegistrationUpdateManyWithoutEventOccurrenceNestedInput = {
  connect?: InputMaybe<Array<EventRegistrationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventRegistrationCreateOrConnectWithoutEventOccurrenceInput>>;
  create?: InputMaybe<Array<EventRegistrationCreateWithoutEventOccurrenceInput>>;
  createMany?: InputMaybe<EventRegistrationCreateManyEventOccurrenceInputEnvelope>;
  delete?: InputMaybe<Array<EventRegistrationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventRegistrationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventRegistrationWhereUniqueInput>>;
  set?: InputMaybe<Array<EventRegistrationWhereUniqueInput>>;
  update?: InputMaybe<Array<EventRegistrationUpdateWithWhereUniqueWithoutEventOccurrenceInput>>;
  updateMany?: InputMaybe<Array<EventRegistrationUpdateManyWithWhereWithoutEventOccurrenceInput>>;
  upsert?: InputMaybe<Array<EventRegistrationUpsertWithWhereUniqueWithoutEventOccurrenceInput>>;
};

export type EventRegistrationUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<EventRegistrationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventRegistrationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<EventRegistrationCreateWithoutUserInput>>;
  createMany?: InputMaybe<EventRegistrationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<EventRegistrationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventRegistrationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventRegistrationWhereUniqueInput>>;
  set?: InputMaybe<Array<EventRegistrationWhereUniqueInput>>;
  update?: InputMaybe<Array<EventRegistrationUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<EventRegistrationUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<EventRegistrationUpsertWithWhereUniqueWithoutUserInput>>;
};

export type EventRegistrationUpdateWithWhereUniqueWithoutEventOccurrenceInput = {
  data: EventRegistrationUpdateWithoutEventOccurrenceInput;
  where: EventRegistrationWhereUniqueInput;
};

export type EventRegistrationUpdateWithWhereUniqueWithoutUserInput = {
  data: EventRegistrationUpdateWithoutUserInput;
  where: EventRegistrationWhereUniqueInput;
};

export type EventRegistrationUpdateWithoutEventOccurrenceInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutEventRegistrationsNestedInput>;
  userTimezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventRegistrationUpdateWithoutUserInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventOccurrence?: InputMaybe<EventOccurrenceUpdateOneWithoutEventRegistrationsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userTimezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventRegistrationUpsertWithWhereUniqueWithoutEventOccurrenceInput = {
  create: EventRegistrationCreateWithoutEventOccurrenceInput;
  update: EventRegistrationUpdateWithoutEventOccurrenceInput;
  where: EventRegistrationWhereUniqueInput;
};

export type EventRegistrationUpsertWithWhereUniqueWithoutUserInput = {
  create: EventRegistrationCreateWithoutUserInput;
  update: EventRegistrationUpdateWithoutUserInput;
  where: EventRegistrationWhereUniqueInput;
};

export type EventRegistrationWhereInput = {
  AND?: InputMaybe<Array<EventRegistrationWhereInput>>;
  NOT?: InputMaybe<Array<EventRegistrationWhereInput>>;
  OR?: InputMaybe<Array<EventRegistrationWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  eventOccurrence?: InputMaybe<EventOccurrenceNullableScalarRelationFilter>;
  eventOccurrenceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  userTimezone?: InputMaybe<StringNullableFilter>;
};

export type EventRegistrationWhereUniqueInput = {
  AND?: InputMaybe<Array<EventRegistrationWhereInput>>;
  NOT?: InputMaybe<Array<EventRegistrationWhereInput>>;
  OR?: InputMaybe<Array<EventRegistrationWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  eventOccurrence?: InputMaybe<EventOccurrenceNullableScalarRelationFilter>;
  eventOccurrenceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  userTimezone?: InputMaybe<StringNullableFilter>;
};

export enum EventScalarFieldEnum {
  Created = 'created',
  Description = 'description',
  Id = 'id',
  MaxRegistrations = 'maxRegistrations',
  Modified = 'modified',
  Slug = 'slug',
  Title = 'title'
}

export type EventScalarRelationFilter = {
  is?: InputMaybe<EventWhereInput>;
  isNot?: InputMaybe<EventWhereInput>;
};

export type EventScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EventScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EventScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EventScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  maxRegistrations?: InputMaybe<IntNullableWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  slug?: InputMaybe<StringWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type EventSumOrderByAggregateInput = {
  maxRegistrations?: InputMaybe<SortOrder>;
};

export type EventUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventCategories?: InputMaybe<EventCategoryUpdateManyWithoutEventNestedInput>;
  eventContents?: InputMaybe<EventContentUpdateManyWithoutEventNestedInput>;
  eventOccurrences?: InputMaybe<EventOccurrenceUpdateManyWithoutEventNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  productEvents?: InputMaybe<ProductEventUpdateManyWithoutEventNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventUpdateOneRequiredWithoutEventCategoriesNestedInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventCategoriesInput>;
  create?: InputMaybe<EventCreateWithoutEventCategoriesInput>;
  update?: InputMaybe<EventUpdateToOneWithWhereWithoutEventCategoriesInput>;
  upsert?: InputMaybe<EventUpsertWithoutEventCategoriesInput>;
};

export type EventUpdateOneRequiredWithoutEventContentsNestedInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventContentsInput>;
  create?: InputMaybe<EventCreateWithoutEventContentsInput>;
  update?: InputMaybe<EventUpdateToOneWithWhereWithoutEventContentsInput>;
  upsert?: InputMaybe<EventUpsertWithoutEventContentsInput>;
};

export type EventUpdateOneRequiredWithoutEventOccurrencesNestedInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventOccurrencesInput>;
  create?: InputMaybe<EventCreateWithoutEventOccurrencesInput>;
  update?: InputMaybe<EventUpdateToOneWithWhereWithoutEventOccurrencesInput>;
  upsert?: InputMaybe<EventUpsertWithoutEventOccurrencesInput>;
};

export type EventUpdateOneRequiredWithoutProductEventsNestedInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutProductEventsInput>;
  create?: InputMaybe<EventCreateWithoutProductEventsInput>;
  update?: InputMaybe<EventUpdateToOneWithWhereWithoutProductEventsInput>;
  upsert?: InputMaybe<EventUpsertWithoutProductEventsInput>;
};

export type EventUpdateToOneWithWhereWithoutEventCategoriesInput = {
  data: EventUpdateWithoutEventCategoriesInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventUpdateToOneWithWhereWithoutEventContentsInput = {
  data: EventUpdateWithoutEventContentsInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventUpdateToOneWithWhereWithoutEventOccurrencesInput = {
  data: EventUpdateWithoutEventOccurrencesInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventUpdateToOneWithWhereWithoutProductEventsInput = {
  data: EventUpdateWithoutProductEventsInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventUpdateWithoutEventCategoriesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventContents?: InputMaybe<EventContentUpdateManyWithoutEventNestedInput>;
  eventOccurrences?: InputMaybe<EventOccurrenceUpdateManyWithoutEventNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  productEvents?: InputMaybe<ProductEventUpdateManyWithoutEventNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutEventContentsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventCategories?: InputMaybe<EventCategoryUpdateManyWithoutEventNestedInput>;
  eventOccurrences?: InputMaybe<EventOccurrenceUpdateManyWithoutEventNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  productEvents?: InputMaybe<ProductEventUpdateManyWithoutEventNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutEventOccurrencesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventCategories?: InputMaybe<EventCategoryUpdateManyWithoutEventNestedInput>;
  eventContents?: InputMaybe<EventContentUpdateManyWithoutEventNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  productEvents?: InputMaybe<ProductEventUpdateManyWithoutEventNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutProductEventsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventCategories?: InputMaybe<EventCategoryUpdateManyWithoutEventNestedInput>;
  eventContents?: InputMaybe<EventContentUpdateManyWithoutEventNestedInput>;
  eventOccurrences?: InputMaybe<EventOccurrenceUpdateManyWithoutEventNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  maxRegistrations?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventUpsertWithoutEventCategoriesInput = {
  create: EventCreateWithoutEventCategoriesInput;
  update: EventUpdateWithoutEventCategoriesInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventUpsertWithoutEventContentsInput = {
  create: EventCreateWithoutEventContentsInput;
  update: EventUpdateWithoutEventContentsInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventUpsertWithoutEventOccurrencesInput = {
  create: EventCreateWithoutEventOccurrencesInput;
  update: EventUpdateWithoutEventOccurrencesInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventUpsertWithoutProductEventsInput = {
  create: EventCreateWithoutProductEventsInput;
  update: EventUpdateWithoutProductEventsInput;
  where?: InputMaybe<EventWhereInput>;
};

export type EventWhereInput = {
  AND?: InputMaybe<Array<EventWhereInput>>;
  NOT?: InputMaybe<Array<EventWhereInput>>;
  OR?: InputMaybe<Array<EventWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  eventCategories?: InputMaybe<EventCategoryListRelationFilter>;
  eventContents?: InputMaybe<EventContentListRelationFilter>;
  eventOccurrences?: InputMaybe<EventOccurrenceListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  maxRegistrations?: InputMaybe<IntNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  productEvents?: InputMaybe<ProductEventListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type EventWhereUniqueInput = {
  AND?: InputMaybe<Array<EventWhereInput>>;
  NOT?: InputMaybe<Array<EventWhereInput>>;
  OR?: InputMaybe<Array<EventWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  eventCategories?: InputMaybe<EventCategoryListRelationFilter>;
  eventContents?: InputMaybe<EventContentListRelationFilter>;
  eventOccurrences?: InputMaybe<EventOccurrenceListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxRegistrations?: InputMaybe<IntNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  productEvents?: InputMaybe<ProductEventListRelationFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<StringFilter>;
};

export type ExchangeRateAvgOrderByAggregateInput = {
  rate?: InputMaybe<SortOrder>;
};

export type ExchangeRateCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  effectiveFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
};

export type ExchangeRateCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency: AcceptedCurrency;
  effectiveFrom: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  rate: Scalars['Decimal']['input'];
};

export type ExchangeRateCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency: AcceptedCurrency;
  effectiveFrom: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  rate: Scalars['Decimal']['input'];
};

export type ExchangeRateMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  effectiveFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
};

export type ExchangeRateMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  effectiveFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
};

export type ExchangeRateOrderByWithAggregationInput = {
  _avg?: InputMaybe<ExchangeRateAvgOrderByAggregateInput>;
  _count?: InputMaybe<ExchangeRateCountOrderByAggregateInput>;
  _max?: InputMaybe<ExchangeRateMaxOrderByAggregateInput>;
  _min?: InputMaybe<ExchangeRateMinOrderByAggregateInput>;
  _sum?: InputMaybe<ExchangeRateSumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  effectiveFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
};

export type ExchangeRateOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  effectiveFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
};

export enum ExchangeRateScalarFieldEnum {
  Created = 'created',
  Currency = 'currency',
  EffectiveFrom = 'effectiveFrom',
  Id = 'id',
  Modified = 'modified',
  Rate = 'rate'
}

export type ExchangeRateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ExchangeRateScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ExchangeRateScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ExchangeRateScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyWithAggregatesFilter>;
  effectiveFrom?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  rate?: InputMaybe<DecimalWithAggregatesFilter>;
};

export type ExchangeRateSumOrderByAggregateInput = {
  rate?: InputMaybe<SortOrder>;
};

export type ExchangeRateUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  effectiveFrom?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rate?: InputMaybe<DecimalFieldUpdateOperationsInput>;
};

export type ExchangeRateUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  effectiveFrom?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rate?: InputMaybe<DecimalFieldUpdateOperationsInput>;
};

export type ExchangeRateWhereInput = {
  AND?: InputMaybe<Array<ExchangeRateWhereInput>>;
  NOT?: InputMaybe<Array<ExchangeRateWhereInput>>;
  OR?: InputMaybe<Array<ExchangeRateWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyFilter>;
  effectiveFrom?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  rate?: InputMaybe<DecimalFilter>;
};

export type ExchangeRateWhereUniqueInput = {
  AND?: InputMaybe<Array<ExchangeRateWhereInput>>;
  NOT?: InputMaybe<Array<ExchangeRateWhereInput>>;
  OR?: InputMaybe<Array<ExchangeRateWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<AcceptedCurrency>;
  effectiveFrom?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  rate?: InputMaybe<DecimalFilter>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GuestAvgOrderByAggregateInput = {
  visitCount?: InputMaybe<SortOrder>;
};

export type GuestCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  fingerprintId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  visitCount?: InputMaybe<SortOrder>;
};

export type GuestCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fingerprintId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  visitCount?: InputMaybe<Scalars['Int']['input']>;
};

export type GuestCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fingerprintId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  visitCount?: InputMaybe<Scalars['Int']['input']>;
};

export type GuestMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  fingerprintId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  visitCount?: InputMaybe<SortOrder>;
};

export type GuestMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  fingerprintId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  visitCount?: InputMaybe<SortOrder>;
};

export type GuestOrderByWithAggregationInput = {
  _avg?: InputMaybe<GuestAvgOrderByAggregateInput>;
  _count?: InputMaybe<GuestCountOrderByAggregateInput>;
  _max?: InputMaybe<GuestMaxOrderByAggregateInput>;
  _min?: InputMaybe<GuestMinOrderByAggregateInput>;
  _sum?: InputMaybe<GuestSumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  fingerprintId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  visitCount?: InputMaybe<SortOrder>;
};

export type GuestOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  fingerprintId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  visitCount?: InputMaybe<SortOrder>;
};

export enum GuestScalarFieldEnum {
  Created = 'created',
  Email = 'email',
  FingerprintId = 'fingerprintId',
  Id = 'id',
  Modified = 'modified',
  VisitCount = 'visitCount'
}

export type GuestScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<GuestScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<GuestScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<GuestScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  email?: InputMaybe<StringNullableWithAggregatesFilter>;
  fingerprintId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  visitCount?: InputMaybe<IntWithAggregatesFilter>;
};

export type GuestSumOrderByAggregateInput = {
  visitCount?: InputMaybe<SortOrder>;
};

export type GuestUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fingerprintId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitCount?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type GuestUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fingerprintId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitCount?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type GuestWhereInput = {
  AND?: InputMaybe<Array<GuestWhereInput>>;
  NOT?: InputMaybe<Array<GuestWhereInput>>;
  OR?: InputMaybe<Array<GuestWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  fingerprintId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  visitCount?: InputMaybe<IntFilter>;
};

export type GuestWhereUniqueInput = {
  AND?: InputMaybe<Array<GuestWhereInput>>;
  NOT?: InputMaybe<Array<GuestWhereInput>>;
  OR?: InputMaybe<Array<GuestWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  fingerprintId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  visitCount?: InputMaybe<IntFilter>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedJsonNullableFilter>;
  _min?: InputMaybe<NestedJsonNullableFilter>;
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedJsonFilter>;
  _min?: InputMaybe<NestedJsonFilter>;
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum LearningStyle {
  FlexibleSequential = 'FLEXIBLE_SEQUENTIAL',
  RigidSequential = 'RIGID_SEQUENTIAL',
  Unstructured = 'UNSTRUCTURED'
}

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedDecimalWithAggregatesFilter = {
  _avg?: InputMaybe<NestedDecimalFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDecimalFilter>;
  _min?: InputMaybe<NestedDecimalFilter>;
  _sum?: InputMaybe<NestedDecimalFilter>;
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedEnumAcceptedCurrencyFilter = {
  equals?: InputMaybe<AcceptedCurrency>;
  in?: InputMaybe<Array<AcceptedCurrency>>;
  not?: InputMaybe<NestedEnumAcceptedCurrencyFilter>;
  notIn?: InputMaybe<Array<AcceptedCurrency>>;
};

export type NestedEnumAcceptedCurrencyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAcceptedCurrencyFilter>;
  _min?: InputMaybe<NestedEnumAcceptedCurrencyFilter>;
  equals?: InputMaybe<AcceptedCurrency>;
  in?: InputMaybe<Array<AcceptedCurrency>>;
  not?: InputMaybe<NestedEnumAcceptedCurrencyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AcceptedCurrency>>;
};

export type NestedEnumBrandingTypeFilter = {
  equals?: InputMaybe<BrandingType>;
  in?: InputMaybe<Array<BrandingType>>;
  not?: InputMaybe<NestedEnumBrandingTypeFilter>;
  notIn?: InputMaybe<Array<BrandingType>>;
};

export type NestedEnumBrandingTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBrandingTypeFilter>;
  _min?: InputMaybe<NestedEnumBrandingTypeFilter>;
  equals?: InputMaybe<BrandingType>;
  in?: InputMaybe<Array<BrandingType>>;
  not?: InputMaybe<NestedEnumBrandingTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BrandingType>>;
};

export type NestedEnumCouponDiscountTypeFilter = {
  equals?: InputMaybe<CouponDiscountType>;
  in?: InputMaybe<Array<CouponDiscountType>>;
  not?: InputMaybe<NestedEnumCouponDiscountTypeFilter>;
  notIn?: InputMaybe<Array<CouponDiscountType>>;
};

export type NestedEnumCouponDiscountTypeNullableFilter = {
  equals?: InputMaybe<CouponDiscountType>;
  in?: InputMaybe<Array<CouponDiscountType>>;
  not?: InputMaybe<NestedEnumCouponDiscountTypeNullableFilter>;
  notIn?: InputMaybe<Array<CouponDiscountType>>;
};

export type NestedEnumCouponDiscountTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCouponDiscountTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumCouponDiscountTypeNullableFilter>;
  equals?: InputMaybe<CouponDiscountType>;
  in?: InputMaybe<Array<CouponDiscountType>>;
  not?: InputMaybe<NestedEnumCouponDiscountTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CouponDiscountType>>;
};

export type NestedEnumCouponDiscountTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCouponDiscountTypeFilter>;
  _min?: InputMaybe<NestedEnumCouponDiscountTypeFilter>;
  equals?: InputMaybe<CouponDiscountType>;
  in?: InputMaybe<Array<CouponDiscountType>>;
  not?: InputMaybe<NestedEnumCouponDiscountTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CouponDiscountType>>;
};

export type NestedEnumLearningStyleFilter = {
  equals?: InputMaybe<LearningStyle>;
  in?: InputMaybe<Array<LearningStyle>>;
  not?: InputMaybe<NestedEnumLearningStyleFilter>;
  notIn?: InputMaybe<Array<LearningStyle>>;
};

export type NestedEnumLearningStyleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumLearningStyleFilter>;
  _min?: InputMaybe<NestedEnumLearningStyleFilter>;
  equals?: InputMaybe<LearningStyle>;
  in?: InputMaybe<Array<LearningStyle>>;
  not?: InputMaybe<NestedEnumLearningStyleWithAggregatesFilter>;
  notIn?: InputMaybe<Array<LearningStyle>>;
};

export type NestedEnumPaymentDiscountSourceNullableFilter = {
  equals?: InputMaybe<PaymentDiscountSource>;
  in?: InputMaybe<Array<PaymentDiscountSource>>;
  not?: InputMaybe<NestedEnumPaymentDiscountSourceNullableFilter>;
  notIn?: InputMaybe<Array<PaymentDiscountSource>>;
};

export type NestedEnumPaymentDiscountSourceNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPaymentDiscountSourceNullableFilter>;
  _min?: InputMaybe<NestedEnumPaymentDiscountSourceNullableFilter>;
  equals?: InputMaybe<PaymentDiscountSource>;
  in?: InputMaybe<Array<PaymentDiscountSource>>;
  not?: InputMaybe<NestedEnumPaymentDiscountSourceNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentDiscountSource>>;
};

export type NestedEnumPromptFrequencyFilter = {
  equals?: InputMaybe<PromptFrequency>;
  in?: InputMaybe<Array<PromptFrequency>>;
  not?: InputMaybe<NestedEnumPromptFrequencyFilter>;
  notIn?: InputMaybe<Array<PromptFrequency>>;
};

export type NestedEnumPromptFrequencyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPromptFrequencyFilter>;
  _min?: InputMaybe<NestedEnumPromptFrequencyFilter>;
  equals?: InputMaybe<PromptFrequency>;
  in?: InputMaybe<Array<PromptFrequency>>;
  not?: InputMaybe<NestedEnumPromptFrequencyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PromptFrequency>>;
};

export type NestedEnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedEnumRoleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumRoleFilter>;
  _min?: InputMaybe<NestedEnumRoleFilter>;
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedEnumStripePaymentIntentStatusFilter = {
  equals?: InputMaybe<StripePaymentIntentStatus>;
  in?: InputMaybe<Array<StripePaymentIntentStatus>>;
  not?: InputMaybe<NestedEnumStripePaymentIntentStatusFilter>;
  notIn?: InputMaybe<Array<StripePaymentIntentStatus>>;
};

export type NestedEnumStripePaymentIntentStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumStripePaymentIntentStatusFilter>;
  _min?: InputMaybe<NestedEnumStripePaymentIntentStatusFilter>;
  equals?: InputMaybe<StripePaymentIntentStatus>;
  in?: InputMaybe<Array<StripePaymentIntentStatus>>;
  not?: InputMaybe<NestedEnumStripePaymentIntentStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<StripePaymentIntentStatus>>;
};

export type NestedEnumTemplateTypeFilter = {
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export type NestedEnumTemplateTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumTemplateTypeFilter>;
  _min?: InputMaybe<NestedEnumTemplateTypeFilter>;
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export type NestedEnumUpgradeDurationModeFilter = {
  equals?: InputMaybe<UpgradeDurationMode>;
  in?: InputMaybe<Array<UpgradeDurationMode>>;
  not?: InputMaybe<NestedEnumUpgradeDurationModeFilter>;
  notIn?: InputMaybe<Array<UpgradeDurationMode>>;
};

export type NestedEnumUpgradeDurationModeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUpgradeDurationModeFilter>;
  _min?: InputMaybe<NestedEnumUpgradeDurationModeFilter>;
  equals?: InputMaybe<UpgradeDurationMode>;
  in?: InputMaybe<Array<UpgradeDurationMode>>;
  not?: InputMaybe<NestedEnumUpgradeDurationModeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UpgradeDurationMode>>;
};

export type NestedEnumUpgradePromptTypeFilter = {
  equals?: InputMaybe<UpgradePromptType>;
  in?: InputMaybe<Array<UpgradePromptType>>;
  not?: InputMaybe<NestedEnumUpgradePromptTypeFilter>;
  notIn?: InputMaybe<Array<UpgradePromptType>>;
};

export type NestedEnumUpgradePromptTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUpgradePromptTypeFilter>;
  _min?: InputMaybe<NestedEnumUpgradePromptTypeFilter>;
  equals?: InputMaybe<UpgradePromptType>;
  in?: InputMaybe<Array<UpgradePromptType>>;
  not?: InputMaybe<NestedEnumUpgradePromptTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UpgradePromptType>>;
};

export type NestedEnumUpgradeTypeNullableFilter = {
  equals?: InputMaybe<UpgradeType>;
  in?: InputMaybe<Array<UpgradeType>>;
  not?: InputMaybe<NestedEnumUpgradeTypeNullableFilter>;
  notIn?: InputMaybe<Array<UpgradeType>>;
};

export type NestedEnumUpgradeTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumUpgradeTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumUpgradeTypeNullableFilter>;
  equals?: InputMaybe<UpgradeType>;
  in?: InputMaybe<Array<UpgradeType>>;
  not?: InputMaybe<NestedEnumUpgradeTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UpgradeType>>;
};

export type NestedEnumUserArticleActionFilter = {
  equals?: InputMaybe<UserArticleAction>;
  in?: InputMaybe<Array<UserArticleAction>>;
  not?: InputMaybe<NestedEnumUserArticleActionFilter>;
  notIn?: InputMaybe<Array<UserArticleAction>>;
};

export type NestedEnumUserArticleActionWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUserArticleActionFilter>;
  _min?: InputMaybe<NestedEnumUserArticleActionFilter>;
  equals?: InputMaybe<UserArticleAction>;
  in?: InputMaybe<Array<UserArticleAction>>;
  not?: InputMaybe<NestedEnumUserArticleActionWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UserArticleAction>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedJsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedJsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NullableEnumCouponDiscountTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CouponDiscountType>;
};

export type NullableEnumPaymentDiscountSourceFieldUpdateOperationsInput = {
  set?: InputMaybe<PaymentDiscountSource>;
};

export type NullableEnumUpgradeTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UpgradeType>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type PaymentAvgOrderByAggregateInput = {
  amountInCents?: InputMaybe<SortOrder>;
  couponDiscountAppliedInCents?: InputMaybe<SortOrder>;
  exchangeRate?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
  upgradeDiscountInCents?: InputMaybe<SortOrder>;
};

export type PaymentCountOrderByAggregateInput = {
  amountInCents?: InputMaybe<SortOrder>;
  billingAddress?: InputMaybe<SortOrder>;
  billingCountryCode?: InputMaybe<SortOrder>;
  couponDiscountAppliedInCents?: InputMaybe<SortOrder>;
  couponDiscountType?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  discountSource?: InputMaybe<SortOrder>;
  exchangeRate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isInvoiceSent?: InputMaybe<SortOrder>;
  isLegacyXero?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  stripePayoutId?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
  upgradeDiscountInCents?: InputMaybe<SortOrder>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
  upgradePromptEngagementId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  xeroInvoiceNumber?: InputMaybe<SortOrder>;
};

export type PaymentCreateInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutUsedInPaymentsInput>;
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutPaymentInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutPaymentInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentCreateNestedManyWithoutPaymentInput>;
  stripePayout?: InputMaybe<StripePayoutCreateNestedOneWithoutPaymentsInput>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountCreateNestedOneWithoutPaymentsInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementCreateNestedOneWithoutPaymentInput>;
  user: UserCreateNestedOneWithoutPaymentsInput;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateManyCouponInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  stripePayoutId?: InputMaybe<Scalars['String']['input']>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscountId?: InputMaybe<Scalars['String']['input']>;
  upgradePromptEngagementId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateManyCouponInputEnvelope = {
  data: Array<PaymentCreateManyCouponInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentCreateManyInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  stripePayoutId?: InputMaybe<Scalars['String']['input']>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscountId?: InputMaybe<Scalars['String']['input']>;
  upgradePromptEngagementId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateManyStripePayoutInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscountId?: InputMaybe<Scalars['String']['input']>;
  upgradePromptEngagementId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateManyStripePayoutInputEnvelope = {
  data: Array<PaymentCreateManyStripePayoutInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentCreateManyUpgradePathDiscountInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  stripePayoutId?: InputMaybe<Scalars['String']['input']>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagementId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateManyUpgradePathDiscountInputEnvelope = {
  data: Array<PaymentCreateManyUpgradePathDiscountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentCreateManyUserInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  stripePayoutId?: InputMaybe<Scalars['String']['input']>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscountId?: InputMaybe<Scalars['String']['input']>;
  upgradePromptEngagementId?: InputMaybe<Scalars['String']['input']>;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateManyUserInputEnvelope = {
  data: Array<PaymentCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentCreateNestedManyWithoutCouponInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutCouponInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutCouponInput>>;
  createMany?: InputMaybe<PaymentCreateManyCouponInputEnvelope>;
};

export type PaymentCreateNestedManyWithoutStripePayoutInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutStripePayoutInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutStripePayoutInput>>;
  createMany?: InputMaybe<PaymentCreateManyStripePayoutInputEnvelope>;
};

export type PaymentCreateNestedManyWithoutUpgradePathDiscountInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutUpgradePathDiscountInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutUpgradePathDiscountInput>>;
  createMany?: InputMaybe<PaymentCreateManyUpgradePathDiscountInputEnvelope>;
};

export type PaymentCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutUserInput>>;
  createMany?: InputMaybe<PaymentCreateManyUserInputEnvelope>;
};

export type PaymentCreateNestedOneWithoutPaymentItemsInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutPaymentItemsInput>;
  create?: InputMaybe<PaymentCreateWithoutPaymentItemsInput>;
};

export type PaymentCreateNestedOneWithoutRefundsInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutRefundsInput>;
  create?: InputMaybe<PaymentCreateWithoutRefundsInput>;
};

export type PaymentCreateNestedOneWithoutStripePaymentIntentsInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: InputMaybe<PaymentCreateWithoutStripePaymentIntentsInput>;
};

export type PaymentCreateNestedOneWithoutUpgradePromptEngagementInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutUpgradePromptEngagementInput>;
  create?: InputMaybe<PaymentCreateWithoutUpgradePromptEngagementInput>;
};

export type PaymentCreateOrConnectWithoutCouponInput = {
  create: PaymentCreateWithoutCouponInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutPaymentItemsInput = {
  create: PaymentCreateWithoutPaymentItemsInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutRefundsInput = {
  create: PaymentCreateWithoutRefundsInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutStripePaymentIntentsInput = {
  create: PaymentCreateWithoutStripePaymentIntentsInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutStripePayoutInput = {
  create: PaymentCreateWithoutStripePayoutInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutUpgradePathDiscountInput = {
  create: PaymentCreateWithoutUpgradePathDiscountInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutUpgradePromptEngagementInput = {
  create: PaymentCreateWithoutUpgradePromptEngagementInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutUserInput = {
  create: PaymentCreateWithoutUserInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateWithoutCouponInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutPaymentInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutPaymentInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentCreateNestedManyWithoutPaymentInput>;
  stripePayout?: InputMaybe<StripePayoutCreateNestedOneWithoutPaymentsInput>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountCreateNestedOneWithoutPaymentsInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementCreateNestedOneWithoutPaymentInput>;
  user: UserCreateNestedOneWithoutPaymentsInput;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateWithoutPaymentItemsInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutUsedInPaymentsInput>;
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutPaymentInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentCreateNestedManyWithoutPaymentInput>;
  stripePayout?: InputMaybe<StripePayoutCreateNestedOneWithoutPaymentsInput>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountCreateNestedOneWithoutPaymentsInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementCreateNestedOneWithoutPaymentInput>;
  user: UserCreateNestedOneWithoutPaymentsInput;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateWithoutRefundsInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutUsedInPaymentsInput>;
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutPaymentInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentCreateNestedManyWithoutPaymentInput>;
  stripePayout?: InputMaybe<StripePayoutCreateNestedOneWithoutPaymentsInput>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountCreateNestedOneWithoutPaymentsInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementCreateNestedOneWithoutPaymentInput>;
  user: UserCreateNestedOneWithoutPaymentsInput;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateWithoutStripePaymentIntentsInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutUsedInPaymentsInput>;
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutPaymentInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutPaymentInput>;
  stripePayout?: InputMaybe<StripePayoutCreateNestedOneWithoutPaymentsInput>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountCreateNestedOneWithoutPaymentsInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementCreateNestedOneWithoutPaymentInput>;
  user: UserCreateNestedOneWithoutPaymentsInput;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateWithoutStripePayoutInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutUsedInPaymentsInput>;
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutPaymentInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutPaymentInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentCreateNestedManyWithoutPaymentInput>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountCreateNestedOneWithoutPaymentsInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementCreateNestedOneWithoutPaymentInput>;
  user: UserCreateNestedOneWithoutPaymentsInput;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateWithoutUpgradePathDiscountInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutUsedInPaymentsInput>;
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutPaymentInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutPaymentInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentCreateNestedManyWithoutPaymentInput>;
  stripePayout?: InputMaybe<StripePayoutCreateNestedOneWithoutPaymentsInput>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementCreateNestedOneWithoutPaymentInput>;
  user: UserCreateNestedOneWithoutPaymentsInput;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateWithoutUpgradePromptEngagementInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutUsedInPaymentsInput>;
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutPaymentInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutPaymentInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentCreateNestedManyWithoutPaymentInput>;
  stripePayout?: InputMaybe<StripePayoutCreateNestedOneWithoutPaymentsInput>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountCreateNestedOneWithoutPaymentsInput>;
  user: UserCreateNestedOneWithoutPaymentsInput;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCreateWithoutUserInput = {
  amountInCents: Scalars['Int']['input'];
  billingAddress: Scalars['JSON']['input'];
  billingCountryCode: Scalars['String']['input'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutUsedInPaymentsInput>;
  couponDiscountAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  couponDiscountType?: InputMaybe<CouponDiscountType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  discountSource?: InputMaybe<PaymentDiscountSource>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutPaymentInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutPaymentInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentCreateNestedManyWithoutPaymentInput>;
  stripePayout?: InputMaybe<StripePayoutCreateNestedOneWithoutPaymentsInput>;
  taxInCents: Scalars['Int']['input'];
  upgradeDiscountInCents?: InputMaybe<Scalars['Int']['input']>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountCreateNestedOneWithoutPaymentsInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementCreateNestedOneWithoutPaymentInput>;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum PaymentDiscountSource {
  Coupon = 'COUPON',
  None = 'NONE',
  UpgradePrompt = 'UPGRADE_PROMPT'
}

export type PaymentItemCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHandled?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  renewsSubscriptionId?: InputMaybe<SortOrder>;
};

export type PaymentItemCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHandled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payment: PaymentCreateNestedOneWithoutPaymentItemsInput;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeCreateNestedOneWithoutPaymentItemsInput>;
  renewsSubscription?: InputMaybe<UserSubscriptionCreateNestedOneWithoutRenewedByPaymentsInput>;
};

export type PaymentItemCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHandled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentId: Scalars['String']['input'];
  productSubscriptionTypeId?: InputMaybe<Scalars['String']['input']>;
  renewsSubscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentItemCreateManyPaymentInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHandled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productSubscriptionTypeId?: InputMaybe<Scalars['String']['input']>;
  renewsSubscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentItemCreateManyPaymentInputEnvelope = {
  data: Array<PaymentItemCreateManyPaymentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentItemCreateManyProductSubscriptionTypeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHandled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentId: Scalars['String']['input'];
  renewsSubscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentItemCreateManyProductSubscriptionTypeInputEnvelope = {
  data: Array<PaymentItemCreateManyProductSubscriptionTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentItemCreateManyRenewsSubscriptionInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHandled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentId: Scalars['String']['input'];
  productSubscriptionTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentItemCreateManyRenewsSubscriptionInputEnvelope = {
  data: Array<PaymentItemCreateManyRenewsSubscriptionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentItemCreateNestedManyWithoutPaymentInput = {
  connect?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentItemCreateOrConnectWithoutPaymentInput>>;
  create?: InputMaybe<Array<PaymentItemCreateWithoutPaymentInput>>;
  createMany?: InputMaybe<PaymentItemCreateManyPaymentInputEnvelope>;
};

export type PaymentItemCreateNestedManyWithoutProductSubscriptionTypeInput = {
  connect?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentItemCreateOrConnectWithoutProductSubscriptionTypeInput>>;
  create?: InputMaybe<Array<PaymentItemCreateWithoutProductSubscriptionTypeInput>>;
  createMany?: InputMaybe<PaymentItemCreateManyProductSubscriptionTypeInputEnvelope>;
};

export type PaymentItemCreateNestedManyWithoutRenewsSubscriptionInput = {
  connect?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentItemCreateOrConnectWithoutRenewsSubscriptionInput>>;
  create?: InputMaybe<Array<PaymentItemCreateWithoutRenewsSubscriptionInput>>;
  createMany?: InputMaybe<PaymentItemCreateManyRenewsSubscriptionInputEnvelope>;
};

export type PaymentItemCreateOrConnectWithoutPaymentInput = {
  create: PaymentItemCreateWithoutPaymentInput;
  where: PaymentItemWhereUniqueInput;
};

export type PaymentItemCreateOrConnectWithoutProductSubscriptionTypeInput = {
  create: PaymentItemCreateWithoutProductSubscriptionTypeInput;
  where: PaymentItemWhereUniqueInput;
};

export type PaymentItemCreateOrConnectWithoutRenewsSubscriptionInput = {
  create: PaymentItemCreateWithoutRenewsSubscriptionInput;
  where: PaymentItemWhereUniqueInput;
};

export type PaymentItemCreateWithoutPaymentInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHandled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeCreateNestedOneWithoutPaymentItemsInput>;
  renewsSubscription?: InputMaybe<UserSubscriptionCreateNestedOneWithoutRenewedByPaymentsInput>;
};

export type PaymentItemCreateWithoutProductSubscriptionTypeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHandled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payment: PaymentCreateNestedOneWithoutPaymentItemsInput;
  renewsSubscription?: InputMaybe<UserSubscriptionCreateNestedOneWithoutRenewedByPaymentsInput>;
};

export type PaymentItemCreateWithoutRenewsSubscriptionInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHandled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payment: PaymentCreateNestedOneWithoutPaymentItemsInput;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeCreateNestedOneWithoutPaymentItemsInput>;
};

export type PaymentItemListRelationFilter = {
  every?: InputMaybe<PaymentItemWhereInput>;
  none?: InputMaybe<PaymentItemWhereInput>;
  some?: InputMaybe<PaymentItemWhereInput>;
};

export type PaymentItemMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHandled?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  renewsSubscriptionId?: InputMaybe<SortOrder>;
};

export type PaymentItemMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHandled?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  renewsSubscriptionId?: InputMaybe<SortOrder>;
};

export type PaymentItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PaymentItemOrderByWithAggregationInput = {
  _count?: InputMaybe<PaymentItemCountOrderByAggregateInput>;
  _max?: InputMaybe<PaymentItemMaxOrderByAggregateInput>;
  _min?: InputMaybe<PaymentItemMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHandled?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrderInput>;
  renewsSubscriptionId?: InputMaybe<SortOrderInput>;
};

export type PaymentItemOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHandled?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  payment?: InputMaybe<PaymentOrderByWithRelationInput>;
  paymentId?: InputMaybe<SortOrder>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeOrderByWithRelationInput>;
  productSubscriptionTypeId?: InputMaybe<SortOrderInput>;
  renewsSubscription?: InputMaybe<UserSubscriptionOrderByWithRelationInput>;
  renewsSubscriptionId?: InputMaybe<SortOrderInput>;
};

export enum PaymentItemScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  IsHandled = 'isHandled',
  Modified = 'modified',
  PaymentId = 'paymentId',
  ProductSubscriptionTypeId = 'productSubscriptionTypeId',
  RenewsSubscriptionId = 'renewsSubscriptionId'
}

export type PaymentItemScalarWhereInput = {
  AND?: InputMaybe<Array<PaymentItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<PaymentItemScalarWhereInput>>;
  OR?: InputMaybe<Array<PaymentItemScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isHandled?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  paymentId?: InputMaybe<StringFilter>;
  productSubscriptionTypeId?: InputMaybe<StringNullableFilter>;
  renewsSubscriptionId?: InputMaybe<StringNullableFilter>;
};

export type PaymentItemScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PaymentItemScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PaymentItemScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PaymentItemScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isHandled?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  paymentId?: InputMaybe<StringWithAggregatesFilter>;
  productSubscriptionTypeId?: InputMaybe<StringNullableWithAggregatesFilter>;
  renewsSubscriptionId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type PaymentItemUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHandled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneRequiredWithoutPaymentItemsNestedInput>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneWithoutPaymentItemsNestedInput>;
  renewsSubscription?: InputMaybe<UserSubscriptionUpdateOneWithoutRenewedByPaymentsNestedInput>;
};

export type PaymentItemUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHandled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentItemUpdateManyWithWhereWithoutPaymentInput = {
  data: PaymentItemUpdateManyMutationInput;
  where: PaymentItemScalarWhereInput;
};

export type PaymentItemUpdateManyWithWhereWithoutProductSubscriptionTypeInput = {
  data: PaymentItemUpdateManyMutationInput;
  where: PaymentItemScalarWhereInput;
};

export type PaymentItemUpdateManyWithWhereWithoutRenewsSubscriptionInput = {
  data: PaymentItemUpdateManyMutationInput;
  where: PaymentItemScalarWhereInput;
};

export type PaymentItemUpdateManyWithoutPaymentNestedInput = {
  connect?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentItemCreateOrConnectWithoutPaymentInput>>;
  create?: InputMaybe<Array<PaymentItemCreateWithoutPaymentInput>>;
  createMany?: InputMaybe<PaymentItemCreateManyPaymentInputEnvelope>;
  delete?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentItemUpdateWithWhereUniqueWithoutPaymentInput>>;
  updateMany?: InputMaybe<Array<PaymentItemUpdateManyWithWhereWithoutPaymentInput>>;
  upsert?: InputMaybe<Array<PaymentItemUpsertWithWhereUniqueWithoutPaymentInput>>;
};

export type PaymentItemUpdateManyWithoutProductSubscriptionTypeNestedInput = {
  connect?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentItemCreateOrConnectWithoutProductSubscriptionTypeInput>>;
  create?: InputMaybe<Array<PaymentItemCreateWithoutProductSubscriptionTypeInput>>;
  createMany?: InputMaybe<PaymentItemCreateManyProductSubscriptionTypeInputEnvelope>;
  delete?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentItemUpdateWithWhereUniqueWithoutProductSubscriptionTypeInput>>;
  updateMany?: InputMaybe<Array<PaymentItemUpdateManyWithWhereWithoutProductSubscriptionTypeInput>>;
  upsert?: InputMaybe<Array<PaymentItemUpsertWithWhereUniqueWithoutProductSubscriptionTypeInput>>;
};

export type PaymentItemUpdateManyWithoutRenewsSubscriptionNestedInput = {
  connect?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentItemCreateOrConnectWithoutRenewsSubscriptionInput>>;
  create?: InputMaybe<Array<PaymentItemCreateWithoutRenewsSubscriptionInput>>;
  createMany?: InputMaybe<PaymentItemCreateManyRenewsSubscriptionInputEnvelope>;
  delete?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentItemUpdateWithWhereUniqueWithoutRenewsSubscriptionInput>>;
  updateMany?: InputMaybe<Array<PaymentItemUpdateManyWithWhereWithoutRenewsSubscriptionInput>>;
  upsert?: InputMaybe<Array<PaymentItemUpsertWithWhereUniqueWithoutRenewsSubscriptionInput>>;
};

export type PaymentItemUpdateWithWhereUniqueWithoutPaymentInput = {
  data: PaymentItemUpdateWithoutPaymentInput;
  where: PaymentItemWhereUniqueInput;
};

export type PaymentItemUpdateWithWhereUniqueWithoutProductSubscriptionTypeInput = {
  data: PaymentItemUpdateWithoutProductSubscriptionTypeInput;
  where: PaymentItemWhereUniqueInput;
};

export type PaymentItemUpdateWithWhereUniqueWithoutRenewsSubscriptionInput = {
  data: PaymentItemUpdateWithoutRenewsSubscriptionInput;
  where: PaymentItemWhereUniqueInput;
};

export type PaymentItemUpdateWithoutPaymentInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHandled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneWithoutPaymentItemsNestedInput>;
  renewsSubscription?: InputMaybe<UserSubscriptionUpdateOneWithoutRenewedByPaymentsNestedInput>;
};

export type PaymentItemUpdateWithoutProductSubscriptionTypeInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHandled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneRequiredWithoutPaymentItemsNestedInput>;
  renewsSubscription?: InputMaybe<UserSubscriptionUpdateOneWithoutRenewedByPaymentsNestedInput>;
};

export type PaymentItemUpdateWithoutRenewsSubscriptionInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHandled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneRequiredWithoutPaymentItemsNestedInput>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneWithoutPaymentItemsNestedInput>;
};

export type PaymentItemUpsertWithWhereUniqueWithoutPaymentInput = {
  create: PaymentItemCreateWithoutPaymentInput;
  update: PaymentItemUpdateWithoutPaymentInput;
  where: PaymentItemWhereUniqueInput;
};

export type PaymentItemUpsertWithWhereUniqueWithoutProductSubscriptionTypeInput = {
  create: PaymentItemCreateWithoutProductSubscriptionTypeInput;
  update: PaymentItemUpdateWithoutProductSubscriptionTypeInput;
  where: PaymentItemWhereUniqueInput;
};

export type PaymentItemUpsertWithWhereUniqueWithoutRenewsSubscriptionInput = {
  create: PaymentItemCreateWithoutRenewsSubscriptionInput;
  update: PaymentItemUpdateWithoutRenewsSubscriptionInput;
  where: PaymentItemWhereUniqueInput;
};

export type PaymentItemWhereInput = {
  AND?: InputMaybe<Array<PaymentItemWhereInput>>;
  NOT?: InputMaybe<Array<PaymentItemWhereInput>>;
  OR?: InputMaybe<Array<PaymentItemWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isHandled?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  payment?: InputMaybe<PaymentScalarRelationFilter>;
  paymentId?: InputMaybe<StringFilter>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeNullableScalarRelationFilter>;
  productSubscriptionTypeId?: InputMaybe<StringNullableFilter>;
  renewsSubscription?: InputMaybe<UserSubscriptionNullableScalarRelationFilter>;
  renewsSubscriptionId?: InputMaybe<StringNullableFilter>;
};

export type PaymentItemWhereUniqueInput = {
  AND?: InputMaybe<Array<PaymentItemWhereInput>>;
  NOT?: InputMaybe<Array<PaymentItemWhereInput>>;
  OR?: InputMaybe<Array<PaymentItemWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHandled?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  payment?: InputMaybe<PaymentScalarRelationFilter>;
  paymentId?: InputMaybe<StringFilter>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeNullableScalarRelationFilter>;
  productSubscriptionTypeId?: InputMaybe<StringNullableFilter>;
  renewsSubscription?: InputMaybe<UserSubscriptionNullableScalarRelationFilter>;
  renewsSubscriptionId?: InputMaybe<StringNullableFilter>;
};

export type PaymentListRelationFilter = {
  every?: InputMaybe<PaymentWhereInput>;
  none?: InputMaybe<PaymentWhereInput>;
  some?: InputMaybe<PaymentWhereInput>;
};

export type PaymentMaxOrderByAggregateInput = {
  amountInCents?: InputMaybe<SortOrder>;
  billingCountryCode?: InputMaybe<SortOrder>;
  couponDiscountAppliedInCents?: InputMaybe<SortOrder>;
  couponDiscountType?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  discountSource?: InputMaybe<SortOrder>;
  exchangeRate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isInvoiceSent?: InputMaybe<SortOrder>;
  isLegacyXero?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  stripePayoutId?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
  upgradeDiscountInCents?: InputMaybe<SortOrder>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
  upgradePromptEngagementId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  xeroInvoiceNumber?: InputMaybe<SortOrder>;
};

export type PaymentMinOrderByAggregateInput = {
  amountInCents?: InputMaybe<SortOrder>;
  billingCountryCode?: InputMaybe<SortOrder>;
  couponDiscountAppliedInCents?: InputMaybe<SortOrder>;
  couponDiscountType?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  discountSource?: InputMaybe<SortOrder>;
  exchangeRate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isInvoiceSent?: InputMaybe<SortOrder>;
  isLegacyXero?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  stripePayoutId?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
  upgradeDiscountInCents?: InputMaybe<SortOrder>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
  upgradePromptEngagementId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  xeroInvoiceNumber?: InputMaybe<SortOrder>;
};

export type PaymentNullableScalarRelationFilter = {
  is?: InputMaybe<PaymentWhereInput>;
  isNot?: InputMaybe<PaymentWhereInput>;
};

export type PaymentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PaymentOrderByWithAggregationInput = {
  _avg?: InputMaybe<PaymentAvgOrderByAggregateInput>;
  _count?: InputMaybe<PaymentCountOrderByAggregateInput>;
  _max?: InputMaybe<PaymentMaxOrderByAggregateInput>;
  _min?: InputMaybe<PaymentMinOrderByAggregateInput>;
  _sum?: InputMaybe<PaymentSumOrderByAggregateInput>;
  amountInCents?: InputMaybe<SortOrder>;
  billingAddress?: InputMaybe<SortOrder>;
  billingCountryCode?: InputMaybe<SortOrder>;
  couponDiscountAppliedInCents?: InputMaybe<SortOrderInput>;
  couponDiscountType?: InputMaybe<SortOrderInput>;
  couponId?: InputMaybe<SortOrderInput>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  discountSource?: InputMaybe<SortOrderInput>;
  exchangeRate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isInvoiceSent?: InputMaybe<SortOrder>;
  isLegacyXero?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  stripePayoutId?: InputMaybe<SortOrderInput>;
  taxInCents?: InputMaybe<SortOrder>;
  upgradeDiscountInCents?: InputMaybe<SortOrderInput>;
  upgradePathDiscountId?: InputMaybe<SortOrderInput>;
  upgradePromptEngagementId?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrder>;
  xeroInvoiceNumber?: InputMaybe<SortOrderInput>;
};

export type PaymentOrderByWithRelationInput = {
  amountInCents?: InputMaybe<SortOrder>;
  billingAddress?: InputMaybe<SortOrder>;
  billingCountryCode?: InputMaybe<SortOrder>;
  coupon?: InputMaybe<CouponOrderByWithRelationInput>;
  couponDiscountAppliedInCents?: InputMaybe<SortOrderInput>;
  couponDiscountType?: InputMaybe<SortOrderInput>;
  couponId?: InputMaybe<SortOrderInput>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  discountSource?: InputMaybe<SortOrderInput>;
  exchangeRate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isInvoiceSent?: InputMaybe<SortOrder>;
  isLegacyXero?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  paymentItems?: InputMaybe<PaymentItemOrderByRelationAggregateInput>;
  refunds?: InputMaybe<RefundOrderByRelationAggregateInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentOrderByRelationAggregateInput>;
  stripePayout?: InputMaybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: InputMaybe<SortOrderInput>;
  taxInCents?: InputMaybe<SortOrder>;
  upgradeDiscountInCents?: InputMaybe<SortOrderInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountOrderByWithRelationInput>;
  upgradePathDiscountId?: InputMaybe<SortOrderInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementOrderByWithRelationInput>;
  upgradePromptEngagementId?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  xeroInvoiceNumber?: InputMaybe<SortOrderInput>;
};

export enum PaymentScalarFieldEnum {
  AmountInCents = 'amountInCents',
  BillingAddress = 'billingAddress',
  BillingCountryCode = 'billingCountryCode',
  CouponDiscountAppliedInCents = 'couponDiscountAppliedInCents',
  CouponDiscountType = 'couponDiscountType',
  CouponId = 'couponId',
  Created = 'created',
  Currency = 'currency',
  DiscountSource = 'discountSource',
  ExchangeRate = 'exchangeRate',
  Id = 'id',
  IsInvoiceSent = 'isInvoiceSent',
  IsLegacyXero = 'isLegacyXero',
  Modified = 'modified',
  StripePayoutId = 'stripePayoutId',
  TaxInCents = 'taxInCents',
  UpgradeDiscountInCents = 'upgradeDiscountInCents',
  UpgradePathDiscountId = 'upgradePathDiscountId',
  UpgradePromptEngagementId = 'upgradePromptEngagementId',
  UserId = 'userId',
  XeroInvoiceNumber = 'xeroInvoiceNumber'
}

export type PaymentScalarRelationFilter = {
  is?: InputMaybe<PaymentWhereInput>;
  isNot?: InputMaybe<PaymentWhereInput>;
};

export type PaymentScalarWhereInput = {
  AND?: InputMaybe<Array<PaymentScalarWhereInput>>;
  NOT?: InputMaybe<Array<PaymentScalarWhereInput>>;
  OR?: InputMaybe<Array<PaymentScalarWhereInput>>;
  amountInCents?: InputMaybe<IntFilter>;
  billingAddress?: InputMaybe<JsonFilter>;
  billingCountryCode?: InputMaybe<StringFilter>;
  couponDiscountAppliedInCents?: InputMaybe<IntNullableFilter>;
  couponDiscountType?: InputMaybe<EnumCouponDiscountTypeNullableFilter>;
  couponId?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyFilter>;
  discountSource?: InputMaybe<EnumPaymentDiscountSourceNullableFilter>;
  exchangeRate?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isInvoiceSent?: InputMaybe<BoolFilter>;
  isLegacyXero?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  stripePayoutId?: InputMaybe<StringNullableFilter>;
  taxInCents?: InputMaybe<IntFilter>;
  upgradeDiscountInCents?: InputMaybe<IntNullableFilter>;
  upgradePathDiscountId?: InputMaybe<StringNullableFilter>;
  upgradePromptEngagementId?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringFilter>;
  xeroInvoiceNumber?: InputMaybe<StringNullableFilter>;
};

export type PaymentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PaymentScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PaymentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PaymentScalarWhereWithAggregatesInput>>;
  amountInCents?: InputMaybe<IntWithAggregatesFilter>;
  billingAddress?: InputMaybe<JsonWithAggregatesFilter>;
  billingCountryCode?: InputMaybe<StringWithAggregatesFilter>;
  couponDiscountAppliedInCents?: InputMaybe<IntNullableWithAggregatesFilter>;
  couponDiscountType?: InputMaybe<EnumCouponDiscountTypeNullableWithAggregatesFilter>;
  couponId?: InputMaybe<StringNullableWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyWithAggregatesFilter>;
  discountSource?: InputMaybe<EnumPaymentDiscountSourceNullableWithAggregatesFilter>;
  exchangeRate?: InputMaybe<FloatNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isInvoiceSent?: InputMaybe<BoolWithAggregatesFilter>;
  isLegacyXero?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  stripePayoutId?: InputMaybe<StringNullableWithAggregatesFilter>;
  taxInCents?: InputMaybe<IntWithAggregatesFilter>;
  upgradeDiscountInCents?: InputMaybe<IntNullableWithAggregatesFilter>;
  upgradePathDiscountId?: InputMaybe<StringNullableWithAggregatesFilter>;
  upgradePromptEngagementId?: InputMaybe<StringNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
  xeroInvoiceNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type PaymentSumOrderByAggregateInput = {
  amountInCents?: InputMaybe<SortOrder>;
  couponDiscountAppliedInCents?: InputMaybe<SortOrder>;
  exchangeRate?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
  upgradeDiscountInCents?: InputMaybe<SortOrder>;
};

export type PaymentUpdateInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutUsedInPaymentsNestedInput>;
  couponDiscountAppliedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponDiscountType?: InputMaybe<NullableEnumCouponDiscountTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  discountSource?: InputMaybe<NullableEnumPaymentDiscountSourceFieldUpdateOperationsInput>;
  exchangeRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInvoiceSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutPaymentNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutPaymentNestedInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentUpdateManyWithoutPaymentNestedInput>;
  stripePayout?: InputMaybe<StripePayoutUpdateOneWithoutPaymentsNestedInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  upgradeDiscountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneWithoutPaymentsNestedInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementUpdateOneWithoutPaymentNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPaymentsNestedInput>;
  xeroInvoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaymentUpdateManyMutationInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponDiscountAppliedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponDiscountType?: InputMaybe<NullableEnumCouponDiscountTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  discountSource?: InputMaybe<NullableEnumPaymentDiscountSourceFieldUpdateOperationsInput>;
  exchangeRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInvoiceSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  upgradeDiscountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  xeroInvoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaymentUpdateManyWithWhereWithoutCouponInput = {
  data: PaymentUpdateManyMutationInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateManyWithWhereWithoutStripePayoutInput = {
  data: PaymentUpdateManyMutationInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateManyWithWhereWithoutUpgradePathDiscountInput = {
  data: PaymentUpdateManyMutationInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateManyWithWhereWithoutUserInput = {
  data: PaymentUpdateManyMutationInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateManyWithoutCouponNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutCouponInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutCouponInput>>;
  createMany?: InputMaybe<PaymentCreateManyCouponInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutCouponInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutCouponInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutCouponInput>>;
};

export type PaymentUpdateManyWithoutStripePayoutNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutStripePayoutInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutStripePayoutInput>>;
  createMany?: InputMaybe<PaymentCreateManyStripePayoutInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutStripePayoutInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutStripePayoutInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutStripePayoutInput>>;
};

export type PaymentUpdateManyWithoutUpgradePathDiscountNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutUpgradePathDiscountInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutUpgradePathDiscountInput>>;
  createMany?: InputMaybe<PaymentCreateManyUpgradePathDiscountInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutUpgradePathDiscountInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutUpgradePathDiscountInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutUpgradePathDiscountInput>>;
};

export type PaymentUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutUserInput>>;
  createMany?: InputMaybe<PaymentCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutUserInput>>;
};

export type PaymentUpdateOneRequiredWithoutPaymentItemsNestedInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutPaymentItemsInput>;
  create?: InputMaybe<PaymentCreateWithoutPaymentItemsInput>;
  update?: InputMaybe<PaymentUpdateToOneWithWhereWithoutPaymentItemsInput>;
  upsert?: InputMaybe<PaymentUpsertWithoutPaymentItemsInput>;
};

export type PaymentUpdateOneRequiredWithoutRefundsNestedInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutRefundsInput>;
  create?: InputMaybe<PaymentCreateWithoutRefundsInput>;
  update?: InputMaybe<PaymentUpdateToOneWithWhereWithoutRefundsInput>;
  upsert?: InputMaybe<PaymentUpsertWithoutRefundsInput>;
};

export type PaymentUpdateOneRequiredWithoutStripePaymentIntentsNestedInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutStripePaymentIntentsInput>;
  create?: InputMaybe<PaymentCreateWithoutStripePaymentIntentsInput>;
  update?: InputMaybe<PaymentUpdateToOneWithWhereWithoutStripePaymentIntentsInput>;
  upsert?: InputMaybe<PaymentUpsertWithoutStripePaymentIntentsInput>;
};

export type PaymentUpdateOneWithoutUpgradePromptEngagementNestedInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutUpgradePromptEngagementInput>;
  create?: InputMaybe<PaymentCreateWithoutUpgradePromptEngagementInput>;
  delete?: InputMaybe<PaymentWhereInput>;
  disconnect?: InputMaybe<PaymentWhereInput>;
  update?: InputMaybe<PaymentUpdateToOneWithWhereWithoutUpgradePromptEngagementInput>;
  upsert?: InputMaybe<PaymentUpsertWithoutUpgradePromptEngagementInput>;
};

export type PaymentUpdateToOneWithWhereWithoutPaymentItemsInput = {
  data: PaymentUpdateWithoutPaymentItemsInput;
  where?: InputMaybe<PaymentWhereInput>;
};

export type PaymentUpdateToOneWithWhereWithoutRefundsInput = {
  data: PaymentUpdateWithoutRefundsInput;
  where?: InputMaybe<PaymentWhereInput>;
};

export type PaymentUpdateToOneWithWhereWithoutStripePaymentIntentsInput = {
  data: PaymentUpdateWithoutStripePaymentIntentsInput;
  where?: InputMaybe<PaymentWhereInput>;
};

export type PaymentUpdateToOneWithWhereWithoutUpgradePromptEngagementInput = {
  data: PaymentUpdateWithoutUpgradePromptEngagementInput;
  where?: InputMaybe<PaymentWhereInput>;
};

export type PaymentUpdateWithWhereUniqueWithoutCouponInput = {
  data: PaymentUpdateWithoutCouponInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpdateWithWhereUniqueWithoutStripePayoutInput = {
  data: PaymentUpdateWithoutStripePayoutInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpdateWithWhereUniqueWithoutUpgradePathDiscountInput = {
  data: PaymentUpdateWithoutUpgradePathDiscountInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpdateWithWhereUniqueWithoutUserInput = {
  data: PaymentUpdateWithoutUserInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpdateWithoutCouponInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponDiscountAppliedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponDiscountType?: InputMaybe<NullableEnumCouponDiscountTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  discountSource?: InputMaybe<NullableEnumPaymentDiscountSourceFieldUpdateOperationsInput>;
  exchangeRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInvoiceSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutPaymentNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutPaymentNestedInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentUpdateManyWithoutPaymentNestedInput>;
  stripePayout?: InputMaybe<StripePayoutUpdateOneWithoutPaymentsNestedInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  upgradeDiscountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneWithoutPaymentsNestedInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementUpdateOneWithoutPaymentNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPaymentsNestedInput>;
  xeroInvoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutPaymentItemsInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutUsedInPaymentsNestedInput>;
  couponDiscountAppliedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponDiscountType?: InputMaybe<NullableEnumCouponDiscountTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  discountSource?: InputMaybe<NullableEnumPaymentDiscountSourceFieldUpdateOperationsInput>;
  exchangeRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInvoiceSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutPaymentNestedInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentUpdateManyWithoutPaymentNestedInput>;
  stripePayout?: InputMaybe<StripePayoutUpdateOneWithoutPaymentsNestedInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  upgradeDiscountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneWithoutPaymentsNestedInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementUpdateOneWithoutPaymentNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPaymentsNestedInput>;
  xeroInvoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutRefundsInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutUsedInPaymentsNestedInput>;
  couponDiscountAppliedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponDiscountType?: InputMaybe<NullableEnumCouponDiscountTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  discountSource?: InputMaybe<NullableEnumPaymentDiscountSourceFieldUpdateOperationsInput>;
  exchangeRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInvoiceSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutPaymentNestedInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentUpdateManyWithoutPaymentNestedInput>;
  stripePayout?: InputMaybe<StripePayoutUpdateOneWithoutPaymentsNestedInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  upgradeDiscountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneWithoutPaymentsNestedInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementUpdateOneWithoutPaymentNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPaymentsNestedInput>;
  xeroInvoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutStripePaymentIntentsInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutUsedInPaymentsNestedInput>;
  couponDiscountAppliedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponDiscountType?: InputMaybe<NullableEnumCouponDiscountTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  discountSource?: InputMaybe<NullableEnumPaymentDiscountSourceFieldUpdateOperationsInput>;
  exchangeRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInvoiceSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutPaymentNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutPaymentNestedInput>;
  stripePayout?: InputMaybe<StripePayoutUpdateOneWithoutPaymentsNestedInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  upgradeDiscountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneWithoutPaymentsNestedInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementUpdateOneWithoutPaymentNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPaymentsNestedInput>;
  xeroInvoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutStripePayoutInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutUsedInPaymentsNestedInput>;
  couponDiscountAppliedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponDiscountType?: InputMaybe<NullableEnumCouponDiscountTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  discountSource?: InputMaybe<NullableEnumPaymentDiscountSourceFieldUpdateOperationsInput>;
  exchangeRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInvoiceSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutPaymentNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutPaymentNestedInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentUpdateManyWithoutPaymentNestedInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  upgradeDiscountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneWithoutPaymentsNestedInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementUpdateOneWithoutPaymentNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPaymentsNestedInput>;
  xeroInvoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutUpgradePathDiscountInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutUsedInPaymentsNestedInput>;
  couponDiscountAppliedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponDiscountType?: InputMaybe<NullableEnumCouponDiscountTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  discountSource?: InputMaybe<NullableEnumPaymentDiscountSourceFieldUpdateOperationsInput>;
  exchangeRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInvoiceSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutPaymentNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutPaymentNestedInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentUpdateManyWithoutPaymentNestedInput>;
  stripePayout?: InputMaybe<StripePayoutUpdateOneWithoutPaymentsNestedInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  upgradeDiscountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementUpdateOneWithoutPaymentNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPaymentsNestedInput>;
  xeroInvoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutUpgradePromptEngagementInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutUsedInPaymentsNestedInput>;
  couponDiscountAppliedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponDiscountType?: InputMaybe<NullableEnumCouponDiscountTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  discountSource?: InputMaybe<NullableEnumPaymentDiscountSourceFieldUpdateOperationsInput>;
  exchangeRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInvoiceSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutPaymentNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutPaymentNestedInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentUpdateManyWithoutPaymentNestedInput>;
  stripePayout?: InputMaybe<StripePayoutUpdateOneWithoutPaymentsNestedInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  upgradeDiscountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneWithoutPaymentsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPaymentsNestedInput>;
  xeroInvoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutUserInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutUsedInPaymentsNestedInput>;
  couponDiscountAppliedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponDiscountType?: InputMaybe<NullableEnumCouponDiscountTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  discountSource?: InputMaybe<NullableEnumPaymentDiscountSourceFieldUpdateOperationsInput>;
  exchangeRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInvoiceSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutPaymentNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutPaymentNestedInput>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentUpdateManyWithoutPaymentNestedInput>;
  stripePayout?: InputMaybe<StripePayoutUpdateOneWithoutPaymentsNestedInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  upgradeDiscountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneWithoutPaymentsNestedInput>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementUpdateOneWithoutPaymentNestedInput>;
  xeroInvoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaymentUpsertWithWhereUniqueWithoutCouponInput = {
  create: PaymentCreateWithoutCouponInput;
  update: PaymentUpdateWithoutCouponInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpsertWithWhereUniqueWithoutStripePayoutInput = {
  create: PaymentCreateWithoutStripePayoutInput;
  update: PaymentUpdateWithoutStripePayoutInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpsertWithWhereUniqueWithoutUpgradePathDiscountInput = {
  create: PaymentCreateWithoutUpgradePathDiscountInput;
  update: PaymentUpdateWithoutUpgradePathDiscountInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpsertWithWhereUniqueWithoutUserInput = {
  create: PaymentCreateWithoutUserInput;
  update: PaymentUpdateWithoutUserInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpsertWithoutPaymentItemsInput = {
  create: PaymentCreateWithoutPaymentItemsInput;
  update: PaymentUpdateWithoutPaymentItemsInput;
  where?: InputMaybe<PaymentWhereInput>;
};

export type PaymentUpsertWithoutRefundsInput = {
  create: PaymentCreateWithoutRefundsInput;
  update: PaymentUpdateWithoutRefundsInput;
  where?: InputMaybe<PaymentWhereInput>;
};

export type PaymentUpsertWithoutStripePaymentIntentsInput = {
  create: PaymentCreateWithoutStripePaymentIntentsInput;
  update: PaymentUpdateWithoutStripePaymentIntentsInput;
  where?: InputMaybe<PaymentWhereInput>;
};

export type PaymentUpsertWithoutUpgradePromptEngagementInput = {
  create: PaymentCreateWithoutUpgradePromptEngagementInput;
  update: PaymentUpdateWithoutUpgradePromptEngagementInput;
  where?: InputMaybe<PaymentWhereInput>;
};

export type PaymentWhereInput = {
  AND?: InputMaybe<Array<PaymentWhereInput>>;
  NOT?: InputMaybe<Array<PaymentWhereInput>>;
  OR?: InputMaybe<Array<PaymentWhereInput>>;
  amountInCents?: InputMaybe<IntFilter>;
  billingAddress?: InputMaybe<JsonFilter>;
  billingCountryCode?: InputMaybe<StringFilter>;
  coupon?: InputMaybe<CouponNullableScalarRelationFilter>;
  couponDiscountAppliedInCents?: InputMaybe<IntNullableFilter>;
  couponDiscountType?: InputMaybe<EnumCouponDiscountTypeNullableFilter>;
  couponId?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyFilter>;
  discountSource?: InputMaybe<EnumPaymentDiscountSourceNullableFilter>;
  exchangeRate?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isInvoiceSent?: InputMaybe<BoolFilter>;
  isLegacyXero?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  paymentItems?: InputMaybe<PaymentItemListRelationFilter>;
  refunds?: InputMaybe<RefundListRelationFilter>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentListRelationFilter>;
  stripePayout?: InputMaybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: InputMaybe<StringNullableFilter>;
  taxInCents?: InputMaybe<IntFilter>;
  upgradeDiscountInCents?: InputMaybe<IntNullableFilter>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountNullableScalarRelationFilter>;
  upgradePathDiscountId?: InputMaybe<StringNullableFilter>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementNullableScalarRelationFilter>;
  upgradePromptEngagementId?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  xeroInvoiceNumber?: InputMaybe<StringNullableFilter>;
};

export type PaymentWhereUniqueInput = {
  AND?: InputMaybe<Array<PaymentWhereInput>>;
  NOT?: InputMaybe<Array<PaymentWhereInput>>;
  OR?: InputMaybe<Array<PaymentWhereInput>>;
  amountInCents?: InputMaybe<IntFilter>;
  billingAddress?: InputMaybe<JsonFilter>;
  billingCountryCode?: InputMaybe<StringFilter>;
  coupon?: InputMaybe<CouponNullableScalarRelationFilter>;
  couponDiscountAppliedInCents?: InputMaybe<IntNullableFilter>;
  couponDiscountType?: InputMaybe<EnumCouponDiscountTypeNullableFilter>;
  couponId?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyFilter>;
  discountSource?: InputMaybe<EnumPaymentDiscountSourceNullableFilter>;
  exchangeRate?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isInvoiceSent?: InputMaybe<BoolFilter>;
  isLegacyXero?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  paymentItems?: InputMaybe<PaymentItemListRelationFilter>;
  refunds?: InputMaybe<RefundListRelationFilter>;
  stripePaymentIntents?: InputMaybe<StripePaymentIntentListRelationFilter>;
  stripePayout?: InputMaybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: InputMaybe<StringNullableFilter>;
  taxInCents?: InputMaybe<IntFilter>;
  upgradeDiscountInCents?: InputMaybe<IntNullableFilter>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountNullableScalarRelationFilter>;
  upgradePathDiscountId?: InputMaybe<StringNullableFilter>;
  upgradePromptEngagement?: InputMaybe<UpgradePromptEngagementNullableScalarRelationFilter>;
  upgradePromptEngagementId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  xeroInvoiceNumber?: InputMaybe<StringNullableFilter>;
};

export type PodcastCountOrderByAggregateInput = {
  captivateFeedUrl?: InputMaybe<SortOrder>;
  captivateId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isManaged?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PodcastCreateInput = {
  captivateFeedUrl: Scalars['String']['input'];
  captivateId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isManaged?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  podcastUsers?: InputMaybe<PodcastUserCreateNestedManyWithoutPodcastInput>;
  productPodcasts?: InputMaybe<ProductPodcastCreateNestedManyWithoutPodcastInput>;
  title: Scalars['String']['input'];
};

export type PodcastCreateManyInput = {
  captivateFeedUrl: Scalars['String']['input'];
  captivateId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isManaged?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};

export type PodcastCreateNestedOneWithoutPodcastUsersInput = {
  connect?: InputMaybe<PodcastWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PodcastCreateOrConnectWithoutPodcastUsersInput>;
  create?: InputMaybe<PodcastCreateWithoutPodcastUsersInput>;
};

export type PodcastCreateNestedOneWithoutProductPodcastsInput = {
  connect?: InputMaybe<PodcastWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PodcastCreateOrConnectWithoutProductPodcastsInput>;
  create?: InputMaybe<PodcastCreateWithoutProductPodcastsInput>;
};

export type PodcastCreateOrConnectWithoutPodcastUsersInput = {
  create: PodcastCreateWithoutPodcastUsersInput;
  where: PodcastWhereUniqueInput;
};

export type PodcastCreateOrConnectWithoutProductPodcastsInput = {
  create: PodcastCreateWithoutProductPodcastsInput;
  where: PodcastWhereUniqueInput;
};

export type PodcastCreateWithoutPodcastUsersInput = {
  captivateFeedUrl: Scalars['String']['input'];
  captivateId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isManaged?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productPodcasts?: InputMaybe<ProductPodcastCreateNestedManyWithoutPodcastInput>;
  title: Scalars['String']['input'];
};

export type PodcastCreateWithoutProductPodcastsInput = {
  captivateFeedUrl: Scalars['String']['input'];
  captivateId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isManaged?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  podcastUsers?: InputMaybe<PodcastUserCreateNestedManyWithoutPodcastInput>;
  title: Scalars['String']['input'];
};

export type PodcastMaxOrderByAggregateInput = {
  captivateFeedUrl?: InputMaybe<SortOrder>;
  captivateId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isManaged?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PodcastMinOrderByAggregateInput = {
  captivateFeedUrl?: InputMaybe<SortOrder>;
  captivateId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isManaged?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PodcastOrderByWithAggregationInput = {
  _count?: InputMaybe<PodcastCountOrderByAggregateInput>;
  _max?: InputMaybe<PodcastMaxOrderByAggregateInput>;
  _min?: InputMaybe<PodcastMinOrderByAggregateInput>;
  captivateFeedUrl?: InputMaybe<SortOrder>;
  captivateId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isManaged?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PodcastOrderByWithRelationInput = {
  captivateFeedUrl?: InputMaybe<SortOrder>;
  captivateId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isManaged?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  podcastUsers?: InputMaybe<PodcastUserOrderByRelationAggregateInput>;
  productPodcasts?: InputMaybe<ProductPodcastOrderByRelationAggregateInput>;
  title?: InputMaybe<SortOrder>;
};

export enum PodcastScalarFieldEnum {
  CaptivateFeedUrl = 'captivateFeedUrl',
  CaptivateId = 'captivateId',
  Created = 'created',
  Id = 'id',
  IsManaged = 'isManaged',
  Modified = 'modified',
  Title = 'title'
}

export type PodcastScalarRelationFilter = {
  is?: InputMaybe<PodcastWhereInput>;
  isNot?: InputMaybe<PodcastWhereInput>;
};

export type PodcastScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PodcastScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PodcastScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PodcastScalarWhereWithAggregatesInput>>;
  captivateFeedUrl?: InputMaybe<StringWithAggregatesFilter>;
  captivateId?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isManaged?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type PodcastUpdateInput = {
  captivateFeedUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  captivateId?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  podcastUsers?: InputMaybe<PodcastUserUpdateManyWithoutPodcastNestedInput>;
  productPodcasts?: InputMaybe<ProductPodcastUpdateManyWithoutPodcastNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PodcastUpdateManyMutationInput = {
  captivateFeedUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  captivateId?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PodcastUpdateOneRequiredWithoutPodcastUsersNestedInput = {
  connect?: InputMaybe<PodcastWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PodcastCreateOrConnectWithoutPodcastUsersInput>;
  create?: InputMaybe<PodcastCreateWithoutPodcastUsersInput>;
  update?: InputMaybe<PodcastUpdateToOneWithWhereWithoutPodcastUsersInput>;
  upsert?: InputMaybe<PodcastUpsertWithoutPodcastUsersInput>;
};

export type PodcastUpdateOneRequiredWithoutProductPodcastsNestedInput = {
  connect?: InputMaybe<PodcastWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PodcastCreateOrConnectWithoutProductPodcastsInput>;
  create?: InputMaybe<PodcastCreateWithoutProductPodcastsInput>;
  update?: InputMaybe<PodcastUpdateToOneWithWhereWithoutProductPodcastsInput>;
  upsert?: InputMaybe<PodcastUpsertWithoutProductPodcastsInput>;
};

export type PodcastUpdateToOneWithWhereWithoutPodcastUsersInput = {
  data: PodcastUpdateWithoutPodcastUsersInput;
  where?: InputMaybe<PodcastWhereInput>;
};

export type PodcastUpdateToOneWithWhereWithoutProductPodcastsInput = {
  data: PodcastUpdateWithoutProductPodcastsInput;
  where?: InputMaybe<PodcastWhereInput>;
};

export type PodcastUpdateWithoutPodcastUsersInput = {
  captivateFeedUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  captivateId?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  productPodcasts?: InputMaybe<ProductPodcastUpdateManyWithoutPodcastNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PodcastUpdateWithoutProductPodcastsInput = {
  captivateFeedUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  captivateId?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  podcastUsers?: InputMaybe<PodcastUserUpdateManyWithoutPodcastNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PodcastUpsertWithoutPodcastUsersInput = {
  create: PodcastCreateWithoutPodcastUsersInput;
  update: PodcastUpdateWithoutPodcastUsersInput;
  where?: InputMaybe<PodcastWhereInput>;
};

export type PodcastUpsertWithoutProductPodcastsInput = {
  create: PodcastCreateWithoutProductPodcastsInput;
  update: PodcastUpdateWithoutProductPodcastsInput;
  where?: InputMaybe<PodcastWhereInput>;
};

export type PodcastUserCountOrderByAggregateInput = {
  captivateFeedUrl?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  podcastId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type PodcastUserCreateInput = {
  captivateFeedUrl: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  podcast: PodcastCreateNestedOneWithoutPodcastUsersInput;
  user: UserCreateNestedOneWithoutPodcastsInput;
};

export type PodcastUserCreateManyInput = {
  captivateFeedUrl: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  podcastId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type PodcastUserCreateManyPodcastInput = {
  captivateFeedUrl: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type PodcastUserCreateManyPodcastInputEnvelope = {
  data: Array<PodcastUserCreateManyPodcastInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PodcastUserCreateManyUserInput = {
  captivateFeedUrl: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  podcastId: Scalars['String']['input'];
};

export type PodcastUserCreateManyUserInputEnvelope = {
  data: Array<PodcastUserCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PodcastUserCreateNestedManyWithoutPodcastInput = {
  connect?: InputMaybe<Array<PodcastUserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PodcastUserCreateOrConnectWithoutPodcastInput>>;
  create?: InputMaybe<Array<PodcastUserCreateWithoutPodcastInput>>;
  createMany?: InputMaybe<PodcastUserCreateManyPodcastInputEnvelope>;
};

export type PodcastUserCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<PodcastUserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PodcastUserCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PodcastUserCreateWithoutUserInput>>;
  createMany?: InputMaybe<PodcastUserCreateManyUserInputEnvelope>;
};

export type PodcastUserCreateOrConnectWithoutPodcastInput = {
  create: PodcastUserCreateWithoutPodcastInput;
  where: PodcastUserWhereUniqueInput;
};

export type PodcastUserCreateOrConnectWithoutUserInput = {
  create: PodcastUserCreateWithoutUserInput;
  where: PodcastUserWhereUniqueInput;
};

export type PodcastUserCreateWithoutPodcastInput = {
  captivateFeedUrl: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutPodcastsInput;
};

export type PodcastUserCreateWithoutUserInput = {
  captivateFeedUrl: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  podcast: PodcastCreateNestedOneWithoutPodcastUsersInput;
};

export type PodcastUserListRelationFilter = {
  every?: InputMaybe<PodcastUserWhereInput>;
  none?: InputMaybe<PodcastUserWhereInput>;
  some?: InputMaybe<PodcastUserWhereInput>;
};

export type PodcastUserMaxOrderByAggregateInput = {
  captivateFeedUrl?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  podcastId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type PodcastUserMinOrderByAggregateInput = {
  captivateFeedUrl?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  podcastId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type PodcastUserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PodcastUserOrderByWithAggregationInput = {
  _count?: InputMaybe<PodcastUserCountOrderByAggregateInput>;
  _max?: InputMaybe<PodcastUserMaxOrderByAggregateInput>;
  _min?: InputMaybe<PodcastUserMinOrderByAggregateInput>;
  captivateFeedUrl?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  podcastId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type PodcastUserOrderByWithRelationInput = {
  captivateFeedUrl?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  podcast?: InputMaybe<PodcastOrderByWithRelationInput>;
  podcastId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type PodcastUserPodcastUserCompoundUniqueInput = {
  podcastId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum PodcastUserScalarFieldEnum {
  CaptivateFeedUrl = 'captivateFeedUrl',
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  PodcastId = 'podcastId',
  UserId = 'userId'
}

export type PodcastUserScalarWhereInput = {
  AND?: InputMaybe<Array<PodcastUserScalarWhereInput>>;
  NOT?: InputMaybe<Array<PodcastUserScalarWhereInput>>;
  OR?: InputMaybe<Array<PodcastUserScalarWhereInput>>;
  captivateFeedUrl?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  podcastId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type PodcastUserScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PodcastUserScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PodcastUserScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PodcastUserScalarWhereWithAggregatesInput>>;
  captivateFeedUrl?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  podcastId?: InputMaybe<StringWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type PodcastUserUpdateInput = {
  captivateFeedUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  podcast?: InputMaybe<PodcastUpdateOneRequiredWithoutPodcastUsersNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPodcastsNestedInput>;
};

export type PodcastUserUpdateManyMutationInput = {
  captivateFeedUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PodcastUserUpdateManyWithWhereWithoutPodcastInput = {
  data: PodcastUserUpdateManyMutationInput;
  where: PodcastUserScalarWhereInput;
};

export type PodcastUserUpdateManyWithWhereWithoutUserInput = {
  data: PodcastUserUpdateManyMutationInput;
  where: PodcastUserScalarWhereInput;
};

export type PodcastUserUpdateManyWithoutPodcastNestedInput = {
  connect?: InputMaybe<Array<PodcastUserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PodcastUserCreateOrConnectWithoutPodcastInput>>;
  create?: InputMaybe<Array<PodcastUserCreateWithoutPodcastInput>>;
  createMany?: InputMaybe<PodcastUserCreateManyPodcastInputEnvelope>;
  delete?: InputMaybe<Array<PodcastUserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PodcastUserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PodcastUserWhereUniqueInput>>;
  set?: InputMaybe<Array<PodcastUserWhereUniqueInput>>;
  update?: InputMaybe<Array<PodcastUserUpdateWithWhereUniqueWithoutPodcastInput>>;
  updateMany?: InputMaybe<Array<PodcastUserUpdateManyWithWhereWithoutPodcastInput>>;
  upsert?: InputMaybe<Array<PodcastUserUpsertWithWhereUniqueWithoutPodcastInput>>;
};

export type PodcastUserUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<PodcastUserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PodcastUserCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PodcastUserCreateWithoutUserInput>>;
  createMany?: InputMaybe<PodcastUserCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<PodcastUserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PodcastUserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PodcastUserWhereUniqueInput>>;
  set?: InputMaybe<Array<PodcastUserWhereUniqueInput>>;
  update?: InputMaybe<Array<PodcastUserUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<PodcastUserUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<PodcastUserUpsertWithWhereUniqueWithoutUserInput>>;
};

export type PodcastUserUpdateWithWhereUniqueWithoutPodcastInput = {
  data: PodcastUserUpdateWithoutPodcastInput;
  where: PodcastUserWhereUniqueInput;
};

export type PodcastUserUpdateWithWhereUniqueWithoutUserInput = {
  data: PodcastUserUpdateWithoutUserInput;
  where: PodcastUserWhereUniqueInput;
};

export type PodcastUserUpdateWithoutPodcastInput = {
  captivateFeedUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPodcastsNestedInput>;
};

export type PodcastUserUpdateWithoutUserInput = {
  captivateFeedUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  podcast?: InputMaybe<PodcastUpdateOneRequiredWithoutPodcastUsersNestedInput>;
};

export type PodcastUserUpsertWithWhereUniqueWithoutPodcastInput = {
  create: PodcastUserCreateWithoutPodcastInput;
  update: PodcastUserUpdateWithoutPodcastInput;
  where: PodcastUserWhereUniqueInput;
};

export type PodcastUserUpsertWithWhereUniqueWithoutUserInput = {
  create: PodcastUserCreateWithoutUserInput;
  update: PodcastUserUpdateWithoutUserInput;
  where: PodcastUserWhereUniqueInput;
};

export type PodcastUserWhereInput = {
  AND?: InputMaybe<Array<PodcastUserWhereInput>>;
  NOT?: InputMaybe<Array<PodcastUserWhereInput>>;
  OR?: InputMaybe<Array<PodcastUserWhereInput>>;
  captivateFeedUrl?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  podcast?: InputMaybe<PodcastScalarRelationFilter>;
  podcastId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type PodcastUserWhereUniqueInput = {
  AND?: InputMaybe<Array<PodcastUserWhereInput>>;
  NOT?: InputMaybe<Array<PodcastUserWhereInput>>;
  OR?: InputMaybe<Array<PodcastUserWhereInput>>;
  captivateFeedUrl?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  podcast?: InputMaybe<PodcastScalarRelationFilter>;
  podcastId?: InputMaybe<StringFilter>;
  podcastUser?: InputMaybe<PodcastUserPodcastUserCompoundUniqueInput>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type PodcastWhereInput = {
  AND?: InputMaybe<Array<PodcastWhereInput>>;
  NOT?: InputMaybe<Array<PodcastWhereInput>>;
  OR?: InputMaybe<Array<PodcastWhereInput>>;
  captivateFeedUrl?: InputMaybe<StringFilter>;
  captivateId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isManaged?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  podcastUsers?: InputMaybe<PodcastUserListRelationFilter>;
  productPodcasts?: InputMaybe<ProductPodcastListRelationFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PodcastWhereUniqueInput = {
  AND?: InputMaybe<Array<PodcastWhereInput>>;
  NOT?: InputMaybe<Array<PodcastWhereInput>>;
  OR?: InputMaybe<Array<PodcastWhereInput>>;
  captivateFeedUrl?: InputMaybe<StringFilter>;
  captivateId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isManaged?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  podcastUsers?: InputMaybe<PodcastUserListRelationFilter>;
  productPodcasts?: InputMaybe<ProductPodcastListRelationFilter>;
  title?: InputMaybe<StringFilter>;
};

export type ProductCountOrderByAggregateInput = {
  brandingType?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  healthProfessionalOnly?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  shortName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
};

export type ProductCreateInput = {
  brandingType?: InputMaybe<BrandingType>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionCreateNestedManyWithoutProductInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  healthProfessionalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProductInput>;
  productEvents?: InputMaybe<ProductEventCreateNestedManyWithoutProductInput>;
  productPodcasts?: InputMaybe<ProductPodcastCreateNestedManyWithoutProductInput>;
  productProgrammes?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProductInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeCreateNestedManyWithoutProductInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  templates?: InputMaybe<TemplateCreateNestedManyWithoutProductInput>;
};

export type ProductCreateManyInput = {
  brandingType?: InputMaybe<BrandingType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  healthProfessionalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type ProductCreateNestedOneWithoutCouponProductRestrictionsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutCouponProductRestrictionsInput>;
  create?: InputMaybe<ProductCreateWithoutCouponProductRestrictionsInput>;
};

export type ProductCreateNestedOneWithoutPrerequisitesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutPrerequisitesInput>;
  create?: InputMaybe<ProductCreateWithoutPrerequisitesInput>;
};

export type ProductCreateNestedOneWithoutProductEventsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutProductEventsInput>;
  create?: InputMaybe<ProductCreateWithoutProductEventsInput>;
};

export type ProductCreateNestedOneWithoutProductPodcastsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutProductPodcastsInput>;
  create?: InputMaybe<ProductCreateWithoutProductPodcastsInput>;
};

export type ProductCreateNestedOneWithoutProductProgrammesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutProductProgrammesInput>;
  create?: InputMaybe<ProductCreateWithoutProductProgrammesInput>;
};

export type ProductCreateNestedOneWithoutProductSubscriptionTypesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutProductSubscriptionTypesInput>;
  create?: InputMaybe<ProductCreateWithoutProductSubscriptionTypesInput>;
};

export type ProductCreateNestedOneWithoutTemplatesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutTemplatesInput>;
  create?: InputMaybe<ProductCreateWithoutTemplatesInput>;
};

export type ProductCreateOrConnectWithoutCouponProductRestrictionsInput = {
  create: ProductCreateWithoutCouponProductRestrictionsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutPrerequisitesInput = {
  create: ProductCreateWithoutPrerequisitesInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutProductEventsInput = {
  create: ProductCreateWithoutProductEventsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutProductPodcastsInput = {
  create: ProductCreateWithoutProductPodcastsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutProductProgrammesInput = {
  create: ProductCreateWithoutProductProgrammesInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutProductSubscriptionTypesInput = {
  create: ProductCreateWithoutProductSubscriptionTypesInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutTemplatesInput = {
  create: ProductCreateWithoutTemplatesInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateWithoutCouponProductRestrictionsInput = {
  brandingType?: InputMaybe<BrandingType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  healthProfessionalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProductInput>;
  productEvents?: InputMaybe<ProductEventCreateNestedManyWithoutProductInput>;
  productPodcasts?: InputMaybe<ProductPodcastCreateNestedManyWithoutProductInput>;
  productProgrammes?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProductInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeCreateNestedManyWithoutProductInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  templates?: InputMaybe<TemplateCreateNestedManyWithoutProductInput>;
};

export type ProductCreateWithoutPrerequisitesInput = {
  brandingType?: InputMaybe<BrandingType>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionCreateNestedManyWithoutProductInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  healthProfessionalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  productEvents?: InputMaybe<ProductEventCreateNestedManyWithoutProductInput>;
  productPodcasts?: InputMaybe<ProductPodcastCreateNestedManyWithoutProductInput>;
  productProgrammes?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProductInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeCreateNestedManyWithoutProductInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  templates?: InputMaybe<TemplateCreateNestedManyWithoutProductInput>;
};

export type ProductCreateWithoutProductEventsInput = {
  brandingType?: InputMaybe<BrandingType>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionCreateNestedManyWithoutProductInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  healthProfessionalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProductInput>;
  productPodcasts?: InputMaybe<ProductPodcastCreateNestedManyWithoutProductInput>;
  productProgrammes?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProductInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeCreateNestedManyWithoutProductInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  templates?: InputMaybe<TemplateCreateNestedManyWithoutProductInput>;
};

export type ProductCreateWithoutProductPodcastsInput = {
  brandingType?: InputMaybe<BrandingType>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionCreateNestedManyWithoutProductInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  healthProfessionalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProductInput>;
  productEvents?: InputMaybe<ProductEventCreateNestedManyWithoutProductInput>;
  productProgrammes?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProductInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeCreateNestedManyWithoutProductInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  templates?: InputMaybe<TemplateCreateNestedManyWithoutProductInput>;
};

export type ProductCreateWithoutProductProgrammesInput = {
  brandingType?: InputMaybe<BrandingType>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionCreateNestedManyWithoutProductInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  healthProfessionalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProductInput>;
  productEvents?: InputMaybe<ProductEventCreateNestedManyWithoutProductInput>;
  productPodcasts?: InputMaybe<ProductPodcastCreateNestedManyWithoutProductInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeCreateNestedManyWithoutProductInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  templates?: InputMaybe<TemplateCreateNestedManyWithoutProductInput>;
};

export type ProductCreateWithoutProductSubscriptionTypesInput = {
  brandingType?: InputMaybe<BrandingType>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionCreateNestedManyWithoutProductInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  healthProfessionalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProductInput>;
  productEvents?: InputMaybe<ProductEventCreateNestedManyWithoutProductInput>;
  productPodcasts?: InputMaybe<ProductPodcastCreateNestedManyWithoutProductInput>;
  productProgrammes?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProductInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  templates?: InputMaybe<TemplateCreateNestedManyWithoutProductInput>;
};

export type ProductCreateWithoutTemplatesInput = {
  brandingType?: InputMaybe<BrandingType>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionCreateNestedManyWithoutProductInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  healthProfessionalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProductInput>;
  productEvents?: InputMaybe<ProductEventCreateNestedManyWithoutProductInput>;
  productPodcasts?: InputMaybe<ProductPodcastCreateNestedManyWithoutProductInput>;
  productProgrammes?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProductInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeCreateNestedManyWithoutProductInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type ProductEventCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductEventCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event: EventCreateNestedOneWithoutProductEventsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  product: ProductCreateNestedOneWithoutProductEventsInput;
};

export type ProductEventCreateManyEventInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['String']['input'];
};

export type ProductEventCreateManyEventInputEnvelope = {
  data: Array<ProductEventCreateManyEventInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductEventCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['String']['input'];
};

export type ProductEventCreateManyProductInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductEventCreateManyProductInputEnvelope = {
  data: Array<ProductEventCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductEventCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<ProductEventWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductEventCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<ProductEventCreateWithoutEventInput>>;
  createMany?: InputMaybe<ProductEventCreateManyEventInputEnvelope>;
};

export type ProductEventCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductEventWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductEventCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductEventCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductEventCreateManyProductInputEnvelope>;
};

export type ProductEventCreateOrConnectWithoutEventInput = {
  create: ProductEventCreateWithoutEventInput;
  where: ProductEventWhereUniqueInput;
};

export type ProductEventCreateOrConnectWithoutProductInput = {
  create: ProductEventCreateWithoutProductInput;
  where: ProductEventWhereUniqueInput;
};

export type ProductEventCreateWithoutEventInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  product: ProductCreateNestedOneWithoutProductEventsInput;
};

export type ProductEventCreateWithoutProductInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event: EventCreateNestedOneWithoutProductEventsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductEventListRelationFilter = {
  every?: InputMaybe<ProductEventWhereInput>;
  none?: InputMaybe<ProductEventWhereInput>;
  some?: InputMaybe<ProductEventWhereInput>;
};

export type ProductEventMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductEventMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductEventOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductEventOrderByWithAggregationInput = {
  _count?: InputMaybe<ProductEventCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductEventMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductEventMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductEventOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductEventProductEventCompoundUniqueInput = {
  eventId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export enum ProductEventScalarFieldEnum {
  Created = 'created',
  EventId = 'eventId',
  Id = 'id',
  Modified = 'modified',
  ProductId = 'productId'
}

export type ProductEventScalarWhereInput = {
  AND?: InputMaybe<Array<ProductEventScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductEventScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductEventScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  productId?: InputMaybe<StringFilter>;
};

export type ProductEventScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductEventScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductEventScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductEventScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  productId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ProductEventUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutProductEventsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutProductEventsNestedInput>;
};

export type ProductEventUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductEventUpdateManyWithWhereWithoutEventInput = {
  data: ProductEventUpdateManyMutationInput;
  where: ProductEventScalarWhereInput;
};

export type ProductEventUpdateManyWithWhereWithoutProductInput = {
  data: ProductEventUpdateManyMutationInput;
  where: ProductEventScalarWhereInput;
};

export type ProductEventUpdateManyWithoutEventNestedInput = {
  connect?: InputMaybe<Array<ProductEventWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductEventCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<ProductEventCreateWithoutEventInput>>;
  createMany?: InputMaybe<ProductEventCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<ProductEventWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductEventScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductEventWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductEventWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductEventUpdateWithWhereUniqueWithoutEventInput>>;
  updateMany?: InputMaybe<Array<ProductEventUpdateManyWithWhereWithoutEventInput>>;
  upsert?: InputMaybe<Array<ProductEventUpsertWithWhereUniqueWithoutEventInput>>;
};

export type ProductEventUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<ProductEventWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductEventCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductEventCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductEventCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ProductEventWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductEventScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductEventWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductEventWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductEventUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ProductEventUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ProductEventUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ProductEventUpdateWithWhereUniqueWithoutEventInput = {
  data: ProductEventUpdateWithoutEventInput;
  where: ProductEventWhereUniqueInput;
};

export type ProductEventUpdateWithWhereUniqueWithoutProductInput = {
  data: ProductEventUpdateWithoutProductInput;
  where: ProductEventWhereUniqueInput;
};

export type ProductEventUpdateWithoutEventInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutProductEventsNestedInput>;
};

export type ProductEventUpdateWithoutProductInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutProductEventsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductEventUpsertWithWhereUniqueWithoutEventInput = {
  create: ProductEventCreateWithoutEventInput;
  update: ProductEventUpdateWithoutEventInput;
  where: ProductEventWhereUniqueInput;
};

export type ProductEventUpsertWithWhereUniqueWithoutProductInput = {
  create: ProductEventCreateWithoutProductInput;
  update: ProductEventUpdateWithoutProductInput;
  where: ProductEventWhereUniqueInput;
};

export type ProductEventWhereInput = {
  AND?: InputMaybe<Array<ProductEventWhereInput>>;
  NOT?: InputMaybe<Array<ProductEventWhereInput>>;
  OR?: InputMaybe<Array<ProductEventWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  event?: InputMaybe<EventScalarRelationFilter>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<StringFilter>;
};

export type ProductEventWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductEventWhereInput>>;
  NOT?: InputMaybe<Array<ProductEventWhereInput>>;
  OR?: InputMaybe<Array<ProductEventWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  event?: InputMaybe<EventScalarRelationFilter>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productEvent?: InputMaybe<ProductEventProductEventCompoundUniqueInput>;
  productId?: InputMaybe<StringFilter>;
};

export type ProductMaxOrderByAggregateInput = {
  brandingType?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  healthProfessionalOnly?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  shortName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
};

export type ProductMinOrderByAggregateInput = {
  brandingType?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  healthProfessionalOnly?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  shortName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
};

export type ProductNullableScalarRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export type ProductOrderByWithAggregationInput = {
  _count?: InputMaybe<ProductCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductMinOrderByAggregateInput>;
  brandingType?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  healthProfessionalOnly?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  shortName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
};

export type ProductOrderByWithRelationInput = {
  brandingType?: InputMaybe<SortOrder>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionOrderByRelationAggregateInput>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  healthProfessionalOnly?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteOrderByRelationAggregateInput>;
  productEvents?: InputMaybe<ProductEventOrderByRelationAggregateInput>;
  productPodcasts?: InputMaybe<ProductPodcastOrderByRelationAggregateInput>;
  productProgrammes?: InputMaybe<ProductProgrammeOrderByRelationAggregateInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeOrderByRelationAggregateInput>;
  shortName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  templates?: InputMaybe<TemplateOrderByRelationAggregateInput>;
};

export type ProductPodcastCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  podcastId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductPodcastCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  podcast: PodcastCreateNestedOneWithoutProductPodcastsInput;
  product: ProductCreateNestedOneWithoutProductPodcastsInput;
};

export type ProductPodcastCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  podcastId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type ProductPodcastCreateManyPodcastInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['String']['input'];
};

export type ProductPodcastCreateManyPodcastInputEnvelope = {
  data: Array<ProductPodcastCreateManyPodcastInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductPodcastCreateManyProductInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  podcastId: Scalars['String']['input'];
};

export type ProductPodcastCreateManyProductInputEnvelope = {
  data: Array<ProductPodcastCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductPodcastCreateNestedManyWithoutPodcastInput = {
  connect?: InputMaybe<Array<ProductPodcastWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductPodcastCreateOrConnectWithoutPodcastInput>>;
  create?: InputMaybe<Array<ProductPodcastCreateWithoutPodcastInput>>;
  createMany?: InputMaybe<ProductPodcastCreateManyPodcastInputEnvelope>;
};

export type ProductPodcastCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductPodcastWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductPodcastCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductPodcastCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductPodcastCreateManyProductInputEnvelope>;
};

export type ProductPodcastCreateOrConnectWithoutPodcastInput = {
  create: ProductPodcastCreateWithoutPodcastInput;
  where: ProductPodcastWhereUniqueInput;
};

export type ProductPodcastCreateOrConnectWithoutProductInput = {
  create: ProductPodcastCreateWithoutProductInput;
  where: ProductPodcastWhereUniqueInput;
};

export type ProductPodcastCreateWithoutPodcastInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  product: ProductCreateNestedOneWithoutProductPodcastsInput;
};

export type ProductPodcastCreateWithoutProductInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  podcast: PodcastCreateNestedOneWithoutProductPodcastsInput;
};

export type ProductPodcastListRelationFilter = {
  every?: InputMaybe<ProductPodcastWhereInput>;
  none?: InputMaybe<ProductPodcastWhereInput>;
  some?: InputMaybe<ProductPodcastWhereInput>;
};

export type ProductPodcastMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  podcastId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductPodcastMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  podcastId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductPodcastOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductPodcastOrderByWithAggregationInput = {
  _count?: InputMaybe<ProductPodcastCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductPodcastMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductPodcastMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  podcastId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductPodcastOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  podcast?: InputMaybe<PodcastOrderByWithRelationInput>;
  podcastId?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductPodcastProductPodcastCompoundUniqueInput = {
  podcastId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export enum ProductPodcastScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  PodcastId = 'podcastId',
  ProductId = 'productId'
}

export type ProductPodcastScalarWhereInput = {
  AND?: InputMaybe<Array<ProductPodcastScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductPodcastScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductPodcastScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  podcastId?: InputMaybe<StringFilter>;
  productId?: InputMaybe<StringFilter>;
};

export type ProductPodcastScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductPodcastScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductPodcastScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductPodcastScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  podcastId?: InputMaybe<StringWithAggregatesFilter>;
  productId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ProductPodcastUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  podcast?: InputMaybe<PodcastUpdateOneRequiredWithoutProductPodcastsNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutProductPodcastsNestedInput>;
};

export type ProductPodcastUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductPodcastUpdateManyWithWhereWithoutPodcastInput = {
  data: ProductPodcastUpdateManyMutationInput;
  where: ProductPodcastScalarWhereInput;
};

export type ProductPodcastUpdateManyWithWhereWithoutProductInput = {
  data: ProductPodcastUpdateManyMutationInput;
  where: ProductPodcastScalarWhereInput;
};

export type ProductPodcastUpdateManyWithoutPodcastNestedInput = {
  connect?: InputMaybe<Array<ProductPodcastWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductPodcastCreateOrConnectWithoutPodcastInput>>;
  create?: InputMaybe<Array<ProductPodcastCreateWithoutPodcastInput>>;
  createMany?: InputMaybe<ProductPodcastCreateManyPodcastInputEnvelope>;
  delete?: InputMaybe<Array<ProductPodcastWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductPodcastScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductPodcastWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductPodcastWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductPodcastUpdateWithWhereUniqueWithoutPodcastInput>>;
  updateMany?: InputMaybe<Array<ProductPodcastUpdateManyWithWhereWithoutPodcastInput>>;
  upsert?: InputMaybe<Array<ProductPodcastUpsertWithWhereUniqueWithoutPodcastInput>>;
};

export type ProductPodcastUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<ProductPodcastWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductPodcastCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductPodcastCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductPodcastCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ProductPodcastWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductPodcastScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductPodcastWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductPodcastWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductPodcastUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ProductPodcastUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ProductPodcastUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ProductPodcastUpdateWithWhereUniqueWithoutPodcastInput = {
  data: ProductPodcastUpdateWithoutPodcastInput;
  where: ProductPodcastWhereUniqueInput;
};

export type ProductPodcastUpdateWithWhereUniqueWithoutProductInput = {
  data: ProductPodcastUpdateWithoutProductInput;
  where: ProductPodcastWhereUniqueInput;
};

export type ProductPodcastUpdateWithoutPodcastInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutProductPodcastsNestedInput>;
};

export type ProductPodcastUpdateWithoutProductInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  podcast?: InputMaybe<PodcastUpdateOneRequiredWithoutProductPodcastsNestedInput>;
};

export type ProductPodcastUpsertWithWhereUniqueWithoutPodcastInput = {
  create: ProductPodcastCreateWithoutPodcastInput;
  update: ProductPodcastUpdateWithoutPodcastInput;
  where: ProductPodcastWhereUniqueInput;
};

export type ProductPodcastUpsertWithWhereUniqueWithoutProductInput = {
  create: ProductPodcastCreateWithoutProductInput;
  update: ProductPodcastUpdateWithoutProductInput;
  where: ProductPodcastWhereUniqueInput;
};

export type ProductPodcastWhereInput = {
  AND?: InputMaybe<Array<ProductPodcastWhereInput>>;
  NOT?: InputMaybe<Array<ProductPodcastWhereInput>>;
  OR?: InputMaybe<Array<ProductPodcastWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  podcast?: InputMaybe<PodcastScalarRelationFilter>;
  podcastId?: InputMaybe<StringFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<StringFilter>;
};

export type ProductPodcastWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductPodcastWhereInput>>;
  NOT?: InputMaybe<Array<ProductPodcastWhereInput>>;
  OR?: InputMaybe<Array<ProductPodcastWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  podcast?: InputMaybe<PodcastScalarRelationFilter>;
  podcastId?: InputMaybe<StringFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<StringFilter>;
  productPodcast?: InputMaybe<ProductPodcastProductPodcastCompoundUniqueInput>;
};

export type ProductProgrammeCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
};

export type ProductProgrammeCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  product: ProductCreateNestedOneWithoutProductProgrammesInput;
  programme: ProgrammeCreateNestedOneWithoutProgrammeProductsInput;
};

export type ProductProgrammeCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['String']['input'];
  programmeId: Scalars['String']['input'];
};

export type ProductProgrammeCreateManyProductInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programmeId: Scalars['String']['input'];
};

export type ProductProgrammeCreateManyProductInputEnvelope = {
  data: Array<ProductProgrammeCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductProgrammeCreateManyProgrammeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['String']['input'];
};

export type ProductProgrammeCreateManyProgrammeInputEnvelope = {
  data: Array<ProductProgrammeCreateManyProgrammeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductProgrammeCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductProgrammeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductProgrammeCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductProgrammeCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductProgrammeCreateManyProductInputEnvelope>;
};

export type ProductProgrammeCreateNestedManyWithoutProgrammeInput = {
  connect?: InputMaybe<Array<ProductProgrammeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductProgrammeCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<ProductProgrammeCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<ProductProgrammeCreateManyProgrammeInputEnvelope>;
};

export type ProductProgrammeCreateOrConnectWithoutProductInput = {
  create: ProductProgrammeCreateWithoutProductInput;
  where: ProductProgrammeWhereUniqueInput;
};

export type ProductProgrammeCreateOrConnectWithoutProgrammeInput = {
  create: ProductProgrammeCreateWithoutProgrammeInput;
  where: ProductProgrammeWhereUniqueInput;
};

export type ProductProgrammeCreateWithoutProductInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programme: ProgrammeCreateNestedOneWithoutProgrammeProductsInput;
};

export type ProductProgrammeCreateWithoutProgrammeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  product: ProductCreateNestedOneWithoutProductProgrammesInput;
};

export type ProductProgrammeListRelationFilter = {
  every?: InputMaybe<ProductProgrammeWhereInput>;
  none?: InputMaybe<ProductProgrammeWhereInput>;
  some?: InputMaybe<ProductProgrammeWhereInput>;
};

export type ProductProgrammeMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
};

export type ProductProgrammeMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
};

export type ProductProgrammeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductProgrammeOrderByWithAggregationInput = {
  _count?: InputMaybe<ProductProgrammeCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductProgrammeMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductProgrammeMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
};

export type ProductProgrammeOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  programme?: InputMaybe<ProgrammeOrderByWithRelationInput>;
  programmeId?: InputMaybe<SortOrder>;
};

export type ProductProgrammePrerequisiteCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
};

export type ProductProgrammePrerequisiteCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  product: ProductCreateNestedOneWithoutPrerequisitesInput;
  programme: ProgrammeCreateNestedOneWithoutPrerequisiteForInput;
};

export type ProductProgrammePrerequisiteCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['String']['input'];
  programmeId: Scalars['String']['input'];
};

export type ProductProgrammePrerequisiteCreateManyProductInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programmeId: Scalars['String']['input'];
};

export type ProductProgrammePrerequisiteCreateManyProductInputEnvelope = {
  data: Array<ProductProgrammePrerequisiteCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductProgrammePrerequisiteCreateManyProgrammeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['String']['input'];
};

export type ProductProgrammePrerequisiteCreateManyProgrammeInputEnvelope = {
  data: Array<ProductProgrammePrerequisiteCreateManyProgrammeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductProgrammePrerequisiteCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductProgrammePrerequisiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductProgrammePrerequisiteCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductProgrammePrerequisiteCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductProgrammePrerequisiteCreateManyProductInputEnvelope>;
};

export type ProductProgrammePrerequisiteCreateNestedManyWithoutProgrammeInput = {
  connect?: InputMaybe<Array<ProductProgrammePrerequisiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductProgrammePrerequisiteCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<ProductProgrammePrerequisiteCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<ProductProgrammePrerequisiteCreateManyProgrammeInputEnvelope>;
};

export type ProductProgrammePrerequisiteCreateOrConnectWithoutProductInput = {
  create: ProductProgrammePrerequisiteCreateWithoutProductInput;
  where: ProductProgrammePrerequisiteWhereUniqueInput;
};

export type ProductProgrammePrerequisiteCreateOrConnectWithoutProgrammeInput = {
  create: ProductProgrammePrerequisiteCreateWithoutProgrammeInput;
  where: ProductProgrammePrerequisiteWhereUniqueInput;
};

export type ProductProgrammePrerequisiteCreateWithoutProductInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programme: ProgrammeCreateNestedOneWithoutPrerequisiteForInput;
};

export type ProductProgrammePrerequisiteCreateWithoutProgrammeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  product: ProductCreateNestedOneWithoutPrerequisitesInput;
};

export type ProductProgrammePrerequisiteListRelationFilter = {
  every?: InputMaybe<ProductProgrammePrerequisiteWhereInput>;
  none?: InputMaybe<ProductProgrammePrerequisiteWhereInput>;
  some?: InputMaybe<ProductProgrammePrerequisiteWhereInput>;
};

export type ProductProgrammePrerequisiteMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
};

export type ProductProgrammePrerequisiteMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
};

export type ProductProgrammePrerequisiteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductProgrammePrerequisiteOrderByWithAggregationInput = {
  _count?: InputMaybe<ProductProgrammePrerequisiteCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductProgrammePrerequisiteMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductProgrammePrerequisiteMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
};

export type ProductProgrammePrerequisiteOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  programme?: InputMaybe<ProgrammeOrderByWithRelationInput>;
  programmeId?: InputMaybe<SortOrder>;
};

export type ProductProgrammePrerequisiteProductProgrammePrerequisiteCompoundUniqueInput = {
  productId: Scalars['String']['input'];
  programmeId: Scalars['String']['input'];
};

export enum ProductProgrammePrerequisiteScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  ProductId = 'productId',
  ProgrammeId = 'programmeId'
}

export type ProductProgrammePrerequisiteScalarWhereInput = {
  AND?: InputMaybe<Array<ProductProgrammePrerequisiteScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductProgrammePrerequisiteScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductProgrammePrerequisiteScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  productId?: InputMaybe<StringFilter>;
  programmeId?: InputMaybe<StringFilter>;
};

export type ProductProgrammePrerequisiteScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductProgrammePrerequisiteScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductProgrammePrerequisiteScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductProgrammePrerequisiteScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  productId?: InputMaybe<StringWithAggregatesFilter>;
  programmeId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ProductProgrammePrerequisiteUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutPrerequisitesNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutPrerequisiteForNestedInput>;
};

export type ProductProgrammePrerequisiteUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductProgrammePrerequisiteUpdateManyWithWhereWithoutProductInput = {
  data: ProductProgrammePrerequisiteUpdateManyMutationInput;
  where: ProductProgrammePrerequisiteScalarWhereInput;
};

export type ProductProgrammePrerequisiteUpdateManyWithWhereWithoutProgrammeInput = {
  data: ProductProgrammePrerequisiteUpdateManyMutationInput;
  where: ProductProgrammePrerequisiteScalarWhereInput;
};

export type ProductProgrammePrerequisiteUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<ProductProgrammePrerequisiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductProgrammePrerequisiteCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductProgrammePrerequisiteCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductProgrammePrerequisiteCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ProductProgrammePrerequisiteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductProgrammePrerequisiteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductProgrammePrerequisiteWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductProgrammePrerequisiteWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductProgrammePrerequisiteUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ProductProgrammePrerequisiteUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ProductProgrammePrerequisiteUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ProductProgrammePrerequisiteUpdateManyWithoutProgrammeNestedInput = {
  connect?: InputMaybe<Array<ProductProgrammePrerequisiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductProgrammePrerequisiteCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<ProductProgrammePrerequisiteCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<ProductProgrammePrerequisiteCreateManyProgrammeInputEnvelope>;
  delete?: InputMaybe<Array<ProductProgrammePrerequisiteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductProgrammePrerequisiteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductProgrammePrerequisiteWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductProgrammePrerequisiteWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductProgrammePrerequisiteUpdateWithWhereUniqueWithoutProgrammeInput>>;
  updateMany?: InputMaybe<Array<ProductProgrammePrerequisiteUpdateManyWithWhereWithoutProgrammeInput>>;
  upsert?: InputMaybe<Array<ProductProgrammePrerequisiteUpsertWithWhereUniqueWithoutProgrammeInput>>;
};

export type ProductProgrammePrerequisiteUpdateWithWhereUniqueWithoutProductInput = {
  data: ProductProgrammePrerequisiteUpdateWithoutProductInput;
  where: ProductProgrammePrerequisiteWhereUniqueInput;
};

export type ProductProgrammePrerequisiteUpdateWithWhereUniqueWithoutProgrammeInput = {
  data: ProductProgrammePrerequisiteUpdateWithoutProgrammeInput;
  where: ProductProgrammePrerequisiteWhereUniqueInput;
};

export type ProductProgrammePrerequisiteUpdateWithoutProductInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutPrerequisiteForNestedInput>;
};

export type ProductProgrammePrerequisiteUpdateWithoutProgrammeInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutPrerequisitesNestedInput>;
};

export type ProductProgrammePrerequisiteUpsertWithWhereUniqueWithoutProductInput = {
  create: ProductProgrammePrerequisiteCreateWithoutProductInput;
  update: ProductProgrammePrerequisiteUpdateWithoutProductInput;
  where: ProductProgrammePrerequisiteWhereUniqueInput;
};

export type ProductProgrammePrerequisiteUpsertWithWhereUniqueWithoutProgrammeInput = {
  create: ProductProgrammePrerequisiteCreateWithoutProgrammeInput;
  update: ProductProgrammePrerequisiteUpdateWithoutProgrammeInput;
  where: ProductProgrammePrerequisiteWhereUniqueInput;
};

export type ProductProgrammePrerequisiteWhereInput = {
  AND?: InputMaybe<Array<ProductProgrammePrerequisiteWhereInput>>;
  NOT?: InputMaybe<Array<ProductProgrammePrerequisiteWhereInput>>;
  OR?: InputMaybe<Array<ProductProgrammePrerequisiteWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<StringFilter>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
};

export type ProductProgrammePrerequisiteWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductProgrammePrerequisiteWhereInput>>;
  NOT?: InputMaybe<Array<ProductProgrammePrerequisiteWhereInput>>;
  OR?: InputMaybe<Array<ProductProgrammePrerequisiteWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<StringFilter>;
  productProgrammePrerequisite?: InputMaybe<ProductProgrammePrerequisiteProductProgrammePrerequisiteCompoundUniqueInput>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
};

export type ProductProgrammeProductProgrammeCompoundUniqueInput = {
  productId: Scalars['String']['input'];
  programmeId: Scalars['String']['input'];
};

export enum ProductProgrammeScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  ProductId = 'productId',
  ProgrammeId = 'programmeId'
}

export type ProductProgrammeScalarWhereInput = {
  AND?: InputMaybe<Array<ProductProgrammeScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductProgrammeScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductProgrammeScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  productId?: InputMaybe<StringFilter>;
  programmeId?: InputMaybe<StringFilter>;
};

export type ProductProgrammeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductProgrammeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductProgrammeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductProgrammeScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  productId?: InputMaybe<StringWithAggregatesFilter>;
  programmeId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ProductProgrammeUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutProductProgrammesNestedInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutProgrammeProductsNestedInput>;
};

export type ProductProgrammeUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductProgrammeUpdateManyWithWhereWithoutProductInput = {
  data: ProductProgrammeUpdateManyMutationInput;
  where: ProductProgrammeScalarWhereInput;
};

export type ProductProgrammeUpdateManyWithWhereWithoutProgrammeInput = {
  data: ProductProgrammeUpdateManyMutationInput;
  where: ProductProgrammeScalarWhereInput;
};

export type ProductProgrammeUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<ProductProgrammeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductProgrammeCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductProgrammeCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductProgrammeCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ProductProgrammeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductProgrammeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductProgrammeWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductProgrammeWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductProgrammeUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ProductProgrammeUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ProductProgrammeUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ProductProgrammeUpdateManyWithoutProgrammeNestedInput = {
  connect?: InputMaybe<Array<ProductProgrammeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductProgrammeCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<ProductProgrammeCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<ProductProgrammeCreateManyProgrammeInputEnvelope>;
  delete?: InputMaybe<Array<ProductProgrammeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductProgrammeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductProgrammeWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductProgrammeWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductProgrammeUpdateWithWhereUniqueWithoutProgrammeInput>>;
  updateMany?: InputMaybe<Array<ProductProgrammeUpdateManyWithWhereWithoutProgrammeInput>>;
  upsert?: InputMaybe<Array<ProductProgrammeUpsertWithWhereUniqueWithoutProgrammeInput>>;
};

export type ProductProgrammeUpdateWithWhereUniqueWithoutProductInput = {
  data: ProductProgrammeUpdateWithoutProductInput;
  where: ProductProgrammeWhereUniqueInput;
};

export type ProductProgrammeUpdateWithWhereUniqueWithoutProgrammeInput = {
  data: ProductProgrammeUpdateWithoutProgrammeInput;
  where: ProductProgrammeWhereUniqueInput;
};

export type ProductProgrammeUpdateWithoutProductInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutProgrammeProductsNestedInput>;
};

export type ProductProgrammeUpdateWithoutProgrammeInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutProductProgrammesNestedInput>;
};

export type ProductProgrammeUpsertWithWhereUniqueWithoutProductInput = {
  create: ProductProgrammeCreateWithoutProductInput;
  update: ProductProgrammeUpdateWithoutProductInput;
  where: ProductProgrammeWhereUniqueInput;
};

export type ProductProgrammeUpsertWithWhereUniqueWithoutProgrammeInput = {
  create: ProductProgrammeCreateWithoutProgrammeInput;
  update: ProductProgrammeUpdateWithoutProgrammeInput;
  where: ProductProgrammeWhereUniqueInput;
};

export type ProductProgrammeWhereInput = {
  AND?: InputMaybe<Array<ProductProgrammeWhereInput>>;
  NOT?: InputMaybe<Array<ProductProgrammeWhereInput>>;
  OR?: InputMaybe<Array<ProductProgrammeWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<StringFilter>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
};

export type ProductProgrammeWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductProgrammeWhereInput>>;
  NOT?: InputMaybe<Array<ProductProgrammeWhereInput>>;
  OR?: InputMaybe<Array<ProductProgrammeWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<StringFilter>;
  productProgramme?: InputMaybe<ProductProgrammeProductProgrammeCompoundUniqueInput>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
};

export enum ProductScalarFieldEnum {
  BrandingType = 'brandingType',
  Created = 'created',
  Description = 'description',
  HealthProfessionalOnly = 'healthProfessionalOnly',
  Id = 'id',
  IsPublished = 'isPublished',
  Modified = 'modified',
  Name = 'name',
  ShortName = 'shortName',
  Slug = 'slug'
}

export type ProductScalarRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export type ProductScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductScalarWhereWithAggregatesInput>>;
  brandingType?: InputMaybe<EnumBrandingTypeWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  healthProfessionalOnly?: InputMaybe<BoolWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isPublished?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  shortName?: InputMaybe<StringWithAggregatesFilter>;
  slug?: InputMaybe<StringWithAggregatesFilter>;
};

export type ProductSubscriptionTypeAvgOrderByAggregateInput = {
  durationInDays?: InputMaybe<SortOrder>;
  priceInCents?: InputMaybe<SortOrder>;
  trialPurchaseLimit?: InputMaybe<SortOrder>;
};

export type ProductSubscriptionTypeCountOrderByAggregateInput = {
  automaticRenew?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  durationInDays?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  isTrialSubscription?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priceInCents?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  trialPurchaseLimit?: InputMaybe<SortOrder>;
  upgradeType?: InputMaybe<SortOrder>;
  xeroAccountCode?: InputMaybe<SortOrder>;
};

export type ProductSubscriptionTypeCreateInput = {
  automaticRenew?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutProductSubscriptionTypeInput>;
  priceInCents: Scalars['Int']['input'];
  product?: InputMaybe<ProductCreateNestedOneWithoutProductSubscriptionTypesInput>;
  trialPurchaseLimit?: InputMaybe<Scalars['Int']['input']>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductCreateNestedManyWithoutProductSubscriptionTypeInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradeType?: InputMaybe<UpgradeType>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutProductSubscriptionTypeInput>;
  xeroAccountCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSubscriptionTypeCreateManyInput = {
  automaticRenew?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  priceInCents: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  trialPurchaseLimit?: InputMaybe<Scalars['Int']['input']>;
  upgradeType?: InputMaybe<UpgradeType>;
  xeroAccountCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSubscriptionTypeCreateManyProductInput = {
  automaticRenew?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  priceInCents: Scalars['Int']['input'];
  trialPurchaseLimit?: InputMaybe<Scalars['Int']['input']>;
  upgradeType?: InputMaybe<UpgradeType>;
  xeroAccountCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSubscriptionTypeCreateManyProductInputEnvelope = {
  data: Array<ProductSubscriptionTypeCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductSubscriptionTypeCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductSubscriptionTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductSubscriptionTypeCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductSubscriptionTypeCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductSubscriptionTypeCreateManyProductInputEnvelope>;
};

export type ProductSubscriptionTypeCreateNestedOneWithoutPaymentItemsInput = {
  connect?: InputMaybe<ProductSubscriptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSubscriptionTypeCreateOrConnectWithoutPaymentItemsInput>;
  create?: InputMaybe<ProductSubscriptionTypeCreateWithoutPaymentItemsInput>;
};

export type ProductSubscriptionTypeCreateNestedOneWithoutUpgradePathTargetProductsInput = {
  connect?: InputMaybe<ProductSubscriptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSubscriptionTypeCreateOrConnectWithoutUpgradePathTargetProductsInput>;
  create?: InputMaybe<ProductSubscriptionTypeCreateWithoutUpgradePathTargetProductsInput>;
};

export type ProductSubscriptionTypeCreateNestedOneWithoutUpgradePathsFromInput = {
  connect?: InputMaybe<ProductSubscriptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSubscriptionTypeCreateOrConnectWithoutUpgradePathsFromInput>;
  create?: InputMaybe<ProductSubscriptionTypeCreateWithoutUpgradePathsFromInput>;
};

export type ProductSubscriptionTypeCreateNestedOneWithoutUpgradePromptEngagementsFromInput = {
  connect?: InputMaybe<ProductSubscriptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSubscriptionTypeCreateOrConnectWithoutUpgradePromptEngagementsFromInput>;
  create?: InputMaybe<ProductSubscriptionTypeCreateWithoutUpgradePromptEngagementsFromInput>;
};

export type ProductSubscriptionTypeCreateNestedOneWithoutUserSubscriptionsInput = {
  connect?: InputMaybe<ProductSubscriptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSubscriptionTypeCreateOrConnectWithoutUserSubscriptionsInput>;
  create?: InputMaybe<ProductSubscriptionTypeCreateWithoutUserSubscriptionsInput>;
};

export type ProductSubscriptionTypeCreateOrConnectWithoutPaymentItemsInput = {
  create: ProductSubscriptionTypeCreateWithoutPaymentItemsInput;
  where: ProductSubscriptionTypeWhereUniqueInput;
};

export type ProductSubscriptionTypeCreateOrConnectWithoutProductInput = {
  create: ProductSubscriptionTypeCreateWithoutProductInput;
  where: ProductSubscriptionTypeWhereUniqueInput;
};

export type ProductSubscriptionTypeCreateOrConnectWithoutUpgradePathTargetProductsInput = {
  create: ProductSubscriptionTypeCreateWithoutUpgradePathTargetProductsInput;
  where: ProductSubscriptionTypeWhereUniqueInput;
};

export type ProductSubscriptionTypeCreateOrConnectWithoutUpgradePathsFromInput = {
  create: ProductSubscriptionTypeCreateWithoutUpgradePathsFromInput;
  where: ProductSubscriptionTypeWhereUniqueInput;
};

export type ProductSubscriptionTypeCreateOrConnectWithoutUpgradePromptEngagementsFromInput = {
  create: ProductSubscriptionTypeCreateWithoutUpgradePromptEngagementsFromInput;
  where: ProductSubscriptionTypeWhereUniqueInput;
};

export type ProductSubscriptionTypeCreateOrConnectWithoutUserSubscriptionsInput = {
  create: ProductSubscriptionTypeCreateWithoutUserSubscriptionsInput;
  where: ProductSubscriptionTypeWhereUniqueInput;
};

export type ProductSubscriptionTypeCreateWithoutPaymentItemsInput = {
  automaticRenew?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  priceInCents: Scalars['Int']['input'];
  product?: InputMaybe<ProductCreateNestedOneWithoutProductSubscriptionTypesInput>;
  trialPurchaseLimit?: InputMaybe<Scalars['Int']['input']>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductCreateNestedManyWithoutProductSubscriptionTypeInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradeType?: InputMaybe<UpgradeType>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutProductSubscriptionTypeInput>;
  xeroAccountCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSubscriptionTypeCreateWithoutProductInput = {
  automaticRenew?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutProductSubscriptionTypeInput>;
  priceInCents: Scalars['Int']['input'];
  trialPurchaseLimit?: InputMaybe<Scalars['Int']['input']>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductCreateNestedManyWithoutProductSubscriptionTypeInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradeType?: InputMaybe<UpgradeType>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutProductSubscriptionTypeInput>;
  xeroAccountCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSubscriptionTypeCreateWithoutUpgradePathTargetProductsInput = {
  automaticRenew?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutProductSubscriptionTypeInput>;
  priceInCents: Scalars['Int']['input'];
  product?: InputMaybe<ProductCreateNestedOneWithoutProductSubscriptionTypesInput>;
  trialPurchaseLimit?: InputMaybe<Scalars['Int']['input']>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradeType?: InputMaybe<UpgradeType>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutProductSubscriptionTypeInput>;
  xeroAccountCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSubscriptionTypeCreateWithoutUpgradePathsFromInput = {
  automaticRenew?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutProductSubscriptionTypeInput>;
  priceInCents: Scalars['Int']['input'];
  product?: InputMaybe<ProductCreateNestedOneWithoutProductSubscriptionTypesInput>;
  trialPurchaseLimit?: InputMaybe<Scalars['Int']['input']>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductCreateNestedManyWithoutProductSubscriptionTypeInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradeType?: InputMaybe<UpgradeType>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutProductSubscriptionTypeInput>;
  xeroAccountCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSubscriptionTypeCreateWithoutUpgradePromptEngagementsFromInput = {
  automaticRenew?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutProductSubscriptionTypeInput>;
  priceInCents: Scalars['Int']['input'];
  product?: InputMaybe<ProductCreateNestedOneWithoutProductSubscriptionTypesInput>;
  trialPurchaseLimit?: InputMaybe<Scalars['Int']['input']>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductCreateNestedManyWithoutProductSubscriptionTypeInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradeType?: InputMaybe<UpgradeType>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutProductSubscriptionTypeInput>;
  xeroAccountCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSubscriptionTypeCreateWithoutUserSubscriptionsInput = {
  automaticRenew?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  paymentItems?: InputMaybe<PaymentItemCreateNestedManyWithoutProductSubscriptionTypeInput>;
  priceInCents: Scalars['Int']['input'];
  product?: InputMaybe<ProductCreateNestedOneWithoutProductSubscriptionTypesInput>;
  trialPurchaseLimit?: InputMaybe<Scalars['Int']['input']>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductCreateNestedManyWithoutProductSubscriptionTypeInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutFromProductSubscriptionTypeInput>;
  upgradeType?: InputMaybe<UpgradeType>;
  xeroAccountCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSubscriptionTypeListRelationFilter = {
  every?: InputMaybe<ProductSubscriptionTypeWhereInput>;
  none?: InputMaybe<ProductSubscriptionTypeWhereInput>;
  some?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeMaxOrderByAggregateInput = {
  automaticRenew?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  durationInDays?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  isTrialSubscription?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priceInCents?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  trialPurchaseLimit?: InputMaybe<SortOrder>;
  upgradeType?: InputMaybe<SortOrder>;
  xeroAccountCode?: InputMaybe<SortOrder>;
};

export type ProductSubscriptionTypeMinOrderByAggregateInput = {
  automaticRenew?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  durationInDays?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  isTrialSubscription?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priceInCents?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  trialPurchaseLimit?: InputMaybe<SortOrder>;
  upgradeType?: InputMaybe<SortOrder>;
  xeroAccountCode?: InputMaybe<SortOrder>;
};

export type ProductSubscriptionTypeNullableScalarRelationFilter = {
  is?: InputMaybe<ProductSubscriptionTypeWhereInput>;
  isNot?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductSubscriptionTypeOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProductSubscriptionTypeAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProductSubscriptionTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductSubscriptionTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductSubscriptionTypeMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProductSubscriptionTypeSumOrderByAggregateInput>;
  automaticRenew?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  durationInDays?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  isTrialSubscription?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priceInCents?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrderInput>;
  trialPurchaseLimit?: InputMaybe<SortOrderInput>;
  upgradeType?: InputMaybe<SortOrderInput>;
  xeroAccountCode?: InputMaybe<SortOrderInput>;
};

export type ProductSubscriptionTypeOrderByWithRelationInput = {
  automaticRenew?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  durationInDays?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  isTrialSubscription?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  paymentItems?: InputMaybe<PaymentItemOrderByRelationAggregateInput>;
  priceInCents?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrderInput>;
  trialPurchaseLimit?: InputMaybe<SortOrderInput>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductOrderByRelationAggregateInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountOrderByRelationAggregateInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementOrderByRelationAggregateInput>;
  upgradeType?: InputMaybe<SortOrderInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionOrderByRelationAggregateInput>;
  xeroAccountCode?: InputMaybe<SortOrderInput>;
};

export enum ProductSubscriptionTypeScalarFieldEnum {
  AutomaticRenew = 'automaticRenew',
  Created = 'created',
  Currency = 'currency',
  Description = 'description',
  DurationInDays = 'durationInDays',
  Id = 'id',
  IsPublished = 'isPublished',
  IsTrialSubscription = 'isTrialSubscription',
  Modified = 'modified',
  Name = 'name',
  PriceInCents = 'priceInCents',
  ProductId = 'productId',
  TrialPurchaseLimit = 'trialPurchaseLimit',
  UpgradeType = 'upgradeType',
  XeroAccountCode = 'xeroAccountCode'
}

export type ProductSubscriptionTypeScalarRelationFilter = {
  is?: InputMaybe<ProductSubscriptionTypeWhereInput>;
  isNot?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeScalarWhereInput = {
  AND?: InputMaybe<Array<ProductSubscriptionTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductSubscriptionTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductSubscriptionTypeScalarWhereInput>>;
  automaticRenew?: InputMaybe<BoolFilter>;
  created?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyFilter>;
  description?: InputMaybe<StringNullableFilter>;
  durationInDays?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  isTrialSubscription?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  priceInCents?: InputMaybe<IntFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  trialPurchaseLimit?: InputMaybe<IntNullableFilter>;
  upgradeType?: InputMaybe<EnumUpgradeTypeNullableFilter>;
  xeroAccountCode?: InputMaybe<StringNullableFilter>;
};

export type ProductSubscriptionTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductSubscriptionTypeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductSubscriptionTypeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductSubscriptionTypeScalarWhereWithAggregatesInput>>;
  automaticRenew?: InputMaybe<BoolWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  durationInDays?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isPublished?: InputMaybe<BoolWithAggregatesFilter>;
  isTrialSubscription?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  priceInCents?: InputMaybe<IntWithAggregatesFilter>;
  productId?: InputMaybe<StringNullableWithAggregatesFilter>;
  trialPurchaseLimit?: InputMaybe<IntNullableWithAggregatesFilter>;
  upgradeType?: InputMaybe<EnumUpgradeTypeNullableWithAggregatesFilter>;
  xeroAccountCode?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ProductSubscriptionTypeSumOrderByAggregateInput = {
  durationInDays?: InputMaybe<SortOrder>;
  priceInCents?: InputMaybe<SortOrder>;
  trialPurchaseLimit?: InputMaybe<SortOrder>;
};

export type ProductSubscriptionTypeUpdateInput = {
  automaticRenew?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  durationInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrialSubscription?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  priceInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutProductSubscriptionTypesNestedInput>;
  trialPurchaseLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradeType?: InputMaybe<NullableEnumUpgradeTypeFieldUpdateOperationsInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  xeroAccountCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductSubscriptionTypeUpdateManyMutationInput = {
  automaticRenew?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  durationInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrialSubscription?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  priceInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  trialPurchaseLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradeType?: InputMaybe<NullableEnumUpgradeTypeFieldUpdateOperationsInput>;
  xeroAccountCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductSubscriptionTypeUpdateManyWithWhereWithoutProductInput = {
  data: ProductSubscriptionTypeUpdateManyMutationInput;
  where: ProductSubscriptionTypeScalarWhereInput;
};

export type ProductSubscriptionTypeUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<ProductSubscriptionTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductSubscriptionTypeCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductSubscriptionTypeCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductSubscriptionTypeCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ProductSubscriptionTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductSubscriptionTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductSubscriptionTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductSubscriptionTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductSubscriptionTypeUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ProductSubscriptionTypeUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ProductSubscriptionTypeUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePathTargetProductsNestedInput = {
  connect?: InputMaybe<ProductSubscriptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSubscriptionTypeCreateOrConnectWithoutUpgradePathTargetProductsInput>;
  create?: InputMaybe<ProductSubscriptionTypeCreateWithoutUpgradePathTargetProductsInput>;
  update?: InputMaybe<ProductSubscriptionTypeUpdateToOneWithWhereWithoutUpgradePathTargetProductsInput>;
  upsert?: InputMaybe<ProductSubscriptionTypeUpsertWithoutUpgradePathTargetProductsInput>;
};

export type ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePathsFromNestedInput = {
  connect?: InputMaybe<ProductSubscriptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSubscriptionTypeCreateOrConnectWithoutUpgradePathsFromInput>;
  create?: InputMaybe<ProductSubscriptionTypeCreateWithoutUpgradePathsFromInput>;
  update?: InputMaybe<ProductSubscriptionTypeUpdateToOneWithWhereWithoutUpgradePathsFromInput>;
  upsert?: InputMaybe<ProductSubscriptionTypeUpsertWithoutUpgradePathsFromInput>;
};

export type ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePromptEngagementsFromNestedInput = {
  connect?: InputMaybe<ProductSubscriptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSubscriptionTypeCreateOrConnectWithoutUpgradePromptEngagementsFromInput>;
  create?: InputMaybe<ProductSubscriptionTypeCreateWithoutUpgradePromptEngagementsFromInput>;
  update?: InputMaybe<ProductSubscriptionTypeUpdateToOneWithWhereWithoutUpgradePromptEngagementsFromInput>;
  upsert?: InputMaybe<ProductSubscriptionTypeUpsertWithoutUpgradePromptEngagementsFromInput>;
};

export type ProductSubscriptionTypeUpdateOneRequiredWithoutUserSubscriptionsNestedInput = {
  connect?: InputMaybe<ProductSubscriptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSubscriptionTypeCreateOrConnectWithoutUserSubscriptionsInput>;
  create?: InputMaybe<ProductSubscriptionTypeCreateWithoutUserSubscriptionsInput>;
  update?: InputMaybe<ProductSubscriptionTypeUpdateToOneWithWhereWithoutUserSubscriptionsInput>;
  upsert?: InputMaybe<ProductSubscriptionTypeUpsertWithoutUserSubscriptionsInput>;
};

export type ProductSubscriptionTypeUpdateOneWithoutPaymentItemsNestedInput = {
  connect?: InputMaybe<ProductSubscriptionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSubscriptionTypeCreateOrConnectWithoutPaymentItemsInput>;
  create?: InputMaybe<ProductSubscriptionTypeCreateWithoutPaymentItemsInput>;
  delete?: InputMaybe<ProductSubscriptionTypeWhereInput>;
  disconnect?: InputMaybe<ProductSubscriptionTypeWhereInput>;
  update?: InputMaybe<ProductSubscriptionTypeUpdateToOneWithWhereWithoutPaymentItemsInput>;
  upsert?: InputMaybe<ProductSubscriptionTypeUpsertWithoutPaymentItemsInput>;
};

export type ProductSubscriptionTypeUpdateToOneWithWhereWithoutPaymentItemsInput = {
  data: ProductSubscriptionTypeUpdateWithoutPaymentItemsInput;
  where?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeUpdateToOneWithWhereWithoutUpgradePathTargetProductsInput = {
  data: ProductSubscriptionTypeUpdateWithoutUpgradePathTargetProductsInput;
  where?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeUpdateToOneWithWhereWithoutUpgradePathsFromInput = {
  data: ProductSubscriptionTypeUpdateWithoutUpgradePathsFromInput;
  where?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeUpdateToOneWithWhereWithoutUpgradePromptEngagementsFromInput = {
  data: ProductSubscriptionTypeUpdateWithoutUpgradePromptEngagementsFromInput;
  where?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeUpdateToOneWithWhereWithoutUserSubscriptionsInput = {
  data: ProductSubscriptionTypeUpdateWithoutUserSubscriptionsInput;
  where?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeUpdateWithWhereUniqueWithoutProductInput = {
  data: ProductSubscriptionTypeUpdateWithoutProductInput;
  where: ProductSubscriptionTypeWhereUniqueInput;
};

export type ProductSubscriptionTypeUpdateWithoutPaymentItemsInput = {
  automaticRenew?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  durationInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrialSubscription?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  priceInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutProductSubscriptionTypesNestedInput>;
  trialPurchaseLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradeType?: InputMaybe<NullableEnumUpgradeTypeFieldUpdateOperationsInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  xeroAccountCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductSubscriptionTypeUpdateWithoutProductInput = {
  automaticRenew?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  durationInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrialSubscription?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  priceInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  trialPurchaseLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradeType?: InputMaybe<NullableEnumUpgradeTypeFieldUpdateOperationsInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  xeroAccountCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductSubscriptionTypeUpdateWithoutUpgradePathTargetProductsInput = {
  automaticRenew?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  durationInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrialSubscription?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  priceInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutProductSubscriptionTypesNestedInput>;
  trialPurchaseLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradeType?: InputMaybe<NullableEnumUpgradeTypeFieldUpdateOperationsInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  xeroAccountCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductSubscriptionTypeUpdateWithoutUpgradePathsFromInput = {
  automaticRenew?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  durationInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrialSubscription?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  priceInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutProductSubscriptionTypesNestedInput>;
  trialPurchaseLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradeType?: InputMaybe<NullableEnumUpgradeTypeFieldUpdateOperationsInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  xeroAccountCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductSubscriptionTypeUpdateWithoutUpgradePromptEngagementsFromInput = {
  automaticRenew?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  durationInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrialSubscription?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  priceInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutProductSubscriptionTypesNestedInput>;
  trialPurchaseLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradeType?: InputMaybe<NullableEnumUpgradeTypeFieldUpdateOperationsInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  xeroAccountCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductSubscriptionTypeUpdateWithoutUserSubscriptionsInput = {
  automaticRenew?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  durationInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrialSubscription?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentItems?: InputMaybe<PaymentItemUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  priceInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutProductSubscriptionTypesNestedInput>;
  trialPurchaseLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductUpdateManyWithoutProductSubscriptionTypeNestedInput>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutFromProductSubscriptionTypeNestedInput>;
  upgradeType?: InputMaybe<NullableEnumUpgradeTypeFieldUpdateOperationsInput>;
  xeroAccountCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductSubscriptionTypeUpsertWithWhereUniqueWithoutProductInput = {
  create: ProductSubscriptionTypeCreateWithoutProductInput;
  update: ProductSubscriptionTypeUpdateWithoutProductInput;
  where: ProductSubscriptionTypeWhereUniqueInput;
};

export type ProductSubscriptionTypeUpsertWithoutPaymentItemsInput = {
  create: ProductSubscriptionTypeCreateWithoutPaymentItemsInput;
  update: ProductSubscriptionTypeUpdateWithoutPaymentItemsInput;
  where?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeUpsertWithoutUpgradePathTargetProductsInput = {
  create: ProductSubscriptionTypeCreateWithoutUpgradePathTargetProductsInput;
  update: ProductSubscriptionTypeUpdateWithoutUpgradePathTargetProductsInput;
  where?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeUpsertWithoutUpgradePathsFromInput = {
  create: ProductSubscriptionTypeCreateWithoutUpgradePathsFromInput;
  update: ProductSubscriptionTypeUpdateWithoutUpgradePathsFromInput;
  where?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeUpsertWithoutUpgradePromptEngagementsFromInput = {
  create: ProductSubscriptionTypeCreateWithoutUpgradePromptEngagementsFromInput;
  update: ProductSubscriptionTypeUpdateWithoutUpgradePromptEngagementsFromInput;
  where?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeUpsertWithoutUserSubscriptionsInput = {
  create: ProductSubscriptionTypeCreateWithoutUserSubscriptionsInput;
  update: ProductSubscriptionTypeUpdateWithoutUserSubscriptionsInput;
  where?: InputMaybe<ProductSubscriptionTypeWhereInput>;
};

export type ProductSubscriptionTypeWhereInput = {
  AND?: InputMaybe<Array<ProductSubscriptionTypeWhereInput>>;
  NOT?: InputMaybe<Array<ProductSubscriptionTypeWhereInput>>;
  OR?: InputMaybe<Array<ProductSubscriptionTypeWhereInput>>;
  automaticRenew?: InputMaybe<BoolFilter>;
  created?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyFilter>;
  description?: InputMaybe<StringNullableFilter>;
  durationInDays?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  isTrialSubscription?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  paymentItems?: InputMaybe<PaymentItemListRelationFilter>;
  priceInCents?: InputMaybe<IntFilter>;
  product?: InputMaybe<ProductNullableScalarRelationFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  trialPurchaseLimit?: InputMaybe<IntNullableFilter>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductListRelationFilter>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountListRelationFilter>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementListRelationFilter>;
  upgradeType?: InputMaybe<EnumUpgradeTypeNullableFilter>;
  userSubscriptions?: InputMaybe<UserSubscriptionListRelationFilter>;
  xeroAccountCode?: InputMaybe<StringNullableFilter>;
};

export type ProductSubscriptionTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductSubscriptionTypeWhereInput>>;
  NOT?: InputMaybe<Array<ProductSubscriptionTypeWhereInput>>;
  OR?: InputMaybe<Array<ProductSubscriptionTypeWhereInput>>;
  automaticRenew?: InputMaybe<BoolFilter>;
  created?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyFilter>;
  description?: InputMaybe<StringNullableFilter>;
  durationInDays?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<BoolFilter>;
  isTrialSubscription?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  paymentItems?: InputMaybe<PaymentItemListRelationFilter>;
  priceInCents?: InputMaybe<IntFilter>;
  product?: InputMaybe<ProductNullableScalarRelationFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  trialPurchaseLimit?: InputMaybe<IntNullableFilter>;
  upgradePathTargetProducts?: InputMaybe<UpgradePathDiscountTargetProductListRelationFilter>;
  upgradePathsFrom?: InputMaybe<UpgradePathDiscountListRelationFilter>;
  upgradePromptEngagementsFrom?: InputMaybe<UpgradePromptEngagementListRelationFilter>;
  upgradeType?: InputMaybe<EnumUpgradeTypeNullableFilter>;
  userSubscriptions?: InputMaybe<UserSubscriptionListRelationFilter>;
  xeroAccountCode?: InputMaybe<StringNullableFilter>;
};

export type ProductUpdateInput = {
  brandingType?: InputMaybe<EnumBrandingTypeFieldUpdateOperationsInput>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionUpdateManyWithoutProductNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthProfessionalOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProductNestedInput>;
  productEvents?: InputMaybe<ProductEventUpdateManyWithoutProductNestedInput>;
  productPodcasts?: InputMaybe<ProductPodcastUpdateManyWithoutProductNestedInput>;
  productProgrammes?: InputMaybe<ProductProgrammeUpdateManyWithoutProductNestedInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeUpdateManyWithoutProductNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutProductNestedInput>;
};

export type ProductUpdateManyMutationInput = {
  brandingType?: InputMaybe<EnumBrandingTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthProfessionalOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductUpdateOneRequiredWithoutCouponProductRestrictionsNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutCouponProductRestrictionsInput>;
  create?: InputMaybe<ProductCreateWithoutCouponProductRestrictionsInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutCouponProductRestrictionsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutCouponProductRestrictionsInput>;
};

export type ProductUpdateOneRequiredWithoutPrerequisitesNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutPrerequisitesInput>;
  create?: InputMaybe<ProductCreateWithoutPrerequisitesInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutPrerequisitesInput>;
  upsert?: InputMaybe<ProductUpsertWithoutPrerequisitesInput>;
};

export type ProductUpdateOneRequiredWithoutProductEventsNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutProductEventsInput>;
  create?: InputMaybe<ProductCreateWithoutProductEventsInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutProductEventsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutProductEventsInput>;
};

export type ProductUpdateOneRequiredWithoutProductPodcastsNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutProductPodcastsInput>;
  create?: InputMaybe<ProductCreateWithoutProductPodcastsInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutProductPodcastsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutProductPodcastsInput>;
};

export type ProductUpdateOneRequiredWithoutProductProgrammesNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutProductProgrammesInput>;
  create?: InputMaybe<ProductCreateWithoutProductProgrammesInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutProductProgrammesInput>;
  upsert?: InputMaybe<ProductUpsertWithoutProductProgrammesInput>;
};

export type ProductUpdateOneWithoutProductSubscriptionTypesNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutProductSubscriptionTypesInput>;
  create?: InputMaybe<ProductCreateWithoutProductSubscriptionTypesInput>;
  delete?: InputMaybe<ProductWhereInput>;
  disconnect?: InputMaybe<ProductWhereInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutProductSubscriptionTypesInput>;
  upsert?: InputMaybe<ProductUpsertWithoutProductSubscriptionTypesInput>;
};

export type ProductUpdateOneWithoutTemplatesNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutTemplatesInput>;
  create?: InputMaybe<ProductCreateWithoutTemplatesInput>;
  delete?: InputMaybe<ProductWhereInput>;
  disconnect?: InputMaybe<ProductWhereInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutTemplatesInput>;
  upsert?: InputMaybe<ProductUpsertWithoutTemplatesInput>;
};

export type ProductUpdateToOneWithWhereWithoutCouponProductRestrictionsInput = {
  data: ProductUpdateWithoutCouponProductRestrictionsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutPrerequisitesInput = {
  data: ProductUpdateWithoutPrerequisitesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutProductEventsInput = {
  data: ProductUpdateWithoutProductEventsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutProductPodcastsInput = {
  data: ProductUpdateWithoutProductPodcastsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutProductProgrammesInput = {
  data: ProductUpdateWithoutProductProgrammesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutProductSubscriptionTypesInput = {
  data: ProductUpdateWithoutProductSubscriptionTypesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutTemplatesInput = {
  data: ProductUpdateWithoutTemplatesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateWithoutCouponProductRestrictionsInput = {
  brandingType?: InputMaybe<EnumBrandingTypeFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthProfessionalOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProductNestedInput>;
  productEvents?: InputMaybe<ProductEventUpdateManyWithoutProductNestedInput>;
  productPodcasts?: InputMaybe<ProductPodcastUpdateManyWithoutProductNestedInput>;
  productProgrammes?: InputMaybe<ProductProgrammeUpdateManyWithoutProductNestedInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeUpdateManyWithoutProductNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutProductNestedInput>;
};

export type ProductUpdateWithoutPrerequisitesInput = {
  brandingType?: InputMaybe<EnumBrandingTypeFieldUpdateOperationsInput>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionUpdateManyWithoutProductNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthProfessionalOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  productEvents?: InputMaybe<ProductEventUpdateManyWithoutProductNestedInput>;
  productPodcasts?: InputMaybe<ProductPodcastUpdateManyWithoutProductNestedInput>;
  productProgrammes?: InputMaybe<ProductProgrammeUpdateManyWithoutProductNestedInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeUpdateManyWithoutProductNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutProductNestedInput>;
};

export type ProductUpdateWithoutProductEventsInput = {
  brandingType?: InputMaybe<EnumBrandingTypeFieldUpdateOperationsInput>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionUpdateManyWithoutProductNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthProfessionalOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProductNestedInput>;
  productPodcasts?: InputMaybe<ProductPodcastUpdateManyWithoutProductNestedInput>;
  productProgrammes?: InputMaybe<ProductProgrammeUpdateManyWithoutProductNestedInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeUpdateManyWithoutProductNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutProductNestedInput>;
};

export type ProductUpdateWithoutProductPodcastsInput = {
  brandingType?: InputMaybe<EnumBrandingTypeFieldUpdateOperationsInput>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionUpdateManyWithoutProductNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthProfessionalOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProductNestedInput>;
  productEvents?: InputMaybe<ProductEventUpdateManyWithoutProductNestedInput>;
  productProgrammes?: InputMaybe<ProductProgrammeUpdateManyWithoutProductNestedInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeUpdateManyWithoutProductNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutProductNestedInput>;
};

export type ProductUpdateWithoutProductProgrammesInput = {
  brandingType?: InputMaybe<EnumBrandingTypeFieldUpdateOperationsInput>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionUpdateManyWithoutProductNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthProfessionalOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProductNestedInput>;
  productEvents?: InputMaybe<ProductEventUpdateManyWithoutProductNestedInput>;
  productPodcasts?: InputMaybe<ProductPodcastUpdateManyWithoutProductNestedInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeUpdateManyWithoutProductNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutProductNestedInput>;
};

export type ProductUpdateWithoutProductSubscriptionTypesInput = {
  brandingType?: InputMaybe<EnumBrandingTypeFieldUpdateOperationsInput>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionUpdateManyWithoutProductNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthProfessionalOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProductNestedInput>;
  productEvents?: InputMaybe<ProductEventUpdateManyWithoutProductNestedInput>;
  productPodcasts?: InputMaybe<ProductPodcastUpdateManyWithoutProductNestedInput>;
  productProgrammes?: InputMaybe<ProductProgrammeUpdateManyWithoutProductNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutProductNestedInput>;
};

export type ProductUpdateWithoutTemplatesInput = {
  brandingType?: InputMaybe<EnumBrandingTypeFieldUpdateOperationsInput>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionUpdateManyWithoutProductNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthProfessionalOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProductNestedInput>;
  productEvents?: InputMaybe<ProductEventUpdateManyWithoutProductNestedInput>;
  productPodcasts?: InputMaybe<ProductPodcastUpdateManyWithoutProductNestedInput>;
  productProgrammes?: InputMaybe<ProductProgrammeUpdateManyWithoutProductNestedInput>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeUpdateManyWithoutProductNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductUpsertWithoutCouponProductRestrictionsInput = {
  create: ProductCreateWithoutCouponProductRestrictionsInput;
  update: ProductUpdateWithoutCouponProductRestrictionsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutPrerequisitesInput = {
  create: ProductCreateWithoutPrerequisitesInput;
  update: ProductUpdateWithoutPrerequisitesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutProductEventsInput = {
  create: ProductCreateWithoutProductEventsInput;
  update: ProductUpdateWithoutProductEventsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutProductPodcastsInput = {
  create: ProductCreateWithoutProductPodcastsInput;
  update: ProductUpdateWithoutProductPodcastsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutProductProgrammesInput = {
  create: ProductCreateWithoutProductProgrammesInput;
  update: ProductUpdateWithoutProductProgrammesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutProductSubscriptionTypesInput = {
  create: ProductCreateWithoutProductSubscriptionTypesInput;
  update: ProductUpdateWithoutProductSubscriptionTypesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutTemplatesInput = {
  create: ProductCreateWithoutTemplatesInput;
  update: ProductUpdateWithoutTemplatesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  brandingType?: InputMaybe<EnumBrandingTypeFilter>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionListRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  healthProfessionalOnly?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteListRelationFilter>;
  productEvents?: InputMaybe<ProductEventListRelationFilter>;
  productPodcasts?: InputMaybe<ProductPodcastListRelationFilter>;
  productProgrammes?: InputMaybe<ProductProgrammeListRelationFilter>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeListRelationFilter>;
  shortName?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  templates?: InputMaybe<TemplateListRelationFilter>;
};

export type ProductWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  brandingType?: InputMaybe<EnumBrandingTypeFilter>;
  couponProductRestrictions?: InputMaybe<CouponProductRestrictionListRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  healthProfessionalOnly?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  prerequisites?: InputMaybe<ProductProgrammePrerequisiteListRelationFilter>;
  productEvents?: InputMaybe<ProductEventListRelationFilter>;
  productPodcasts?: InputMaybe<ProductPodcastListRelationFilter>;
  productProgrammes?: InputMaybe<ProductProgrammeListRelationFilter>;
  productSubscriptionTypes?: InputMaybe<ProductSubscriptionTypeListRelationFilter>;
  shortName?: InputMaybe<StringFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  templates?: InputMaybe<TemplateListRelationFilter>;
};

export type ProgrammeAvgOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProgrammeCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHidden?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  learningStyle?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  shortName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProgrammeCreateInput = {
  categories?: InputMaybe<CategoryCreateNestedManyWithoutProgrammeInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  learningStyle?: InputMaybe<LearningStyle>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProgrammeInput>;
  programmeProducts?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProgrammeInput>;
  programmeTags?: InputMaybe<ProgrammeTagCreateNestedManyWithoutProgrammeInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutProgrammeInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  userProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutProgrammeInput>;
};

export type ProgrammeCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  learningStyle?: InputMaybe<LearningStyle>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgrammeCreateNestedOneWithoutCategoriesInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutCategoriesInput>;
  create?: InputMaybe<ProgrammeCreateWithoutCategoriesInput>;
};

export type ProgrammeCreateNestedOneWithoutPrerequisiteForInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutPrerequisiteForInput>;
  create?: InputMaybe<ProgrammeCreateWithoutPrerequisiteForInput>;
};

export type ProgrammeCreateNestedOneWithoutProgrammeProductsInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutProgrammeProductsInput>;
  create?: InputMaybe<ProgrammeCreateWithoutProgrammeProductsInput>;
};

export type ProgrammeCreateNestedOneWithoutProgrammeTagsInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutProgrammeTagsInput>;
  create?: InputMaybe<ProgrammeCreateWithoutProgrammeTagsInput>;
};

export type ProgrammeCreateNestedOneWithoutSavedForLaterInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutSavedForLaterInput>;
  create?: InputMaybe<ProgrammeCreateWithoutSavedForLaterInput>;
};

export type ProgrammeCreateNestedOneWithoutUserProgressionsInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutUserProgressionsInput>;
  create?: InputMaybe<ProgrammeCreateWithoutUserProgressionsInput>;
};

export type ProgrammeCreateOrConnectWithoutCategoriesInput = {
  create: ProgrammeCreateWithoutCategoriesInput;
  where: ProgrammeWhereUniqueInput;
};

export type ProgrammeCreateOrConnectWithoutPrerequisiteForInput = {
  create: ProgrammeCreateWithoutPrerequisiteForInput;
  where: ProgrammeWhereUniqueInput;
};

export type ProgrammeCreateOrConnectWithoutProgrammeProductsInput = {
  create: ProgrammeCreateWithoutProgrammeProductsInput;
  where: ProgrammeWhereUniqueInput;
};

export type ProgrammeCreateOrConnectWithoutProgrammeTagsInput = {
  create: ProgrammeCreateWithoutProgrammeTagsInput;
  where: ProgrammeWhereUniqueInput;
};

export type ProgrammeCreateOrConnectWithoutSavedForLaterInput = {
  create: ProgrammeCreateWithoutSavedForLaterInput;
  where: ProgrammeWhereUniqueInput;
};

export type ProgrammeCreateOrConnectWithoutUserProgressionsInput = {
  create: ProgrammeCreateWithoutUserProgressionsInput;
  where: ProgrammeWhereUniqueInput;
};

export type ProgrammeCreateWithoutCategoriesInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  learningStyle?: InputMaybe<LearningStyle>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProgrammeInput>;
  programmeProducts?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProgrammeInput>;
  programmeTags?: InputMaybe<ProgrammeTagCreateNestedManyWithoutProgrammeInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutProgrammeInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  userProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutProgrammeInput>;
};

export type ProgrammeCreateWithoutPrerequisiteForInput = {
  categories?: InputMaybe<CategoryCreateNestedManyWithoutProgrammeInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  learningStyle?: InputMaybe<LearningStyle>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  programmeProducts?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProgrammeInput>;
  programmeTags?: InputMaybe<ProgrammeTagCreateNestedManyWithoutProgrammeInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutProgrammeInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  userProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutProgrammeInput>;
};

export type ProgrammeCreateWithoutProgrammeProductsInput = {
  categories?: InputMaybe<CategoryCreateNestedManyWithoutProgrammeInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  learningStyle?: InputMaybe<LearningStyle>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProgrammeInput>;
  programmeTags?: InputMaybe<ProgrammeTagCreateNestedManyWithoutProgrammeInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutProgrammeInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  userProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutProgrammeInput>;
};

export type ProgrammeCreateWithoutProgrammeTagsInput = {
  categories?: InputMaybe<CategoryCreateNestedManyWithoutProgrammeInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  learningStyle?: InputMaybe<LearningStyle>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProgrammeInput>;
  programmeProducts?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProgrammeInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutProgrammeInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  userProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutProgrammeInput>;
};

export type ProgrammeCreateWithoutSavedForLaterInput = {
  categories?: InputMaybe<CategoryCreateNestedManyWithoutProgrammeInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  learningStyle?: InputMaybe<LearningStyle>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProgrammeInput>;
  programmeProducts?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProgrammeInput>;
  programmeTags?: InputMaybe<ProgrammeTagCreateNestedManyWithoutProgrammeInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  userProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutProgrammeInput>;
};

export type ProgrammeCreateWithoutUserProgressionsInput = {
  categories?: InputMaybe<CategoryCreateNestedManyWithoutProgrammeInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  learningStyle?: InputMaybe<LearningStyle>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteCreateNestedManyWithoutProgrammeInput>;
  programmeProducts?: InputMaybe<ProductProgrammeCreateNestedManyWithoutProgrammeInput>;
  programmeTags?: InputMaybe<ProgrammeTagCreateNestedManyWithoutProgrammeInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutProgrammeInput>;
  shortName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgrammeMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHidden?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  learningStyle?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  shortName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProgrammeMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHidden?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  learningStyle?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  shortName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProgrammeOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProgrammeAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProgrammeCountOrderByAggregateInput>;
  _max?: InputMaybe<ProgrammeMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProgrammeMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProgrammeSumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHidden?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  learningStyle?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  shortName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProgrammeOrderByWithRelationInput = {
  categories?: InputMaybe<CategoryOrderByRelationAggregateInput>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHidden?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  learningStyle?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteOrderByRelationAggregateInput>;
  programmeProducts?: InputMaybe<ProductProgrammeOrderByRelationAggregateInput>;
  programmeTags?: InputMaybe<ProgrammeTagOrderByRelationAggregateInput>;
  savedForLater?: InputMaybe<SavedForLaterOrderByRelationAggregateInput>;
  shortName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  userProgressions?: InputMaybe<ProgrammeProgressionOrderByRelationAggregateInput>;
};

export type ProgrammeProgressionAvgOrderByAggregateInput = {
  percentage?: InputMaybe<SortOrder>;
};

export type ProgrammeProgressionCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedKlaviyoCompleted?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ProgrammeProgressionCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  programme: ProgrammeCreateNestedOneWithoutUserProgressionsInput;
  user: UserCreateNestedOneWithoutProgrammeProgressionsInput;
};

export type ProgrammeProgressionCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  programmeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ProgrammeProgressionCreateManyProgrammeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  userId: Scalars['String']['input'];
};

export type ProgrammeProgressionCreateManyProgrammeInputEnvelope = {
  data: Array<ProgrammeProgressionCreateManyProgrammeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgrammeProgressionCreateManyUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  programmeId: Scalars['String']['input'];
};

export type ProgrammeProgressionCreateManyUserInputEnvelope = {
  data: Array<ProgrammeProgressionCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgrammeProgressionCreateNestedManyWithoutProgrammeInput = {
  connect?: InputMaybe<Array<ProgrammeProgressionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProgrammeProgressionCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<ProgrammeProgressionCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<ProgrammeProgressionCreateManyProgrammeInputEnvelope>;
};

export type ProgrammeProgressionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ProgrammeProgressionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProgrammeProgressionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ProgrammeProgressionCreateWithoutUserInput>>;
  createMany?: InputMaybe<ProgrammeProgressionCreateManyUserInputEnvelope>;
};

export type ProgrammeProgressionCreateOrConnectWithoutProgrammeInput = {
  create: ProgrammeProgressionCreateWithoutProgrammeInput;
  where: ProgrammeProgressionWhereUniqueInput;
};

export type ProgrammeProgressionCreateOrConnectWithoutUserInput = {
  create: ProgrammeProgressionCreateWithoutUserInput;
  where: ProgrammeProgressionWhereUniqueInput;
};

export type ProgrammeProgressionCreateWithoutProgrammeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  user: UserCreateNestedOneWithoutProgrammeProgressionsInput;
};

export type ProgrammeProgressionCreateWithoutUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  programme: ProgrammeCreateNestedOneWithoutUserProgressionsInput;
};

export type ProgrammeProgressionListRelationFilter = {
  every?: InputMaybe<ProgrammeProgressionWhereInput>;
  none?: InputMaybe<ProgrammeProgressionWhereInput>;
  some?: InputMaybe<ProgrammeProgressionWhereInput>;
};

export type ProgrammeProgressionMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedKlaviyoCompleted?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ProgrammeProgressionMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedKlaviyoCompleted?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ProgrammeProgressionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProgrammeProgressionOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProgrammeProgressionAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProgrammeProgressionCountOrderByAggregateInput>;
  _max?: InputMaybe<ProgrammeProgressionMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProgrammeProgressionMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProgrammeProgressionSumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedKlaviyoCompleted?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrderInput>;
  programmeId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ProgrammeProgressionOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedKlaviyoCompleted?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrderInput>;
  programme?: InputMaybe<ProgrammeOrderByWithRelationInput>;
  programmeId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type ProgrammeProgressionProgrammeProgressionCompoundUniqueInput = {
  programmeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum ProgrammeProgressionScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  IsCompleted = 'isCompleted',
  Modified = 'modified',
  NotifiedKlaviyoCompleted = 'notifiedKlaviyoCompleted',
  Percentage = 'percentage',
  ProgrammeId = 'programmeId',
  UserId = 'userId'
}

export type ProgrammeProgressionScalarWhereInput = {
  AND?: InputMaybe<Array<ProgrammeProgressionScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProgrammeProgressionScalarWhereInput>>;
  OR?: InputMaybe<Array<ProgrammeProgressionScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isCompleted?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  notifiedKlaviyoCompleted?: InputMaybe<BoolFilter>;
  percentage?: InputMaybe<FloatNullableFilter>;
  programmeId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ProgrammeProgressionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProgrammeProgressionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProgrammeProgressionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProgrammeProgressionScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isCompleted?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  notifiedKlaviyoCompleted?: InputMaybe<BoolWithAggregatesFilter>;
  percentage?: InputMaybe<FloatNullableWithAggregatesFilter>;
  programmeId?: InputMaybe<StringWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ProgrammeProgressionSumOrderByAggregateInput = {
  percentage?: InputMaybe<SortOrder>;
};

export type ProgrammeProgressionUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedKlaviyoCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  percentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutUserProgressionsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutProgrammeProgressionsNestedInput>;
};

export type ProgrammeProgressionUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedKlaviyoCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  percentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type ProgrammeProgressionUpdateManyWithWhereWithoutProgrammeInput = {
  data: ProgrammeProgressionUpdateManyMutationInput;
  where: ProgrammeProgressionScalarWhereInput;
};

export type ProgrammeProgressionUpdateManyWithWhereWithoutUserInput = {
  data: ProgrammeProgressionUpdateManyMutationInput;
  where: ProgrammeProgressionScalarWhereInput;
};

export type ProgrammeProgressionUpdateManyWithoutProgrammeNestedInput = {
  connect?: InputMaybe<Array<ProgrammeProgressionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProgrammeProgressionCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<ProgrammeProgressionCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<ProgrammeProgressionCreateManyProgrammeInputEnvelope>;
  delete?: InputMaybe<Array<ProgrammeProgressionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProgrammeProgressionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProgrammeProgressionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProgrammeProgressionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProgrammeProgressionUpdateWithWhereUniqueWithoutProgrammeInput>>;
  updateMany?: InputMaybe<Array<ProgrammeProgressionUpdateManyWithWhereWithoutProgrammeInput>>;
  upsert?: InputMaybe<Array<ProgrammeProgressionUpsertWithWhereUniqueWithoutProgrammeInput>>;
};

export type ProgrammeProgressionUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ProgrammeProgressionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProgrammeProgressionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ProgrammeProgressionCreateWithoutUserInput>>;
  createMany?: InputMaybe<ProgrammeProgressionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ProgrammeProgressionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProgrammeProgressionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProgrammeProgressionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProgrammeProgressionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProgrammeProgressionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ProgrammeProgressionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ProgrammeProgressionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ProgrammeProgressionUpdateWithWhereUniqueWithoutProgrammeInput = {
  data: ProgrammeProgressionUpdateWithoutProgrammeInput;
  where: ProgrammeProgressionWhereUniqueInput;
};

export type ProgrammeProgressionUpdateWithWhereUniqueWithoutUserInput = {
  data: ProgrammeProgressionUpdateWithoutUserInput;
  where: ProgrammeProgressionWhereUniqueInput;
};

export type ProgrammeProgressionUpdateWithoutProgrammeInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedKlaviyoCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  percentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutProgrammeProgressionsNestedInput>;
};

export type ProgrammeProgressionUpdateWithoutUserInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedKlaviyoCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  percentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutUserProgressionsNestedInput>;
};

export type ProgrammeProgressionUpsertWithWhereUniqueWithoutProgrammeInput = {
  create: ProgrammeProgressionCreateWithoutProgrammeInput;
  update: ProgrammeProgressionUpdateWithoutProgrammeInput;
  where: ProgrammeProgressionWhereUniqueInput;
};

export type ProgrammeProgressionUpsertWithWhereUniqueWithoutUserInput = {
  create: ProgrammeProgressionCreateWithoutUserInput;
  update: ProgrammeProgressionUpdateWithoutUserInput;
  where: ProgrammeProgressionWhereUniqueInput;
};

export type ProgrammeProgressionWhereInput = {
  AND?: InputMaybe<Array<ProgrammeProgressionWhereInput>>;
  NOT?: InputMaybe<Array<ProgrammeProgressionWhereInput>>;
  OR?: InputMaybe<Array<ProgrammeProgressionWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isCompleted?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  notifiedKlaviyoCompleted?: InputMaybe<BoolFilter>;
  percentage?: InputMaybe<FloatNullableFilter>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ProgrammeProgressionWhereUniqueInput = {
  AND?: InputMaybe<Array<ProgrammeProgressionWhereInput>>;
  NOT?: InputMaybe<Array<ProgrammeProgressionWhereInput>>;
  OR?: InputMaybe<Array<ProgrammeProgressionWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  notifiedKlaviyoCompleted?: InputMaybe<BoolFilter>;
  percentage?: InputMaybe<FloatNullableFilter>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
  programmeProgression?: InputMaybe<ProgrammeProgressionProgrammeProgressionCompoundUniqueInput>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export enum ProgrammeScalarFieldEnum {
  Created = 'created',
  Description = 'description',
  Id = 'id',
  IsHidden = 'isHidden',
  IsPublished = 'isPublished',
  LearningStyle = 'learningStyle',
  Modified = 'modified',
  Name = 'name',
  ShortName = 'shortName',
  Slug = 'slug',
  SortOrder = 'sortOrder'
}

export type ProgrammeScalarRelationFilter = {
  is?: InputMaybe<ProgrammeWhereInput>;
  isNot?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProgrammeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProgrammeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProgrammeScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isHidden?: InputMaybe<BoolWithAggregatesFilter>;
  isPublished?: InputMaybe<BoolWithAggregatesFilter>;
  learningStyle?: InputMaybe<EnumLearningStyleWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  shortName?: InputMaybe<StringWithAggregatesFilter>;
  slug?: InputMaybe<StringWithAggregatesFilter>;
  sortOrder?: InputMaybe<IntWithAggregatesFilter>;
};

export type ProgrammeSumOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProgrammeTagCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
};

export type ProgrammeTagCreateInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  programme: ProgrammeCreateNestedOneWithoutProgrammeTagsInput;
  tag: TagCreateNestedOneWithoutProgrammeTagsInput;
};

export type ProgrammeTagCreateManyInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  programmeId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type ProgrammeTagCreateManyProgrammeInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  tagId: Scalars['String']['input'];
};

export type ProgrammeTagCreateManyProgrammeInputEnvelope = {
  data: Array<ProgrammeTagCreateManyProgrammeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgrammeTagCreateManyTagInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  programmeId: Scalars['String']['input'];
};

export type ProgrammeTagCreateManyTagInputEnvelope = {
  data: Array<ProgrammeTagCreateManyTagInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgrammeTagCreateNestedManyWithoutProgrammeInput = {
  connect?: InputMaybe<Array<ProgrammeTagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProgrammeTagCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<ProgrammeTagCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<ProgrammeTagCreateManyProgrammeInputEnvelope>;
};

export type ProgrammeTagCreateNestedManyWithoutTagInput = {
  connect?: InputMaybe<Array<ProgrammeTagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProgrammeTagCreateOrConnectWithoutTagInput>>;
  create?: InputMaybe<Array<ProgrammeTagCreateWithoutTagInput>>;
  createMany?: InputMaybe<ProgrammeTagCreateManyTagInputEnvelope>;
};

export type ProgrammeTagCreateOrConnectWithoutProgrammeInput = {
  create: ProgrammeTagCreateWithoutProgrammeInput;
  where: ProgrammeTagWhereUniqueInput;
};

export type ProgrammeTagCreateOrConnectWithoutTagInput = {
  create: ProgrammeTagCreateWithoutTagInput;
  where: ProgrammeTagWhereUniqueInput;
};

export type ProgrammeTagCreateWithoutProgrammeInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  tag: TagCreateNestedOneWithoutProgrammeTagsInput;
};

export type ProgrammeTagCreateWithoutTagInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  programme: ProgrammeCreateNestedOneWithoutProgrammeTagsInput;
};

export type ProgrammeTagListRelationFilter = {
  every?: InputMaybe<ProgrammeTagWhereInput>;
  none?: InputMaybe<ProgrammeTagWhereInput>;
  some?: InputMaybe<ProgrammeTagWhereInput>;
};

export type ProgrammeTagMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
};

export type ProgrammeTagMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
};

export type ProgrammeTagOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProgrammeTagOrderByWithAggregationInput = {
  _count?: InputMaybe<ProgrammeTagCountOrderByAggregateInput>;
  _max?: InputMaybe<ProgrammeTagMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProgrammeTagMinOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
};

export type ProgrammeTagOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  programme?: InputMaybe<ProgrammeOrderByWithRelationInput>;
  programmeId?: InputMaybe<SortOrder>;
  tag?: InputMaybe<TagOrderByWithRelationInput>;
  tagId?: InputMaybe<SortOrder>;
};

export type ProgrammeTagProgrammeTagCompoundUniqueInput = {
  programmeId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export enum ProgrammeTagScalarFieldEnum {
  Id = 'id',
  ProgrammeId = 'programmeId',
  TagId = 'tagId'
}

export type ProgrammeTagScalarWhereInput = {
  AND?: InputMaybe<Array<ProgrammeTagScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProgrammeTagScalarWhereInput>>;
  OR?: InputMaybe<Array<ProgrammeTagScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  programmeId?: InputMaybe<StringFilter>;
  tagId?: InputMaybe<StringFilter>;
};

export type ProgrammeTagScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProgrammeTagScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProgrammeTagScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProgrammeTagScalarWhereWithAggregatesInput>>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  programmeId?: InputMaybe<StringWithAggregatesFilter>;
  tagId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ProgrammeTagUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutProgrammeTagsNestedInput>;
  tag?: InputMaybe<TagUpdateOneRequiredWithoutProgrammeTagsNestedInput>;
};

export type ProgrammeTagUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProgrammeTagUpdateManyWithWhereWithoutProgrammeInput = {
  data: ProgrammeTagUpdateManyMutationInput;
  where: ProgrammeTagScalarWhereInput;
};

export type ProgrammeTagUpdateManyWithWhereWithoutTagInput = {
  data: ProgrammeTagUpdateManyMutationInput;
  where: ProgrammeTagScalarWhereInput;
};

export type ProgrammeTagUpdateManyWithoutProgrammeNestedInput = {
  connect?: InputMaybe<Array<ProgrammeTagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProgrammeTagCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<ProgrammeTagCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<ProgrammeTagCreateManyProgrammeInputEnvelope>;
  delete?: InputMaybe<Array<ProgrammeTagWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProgrammeTagScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProgrammeTagWhereUniqueInput>>;
  set?: InputMaybe<Array<ProgrammeTagWhereUniqueInput>>;
  update?: InputMaybe<Array<ProgrammeTagUpdateWithWhereUniqueWithoutProgrammeInput>>;
  updateMany?: InputMaybe<Array<ProgrammeTagUpdateManyWithWhereWithoutProgrammeInput>>;
  upsert?: InputMaybe<Array<ProgrammeTagUpsertWithWhereUniqueWithoutProgrammeInput>>;
};

export type ProgrammeTagUpdateManyWithoutTagNestedInput = {
  connect?: InputMaybe<Array<ProgrammeTagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProgrammeTagCreateOrConnectWithoutTagInput>>;
  create?: InputMaybe<Array<ProgrammeTagCreateWithoutTagInput>>;
  createMany?: InputMaybe<ProgrammeTagCreateManyTagInputEnvelope>;
  delete?: InputMaybe<Array<ProgrammeTagWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProgrammeTagScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProgrammeTagWhereUniqueInput>>;
  set?: InputMaybe<Array<ProgrammeTagWhereUniqueInput>>;
  update?: InputMaybe<Array<ProgrammeTagUpdateWithWhereUniqueWithoutTagInput>>;
  updateMany?: InputMaybe<Array<ProgrammeTagUpdateManyWithWhereWithoutTagInput>>;
  upsert?: InputMaybe<Array<ProgrammeTagUpsertWithWhereUniqueWithoutTagInput>>;
};

export type ProgrammeTagUpdateWithWhereUniqueWithoutProgrammeInput = {
  data: ProgrammeTagUpdateWithoutProgrammeInput;
  where: ProgrammeTagWhereUniqueInput;
};

export type ProgrammeTagUpdateWithWhereUniqueWithoutTagInput = {
  data: ProgrammeTagUpdateWithoutTagInput;
  where: ProgrammeTagWhereUniqueInput;
};

export type ProgrammeTagUpdateWithoutProgrammeInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  tag?: InputMaybe<TagUpdateOneRequiredWithoutProgrammeTagsNestedInput>;
};

export type ProgrammeTagUpdateWithoutTagInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutProgrammeTagsNestedInput>;
};

export type ProgrammeTagUpsertWithWhereUniqueWithoutProgrammeInput = {
  create: ProgrammeTagCreateWithoutProgrammeInput;
  update: ProgrammeTagUpdateWithoutProgrammeInput;
  where: ProgrammeTagWhereUniqueInput;
};

export type ProgrammeTagUpsertWithWhereUniqueWithoutTagInput = {
  create: ProgrammeTagCreateWithoutTagInput;
  update: ProgrammeTagUpdateWithoutTagInput;
  where: ProgrammeTagWhereUniqueInput;
};

export type ProgrammeTagWhereInput = {
  AND?: InputMaybe<Array<ProgrammeTagWhereInput>>;
  NOT?: InputMaybe<Array<ProgrammeTagWhereInput>>;
  OR?: InputMaybe<Array<ProgrammeTagWhereInput>>;
  id?: InputMaybe<StringFilter>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
  tag?: InputMaybe<TagScalarRelationFilter>;
  tagId?: InputMaybe<StringFilter>;
};

export type ProgrammeTagWhereUniqueInput = {
  AND?: InputMaybe<Array<ProgrammeTagWhereInput>>;
  NOT?: InputMaybe<Array<ProgrammeTagWhereInput>>;
  OR?: InputMaybe<Array<ProgrammeTagWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
  programmeTag?: InputMaybe<ProgrammeTagProgrammeTagCompoundUniqueInput>;
  tag?: InputMaybe<TagScalarRelationFilter>;
  tagId?: InputMaybe<StringFilter>;
};

export type ProgrammeUpdateInput = {
  categories?: InputMaybe<CategoryUpdateManyWithoutProgrammeNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  learningStyle?: InputMaybe<EnumLearningStyleFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProgrammeNestedInput>;
  programmeProducts?: InputMaybe<ProductProgrammeUpdateManyWithoutProgrammeNestedInput>;
  programmeTags?: InputMaybe<ProgrammeTagUpdateManyWithoutProgrammeNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutProgrammeNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  userProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutProgrammeNestedInput>;
};

export type ProgrammeUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  learningStyle?: InputMaybe<EnumLearningStyleFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProgrammeUpdateOneRequiredWithoutCategoriesNestedInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutCategoriesInput>;
  create?: InputMaybe<ProgrammeCreateWithoutCategoriesInput>;
  update?: InputMaybe<ProgrammeUpdateToOneWithWhereWithoutCategoriesInput>;
  upsert?: InputMaybe<ProgrammeUpsertWithoutCategoriesInput>;
};

export type ProgrammeUpdateOneRequiredWithoutPrerequisiteForNestedInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutPrerequisiteForInput>;
  create?: InputMaybe<ProgrammeCreateWithoutPrerequisiteForInput>;
  update?: InputMaybe<ProgrammeUpdateToOneWithWhereWithoutPrerequisiteForInput>;
  upsert?: InputMaybe<ProgrammeUpsertWithoutPrerequisiteForInput>;
};

export type ProgrammeUpdateOneRequiredWithoutProgrammeProductsNestedInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutProgrammeProductsInput>;
  create?: InputMaybe<ProgrammeCreateWithoutProgrammeProductsInput>;
  update?: InputMaybe<ProgrammeUpdateToOneWithWhereWithoutProgrammeProductsInput>;
  upsert?: InputMaybe<ProgrammeUpsertWithoutProgrammeProductsInput>;
};

export type ProgrammeUpdateOneRequiredWithoutProgrammeTagsNestedInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutProgrammeTagsInput>;
  create?: InputMaybe<ProgrammeCreateWithoutProgrammeTagsInput>;
  update?: InputMaybe<ProgrammeUpdateToOneWithWhereWithoutProgrammeTagsInput>;
  upsert?: InputMaybe<ProgrammeUpsertWithoutProgrammeTagsInput>;
};

export type ProgrammeUpdateOneRequiredWithoutSavedForLaterNestedInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutSavedForLaterInput>;
  create?: InputMaybe<ProgrammeCreateWithoutSavedForLaterInput>;
  update?: InputMaybe<ProgrammeUpdateToOneWithWhereWithoutSavedForLaterInput>;
  upsert?: InputMaybe<ProgrammeUpsertWithoutSavedForLaterInput>;
};

export type ProgrammeUpdateOneRequiredWithoutUserProgressionsNestedInput = {
  connect?: InputMaybe<ProgrammeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgrammeCreateOrConnectWithoutUserProgressionsInput>;
  create?: InputMaybe<ProgrammeCreateWithoutUserProgressionsInput>;
  update?: InputMaybe<ProgrammeUpdateToOneWithWhereWithoutUserProgressionsInput>;
  upsert?: InputMaybe<ProgrammeUpsertWithoutUserProgressionsInput>;
};

export type ProgrammeUpdateToOneWithWhereWithoutCategoriesInput = {
  data: ProgrammeUpdateWithoutCategoriesInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeUpdateToOneWithWhereWithoutPrerequisiteForInput = {
  data: ProgrammeUpdateWithoutPrerequisiteForInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeUpdateToOneWithWhereWithoutProgrammeProductsInput = {
  data: ProgrammeUpdateWithoutProgrammeProductsInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeUpdateToOneWithWhereWithoutProgrammeTagsInput = {
  data: ProgrammeUpdateWithoutProgrammeTagsInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeUpdateToOneWithWhereWithoutSavedForLaterInput = {
  data: ProgrammeUpdateWithoutSavedForLaterInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeUpdateToOneWithWhereWithoutUserProgressionsInput = {
  data: ProgrammeUpdateWithoutUserProgressionsInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeUpdateWithoutCategoriesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  learningStyle?: InputMaybe<EnumLearningStyleFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProgrammeNestedInput>;
  programmeProducts?: InputMaybe<ProductProgrammeUpdateManyWithoutProgrammeNestedInput>;
  programmeTags?: InputMaybe<ProgrammeTagUpdateManyWithoutProgrammeNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutProgrammeNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  userProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutProgrammeNestedInput>;
};

export type ProgrammeUpdateWithoutPrerequisiteForInput = {
  categories?: InputMaybe<CategoryUpdateManyWithoutProgrammeNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  learningStyle?: InputMaybe<EnumLearningStyleFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  programmeProducts?: InputMaybe<ProductProgrammeUpdateManyWithoutProgrammeNestedInput>;
  programmeTags?: InputMaybe<ProgrammeTagUpdateManyWithoutProgrammeNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutProgrammeNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  userProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutProgrammeNestedInput>;
};

export type ProgrammeUpdateWithoutProgrammeProductsInput = {
  categories?: InputMaybe<CategoryUpdateManyWithoutProgrammeNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  learningStyle?: InputMaybe<EnumLearningStyleFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProgrammeNestedInput>;
  programmeTags?: InputMaybe<ProgrammeTagUpdateManyWithoutProgrammeNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutProgrammeNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  userProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutProgrammeNestedInput>;
};

export type ProgrammeUpdateWithoutProgrammeTagsInput = {
  categories?: InputMaybe<CategoryUpdateManyWithoutProgrammeNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  learningStyle?: InputMaybe<EnumLearningStyleFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProgrammeNestedInput>;
  programmeProducts?: InputMaybe<ProductProgrammeUpdateManyWithoutProgrammeNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutProgrammeNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  userProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutProgrammeNestedInput>;
};

export type ProgrammeUpdateWithoutSavedForLaterInput = {
  categories?: InputMaybe<CategoryUpdateManyWithoutProgrammeNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  learningStyle?: InputMaybe<EnumLearningStyleFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProgrammeNestedInput>;
  programmeProducts?: InputMaybe<ProductProgrammeUpdateManyWithoutProgrammeNestedInput>;
  programmeTags?: InputMaybe<ProgrammeTagUpdateManyWithoutProgrammeNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
  userProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutProgrammeNestedInput>;
};

export type ProgrammeUpdateWithoutUserProgressionsInput = {
  categories?: InputMaybe<CategoryUpdateManyWithoutProgrammeNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isHidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  learningStyle?: InputMaybe<EnumLearningStyleFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteUpdateManyWithoutProgrammeNestedInput>;
  programmeProducts?: InputMaybe<ProductProgrammeUpdateManyWithoutProgrammeNestedInput>;
  programmeTags?: InputMaybe<ProgrammeTagUpdateManyWithoutProgrammeNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutProgrammeNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProgrammeUpsertWithoutCategoriesInput = {
  create: ProgrammeCreateWithoutCategoriesInput;
  update: ProgrammeUpdateWithoutCategoriesInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeUpsertWithoutPrerequisiteForInput = {
  create: ProgrammeCreateWithoutPrerequisiteForInput;
  update: ProgrammeUpdateWithoutPrerequisiteForInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeUpsertWithoutProgrammeProductsInput = {
  create: ProgrammeCreateWithoutProgrammeProductsInput;
  update: ProgrammeUpdateWithoutProgrammeProductsInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeUpsertWithoutProgrammeTagsInput = {
  create: ProgrammeCreateWithoutProgrammeTagsInput;
  update: ProgrammeUpdateWithoutProgrammeTagsInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeUpsertWithoutSavedForLaterInput = {
  create: ProgrammeCreateWithoutSavedForLaterInput;
  update: ProgrammeUpdateWithoutSavedForLaterInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeUpsertWithoutUserProgressionsInput = {
  create: ProgrammeCreateWithoutUserProgressionsInput;
  update: ProgrammeUpdateWithoutUserProgressionsInput;
  where?: InputMaybe<ProgrammeWhereInput>;
};

export type ProgrammeWhereInput = {
  AND?: InputMaybe<Array<ProgrammeWhereInput>>;
  NOT?: InputMaybe<Array<ProgrammeWhereInput>>;
  OR?: InputMaybe<Array<ProgrammeWhereInput>>;
  categories?: InputMaybe<CategoryListRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isHidden?: InputMaybe<BoolFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  learningStyle?: InputMaybe<EnumLearningStyleFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteListRelationFilter>;
  programmeProducts?: InputMaybe<ProductProgrammeListRelationFilter>;
  programmeTags?: InputMaybe<ProgrammeTagListRelationFilter>;
  savedForLater?: InputMaybe<SavedForLaterListRelationFilter>;
  shortName?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
  userProgressions?: InputMaybe<ProgrammeProgressionListRelationFilter>;
};

export type ProgrammeWhereUniqueInput = {
  AND?: InputMaybe<Array<ProgrammeWhereInput>>;
  NOT?: InputMaybe<Array<ProgrammeWhereInput>>;
  OR?: InputMaybe<Array<ProgrammeWhereInput>>;
  categories?: InputMaybe<CategoryListRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<BoolFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  learningStyle?: InputMaybe<EnumLearningStyleFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  prerequisiteFor?: InputMaybe<ProductProgrammePrerequisiteListRelationFilter>;
  programmeProducts?: InputMaybe<ProductProgrammeListRelationFilter>;
  programmeTags?: InputMaybe<ProgrammeTagListRelationFilter>;
  savedForLater?: InputMaybe<SavedForLaterListRelationFilter>;
  shortName?: InputMaybe<StringFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<IntFilter>;
  userProgressions?: InputMaybe<ProgrammeProgressionListRelationFilter>;
};

/** Controls how often a prompt is shown to users after they've engaged with it. */
export enum PromptFrequency {
  Evergreen = 'EVERGREEN',
  EveryPageLoad = 'EVERY_PAGE_LOAD',
  Once = 'ONCE',
  OncePerDay = 'ONCE_PER_DAY',
  OncePerSession = 'ONCE_PER_SESSION'
}

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type QuizCategoryAvgOrderByAggregateInput = {
  maxAttempts?: InputMaybe<SortOrder>;
  minScore?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QuizCategoryCountOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  maxAttempts?: InputMaybe<SortOrder>;
  minScore?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QuizCategoryCreateInput = {
  category: CategoryCreateNestedOneWithoutCategoryQuizzesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  quiz: QuizCreateNestedOneWithoutQuizCategoriesInput;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type QuizCategoryCreateManyCategoryInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  quizId: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type QuizCategoryCreateManyCategoryInputEnvelope = {
  data: Array<QuizCategoryCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuizCategoryCreateManyInput = {
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  quizId: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type QuizCategoryCreateManyQuizInput = {
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type QuizCategoryCreateManyQuizInputEnvelope = {
  data: Array<QuizCategoryCreateManyQuizInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuizCategoryCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<QuizCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuizCategoryCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<QuizCategoryCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<QuizCategoryCreateManyCategoryInputEnvelope>;
};

export type QuizCategoryCreateNestedManyWithoutQuizInput = {
  connect?: InputMaybe<Array<QuizCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuizCategoryCreateOrConnectWithoutQuizInput>>;
  create?: InputMaybe<Array<QuizCategoryCreateWithoutQuizInput>>;
  createMany?: InputMaybe<QuizCategoryCreateManyQuizInputEnvelope>;
};

export type QuizCategoryCreateOrConnectWithoutCategoryInput = {
  create: QuizCategoryCreateWithoutCategoryInput;
  where: QuizCategoryWhereUniqueInput;
};

export type QuizCategoryCreateOrConnectWithoutQuizInput = {
  create: QuizCategoryCreateWithoutQuizInput;
  where: QuizCategoryWhereUniqueInput;
};

export type QuizCategoryCreateWithoutCategoryInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  quiz: QuizCreateNestedOneWithoutQuizCategoriesInput;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type QuizCategoryCreateWithoutQuizInput = {
  category: CategoryCreateNestedOneWithoutCategoryQuizzesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Float']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type QuizCategoryListRelationFilter = {
  every?: InputMaybe<QuizCategoryWhereInput>;
  none?: InputMaybe<QuizCategoryWhereInput>;
  some?: InputMaybe<QuizCategoryWhereInput>;
};

export type QuizCategoryMaxOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  maxAttempts?: InputMaybe<SortOrder>;
  minScore?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QuizCategoryMinOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  maxAttempts?: InputMaybe<SortOrder>;
  minScore?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QuizCategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type QuizCategoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<QuizCategoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<QuizCategoryCountOrderByAggregateInput>;
  _max?: InputMaybe<QuizCategoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<QuizCategoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<QuizCategorySumOrderByAggregateInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  maxAttempts?: InputMaybe<SortOrderInput>;
  minScore?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QuizCategoryOrderByWithRelationInput = {
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  maxAttempts?: InputMaybe<SortOrderInput>;
  minScore?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  quiz?: InputMaybe<QuizOrderByWithRelationInput>;
  quizId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QuizCategoryQuizCategoryCompoundUniqueInput = {
  categoryId: Scalars['String']['input'];
  quizId: Scalars['String']['input'];
};

export enum QuizCategoryScalarFieldEnum {
  CategoryId = 'categoryId',
  Created = 'created',
  Id = 'id',
  IsPinned = 'isPinned',
  IsRequired = 'isRequired',
  MaxAttempts = 'maxAttempts',
  MinScore = 'minScore',
  Modified = 'modified',
  QuizId = 'quizId',
  SortOrder = 'sortOrder'
}

export type QuizCategoryScalarWhereInput = {
  AND?: InputMaybe<Array<QuizCategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<QuizCategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<QuizCategoryScalarWhereInput>>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  maxAttempts?: InputMaybe<IntNullableFilter>;
  minScore?: InputMaybe<FloatNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  quizId?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type QuizCategoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<QuizCategoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<QuizCategoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<QuizCategoryScalarWhereWithAggregatesInput>>;
  categoryId?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isPinned?: InputMaybe<BoolWithAggregatesFilter>;
  isRequired?: InputMaybe<BoolWithAggregatesFilter>;
  maxAttempts?: InputMaybe<IntNullableWithAggregatesFilter>;
  minScore?: InputMaybe<FloatNullableWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  quizId?: InputMaybe<StringWithAggregatesFilter>;
  sortOrder?: InputMaybe<IntWithAggregatesFilter>;
};

export type QuizCategorySumOrderByAggregateInput = {
  maxAttempts?: InputMaybe<SortOrder>;
  minScore?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QuizCategoryUpdateInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutCategoryQuizzesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maxAttempts?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  quiz?: InputMaybe<QuizUpdateOneRequiredWithoutQuizCategoriesNestedInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizCategoryUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maxAttempts?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizCategoryUpdateManyWithWhereWithoutCategoryInput = {
  data: QuizCategoryUpdateManyMutationInput;
  where: QuizCategoryScalarWhereInput;
};

export type QuizCategoryUpdateManyWithWhereWithoutQuizInput = {
  data: QuizCategoryUpdateManyMutationInput;
  where: QuizCategoryScalarWhereInput;
};

export type QuizCategoryUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<QuizCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuizCategoryCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<QuizCategoryCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<QuizCategoryCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<QuizCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<QuizCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<QuizCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<QuizCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<QuizCategoryUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<QuizCategoryUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<QuizCategoryUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type QuizCategoryUpdateManyWithoutQuizNestedInput = {
  connect?: InputMaybe<Array<QuizCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuizCategoryCreateOrConnectWithoutQuizInput>>;
  create?: InputMaybe<Array<QuizCategoryCreateWithoutQuizInput>>;
  createMany?: InputMaybe<QuizCategoryCreateManyQuizInputEnvelope>;
  delete?: InputMaybe<Array<QuizCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<QuizCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<QuizCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<QuizCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<QuizCategoryUpdateWithWhereUniqueWithoutQuizInput>>;
  updateMany?: InputMaybe<Array<QuizCategoryUpdateManyWithWhereWithoutQuizInput>>;
  upsert?: InputMaybe<Array<QuizCategoryUpsertWithWhereUniqueWithoutQuizInput>>;
};

export type QuizCategoryUpdateWithWhereUniqueWithoutCategoryInput = {
  data: QuizCategoryUpdateWithoutCategoryInput;
  where: QuizCategoryWhereUniqueInput;
};

export type QuizCategoryUpdateWithWhereUniqueWithoutQuizInput = {
  data: QuizCategoryUpdateWithoutQuizInput;
  where: QuizCategoryWhereUniqueInput;
};

export type QuizCategoryUpdateWithoutCategoryInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maxAttempts?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  quiz?: InputMaybe<QuizUpdateOneRequiredWithoutQuizCategoriesNestedInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizCategoryUpdateWithoutQuizInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutCategoryQuizzesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maxAttempts?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizCategoryUpsertWithWhereUniqueWithoutCategoryInput = {
  create: QuizCategoryCreateWithoutCategoryInput;
  update: QuizCategoryUpdateWithoutCategoryInput;
  where: QuizCategoryWhereUniqueInput;
};

export type QuizCategoryUpsertWithWhereUniqueWithoutQuizInput = {
  create: QuizCategoryCreateWithoutQuizInput;
  update: QuizCategoryUpdateWithoutQuizInput;
  where: QuizCategoryWhereUniqueInput;
};

export type QuizCategoryWhereInput = {
  AND?: InputMaybe<Array<QuizCategoryWhereInput>>;
  NOT?: InputMaybe<Array<QuizCategoryWhereInput>>;
  OR?: InputMaybe<Array<QuizCategoryWhereInput>>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  maxAttempts?: InputMaybe<IntNullableFilter>;
  minScore?: InputMaybe<FloatNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  quiz?: InputMaybe<QuizScalarRelationFilter>;
  quizId?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type QuizCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<QuizCategoryWhereInput>>;
  NOT?: InputMaybe<Array<QuizCategoryWhereInput>>;
  OR?: InputMaybe<Array<QuizCategoryWhereInput>>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  maxAttempts?: InputMaybe<IntNullableFilter>;
  minScore?: InputMaybe<FloatNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  quiz?: InputMaybe<QuizScalarRelationFilter>;
  quizCategory?: InputMaybe<QuizCategoryQuizCategoryCompoundUniqueInput>;
  quizId?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type QuizCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type QuizCreateInput = {
  attemptedBy?: InputMaybe<UserQuizCreateNestedManyWithoutQuizInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutQuizInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  quizCategories?: InputMaybe<QuizCategoryCreateNestedManyWithoutQuizInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type QuizCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type QuizCreateNestedOneWithoutAttemptedByInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutAttemptedByInput>;
  create?: InputMaybe<QuizCreateWithoutAttemptedByInput>;
};

export type QuizCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<QuizCreateWithoutContentInput>;
};

export type QuizCreateNestedOneWithoutQuizCategoriesInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutQuizCategoriesInput>;
  create?: InputMaybe<QuizCreateWithoutQuizCategoriesInput>;
};

export type QuizCreateOrConnectWithoutAttemptedByInput = {
  create: QuizCreateWithoutAttemptedByInput;
  where: QuizWhereUniqueInput;
};

export type QuizCreateOrConnectWithoutContentInput = {
  create: QuizCreateWithoutContentInput;
  where: QuizWhereUniqueInput;
};

export type QuizCreateOrConnectWithoutQuizCategoriesInput = {
  create: QuizCreateWithoutQuizCategoriesInput;
  where: QuizWhereUniqueInput;
};

export type QuizCreateWithoutAttemptedByInput = {
  content?: InputMaybe<ContentCreateNestedOneWithoutQuizInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  quizCategories?: InputMaybe<QuizCategoryCreateNestedManyWithoutQuizInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type QuizCreateWithoutContentInput = {
  attemptedBy?: InputMaybe<UserQuizCreateNestedManyWithoutQuizInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  quizCategories?: InputMaybe<QuizCategoryCreateNestedManyWithoutQuizInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type QuizCreateWithoutQuizCategoriesInput = {
  attemptedBy?: InputMaybe<UserQuizCreateNestedManyWithoutQuizInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutQuizInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type QuizMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type QuizMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type QuizNullableScalarRelationFilter = {
  is?: InputMaybe<QuizWhereInput>;
  isNot?: InputMaybe<QuizWhereInput>;
};

export type QuizOrderByWithAggregationInput = {
  _count?: InputMaybe<QuizCountOrderByAggregateInput>;
  _max?: InputMaybe<QuizMaxOrderByAggregateInput>;
  _min?: InputMaybe<QuizMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type QuizOrderByWithRelationInput = {
  attemptedBy?: InputMaybe<UserQuizOrderByRelationAggregateInput>;
  content?: InputMaybe<ContentOrderByWithRelationInput>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  quizCategories?: InputMaybe<QuizCategoryOrderByRelationAggregateInput>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export enum QuizScalarFieldEnum {
  Created = 'created',
  Description = 'description',
  Id = 'id',
  IsPublished = 'isPublished',
  Modified = 'modified',
  Slug = 'slug',
  Title = 'title'
}

export type QuizScalarRelationFilter = {
  is?: InputMaybe<QuizWhereInput>;
  isNot?: InputMaybe<QuizWhereInput>;
};

export type QuizScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<QuizScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<QuizScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<QuizScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isPublished?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  slug?: InputMaybe<StringWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type QuizUpdateInput = {
  attemptedBy?: InputMaybe<UserQuizUpdateManyWithoutQuizNestedInput>;
  content?: InputMaybe<ContentUpdateOneWithoutQuizNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  quizCategories?: InputMaybe<QuizCategoryUpdateManyWithoutQuizNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizUpdateOneRequiredWithoutAttemptedByNestedInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutAttemptedByInput>;
  create?: InputMaybe<QuizCreateWithoutAttemptedByInput>;
  update?: InputMaybe<QuizUpdateToOneWithWhereWithoutAttemptedByInput>;
  upsert?: InputMaybe<QuizUpsertWithoutAttemptedByInput>;
};

export type QuizUpdateOneRequiredWithoutQuizCategoriesNestedInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutQuizCategoriesInput>;
  create?: InputMaybe<QuizCreateWithoutQuizCategoriesInput>;
  update?: InputMaybe<QuizUpdateToOneWithWhereWithoutQuizCategoriesInput>;
  upsert?: InputMaybe<QuizUpsertWithoutQuizCategoriesInput>;
};

export type QuizUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<QuizCreateWithoutContentInput>;
  delete?: InputMaybe<QuizWhereInput>;
  disconnect?: InputMaybe<QuizWhereInput>;
  update?: InputMaybe<QuizUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<QuizUpsertWithoutContentInput>;
};

export type QuizUpdateToOneWithWhereWithoutAttemptedByInput = {
  data: QuizUpdateWithoutAttemptedByInput;
  where?: InputMaybe<QuizWhereInput>;
};

export type QuizUpdateToOneWithWhereWithoutContentInput = {
  data: QuizUpdateWithoutContentInput;
  where?: InputMaybe<QuizWhereInput>;
};

export type QuizUpdateToOneWithWhereWithoutQuizCategoriesInput = {
  data: QuizUpdateWithoutQuizCategoriesInput;
  where?: InputMaybe<QuizWhereInput>;
};

export type QuizUpdateWithoutAttemptedByInput = {
  content?: InputMaybe<ContentUpdateOneWithoutQuizNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  quizCategories?: InputMaybe<QuizCategoryUpdateManyWithoutQuizNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizUpdateWithoutContentInput = {
  attemptedBy?: InputMaybe<UserQuizUpdateManyWithoutQuizNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  quizCategories?: InputMaybe<QuizCategoryUpdateManyWithoutQuizNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizUpdateWithoutQuizCategoriesInput = {
  attemptedBy?: InputMaybe<UserQuizUpdateManyWithoutQuizNestedInput>;
  content?: InputMaybe<ContentUpdateOneWithoutQuizNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizUpsertWithoutAttemptedByInput = {
  create: QuizCreateWithoutAttemptedByInput;
  update: QuizUpdateWithoutAttemptedByInput;
  where?: InputMaybe<QuizWhereInput>;
};

export type QuizUpsertWithoutContentInput = {
  create: QuizCreateWithoutContentInput;
  update: QuizUpdateWithoutContentInput;
  where?: InputMaybe<QuizWhereInput>;
};

export type QuizUpsertWithoutQuizCategoriesInput = {
  create: QuizCreateWithoutQuizCategoriesInput;
  update: QuizUpdateWithoutQuizCategoriesInput;
  where?: InputMaybe<QuizWhereInput>;
};

export type QuizWhereInput = {
  AND?: InputMaybe<Array<QuizWhereInput>>;
  NOT?: InputMaybe<Array<QuizWhereInput>>;
  OR?: InputMaybe<Array<QuizWhereInput>>;
  attemptedBy?: InputMaybe<UserQuizListRelationFilter>;
  content?: InputMaybe<ContentNullableScalarRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  quizCategories?: InputMaybe<QuizCategoryListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type QuizWhereUniqueInput = {
  AND?: InputMaybe<Array<QuizWhereInput>>;
  NOT?: InputMaybe<Array<QuizWhereInput>>;
  OR?: InputMaybe<Array<QuizWhereInput>>;
  attemptedBy?: InputMaybe<UserQuizListRelationFilter>;
  content?: InputMaybe<ContentNullableScalarRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  quizCategories?: InputMaybe<QuizCategoryListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type RefundAvgOrderByAggregateInput = {
  amountInCents?: InputMaybe<SortOrder>;
};

export type RefundCountOrderByAggregateInput = {
  amountInCents?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLegacyXero?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  stripePayoutId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  xeroCreditNoteNumber?: InputMaybe<SortOrder>;
};

export type RefundCreateInput = {
  amountInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payment: PaymentCreateNestedOneWithoutRefundsInput;
  stripePayout?: InputMaybe<StripePayoutCreateNestedOneWithoutRefundsInput>;
  user: UserCreateNestedOneWithoutRefundsInput;
  xeroCreditNoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RefundCreateManyInput = {
  amountInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentId: Scalars['String']['input'];
  stripePayoutId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  xeroCreditNoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RefundCreateManyPaymentInput = {
  amountInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  stripePayoutId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  xeroCreditNoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RefundCreateManyPaymentInputEnvelope = {
  data: Array<RefundCreateManyPaymentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RefundCreateManyStripePayoutInput = {
  amountInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  xeroCreditNoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RefundCreateManyStripePayoutInputEnvelope = {
  data: Array<RefundCreateManyStripePayoutInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RefundCreateManyUserInput = {
  amountInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  paymentId: Scalars['String']['input'];
  stripePayoutId?: InputMaybe<Scalars['String']['input']>;
  xeroCreditNoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RefundCreateManyUserInputEnvelope = {
  data: Array<RefundCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RefundCreateNestedManyWithoutPaymentInput = {
  connect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RefundCreateOrConnectWithoutPaymentInput>>;
  create?: InputMaybe<Array<RefundCreateWithoutPaymentInput>>;
  createMany?: InputMaybe<RefundCreateManyPaymentInputEnvelope>;
};

export type RefundCreateNestedManyWithoutStripePayoutInput = {
  connect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RefundCreateOrConnectWithoutStripePayoutInput>>;
  create?: InputMaybe<Array<RefundCreateWithoutStripePayoutInput>>;
  createMany?: InputMaybe<RefundCreateManyStripePayoutInputEnvelope>;
};

export type RefundCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RefundCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<RefundCreateWithoutUserInput>>;
  createMany?: InputMaybe<RefundCreateManyUserInputEnvelope>;
};

export type RefundCreateOrConnectWithoutPaymentInput = {
  create: RefundCreateWithoutPaymentInput;
  where: RefundWhereUniqueInput;
};

export type RefundCreateOrConnectWithoutStripePayoutInput = {
  create: RefundCreateWithoutStripePayoutInput;
  where: RefundWhereUniqueInput;
};

export type RefundCreateOrConnectWithoutUserInput = {
  create: RefundCreateWithoutUserInput;
  where: RefundWhereUniqueInput;
};

export type RefundCreateWithoutPaymentInput = {
  amountInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  stripePayout?: InputMaybe<StripePayoutCreateNestedOneWithoutRefundsInput>;
  user: UserCreateNestedOneWithoutRefundsInput;
  xeroCreditNoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RefundCreateWithoutStripePayoutInput = {
  amountInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payment: PaymentCreateNestedOneWithoutRefundsInput;
  user: UserCreateNestedOneWithoutRefundsInput;
  xeroCreditNoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RefundCreateWithoutUserInput = {
  amountInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<AcceptedCurrency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLegacyXero?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payment: PaymentCreateNestedOneWithoutRefundsInput;
  stripePayout?: InputMaybe<StripePayoutCreateNestedOneWithoutRefundsInput>;
  xeroCreditNoteNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RefundListRelationFilter = {
  every?: InputMaybe<RefundWhereInput>;
  none?: InputMaybe<RefundWhereInput>;
  some?: InputMaybe<RefundWhereInput>;
};

export type RefundMaxOrderByAggregateInput = {
  amountInCents?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLegacyXero?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  stripePayoutId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  xeroCreditNoteNumber?: InputMaybe<SortOrder>;
};

export type RefundMinOrderByAggregateInput = {
  amountInCents?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLegacyXero?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  stripePayoutId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  xeroCreditNoteNumber?: InputMaybe<SortOrder>;
};

export type RefundOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RefundOrderByWithAggregationInput = {
  _avg?: InputMaybe<RefundAvgOrderByAggregateInput>;
  _count?: InputMaybe<RefundCountOrderByAggregateInput>;
  _max?: InputMaybe<RefundMaxOrderByAggregateInput>;
  _min?: InputMaybe<RefundMinOrderByAggregateInput>;
  _sum?: InputMaybe<RefundSumOrderByAggregateInput>;
  amountInCents?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLegacyXero?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  stripePayoutId?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrder>;
  xeroCreditNoteNumber?: InputMaybe<SortOrderInput>;
};

export type RefundOrderByWithRelationInput = {
  amountInCents?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLegacyXero?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  payment?: InputMaybe<PaymentOrderByWithRelationInput>;
  paymentId?: InputMaybe<SortOrder>;
  stripePayout?: InputMaybe<StripePayoutOrderByWithRelationInput>;
  stripePayoutId?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  xeroCreditNoteNumber?: InputMaybe<SortOrderInput>;
};

export enum RefundScalarFieldEnum {
  AmountInCents = 'amountInCents',
  Created = 'created',
  Currency = 'currency',
  Id = 'id',
  IsLegacyXero = 'isLegacyXero',
  Modified = 'modified',
  PaymentId = 'paymentId',
  StripePayoutId = 'stripePayoutId',
  UserId = 'userId',
  XeroCreditNoteNumber = 'xeroCreditNoteNumber'
}

export type RefundScalarWhereInput = {
  AND?: InputMaybe<Array<RefundScalarWhereInput>>;
  NOT?: InputMaybe<Array<RefundScalarWhereInput>>;
  OR?: InputMaybe<Array<RefundScalarWhereInput>>;
  amountInCents?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyFilter>;
  id?: InputMaybe<StringFilter>;
  isLegacyXero?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  paymentId?: InputMaybe<StringFilter>;
  stripePayoutId?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringFilter>;
  xeroCreditNoteNumber?: InputMaybe<StringNullableFilter>;
};

export type RefundScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<RefundScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<RefundScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<RefundScalarWhereWithAggregatesInput>>;
  amountInCents?: InputMaybe<IntWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isLegacyXero?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  paymentId?: InputMaybe<StringWithAggregatesFilter>;
  stripePayoutId?: InputMaybe<StringNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
  xeroCreditNoteNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type RefundSumOrderByAggregateInput = {
  amountInCents?: InputMaybe<SortOrder>;
};

export type RefundUpdateInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneRequiredWithoutRefundsNestedInput>;
  stripePayout?: InputMaybe<StripePayoutUpdateOneWithoutRefundsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutRefundsNestedInput>;
  xeroCreditNoteNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type RefundUpdateManyMutationInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  xeroCreditNoteNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type RefundUpdateManyWithWhereWithoutPaymentInput = {
  data: RefundUpdateManyMutationInput;
  where: RefundScalarWhereInput;
};

export type RefundUpdateManyWithWhereWithoutStripePayoutInput = {
  data: RefundUpdateManyMutationInput;
  where: RefundScalarWhereInput;
};

export type RefundUpdateManyWithWhereWithoutUserInput = {
  data: RefundUpdateManyMutationInput;
  where: RefundScalarWhereInput;
};

export type RefundUpdateManyWithoutPaymentNestedInput = {
  connect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RefundCreateOrConnectWithoutPaymentInput>>;
  create?: InputMaybe<Array<RefundCreateWithoutPaymentInput>>;
  createMany?: InputMaybe<RefundCreateManyPaymentInputEnvelope>;
  delete?: InputMaybe<Array<RefundWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RefundScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  set?: InputMaybe<Array<RefundWhereUniqueInput>>;
  update?: InputMaybe<Array<RefundUpdateWithWhereUniqueWithoutPaymentInput>>;
  updateMany?: InputMaybe<Array<RefundUpdateManyWithWhereWithoutPaymentInput>>;
  upsert?: InputMaybe<Array<RefundUpsertWithWhereUniqueWithoutPaymentInput>>;
};

export type RefundUpdateManyWithoutStripePayoutNestedInput = {
  connect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RefundCreateOrConnectWithoutStripePayoutInput>>;
  create?: InputMaybe<Array<RefundCreateWithoutStripePayoutInput>>;
  createMany?: InputMaybe<RefundCreateManyStripePayoutInputEnvelope>;
  delete?: InputMaybe<Array<RefundWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RefundScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  set?: InputMaybe<Array<RefundWhereUniqueInput>>;
  update?: InputMaybe<Array<RefundUpdateWithWhereUniqueWithoutStripePayoutInput>>;
  updateMany?: InputMaybe<Array<RefundUpdateManyWithWhereWithoutStripePayoutInput>>;
  upsert?: InputMaybe<Array<RefundUpsertWithWhereUniqueWithoutStripePayoutInput>>;
};

export type RefundUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RefundCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<RefundCreateWithoutUserInput>>;
  createMany?: InputMaybe<RefundCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<RefundWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RefundScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  set?: InputMaybe<Array<RefundWhereUniqueInput>>;
  update?: InputMaybe<Array<RefundUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<RefundUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<RefundUpsertWithWhereUniqueWithoutUserInput>>;
};

export type RefundUpdateWithWhereUniqueWithoutPaymentInput = {
  data: RefundUpdateWithoutPaymentInput;
  where: RefundWhereUniqueInput;
};

export type RefundUpdateWithWhereUniqueWithoutStripePayoutInput = {
  data: RefundUpdateWithoutStripePayoutInput;
  where: RefundWhereUniqueInput;
};

export type RefundUpdateWithWhereUniqueWithoutUserInput = {
  data: RefundUpdateWithoutUserInput;
  where: RefundWhereUniqueInput;
};

export type RefundUpdateWithoutPaymentInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  stripePayout?: InputMaybe<StripePayoutUpdateOneWithoutRefundsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutRefundsNestedInput>;
  xeroCreditNoteNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type RefundUpdateWithoutStripePayoutInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneRequiredWithoutRefundsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutRefundsNestedInput>;
  xeroCreditNoteNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type RefundUpdateWithoutUserInput = {
  amountInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumAcceptedCurrencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLegacyXero?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneRequiredWithoutRefundsNestedInput>;
  stripePayout?: InputMaybe<StripePayoutUpdateOneWithoutRefundsNestedInput>;
  xeroCreditNoteNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type RefundUpsertWithWhereUniqueWithoutPaymentInput = {
  create: RefundCreateWithoutPaymentInput;
  update: RefundUpdateWithoutPaymentInput;
  where: RefundWhereUniqueInput;
};

export type RefundUpsertWithWhereUniqueWithoutStripePayoutInput = {
  create: RefundCreateWithoutStripePayoutInput;
  update: RefundUpdateWithoutStripePayoutInput;
  where: RefundWhereUniqueInput;
};

export type RefundUpsertWithWhereUniqueWithoutUserInput = {
  create: RefundCreateWithoutUserInput;
  update: RefundUpdateWithoutUserInput;
  where: RefundWhereUniqueInput;
};

export type RefundWhereInput = {
  AND?: InputMaybe<Array<RefundWhereInput>>;
  NOT?: InputMaybe<Array<RefundWhereInput>>;
  OR?: InputMaybe<Array<RefundWhereInput>>;
  amountInCents?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyFilter>;
  id?: InputMaybe<StringFilter>;
  isLegacyXero?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  payment?: InputMaybe<PaymentScalarRelationFilter>;
  paymentId?: InputMaybe<StringFilter>;
  stripePayout?: InputMaybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  xeroCreditNoteNumber?: InputMaybe<StringNullableFilter>;
};

export type RefundWhereUniqueInput = {
  AND?: InputMaybe<Array<RefundWhereInput>>;
  NOT?: InputMaybe<Array<RefundWhereInput>>;
  OR?: InputMaybe<Array<RefundWhereInput>>;
  amountInCents?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumAcceptedCurrencyFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLegacyXero?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  payment?: InputMaybe<PaymentScalarRelationFilter>;
  paymentId?: InputMaybe<StringFilter>;
  stripePayout?: InputMaybe<StripePayoutNullableScalarRelationFilter>;
  stripePayoutId?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  xeroCreditNoteNumber?: InputMaybe<StringNullableFilter>;
};

export type ResourceCategoryAvgOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type ResourceCategoryCountOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ResourceCategoryCreateInput = {
  category: CategoryCreateNestedOneWithoutCategoryResourcesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resource: ResourceCreateNestedOneWithoutResourceCategoriesInput;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ResourceCategoryCreateManyCategoryInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resourceId: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ResourceCategoryCreateManyCategoryInputEnvelope = {
  data: Array<ResourceCategoryCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceCategoryCreateManyInput = {
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resourceId: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ResourceCategoryCreateManyResourceInput = {
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ResourceCategoryCreateManyResourceInputEnvelope = {
  data: Array<ResourceCategoryCreateManyResourceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceCategoryCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<ResourceCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCategoryCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<ResourceCategoryCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<ResourceCategoryCreateManyCategoryInputEnvelope>;
};

export type ResourceCategoryCreateNestedManyWithoutResourceInput = {
  connect?: InputMaybe<Array<ResourceCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCategoryCreateOrConnectWithoutResourceInput>>;
  create?: InputMaybe<Array<ResourceCategoryCreateWithoutResourceInput>>;
  createMany?: InputMaybe<ResourceCategoryCreateManyResourceInputEnvelope>;
};

export type ResourceCategoryCreateOrConnectWithoutCategoryInput = {
  create: ResourceCategoryCreateWithoutCategoryInput;
  where: ResourceCategoryWhereUniqueInput;
};

export type ResourceCategoryCreateOrConnectWithoutResourceInput = {
  create: ResourceCategoryCreateWithoutResourceInput;
  where: ResourceCategoryWhereUniqueInput;
};

export type ResourceCategoryCreateWithoutCategoryInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resource: ResourceCreateNestedOneWithoutResourceCategoriesInput;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ResourceCategoryCreateWithoutResourceInput = {
  category: CategoryCreateNestedOneWithoutCategoryResourcesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ResourceCategoryListRelationFilter = {
  every?: InputMaybe<ResourceCategoryWhereInput>;
  none?: InputMaybe<ResourceCategoryWhereInput>;
  some?: InputMaybe<ResourceCategoryWhereInput>;
};

export type ResourceCategoryMaxOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ResourceCategoryMinOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ResourceCategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ResourceCategoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<ResourceCategoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<ResourceCategoryCountOrderByAggregateInput>;
  _max?: InputMaybe<ResourceCategoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<ResourceCategoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<ResourceCategorySumOrderByAggregateInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ResourceCategoryOrderByWithRelationInput = {
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  isRequired?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resource?: InputMaybe<ResourceOrderByWithRelationInput>;
  resourceId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ResourceCategoryResourceCategoryCompoundUniqueInput = {
  categoryId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
};

export enum ResourceCategoryScalarFieldEnum {
  CategoryId = 'categoryId',
  Created = 'created',
  Id = 'id',
  IsPinned = 'isPinned',
  IsRequired = 'isRequired',
  Modified = 'modified',
  ResourceId = 'resourceId',
  SortOrder = 'sortOrder'
}

export type ResourceCategoryScalarWhereInput = {
  AND?: InputMaybe<Array<ResourceCategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<ResourceCategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<ResourceCategoryScalarWhereInput>>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  resourceId?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type ResourceCategoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ResourceCategoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ResourceCategoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ResourceCategoryScalarWhereWithAggregatesInput>>;
  categoryId?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isPinned?: InputMaybe<BoolWithAggregatesFilter>;
  isRequired?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  resourceId?: InputMaybe<StringWithAggregatesFilter>;
  sortOrder?: InputMaybe<IntWithAggregatesFilter>;
};

export type ResourceCategorySumOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type ResourceCategoryUpdateInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutCategoryResourcesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  resource?: InputMaybe<ResourceUpdateOneRequiredWithoutResourceCategoriesNestedInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ResourceCategoryUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ResourceCategoryUpdateManyWithWhereWithoutCategoryInput = {
  data: ResourceCategoryUpdateManyMutationInput;
  where: ResourceCategoryScalarWhereInput;
};

export type ResourceCategoryUpdateManyWithWhereWithoutResourceInput = {
  data: ResourceCategoryUpdateManyMutationInput;
  where: ResourceCategoryScalarWhereInput;
};

export type ResourceCategoryUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<ResourceCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCategoryCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<ResourceCategoryCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<ResourceCategoryCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<ResourceCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResourceCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResourceCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<ResourceCategoryUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<ResourceCategoryUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<ResourceCategoryUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type ResourceCategoryUpdateManyWithoutResourceNestedInput = {
  connect?: InputMaybe<Array<ResourceCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCategoryCreateOrConnectWithoutResourceInput>>;
  create?: InputMaybe<Array<ResourceCategoryCreateWithoutResourceInput>>;
  createMany?: InputMaybe<ResourceCategoryCreateManyResourceInputEnvelope>;
  delete?: InputMaybe<Array<ResourceCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResourceCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResourceCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<ResourceCategoryUpdateWithWhereUniqueWithoutResourceInput>>;
  updateMany?: InputMaybe<Array<ResourceCategoryUpdateManyWithWhereWithoutResourceInput>>;
  upsert?: InputMaybe<Array<ResourceCategoryUpsertWithWhereUniqueWithoutResourceInput>>;
};

export type ResourceCategoryUpdateWithWhereUniqueWithoutCategoryInput = {
  data: ResourceCategoryUpdateWithoutCategoryInput;
  where: ResourceCategoryWhereUniqueInput;
};

export type ResourceCategoryUpdateWithWhereUniqueWithoutResourceInput = {
  data: ResourceCategoryUpdateWithoutResourceInput;
  where: ResourceCategoryWhereUniqueInput;
};

export type ResourceCategoryUpdateWithoutCategoryInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  resource?: InputMaybe<ResourceUpdateOneRequiredWithoutResourceCategoriesNestedInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ResourceCategoryUpdateWithoutResourceInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutCategoryResourcesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ResourceCategoryUpsertWithWhereUniqueWithoutCategoryInput = {
  create: ResourceCategoryCreateWithoutCategoryInput;
  update: ResourceCategoryUpdateWithoutCategoryInput;
  where: ResourceCategoryWhereUniqueInput;
};

export type ResourceCategoryUpsertWithWhereUniqueWithoutResourceInput = {
  create: ResourceCategoryCreateWithoutResourceInput;
  update: ResourceCategoryUpdateWithoutResourceInput;
  where: ResourceCategoryWhereUniqueInput;
};

export type ResourceCategoryWhereInput = {
  AND?: InputMaybe<Array<ResourceCategoryWhereInput>>;
  NOT?: InputMaybe<Array<ResourceCategoryWhereInput>>;
  OR?: InputMaybe<Array<ResourceCategoryWhereInput>>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  resource?: InputMaybe<ResourceScalarRelationFilter>;
  resourceId?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type ResourceCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<ResourceCategoryWhereInput>>;
  NOT?: InputMaybe<Array<ResourceCategoryWhereInput>>;
  OR?: InputMaybe<Array<ResourceCategoryWhereInput>>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<BoolFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  resource?: InputMaybe<ResourceScalarRelationFilter>;
  resourceCategory?: InputMaybe<ResourceCategoryResourceCategoryCompoundUniqueInput>;
  resourceId?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type ResourceCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  frontmatter?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  publishedFrontmatter?: InputMaybe<SortOrder>;
  resourceTypeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type ResourceCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  downloadedBy?: InputMaybe<UserResourceCreateNestedManyWithoutResourceInput>;
  filename: Scalars['String']['input'];
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  resourceCategories?: InputMaybe<ResourceCategoryCreateNestedManyWithoutResourceInput>;
  resourceType?: InputMaybe<ResourceTypeCreateNestedOneWithoutResourcesInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutResourceInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ResourceCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  filename: Scalars['String']['input'];
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  resourceTypeId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ResourceCreateManyResourceTypeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  filename: Scalars['String']['input'];
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ResourceCreateManyResourceTypeInputEnvelope = {
  data: Array<ResourceCreateManyResourceTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceCreateNestedManyWithoutResourceTypeInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutResourceTypeInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutResourceTypeInput>>;
  createMany?: InputMaybe<ResourceCreateManyResourceTypeInputEnvelope>;
};

export type ResourceCreateNestedOneWithoutDownloadedByInput = {
  connect?: InputMaybe<ResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceCreateOrConnectWithoutDownloadedByInput>;
  create?: InputMaybe<ResourceCreateWithoutDownloadedByInput>;
};

export type ResourceCreateNestedOneWithoutResourceCategoriesInput = {
  connect?: InputMaybe<ResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceCreateOrConnectWithoutResourceCategoriesInput>;
  create?: InputMaybe<ResourceCreateWithoutResourceCategoriesInput>;
};

export type ResourceCreateNestedOneWithoutSavedForLaterInput = {
  connect?: InputMaybe<ResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceCreateOrConnectWithoutSavedForLaterInput>;
  create?: InputMaybe<ResourceCreateWithoutSavedForLaterInput>;
};

export type ResourceCreateOrConnectWithoutDownloadedByInput = {
  create: ResourceCreateWithoutDownloadedByInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceCreateOrConnectWithoutResourceCategoriesInput = {
  create: ResourceCreateWithoutResourceCategoriesInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceCreateOrConnectWithoutResourceTypeInput = {
  create: ResourceCreateWithoutResourceTypeInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceCreateOrConnectWithoutSavedForLaterInput = {
  create: ResourceCreateWithoutSavedForLaterInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceCreateWithoutDownloadedByInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  filename: Scalars['String']['input'];
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  resourceCategories?: InputMaybe<ResourceCategoryCreateNestedManyWithoutResourceInput>;
  resourceType?: InputMaybe<ResourceTypeCreateNestedOneWithoutResourcesInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutResourceInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ResourceCreateWithoutResourceCategoriesInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  downloadedBy?: InputMaybe<UserResourceCreateNestedManyWithoutResourceInput>;
  filename: Scalars['String']['input'];
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  resourceType?: InputMaybe<ResourceTypeCreateNestedOneWithoutResourcesInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutResourceInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ResourceCreateWithoutResourceTypeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  downloadedBy?: InputMaybe<UserResourceCreateNestedManyWithoutResourceInput>;
  filename: Scalars['String']['input'];
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  resourceCategories?: InputMaybe<ResourceCategoryCreateNestedManyWithoutResourceInput>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutResourceInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ResourceCreateWithoutSavedForLaterInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  downloadedBy?: InputMaybe<UserResourceCreateNestedManyWithoutResourceInput>;
  filename: Scalars['String']['input'];
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  resourceCategories?: InputMaybe<ResourceCategoryCreateNestedManyWithoutResourceInput>;
  resourceType?: InputMaybe<ResourceTypeCreateNestedOneWithoutResourcesInput>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ResourceListRelationFilter = {
  every?: InputMaybe<ResourceWhereInput>;
  none?: InputMaybe<ResourceWhereInput>;
  some?: InputMaybe<ResourceWhereInput>;
};

export type ResourceMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceTypeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type ResourceMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceTypeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type ResourceNullableScalarRelationFilter = {
  is?: InputMaybe<ResourceWhereInput>;
  isNot?: InputMaybe<ResourceWhereInput>;
};

export type ResourceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ResourceOrderByWithAggregationInput = {
  _count?: InputMaybe<ResourceCountOrderByAggregateInput>;
  _max?: InputMaybe<ResourceMaxOrderByAggregateInput>;
  _min?: InputMaybe<ResourceMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  frontmatter?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  publishedFrontmatter?: InputMaybe<SortOrderInput>;
  resourceTypeId?: InputMaybe<SortOrderInput>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type ResourceOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  downloadedBy?: InputMaybe<UserResourceOrderByRelationAggregateInput>;
  filename?: InputMaybe<SortOrder>;
  frontmatter?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  publishedFrontmatter?: InputMaybe<SortOrderInput>;
  resourceCategories?: InputMaybe<ResourceCategoryOrderByRelationAggregateInput>;
  resourceType?: InputMaybe<ResourceTypeOrderByWithRelationInput>;
  resourceTypeId?: InputMaybe<SortOrderInput>;
  savedForLater?: InputMaybe<SavedForLaterOrderByRelationAggregateInput>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export enum ResourceScalarFieldEnum {
  Created = 'created',
  Filename = 'filename',
  Frontmatter = 'frontmatter',
  Id = 'id',
  IsPublished = 'isPublished',
  Modified = 'modified',
  PublishedFrontmatter = 'publishedFrontmatter',
  ResourceTypeId = 'resourceTypeId',
  Slug = 'slug',
  Title = 'title',
  Url = 'url'
}

export type ResourceScalarRelationFilter = {
  is?: InputMaybe<ResourceWhereInput>;
  isNot?: InputMaybe<ResourceWhereInput>;
};

export type ResourceScalarWhereInput = {
  AND?: InputMaybe<Array<ResourceScalarWhereInput>>;
  NOT?: InputMaybe<Array<ResourceScalarWhereInput>>;
  OR?: InputMaybe<Array<ResourceScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  filename?: InputMaybe<StringFilter>;
  frontmatter?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  publishedFrontmatter?: InputMaybe<JsonNullableFilter>;
  resourceTypeId?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type ResourceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ResourceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ResourceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ResourceScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  filename?: InputMaybe<StringWithAggregatesFilter>;
  frontmatter?: InputMaybe<JsonNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isPublished?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  publishedFrontmatter?: InputMaybe<JsonNullableWithAggregatesFilter>;
  resourceTypeId?: InputMaybe<StringNullableWithAggregatesFilter>;
  slug?: InputMaybe<StringWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  url?: InputMaybe<StringWithAggregatesFilter>;
};

export type ResourceTypeCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ResourceTypeCreateInput = {
  articles?: InputMaybe<ArticleCreateNestedManyWithoutResourceTypeInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  resources?: InputMaybe<ResourceCreateNestedManyWithoutResourceTypeInput>;
};

export type ResourceTypeCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
};

export type ResourceTypeCreateNestedOneWithoutArticlesInput = {
  connect?: InputMaybe<ResourceTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceTypeCreateOrConnectWithoutArticlesInput>;
  create?: InputMaybe<ResourceTypeCreateWithoutArticlesInput>;
};

export type ResourceTypeCreateNestedOneWithoutResourcesInput = {
  connect?: InputMaybe<ResourceTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceTypeCreateOrConnectWithoutResourcesInput>;
  create?: InputMaybe<ResourceTypeCreateWithoutResourcesInput>;
};

export type ResourceTypeCreateOrConnectWithoutArticlesInput = {
  create: ResourceTypeCreateWithoutArticlesInput;
  where: ResourceTypeWhereUniqueInput;
};

export type ResourceTypeCreateOrConnectWithoutResourcesInput = {
  create: ResourceTypeCreateWithoutResourcesInput;
  where: ResourceTypeWhereUniqueInput;
};

export type ResourceTypeCreateWithoutArticlesInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  resources?: InputMaybe<ResourceCreateNestedManyWithoutResourceTypeInput>;
};

export type ResourceTypeCreateWithoutResourcesInput = {
  articles?: InputMaybe<ArticleCreateNestedManyWithoutResourceTypeInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
};

export type ResourceTypeMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ResourceTypeMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ResourceTypeNullableScalarRelationFilter = {
  is?: InputMaybe<ResourceTypeWhereInput>;
  isNot?: InputMaybe<ResourceTypeWhereInput>;
};

export type ResourceTypeOrderByWithAggregationInput = {
  _count?: InputMaybe<ResourceTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<ResourceTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<ResourceTypeMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ResourceTypeOrderByWithRelationInput = {
  articles?: InputMaybe<ArticleOrderByRelationAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  resources?: InputMaybe<ResourceOrderByRelationAggregateInput>;
};

export enum ResourceTypeScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  Name = 'name'
}

export type ResourceTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ResourceTypeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ResourceTypeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ResourceTypeScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
};

export type ResourceTypeUpdateInput = {
  articles?: InputMaybe<ArticleUpdateManyWithoutResourceTypeNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutResourceTypeNestedInput>;
};

export type ResourceTypeUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ResourceTypeUpdateOneWithoutArticlesNestedInput = {
  connect?: InputMaybe<ResourceTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceTypeCreateOrConnectWithoutArticlesInput>;
  create?: InputMaybe<ResourceTypeCreateWithoutArticlesInput>;
  delete?: InputMaybe<ResourceTypeWhereInput>;
  disconnect?: InputMaybe<ResourceTypeWhereInput>;
  update?: InputMaybe<ResourceTypeUpdateToOneWithWhereWithoutArticlesInput>;
  upsert?: InputMaybe<ResourceTypeUpsertWithoutArticlesInput>;
};

export type ResourceTypeUpdateOneWithoutResourcesNestedInput = {
  connect?: InputMaybe<ResourceTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceTypeCreateOrConnectWithoutResourcesInput>;
  create?: InputMaybe<ResourceTypeCreateWithoutResourcesInput>;
  delete?: InputMaybe<ResourceTypeWhereInput>;
  disconnect?: InputMaybe<ResourceTypeWhereInput>;
  update?: InputMaybe<ResourceTypeUpdateToOneWithWhereWithoutResourcesInput>;
  upsert?: InputMaybe<ResourceTypeUpsertWithoutResourcesInput>;
};

export type ResourceTypeUpdateToOneWithWhereWithoutArticlesInput = {
  data: ResourceTypeUpdateWithoutArticlesInput;
  where?: InputMaybe<ResourceTypeWhereInput>;
};

export type ResourceTypeUpdateToOneWithWhereWithoutResourcesInput = {
  data: ResourceTypeUpdateWithoutResourcesInput;
  where?: InputMaybe<ResourceTypeWhereInput>;
};

export type ResourceTypeUpdateWithoutArticlesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutResourceTypeNestedInput>;
};

export type ResourceTypeUpdateWithoutResourcesInput = {
  articles?: InputMaybe<ArticleUpdateManyWithoutResourceTypeNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ResourceTypeUpsertWithoutArticlesInput = {
  create: ResourceTypeCreateWithoutArticlesInput;
  update: ResourceTypeUpdateWithoutArticlesInput;
  where?: InputMaybe<ResourceTypeWhereInput>;
};

export type ResourceTypeUpsertWithoutResourcesInput = {
  create: ResourceTypeCreateWithoutResourcesInput;
  update: ResourceTypeUpdateWithoutResourcesInput;
  where?: InputMaybe<ResourceTypeWhereInput>;
};

export type ResourceTypeWhereInput = {
  AND?: InputMaybe<Array<ResourceTypeWhereInput>>;
  NOT?: InputMaybe<Array<ResourceTypeWhereInput>>;
  OR?: InputMaybe<Array<ResourceTypeWhereInput>>;
  articles?: InputMaybe<ArticleListRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  resources?: InputMaybe<ResourceListRelationFilter>;
};

export type ResourceTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<ResourceTypeWhereInput>>;
  NOT?: InputMaybe<Array<ResourceTypeWhereInput>>;
  OR?: InputMaybe<Array<ResourceTypeWhereInput>>;
  articles?: InputMaybe<ArticleListRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  resources?: InputMaybe<ResourceListRelationFilter>;
};

export type ResourceUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  downloadedBy?: InputMaybe<UserResourceUpdateManyWithoutResourceNestedInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  resourceCategories?: InputMaybe<ResourceCategoryUpdateManyWithoutResourceNestedInput>;
  resourceType?: InputMaybe<ResourceTypeUpdateOneWithoutResourcesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutResourceNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ResourceUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ResourceUpdateManyWithWhereWithoutResourceTypeInput = {
  data: ResourceUpdateManyMutationInput;
  where: ResourceScalarWhereInput;
};

export type ResourceUpdateManyWithoutResourceTypeNestedInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutResourceTypeInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutResourceTypeInput>>;
  createMany?: InputMaybe<ResourceCreateManyResourceTypeInputEnvelope>;
  delete?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<ResourceUpdateWithWhereUniqueWithoutResourceTypeInput>>;
  updateMany?: InputMaybe<Array<ResourceUpdateManyWithWhereWithoutResourceTypeInput>>;
  upsert?: InputMaybe<Array<ResourceUpsertWithWhereUniqueWithoutResourceTypeInput>>;
};

export type ResourceUpdateOneRequiredWithoutDownloadedByNestedInput = {
  connect?: InputMaybe<ResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceCreateOrConnectWithoutDownloadedByInput>;
  create?: InputMaybe<ResourceCreateWithoutDownloadedByInput>;
  update?: InputMaybe<ResourceUpdateToOneWithWhereWithoutDownloadedByInput>;
  upsert?: InputMaybe<ResourceUpsertWithoutDownloadedByInput>;
};

export type ResourceUpdateOneRequiredWithoutResourceCategoriesNestedInput = {
  connect?: InputMaybe<ResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceCreateOrConnectWithoutResourceCategoriesInput>;
  create?: InputMaybe<ResourceCreateWithoutResourceCategoriesInput>;
  update?: InputMaybe<ResourceUpdateToOneWithWhereWithoutResourceCategoriesInput>;
  upsert?: InputMaybe<ResourceUpsertWithoutResourceCategoriesInput>;
};

export type ResourceUpdateOneWithoutSavedForLaterNestedInput = {
  connect?: InputMaybe<ResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceCreateOrConnectWithoutSavedForLaterInput>;
  create?: InputMaybe<ResourceCreateWithoutSavedForLaterInput>;
  delete?: InputMaybe<ResourceWhereInput>;
  disconnect?: InputMaybe<ResourceWhereInput>;
  update?: InputMaybe<ResourceUpdateToOneWithWhereWithoutSavedForLaterInput>;
  upsert?: InputMaybe<ResourceUpsertWithoutSavedForLaterInput>;
};

export type ResourceUpdateToOneWithWhereWithoutDownloadedByInput = {
  data: ResourceUpdateWithoutDownloadedByInput;
  where?: InputMaybe<ResourceWhereInput>;
};

export type ResourceUpdateToOneWithWhereWithoutResourceCategoriesInput = {
  data: ResourceUpdateWithoutResourceCategoriesInput;
  where?: InputMaybe<ResourceWhereInput>;
};

export type ResourceUpdateToOneWithWhereWithoutSavedForLaterInput = {
  data: ResourceUpdateWithoutSavedForLaterInput;
  where?: InputMaybe<ResourceWhereInput>;
};

export type ResourceUpdateWithWhereUniqueWithoutResourceTypeInput = {
  data: ResourceUpdateWithoutResourceTypeInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceUpdateWithoutDownloadedByInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  resourceCategories?: InputMaybe<ResourceCategoryUpdateManyWithoutResourceNestedInput>;
  resourceType?: InputMaybe<ResourceTypeUpdateOneWithoutResourcesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutResourceNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ResourceUpdateWithoutResourceCategoriesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  downloadedBy?: InputMaybe<UserResourceUpdateManyWithoutResourceNestedInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  resourceType?: InputMaybe<ResourceTypeUpdateOneWithoutResourcesNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutResourceNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ResourceUpdateWithoutResourceTypeInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  downloadedBy?: InputMaybe<UserResourceUpdateManyWithoutResourceNestedInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  resourceCategories?: InputMaybe<ResourceCategoryUpdateManyWithoutResourceNestedInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutResourceNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ResourceUpdateWithoutSavedForLaterInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  downloadedBy?: InputMaybe<UserResourceUpdateManyWithoutResourceNestedInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  frontmatter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  publishedFrontmatter?: InputMaybe<Scalars['JSON']['input']>;
  resourceCategories?: InputMaybe<ResourceCategoryUpdateManyWithoutResourceNestedInput>;
  resourceType?: InputMaybe<ResourceTypeUpdateOneWithoutResourcesNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ResourceUpsertWithWhereUniqueWithoutResourceTypeInput = {
  create: ResourceCreateWithoutResourceTypeInput;
  update: ResourceUpdateWithoutResourceTypeInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceUpsertWithoutDownloadedByInput = {
  create: ResourceCreateWithoutDownloadedByInput;
  update: ResourceUpdateWithoutDownloadedByInput;
  where?: InputMaybe<ResourceWhereInput>;
};

export type ResourceUpsertWithoutResourceCategoriesInput = {
  create: ResourceCreateWithoutResourceCategoriesInput;
  update: ResourceUpdateWithoutResourceCategoriesInput;
  where?: InputMaybe<ResourceWhereInput>;
};

export type ResourceUpsertWithoutSavedForLaterInput = {
  create: ResourceCreateWithoutSavedForLaterInput;
  update: ResourceUpdateWithoutSavedForLaterInput;
  where?: InputMaybe<ResourceWhereInput>;
};

export type ResourceWhereInput = {
  AND?: InputMaybe<Array<ResourceWhereInput>>;
  NOT?: InputMaybe<Array<ResourceWhereInput>>;
  OR?: InputMaybe<Array<ResourceWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  downloadedBy?: InputMaybe<UserResourceListRelationFilter>;
  filename?: InputMaybe<StringFilter>;
  frontmatter?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  publishedFrontmatter?: InputMaybe<JsonNullableFilter>;
  resourceCategories?: InputMaybe<ResourceCategoryListRelationFilter>;
  resourceType?: InputMaybe<ResourceTypeNullableScalarRelationFilter>;
  resourceTypeId?: InputMaybe<StringNullableFilter>;
  savedForLater?: InputMaybe<SavedForLaterListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type ResourceWhereUniqueInput = {
  AND?: InputMaybe<Array<ResourceWhereInput>>;
  NOT?: InputMaybe<Array<ResourceWhereInput>>;
  OR?: InputMaybe<Array<ResourceWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  downloadedBy?: InputMaybe<UserResourceListRelationFilter>;
  filename?: InputMaybe<StringFilter>;
  frontmatter?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  publishedFrontmatter?: InputMaybe<JsonNullableFilter>;
  resourceCategories?: InputMaybe<ResourceCategoryListRelationFilter>;
  resourceType?: InputMaybe<ResourceTypeNullableScalarRelationFilter>;
  resourceTypeId?: InputMaybe<StringNullableFilter>;
  savedForLater?: InputMaybe<SavedForLaterListRelationFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export enum Role {
  Admin = 'ADMIN',
  User = 'USER'
}

export type SavedForLaterCountOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type SavedForLaterCreateInput = {
  article?: InputMaybe<ArticleCreateNestedOneWithoutSavedForLaterInput>;
  category: CategoryCreateNestedOneWithoutSavedForLaterInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programme: ProgrammeCreateNestedOneWithoutSavedForLaterInput;
  resource?: InputMaybe<ResourceCreateNestedOneWithoutSavedForLaterInput>;
  user: UserCreateNestedOneWithoutSavedForLaterInput;
};

export type SavedForLaterCreateManyArticleInput = {
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programmeId: Scalars['String']['input'];
  resourceId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type SavedForLaterCreateManyArticleInputEnvelope = {
  data: Array<SavedForLaterCreateManyArticleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SavedForLaterCreateManyCategoryInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programmeId: Scalars['String']['input'];
  resourceId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type SavedForLaterCreateManyCategoryInputEnvelope = {
  data: Array<SavedForLaterCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SavedForLaterCreateManyInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programmeId: Scalars['String']['input'];
  resourceId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type SavedForLaterCreateManyProgrammeInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type SavedForLaterCreateManyProgrammeInputEnvelope = {
  data: Array<SavedForLaterCreateManyProgrammeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SavedForLaterCreateManyResourceInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programmeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SavedForLaterCreateManyResourceInputEnvelope = {
  data: Array<SavedForLaterCreateManyResourceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SavedForLaterCreateManyUserInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programmeId: Scalars['String']['input'];
  resourceId?: InputMaybe<Scalars['String']['input']>;
};

export type SavedForLaterCreateManyUserInputEnvelope = {
  data: Array<SavedForLaterCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SavedForLaterCreateNestedManyWithoutArticleInput = {
  connect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedForLaterCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<SavedForLaterCreateWithoutArticleInput>>;
  createMany?: InputMaybe<SavedForLaterCreateManyArticleInputEnvelope>;
};

export type SavedForLaterCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedForLaterCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<SavedForLaterCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<SavedForLaterCreateManyCategoryInputEnvelope>;
};

export type SavedForLaterCreateNestedManyWithoutProgrammeInput = {
  connect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedForLaterCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<SavedForLaterCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<SavedForLaterCreateManyProgrammeInputEnvelope>;
};

export type SavedForLaterCreateNestedManyWithoutResourceInput = {
  connect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedForLaterCreateOrConnectWithoutResourceInput>>;
  create?: InputMaybe<Array<SavedForLaterCreateWithoutResourceInput>>;
  createMany?: InputMaybe<SavedForLaterCreateManyResourceInputEnvelope>;
};

export type SavedForLaterCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedForLaterCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SavedForLaterCreateWithoutUserInput>>;
  createMany?: InputMaybe<SavedForLaterCreateManyUserInputEnvelope>;
};

export type SavedForLaterCreateOrConnectWithoutArticleInput = {
  create: SavedForLaterCreateWithoutArticleInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterCreateOrConnectWithoutCategoryInput = {
  create: SavedForLaterCreateWithoutCategoryInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterCreateOrConnectWithoutProgrammeInput = {
  create: SavedForLaterCreateWithoutProgrammeInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterCreateOrConnectWithoutResourceInput = {
  create: SavedForLaterCreateWithoutResourceInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterCreateOrConnectWithoutUserInput = {
  create: SavedForLaterCreateWithoutUserInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterCreateWithoutArticleInput = {
  category: CategoryCreateNestedOneWithoutSavedForLaterInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programme: ProgrammeCreateNestedOneWithoutSavedForLaterInput;
  resource?: InputMaybe<ResourceCreateNestedOneWithoutSavedForLaterInput>;
  user: UserCreateNestedOneWithoutSavedForLaterInput;
};

export type SavedForLaterCreateWithoutCategoryInput = {
  article?: InputMaybe<ArticleCreateNestedOneWithoutSavedForLaterInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programme: ProgrammeCreateNestedOneWithoutSavedForLaterInput;
  resource?: InputMaybe<ResourceCreateNestedOneWithoutSavedForLaterInput>;
  user: UserCreateNestedOneWithoutSavedForLaterInput;
};

export type SavedForLaterCreateWithoutProgrammeInput = {
  article?: InputMaybe<ArticleCreateNestedOneWithoutSavedForLaterInput>;
  category: CategoryCreateNestedOneWithoutSavedForLaterInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resource?: InputMaybe<ResourceCreateNestedOneWithoutSavedForLaterInput>;
  user: UserCreateNestedOneWithoutSavedForLaterInput;
};

export type SavedForLaterCreateWithoutResourceInput = {
  article?: InputMaybe<ArticleCreateNestedOneWithoutSavedForLaterInput>;
  category: CategoryCreateNestedOneWithoutSavedForLaterInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programme: ProgrammeCreateNestedOneWithoutSavedForLaterInput;
  user: UserCreateNestedOneWithoutSavedForLaterInput;
};

export type SavedForLaterCreateWithoutUserInput = {
  article?: InputMaybe<ArticleCreateNestedOneWithoutSavedForLaterInput>;
  category: CategoryCreateNestedOneWithoutSavedForLaterInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  programme: ProgrammeCreateNestedOneWithoutSavedForLaterInput;
  resource?: InputMaybe<ResourceCreateNestedOneWithoutSavedForLaterInput>;
};

export type SavedForLaterListRelationFilter = {
  every?: InputMaybe<SavedForLaterWhereInput>;
  none?: InputMaybe<SavedForLaterWhereInput>;
  some?: InputMaybe<SavedForLaterWhereInput>;
};

export type SavedForLaterMaxOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type SavedForLaterMinOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type SavedForLaterOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SavedForLaterOrderByWithAggregationInput = {
  _count?: InputMaybe<SavedForLaterCountOrderByAggregateInput>;
  _max?: InputMaybe<SavedForLaterMaxOrderByAggregateInput>;
  _min?: InputMaybe<SavedForLaterMinOrderByAggregateInput>;
  articleId?: InputMaybe<SortOrderInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  programmeId?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrder>;
};

export type SavedForLaterOrderByWithRelationInput = {
  article?: InputMaybe<ArticleOrderByWithRelationInput>;
  articleId?: InputMaybe<SortOrderInput>;
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPinned?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  programme?: InputMaybe<ProgrammeOrderByWithRelationInput>;
  programmeId?: InputMaybe<SortOrder>;
  resource?: InputMaybe<ResourceOrderByWithRelationInput>;
  resourceId?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type SavedForLaterSavedForLaterCompoundUniqueInput = {
  articleId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum SavedForLaterScalarFieldEnum {
  ArticleId = 'articleId',
  CategoryId = 'categoryId',
  Created = 'created',
  Id = 'id',
  IsPinned = 'isPinned',
  Modified = 'modified',
  ProgrammeId = 'programmeId',
  ResourceId = 'resourceId',
  UserId = 'userId'
}

export type SavedForLaterScalarWhereInput = {
  AND?: InputMaybe<Array<SavedForLaterScalarWhereInput>>;
  NOT?: InputMaybe<Array<SavedForLaterScalarWhereInput>>;
  OR?: InputMaybe<Array<SavedForLaterScalarWhereInput>>;
  articleId?: InputMaybe<StringNullableFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPinned?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  programmeId?: InputMaybe<StringFilter>;
  resourceId?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type SavedForLaterScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SavedForLaterScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SavedForLaterScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SavedForLaterScalarWhereWithAggregatesInput>>;
  articleId?: InputMaybe<StringNullableWithAggregatesFilter>;
  categoryId?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isPinned?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  programmeId?: InputMaybe<StringWithAggregatesFilter>;
  resourceId?: InputMaybe<StringNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type SavedForLaterUpdateInput = {
  article?: InputMaybe<ArticleUpdateOneWithoutSavedForLaterNestedInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutSavedForLaterNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutSavedForLaterNestedInput>;
  resource?: InputMaybe<ResourceUpdateOneWithoutSavedForLaterNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutSavedForLaterNestedInput>;
};

export type SavedForLaterUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SavedForLaterUpdateManyWithWhereWithoutArticleInput = {
  data: SavedForLaterUpdateManyMutationInput;
  where: SavedForLaterScalarWhereInput;
};

export type SavedForLaterUpdateManyWithWhereWithoutCategoryInput = {
  data: SavedForLaterUpdateManyMutationInput;
  where: SavedForLaterScalarWhereInput;
};

export type SavedForLaterUpdateManyWithWhereWithoutProgrammeInput = {
  data: SavedForLaterUpdateManyMutationInput;
  where: SavedForLaterScalarWhereInput;
};

export type SavedForLaterUpdateManyWithWhereWithoutResourceInput = {
  data: SavedForLaterUpdateManyMutationInput;
  where: SavedForLaterScalarWhereInput;
};

export type SavedForLaterUpdateManyWithWhereWithoutUserInput = {
  data: SavedForLaterUpdateManyMutationInput;
  where: SavedForLaterScalarWhereInput;
};

export type SavedForLaterUpdateManyWithoutArticleNestedInput = {
  connect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedForLaterCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<SavedForLaterCreateWithoutArticleInput>>;
  createMany?: InputMaybe<SavedForLaterCreateManyArticleInputEnvelope>;
  delete?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SavedForLaterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  set?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  update?: InputMaybe<Array<SavedForLaterUpdateWithWhereUniqueWithoutArticleInput>>;
  updateMany?: InputMaybe<Array<SavedForLaterUpdateManyWithWhereWithoutArticleInput>>;
  upsert?: InputMaybe<Array<SavedForLaterUpsertWithWhereUniqueWithoutArticleInput>>;
};

export type SavedForLaterUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedForLaterCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<SavedForLaterCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<SavedForLaterCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SavedForLaterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  set?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  update?: InputMaybe<Array<SavedForLaterUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<SavedForLaterUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<SavedForLaterUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type SavedForLaterUpdateManyWithoutProgrammeNestedInput = {
  connect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedForLaterCreateOrConnectWithoutProgrammeInput>>;
  create?: InputMaybe<Array<SavedForLaterCreateWithoutProgrammeInput>>;
  createMany?: InputMaybe<SavedForLaterCreateManyProgrammeInputEnvelope>;
  delete?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SavedForLaterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  set?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  update?: InputMaybe<Array<SavedForLaterUpdateWithWhereUniqueWithoutProgrammeInput>>;
  updateMany?: InputMaybe<Array<SavedForLaterUpdateManyWithWhereWithoutProgrammeInput>>;
  upsert?: InputMaybe<Array<SavedForLaterUpsertWithWhereUniqueWithoutProgrammeInput>>;
};

export type SavedForLaterUpdateManyWithoutResourceNestedInput = {
  connect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedForLaterCreateOrConnectWithoutResourceInput>>;
  create?: InputMaybe<Array<SavedForLaterCreateWithoutResourceInput>>;
  createMany?: InputMaybe<SavedForLaterCreateManyResourceInputEnvelope>;
  delete?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SavedForLaterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  set?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  update?: InputMaybe<Array<SavedForLaterUpdateWithWhereUniqueWithoutResourceInput>>;
  updateMany?: InputMaybe<Array<SavedForLaterUpdateManyWithWhereWithoutResourceInput>>;
  upsert?: InputMaybe<Array<SavedForLaterUpsertWithWhereUniqueWithoutResourceInput>>;
};

export type SavedForLaterUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedForLaterCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SavedForLaterCreateWithoutUserInput>>;
  createMany?: InputMaybe<SavedForLaterCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SavedForLaterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  set?: InputMaybe<Array<SavedForLaterWhereUniqueInput>>;
  update?: InputMaybe<Array<SavedForLaterUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<SavedForLaterUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<SavedForLaterUpsertWithWhereUniqueWithoutUserInput>>;
};

export type SavedForLaterUpdateWithWhereUniqueWithoutArticleInput = {
  data: SavedForLaterUpdateWithoutArticleInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterUpdateWithWhereUniqueWithoutCategoryInput = {
  data: SavedForLaterUpdateWithoutCategoryInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterUpdateWithWhereUniqueWithoutProgrammeInput = {
  data: SavedForLaterUpdateWithoutProgrammeInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterUpdateWithWhereUniqueWithoutResourceInput = {
  data: SavedForLaterUpdateWithoutResourceInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterUpdateWithWhereUniqueWithoutUserInput = {
  data: SavedForLaterUpdateWithoutUserInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterUpdateWithoutArticleInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutSavedForLaterNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutSavedForLaterNestedInput>;
  resource?: InputMaybe<ResourceUpdateOneWithoutSavedForLaterNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutSavedForLaterNestedInput>;
};

export type SavedForLaterUpdateWithoutCategoryInput = {
  article?: InputMaybe<ArticleUpdateOneWithoutSavedForLaterNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutSavedForLaterNestedInput>;
  resource?: InputMaybe<ResourceUpdateOneWithoutSavedForLaterNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutSavedForLaterNestedInput>;
};

export type SavedForLaterUpdateWithoutProgrammeInput = {
  article?: InputMaybe<ArticleUpdateOneWithoutSavedForLaterNestedInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutSavedForLaterNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  resource?: InputMaybe<ResourceUpdateOneWithoutSavedForLaterNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutSavedForLaterNestedInput>;
};

export type SavedForLaterUpdateWithoutResourceInput = {
  article?: InputMaybe<ArticleUpdateOneWithoutSavedForLaterNestedInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutSavedForLaterNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutSavedForLaterNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutSavedForLaterNestedInput>;
};

export type SavedForLaterUpdateWithoutUserInput = {
  article?: InputMaybe<ArticleUpdateOneWithoutSavedForLaterNestedInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutSavedForLaterNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPinned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  programme?: InputMaybe<ProgrammeUpdateOneRequiredWithoutSavedForLaterNestedInput>;
  resource?: InputMaybe<ResourceUpdateOneWithoutSavedForLaterNestedInput>;
};

export type SavedForLaterUpsertWithWhereUniqueWithoutArticleInput = {
  create: SavedForLaterCreateWithoutArticleInput;
  update: SavedForLaterUpdateWithoutArticleInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterUpsertWithWhereUniqueWithoutCategoryInput = {
  create: SavedForLaterCreateWithoutCategoryInput;
  update: SavedForLaterUpdateWithoutCategoryInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterUpsertWithWhereUniqueWithoutProgrammeInput = {
  create: SavedForLaterCreateWithoutProgrammeInput;
  update: SavedForLaterUpdateWithoutProgrammeInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterUpsertWithWhereUniqueWithoutResourceInput = {
  create: SavedForLaterCreateWithoutResourceInput;
  update: SavedForLaterUpdateWithoutResourceInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterUpsertWithWhereUniqueWithoutUserInput = {
  create: SavedForLaterCreateWithoutUserInput;
  update: SavedForLaterUpdateWithoutUserInput;
  where: SavedForLaterWhereUniqueInput;
};

export type SavedForLaterWhereInput = {
  AND?: InputMaybe<Array<SavedForLaterWhereInput>>;
  NOT?: InputMaybe<Array<SavedForLaterWhereInput>>;
  OR?: InputMaybe<Array<SavedForLaterWhereInput>>;
  article?: InputMaybe<ArticleNullableScalarRelationFilter>;
  articleId?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPinned?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
  resource?: InputMaybe<ResourceNullableScalarRelationFilter>;
  resourceId?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type SavedForLaterWhereUniqueInput = {
  AND?: InputMaybe<Array<SavedForLaterWhereInput>>;
  NOT?: InputMaybe<Array<SavedForLaterWhereInput>>;
  OR?: InputMaybe<Array<SavedForLaterWhereInput>>;
  article?: InputMaybe<ArticleNullableScalarRelationFilter>;
  articleId?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  programme?: InputMaybe<ProgrammeScalarRelationFilter>;
  programmeId?: InputMaybe<StringFilter>;
  resource?: InputMaybe<ResourceNullableScalarRelationFilter>;
  resourceId?: InputMaybe<StringNullableFilter>;
  savedForLater?: InputMaybe<SavedForLaterSavedForLaterCompoundUniqueInput>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type SectionImageCategoryAvgOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type SectionImageCategoryCountOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sectionImageId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type SectionImageCategoryCreateInput = {
  category: CategoryCreateNestedOneWithoutCategoryImageInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sectionImage: SectionImageCreateNestedOneWithoutSectionImageCategoriesInput;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SectionImageCategoryCreateManyInput = {
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sectionImageId: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SectionImageCategoryCreateManySectionImageInput = {
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SectionImageCategoryCreateManySectionImageInputEnvelope = {
  data: Array<SectionImageCategoryCreateManySectionImageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SectionImageCategoryCreateNestedManyWithoutSectionImageInput = {
  connect?: InputMaybe<Array<SectionImageCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SectionImageCategoryCreateOrConnectWithoutSectionImageInput>>;
  create?: InputMaybe<Array<SectionImageCategoryCreateWithoutSectionImageInput>>;
  createMany?: InputMaybe<SectionImageCategoryCreateManySectionImageInputEnvelope>;
};

export type SectionImageCategoryCreateNestedOneWithoutCategoryInput = {
  connect?: InputMaybe<SectionImageCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SectionImageCategoryCreateOrConnectWithoutCategoryInput>;
  create?: InputMaybe<SectionImageCategoryCreateWithoutCategoryInput>;
};

export type SectionImageCategoryCreateOrConnectWithoutCategoryInput = {
  create: SectionImageCategoryCreateWithoutCategoryInput;
  where: SectionImageCategoryWhereUniqueInput;
};

export type SectionImageCategoryCreateOrConnectWithoutSectionImageInput = {
  create: SectionImageCategoryCreateWithoutSectionImageInput;
  where: SectionImageCategoryWhereUniqueInput;
};

export type SectionImageCategoryCreateWithoutCategoryInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sectionImage: SectionImageCreateNestedOneWithoutSectionImageCategoriesInput;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SectionImageCategoryCreateWithoutSectionImageInput = {
  category: CategoryCreateNestedOneWithoutCategoryImageInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SectionImageCategoryListRelationFilter = {
  every?: InputMaybe<SectionImageCategoryWhereInput>;
  none?: InputMaybe<SectionImageCategoryWhereInput>;
  some?: InputMaybe<SectionImageCategoryWhereInput>;
};

export type SectionImageCategoryMaxOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sectionImageId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type SectionImageCategoryMinOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sectionImageId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type SectionImageCategoryNullableScalarRelationFilter = {
  is?: InputMaybe<SectionImageCategoryWhereInput>;
  isNot?: InputMaybe<SectionImageCategoryWhereInput>;
};

export type SectionImageCategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SectionImageCategoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<SectionImageCategoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<SectionImageCategoryCountOrderByAggregateInput>;
  _max?: InputMaybe<SectionImageCategoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<SectionImageCategoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<SectionImageCategorySumOrderByAggregateInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sectionImageId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type SectionImageCategoryOrderByWithRelationInput = {
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sectionImage?: InputMaybe<SectionImageOrderByWithRelationInput>;
  sectionImageId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum SectionImageCategoryScalarFieldEnum {
  CategoryId = 'categoryId',
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  SectionImageId = 'sectionImageId',
  SortOrder = 'sortOrder'
}

export type SectionImageCategoryScalarWhereInput = {
  AND?: InputMaybe<Array<SectionImageCategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<SectionImageCategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<SectionImageCategoryScalarWhereInput>>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sectionImageId?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type SectionImageCategoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SectionImageCategoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SectionImageCategoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SectionImageCategoryScalarWhereWithAggregatesInput>>;
  categoryId?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  sectionImageId?: InputMaybe<StringWithAggregatesFilter>;
  sortOrder?: InputMaybe<IntWithAggregatesFilter>;
};

export type SectionImageCategorySectionImageCategoryCompoundUniqueInput = {
  categoryId: Scalars['String']['input'];
  sectionImageId: Scalars['String']['input'];
};

export type SectionImageCategorySumOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type SectionImageCategoryUpdateInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutCategoryImageNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sectionImage?: InputMaybe<SectionImageUpdateOneRequiredWithoutSectionImageCategoriesNestedInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SectionImageCategoryUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SectionImageCategoryUpdateManyWithWhereWithoutSectionImageInput = {
  data: SectionImageCategoryUpdateManyMutationInput;
  where: SectionImageCategoryScalarWhereInput;
};

export type SectionImageCategoryUpdateManyWithoutSectionImageNestedInput = {
  connect?: InputMaybe<Array<SectionImageCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SectionImageCategoryCreateOrConnectWithoutSectionImageInput>>;
  create?: InputMaybe<Array<SectionImageCategoryCreateWithoutSectionImageInput>>;
  createMany?: InputMaybe<SectionImageCategoryCreateManySectionImageInputEnvelope>;
  delete?: InputMaybe<Array<SectionImageCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SectionImageCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SectionImageCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<SectionImageCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<SectionImageCategoryUpdateWithWhereUniqueWithoutSectionImageInput>>;
  updateMany?: InputMaybe<Array<SectionImageCategoryUpdateManyWithWhereWithoutSectionImageInput>>;
  upsert?: InputMaybe<Array<SectionImageCategoryUpsertWithWhereUniqueWithoutSectionImageInput>>;
};

export type SectionImageCategoryUpdateOneWithoutCategoryNestedInput = {
  connect?: InputMaybe<SectionImageCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SectionImageCategoryCreateOrConnectWithoutCategoryInput>;
  create?: InputMaybe<SectionImageCategoryCreateWithoutCategoryInput>;
  delete?: InputMaybe<SectionImageCategoryWhereInput>;
  disconnect?: InputMaybe<SectionImageCategoryWhereInput>;
  update?: InputMaybe<SectionImageCategoryUpdateToOneWithWhereWithoutCategoryInput>;
  upsert?: InputMaybe<SectionImageCategoryUpsertWithoutCategoryInput>;
};

export type SectionImageCategoryUpdateToOneWithWhereWithoutCategoryInput = {
  data: SectionImageCategoryUpdateWithoutCategoryInput;
  where?: InputMaybe<SectionImageCategoryWhereInput>;
};

export type SectionImageCategoryUpdateWithWhereUniqueWithoutSectionImageInput = {
  data: SectionImageCategoryUpdateWithoutSectionImageInput;
  where: SectionImageCategoryWhereUniqueInput;
};

export type SectionImageCategoryUpdateWithoutCategoryInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sectionImage?: InputMaybe<SectionImageUpdateOneRequiredWithoutSectionImageCategoriesNestedInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SectionImageCategoryUpdateWithoutSectionImageInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutCategoryImageNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SectionImageCategoryUpsertWithWhereUniqueWithoutSectionImageInput = {
  create: SectionImageCategoryCreateWithoutSectionImageInput;
  update: SectionImageCategoryUpdateWithoutSectionImageInput;
  where: SectionImageCategoryWhereUniqueInput;
};

export type SectionImageCategoryUpsertWithoutCategoryInput = {
  create: SectionImageCategoryCreateWithoutCategoryInput;
  update: SectionImageCategoryUpdateWithoutCategoryInput;
  where?: InputMaybe<SectionImageCategoryWhereInput>;
};

export type SectionImageCategoryWhereInput = {
  AND?: InputMaybe<Array<SectionImageCategoryWhereInput>>;
  NOT?: InputMaybe<Array<SectionImageCategoryWhereInput>>;
  OR?: InputMaybe<Array<SectionImageCategoryWhereInput>>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sectionImage?: InputMaybe<SectionImageScalarRelationFilter>;
  sectionImageId?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type SectionImageCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<SectionImageCategoryWhereInput>>;
  NOT?: InputMaybe<Array<SectionImageCategoryWhereInput>>;
  OR?: InputMaybe<Array<SectionImageCategoryWhereInput>>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  sectionImage?: InputMaybe<SectionImageScalarRelationFilter>;
  sectionImageCategory?: InputMaybe<SectionImageCategorySectionImageCategoryCompoundUniqueInput>;
  sectionImageId?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntFilter>;
};

export type SectionImageCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SectionImageCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sectionImageCategories?: InputMaybe<SectionImageCategoryCreateNestedManyWithoutSectionImageInput>;
  url: Scalars['String']['input'];
};

export type SectionImageCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type SectionImageCreateNestedOneWithoutSectionImageCategoriesInput = {
  connect?: InputMaybe<SectionImageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SectionImageCreateOrConnectWithoutSectionImageCategoriesInput>;
  create?: InputMaybe<SectionImageCreateWithoutSectionImageCategoriesInput>;
};

export type SectionImageCreateOrConnectWithoutSectionImageCategoriesInput = {
  create: SectionImageCreateWithoutSectionImageCategoriesInput;
  where: SectionImageWhereUniqueInput;
};

export type SectionImageCreateWithoutSectionImageCategoriesInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type SectionImageMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SectionImageMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SectionImageOrderByWithAggregationInput = {
  _count?: InputMaybe<SectionImageCountOrderByAggregateInput>;
  _max?: InputMaybe<SectionImageMaxOrderByAggregateInput>;
  _min?: InputMaybe<SectionImageMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SectionImageOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sectionImageCategories?: InputMaybe<SectionImageCategoryOrderByRelationAggregateInput>;
  url?: InputMaybe<SortOrder>;
};

export enum SectionImageScalarFieldEnum {
  Created = 'created',
  Filename = 'filename',
  Id = 'id',
  Modified = 'modified',
  Url = 'url'
}

export type SectionImageScalarRelationFilter = {
  is?: InputMaybe<SectionImageWhereInput>;
  isNot?: InputMaybe<SectionImageWhereInput>;
};

export type SectionImageScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SectionImageScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SectionImageScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SectionImageScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  filename?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  url?: InputMaybe<StringWithAggregatesFilter>;
};

export type SectionImageUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  filename?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sectionImageCategories?: InputMaybe<SectionImageCategoryUpdateManyWithoutSectionImageNestedInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SectionImageUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  filename?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SectionImageUpdateOneRequiredWithoutSectionImageCategoriesNestedInput = {
  connect?: InputMaybe<SectionImageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SectionImageCreateOrConnectWithoutSectionImageCategoriesInput>;
  create?: InputMaybe<SectionImageCreateWithoutSectionImageCategoriesInput>;
  update?: InputMaybe<SectionImageUpdateToOneWithWhereWithoutSectionImageCategoriesInput>;
  upsert?: InputMaybe<SectionImageUpsertWithoutSectionImageCategoriesInput>;
};

export type SectionImageUpdateToOneWithWhereWithoutSectionImageCategoriesInput = {
  data: SectionImageUpdateWithoutSectionImageCategoriesInput;
  where?: InputMaybe<SectionImageWhereInput>;
};

export type SectionImageUpdateWithoutSectionImageCategoriesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  filename?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SectionImageUpsertWithoutSectionImageCategoriesInput = {
  create: SectionImageCreateWithoutSectionImageCategoriesInput;
  update: SectionImageUpdateWithoutSectionImageCategoriesInput;
  where?: InputMaybe<SectionImageWhereInput>;
};

export type SectionImageWhereInput = {
  AND?: InputMaybe<Array<SectionImageWhereInput>>;
  NOT?: InputMaybe<Array<SectionImageWhereInput>>;
  OR?: InputMaybe<Array<SectionImageWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  filename?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sectionImageCategories?: InputMaybe<SectionImageCategoryListRelationFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SectionImageWhereUniqueInput = {
  AND?: InputMaybe<Array<SectionImageWhereInput>>;
  NOT?: InputMaybe<Array<SectionImageWhereInput>>;
  OR?: InputMaybe<Array<SectionImageWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  filename?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  sectionImageCategories?: InputMaybe<SectionImageCategoryListRelationFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SessionCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
};

export type SessionCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SessionCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SessionMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
};

export type SessionMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
};

export type SessionOrderByWithAggregationInput = {
  _count?: InputMaybe<SessionCountOrderByAggregateInput>;
  _max?: InputMaybe<SessionMaxOrderByAggregateInput>;
  _min?: InputMaybe<SessionMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
};

export type SessionOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
};

export enum SessionScalarFieldEnum {
  Created = 'created',
  Data = 'data',
  Id = 'id',
  Modified = 'modified'
}

export type SessionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SessionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SessionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SessionScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  data?: InputMaybe<JsonWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type SessionUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SessionUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SessionWhereInput = {
  AND?: InputMaybe<Array<SessionWhereInput>>;
  NOT?: InputMaybe<Array<SessionWhereInput>>;
  OR?: InputMaybe<Array<SessionWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
};

export type SessionWhereUniqueInput = {
  AND?: InputMaybe<Array<SessionWhereInput>>;
  NOT?: InputMaybe<Array<SessionWhereInput>>;
  OR?: InputMaybe<Array<SessionWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
};

export type ShortUrlCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  fullUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  shortSlug?: InputMaybe<SortOrder>;
};

export type ShortUrlCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  fullUrl: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  shortSlug: Scalars['String']['input'];
};

export type ShortUrlCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  fullUrl: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  shortSlug: Scalars['String']['input'];
};

export type ShortUrlMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  fullUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  shortSlug?: InputMaybe<SortOrder>;
};

export type ShortUrlMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  fullUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  shortSlug?: InputMaybe<SortOrder>;
};

export type ShortUrlOrderByWithAggregationInput = {
  _count?: InputMaybe<ShortUrlCountOrderByAggregateInput>;
  _max?: InputMaybe<ShortUrlMaxOrderByAggregateInput>;
  _min?: InputMaybe<ShortUrlMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  fullUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  shortSlug?: InputMaybe<SortOrder>;
};

export type ShortUrlOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  fullUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  shortSlug?: InputMaybe<SortOrder>;
};

export enum ShortUrlScalarFieldEnum {
  Created = 'created',
  FullUrl = 'fullUrl',
  Id = 'id',
  IsActive = 'isActive',
  Modified = 'modified',
  ShortSlug = 'shortSlug'
}

export type ShortUrlScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ShortUrlScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ShortUrlScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ShortUrlScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  fullUrl?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isActive?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  shortSlug?: InputMaybe<StringWithAggregatesFilter>;
};

export type ShortUrlUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fullUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  shortSlug?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ShortUrlUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fullUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  shortSlug?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ShortUrlWhereInput = {
  AND?: InputMaybe<Array<ShortUrlWhereInput>>;
  NOT?: InputMaybe<Array<ShortUrlWhereInput>>;
  OR?: InputMaybe<Array<ShortUrlWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  fullUrl?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  shortSlug?: InputMaybe<StringFilter>;
};

export type ShortUrlWhereUniqueInput = {
  AND?: InputMaybe<Array<ShortUrlWhereInput>>;
  NOT?: InputMaybe<Array<ShortUrlWhereInput>>;
  OR?: InputMaybe<Array<ShortUrlWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  fullUrl?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  shortSlug?: InputMaybe<Scalars['String']['input']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeEventCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActioned?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  payload?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type StripeEventCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isActioned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payload: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type StripeEventCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isActioned?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payload: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type StripeEventMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActioned?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type StripeEventMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActioned?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type StripeEventOrderByWithAggregationInput = {
  _count?: InputMaybe<StripeEventCountOrderByAggregateInput>;
  _max?: InputMaybe<StripeEventMaxOrderByAggregateInput>;
  _min?: InputMaybe<StripeEventMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActioned?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  payload?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type StripeEventOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActioned?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  payload?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum StripeEventScalarFieldEnum {
  Created = 'created',
  EventId = 'eventId',
  Id = 'id',
  IsActioned = 'isActioned',
  Modified = 'modified',
  Payload = 'payload',
  Type = 'type'
}

export type StripeEventScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<StripeEventScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<StripeEventScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<StripeEventScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isActioned?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  payload?: InputMaybe<JsonWithAggregatesFilter>;
  type?: InputMaybe<StringWithAggregatesFilter>;
};

export type StripeEventUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActioned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StripeEventUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActioned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StripeEventWhereInput = {
  AND?: InputMaybe<Array<StripeEventWhereInput>>;
  NOT?: InputMaybe<Array<StripeEventWhereInput>>;
  OR?: InputMaybe<Array<StripeEventWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isActioned?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  payload?: InputMaybe<JsonFilter>;
  type?: InputMaybe<StringFilter>;
};

export type StripeEventWhereUniqueInput = {
  AND?: InputMaybe<Array<StripeEventWhereInput>>;
  NOT?: InputMaybe<Array<StripeEventWhereInput>>;
  OR?: InputMaybe<Array<StripeEventWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActioned?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  payload?: InputMaybe<JsonFilter>;
  type?: InputMaybe<StringFilter>;
};

export type StripePaymentIntentAvgOrderByAggregateInput = {
  chargedInCents?: InputMaybe<SortOrder>;
  feesPaidInCents?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  taxPaidInCents?: InputMaybe<SortOrder>;
};

export type StripePaymentIntentCountOrderByAggregateInput = {
  chargedInCents?: InputMaybe<SortOrder>;
  clientSecret?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  feesPaidInCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  paymentIntentId?: InputMaybe<SortOrder>;
  rawResponse?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  taxPaidInCents?: InputMaybe<SortOrder>;
};

export type StripePaymentIntentCreateInput = {
  chargedInCents?: InputMaybe<Scalars['Int']['input']>;
  clientSecret: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feesPaidInCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  netInCents?: InputMaybe<Scalars['Int']['input']>;
  payment: PaymentCreateNestedOneWithoutStripePaymentIntentsInput;
  paymentIntentId: Scalars['String']['input'];
  rawResponse: Scalars['JSON']['input'];
  status?: InputMaybe<StripePaymentIntentStatus>;
  taxPaidInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type StripePaymentIntentCreateManyInput = {
  chargedInCents?: InputMaybe<Scalars['Int']['input']>;
  clientSecret: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feesPaidInCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  netInCents?: InputMaybe<Scalars['Int']['input']>;
  paymentId: Scalars['String']['input'];
  paymentIntentId: Scalars['String']['input'];
  rawResponse: Scalars['JSON']['input'];
  status?: InputMaybe<StripePaymentIntentStatus>;
  taxPaidInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type StripePaymentIntentCreateManyPaymentInput = {
  chargedInCents?: InputMaybe<Scalars['Int']['input']>;
  clientSecret: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feesPaidInCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  netInCents?: InputMaybe<Scalars['Int']['input']>;
  paymentIntentId: Scalars['String']['input'];
  rawResponse: Scalars['JSON']['input'];
  status?: InputMaybe<StripePaymentIntentStatus>;
  taxPaidInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type StripePaymentIntentCreateManyPaymentInputEnvelope = {
  data: Array<StripePaymentIntentCreateManyPaymentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripePaymentIntentCreateNestedManyWithoutPaymentInput = {
  connect?: InputMaybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripePaymentIntentCreateOrConnectWithoutPaymentInput>>;
  create?: InputMaybe<Array<StripePaymentIntentCreateWithoutPaymentInput>>;
  createMany?: InputMaybe<StripePaymentIntentCreateManyPaymentInputEnvelope>;
};

export type StripePaymentIntentCreateOrConnectWithoutPaymentInput = {
  create: StripePaymentIntentCreateWithoutPaymentInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentCreateWithoutPaymentInput = {
  chargedInCents?: InputMaybe<Scalars['Int']['input']>;
  clientSecret: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feesPaidInCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  netInCents?: InputMaybe<Scalars['Int']['input']>;
  paymentIntentId: Scalars['String']['input'];
  rawResponse: Scalars['JSON']['input'];
  status?: InputMaybe<StripePaymentIntentStatus>;
  taxPaidInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type StripePaymentIntentListRelationFilter = {
  every?: InputMaybe<StripePaymentIntentWhereInput>;
  none?: InputMaybe<StripePaymentIntentWhereInput>;
  some?: InputMaybe<StripePaymentIntentWhereInput>;
};

export type StripePaymentIntentMaxOrderByAggregateInput = {
  chargedInCents?: InputMaybe<SortOrder>;
  clientSecret?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  feesPaidInCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  paymentIntentId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  taxPaidInCents?: InputMaybe<SortOrder>;
};

export type StripePaymentIntentMinOrderByAggregateInput = {
  chargedInCents?: InputMaybe<SortOrder>;
  clientSecret?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  feesPaidInCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  paymentIntentId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  taxPaidInCents?: InputMaybe<SortOrder>;
};

export type StripePaymentIntentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StripePaymentIntentOrderByWithAggregationInput = {
  _avg?: InputMaybe<StripePaymentIntentAvgOrderByAggregateInput>;
  _count?: InputMaybe<StripePaymentIntentCountOrderByAggregateInput>;
  _max?: InputMaybe<StripePaymentIntentMaxOrderByAggregateInput>;
  _min?: InputMaybe<StripePaymentIntentMinOrderByAggregateInput>;
  _sum?: InputMaybe<StripePaymentIntentSumOrderByAggregateInput>;
  chargedInCents?: InputMaybe<SortOrderInput>;
  clientSecret?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  feesPaidInCents?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrderInput>;
  paymentId?: InputMaybe<SortOrder>;
  paymentIntentId?: InputMaybe<SortOrder>;
  rawResponse?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  taxPaidInCents?: InputMaybe<SortOrderInput>;
};

export type StripePaymentIntentOrderByWithRelationInput = {
  chargedInCents?: InputMaybe<SortOrderInput>;
  clientSecret?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  feesPaidInCents?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrderInput>;
  payment?: InputMaybe<PaymentOrderByWithRelationInput>;
  paymentId?: InputMaybe<SortOrder>;
  paymentIntentId?: InputMaybe<SortOrder>;
  rawResponse?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  taxPaidInCents?: InputMaybe<SortOrderInput>;
};

export enum StripePaymentIntentScalarFieldEnum {
  ChargedInCents = 'chargedInCents',
  ClientSecret = 'clientSecret',
  Created = 'created',
  FeesPaidInCents = 'feesPaidInCents',
  Id = 'id',
  Modified = 'modified',
  NetInCents = 'netInCents',
  PaymentId = 'paymentId',
  PaymentIntentId = 'paymentIntentId',
  RawResponse = 'rawResponse',
  Status = 'status',
  TaxPaidInCents = 'taxPaidInCents'
}

export type StripePaymentIntentScalarWhereInput = {
  AND?: InputMaybe<Array<StripePaymentIntentScalarWhereInput>>;
  NOT?: InputMaybe<Array<StripePaymentIntentScalarWhereInput>>;
  OR?: InputMaybe<Array<StripePaymentIntentScalarWhereInput>>;
  chargedInCents?: InputMaybe<IntNullableFilter>;
  clientSecret?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  feesPaidInCents?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  netInCents?: InputMaybe<IntNullableFilter>;
  paymentId?: InputMaybe<StringFilter>;
  paymentIntentId?: InputMaybe<StringFilter>;
  rawResponse?: InputMaybe<JsonFilter>;
  status?: InputMaybe<EnumStripePaymentIntentStatusFilter>;
  taxPaidInCents?: InputMaybe<IntNullableFilter>;
};

export type StripePaymentIntentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<StripePaymentIntentScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<StripePaymentIntentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<StripePaymentIntentScalarWhereWithAggregatesInput>>;
  chargedInCents?: InputMaybe<IntNullableWithAggregatesFilter>;
  clientSecret?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  feesPaidInCents?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  netInCents?: InputMaybe<IntNullableWithAggregatesFilter>;
  paymentId?: InputMaybe<StringWithAggregatesFilter>;
  paymentIntentId?: InputMaybe<StringWithAggregatesFilter>;
  rawResponse?: InputMaybe<JsonWithAggregatesFilter>;
  status?: InputMaybe<EnumStripePaymentIntentStatusWithAggregatesFilter>;
  taxPaidInCents?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export enum StripePaymentIntentStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type StripePaymentIntentSumOrderByAggregateInput = {
  chargedInCents?: InputMaybe<SortOrder>;
  feesPaidInCents?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  taxPaidInCents?: InputMaybe<SortOrder>;
};

export type StripePaymentIntentUpdateInput = {
  chargedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientSecret?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feesPaidInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  netInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneRequiredWithoutStripePaymentIntentsNestedInput>;
  paymentIntentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rawResponse?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumStripePaymentIntentStatusFieldUpdateOperationsInput>;
  taxPaidInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type StripePaymentIntentUpdateManyMutationInput = {
  chargedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientSecret?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feesPaidInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  netInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rawResponse?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumStripePaymentIntentStatusFieldUpdateOperationsInput>;
  taxPaidInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type StripePaymentIntentUpdateManyWithWhereWithoutPaymentInput = {
  data: StripePaymentIntentUpdateManyMutationInput;
  where: StripePaymentIntentScalarWhereInput;
};

export type StripePaymentIntentUpdateManyWithoutPaymentNestedInput = {
  connect?: InputMaybe<Array<StripePaymentIntentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripePaymentIntentCreateOrConnectWithoutPaymentInput>>;
  create?: InputMaybe<Array<StripePaymentIntentCreateWithoutPaymentInput>>;
  createMany?: InputMaybe<StripePaymentIntentCreateManyPaymentInputEnvelope>;
  delete?: InputMaybe<Array<StripePaymentIntentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StripePaymentIntentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StripePaymentIntentWhereUniqueInput>>;
  set?: InputMaybe<Array<StripePaymentIntentWhereUniqueInput>>;
  update?: InputMaybe<Array<StripePaymentIntentUpdateWithWhereUniqueWithoutPaymentInput>>;
  updateMany?: InputMaybe<Array<StripePaymentIntentUpdateManyWithWhereWithoutPaymentInput>>;
  upsert?: InputMaybe<Array<StripePaymentIntentUpsertWithWhereUniqueWithoutPaymentInput>>;
};

export type StripePaymentIntentUpdateWithWhereUniqueWithoutPaymentInput = {
  data: StripePaymentIntentUpdateWithoutPaymentInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentUpdateWithoutPaymentInput = {
  chargedInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  clientSecret?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feesPaidInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  netInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rawResponse?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumStripePaymentIntentStatusFieldUpdateOperationsInput>;
  taxPaidInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type StripePaymentIntentUpsertWithWhereUniqueWithoutPaymentInput = {
  create: StripePaymentIntentCreateWithoutPaymentInput;
  update: StripePaymentIntentUpdateWithoutPaymentInput;
  where: StripePaymentIntentWhereUniqueInput;
};

export type StripePaymentIntentWhereInput = {
  AND?: InputMaybe<Array<StripePaymentIntentWhereInput>>;
  NOT?: InputMaybe<Array<StripePaymentIntentWhereInput>>;
  OR?: InputMaybe<Array<StripePaymentIntentWhereInput>>;
  chargedInCents?: InputMaybe<IntNullableFilter>;
  clientSecret?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  feesPaidInCents?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  netInCents?: InputMaybe<IntNullableFilter>;
  payment?: InputMaybe<PaymentScalarRelationFilter>;
  paymentId?: InputMaybe<StringFilter>;
  paymentIntentId?: InputMaybe<StringFilter>;
  rawResponse?: InputMaybe<JsonFilter>;
  status?: InputMaybe<EnumStripePaymentIntentStatusFilter>;
  taxPaidInCents?: InputMaybe<IntNullableFilter>;
};

export type StripePaymentIntentWhereUniqueInput = {
  AND?: InputMaybe<Array<StripePaymentIntentWhereInput>>;
  NOT?: InputMaybe<Array<StripePaymentIntentWhereInput>>;
  OR?: InputMaybe<Array<StripePaymentIntentWhereInput>>;
  chargedInCents?: InputMaybe<IntNullableFilter>;
  clientSecret?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  feesPaidInCents?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  netInCents?: InputMaybe<IntNullableFilter>;
  payment?: InputMaybe<PaymentScalarRelationFilter>;
  paymentId?: InputMaybe<StringFilter>;
  paymentIntentId?: InputMaybe<StringFilter>;
  rawResponse?: InputMaybe<JsonFilter>;
  status?: InputMaybe<EnumStripePaymentIntentStatusFilter>;
  taxPaidInCents?: InputMaybe<IntNullableFilter>;
};

export type StripePayoutAvgOrderByAggregateInput = {
  adjustmentsInCents?: InputMaybe<SortOrder>;
  chargesInCents?: InputMaybe<SortOrder>;
  feesInCents?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  refundsInCents?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
};

export type StripePayoutCountOrderByAggregateInput = {
  adjustmentsInCents?: InputMaybe<SortOrder>;
  chargesInCents?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  feesInCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  payoutId?: InputMaybe<SortOrder>;
  refundsInCents?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
  traceId?: InputMaybe<SortOrder>;
  xeroSupplierInvoiceNo?: InputMaybe<SortOrder>;
};

export type StripePayoutCreateInput = {
  adjustmentsInCents: Scalars['Int']['input'];
  chargesInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feesInCents: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  netInCents: Scalars['Int']['input'];
  payments?: InputMaybe<PaymentCreateNestedManyWithoutStripePayoutInput>;
  payoutId: Scalars['String']['input'];
  refunds?: InputMaybe<RefundCreateNestedManyWithoutStripePayoutInput>;
  refundsInCents: Scalars['Int']['input'];
  taxInCents: Scalars['Int']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
  xeroSupplierInvoiceNo?: InputMaybe<Scalars['String']['input']>;
};

export type StripePayoutCreateManyInput = {
  adjustmentsInCents: Scalars['Int']['input'];
  chargesInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feesInCents: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  netInCents: Scalars['Int']['input'];
  payoutId: Scalars['String']['input'];
  refundsInCents: Scalars['Int']['input'];
  taxInCents: Scalars['Int']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
  xeroSupplierInvoiceNo?: InputMaybe<Scalars['String']['input']>;
};

export type StripePayoutCreateNestedOneWithoutPaymentsInput = {
  connect?: InputMaybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StripePayoutCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<StripePayoutCreateWithoutPaymentsInput>;
};

export type StripePayoutCreateNestedOneWithoutRefundsInput = {
  connect?: InputMaybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StripePayoutCreateOrConnectWithoutRefundsInput>;
  create?: InputMaybe<StripePayoutCreateWithoutRefundsInput>;
};

export type StripePayoutCreateOrConnectWithoutPaymentsInput = {
  create: StripePayoutCreateWithoutPaymentsInput;
  where: StripePayoutWhereUniqueInput;
};

export type StripePayoutCreateOrConnectWithoutRefundsInput = {
  create: StripePayoutCreateWithoutRefundsInput;
  where: StripePayoutWhereUniqueInput;
};

export type StripePayoutCreateWithoutPaymentsInput = {
  adjustmentsInCents: Scalars['Int']['input'];
  chargesInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feesInCents: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  netInCents: Scalars['Int']['input'];
  payoutId: Scalars['String']['input'];
  refunds?: InputMaybe<RefundCreateNestedManyWithoutStripePayoutInput>;
  refundsInCents: Scalars['Int']['input'];
  taxInCents: Scalars['Int']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
  xeroSupplierInvoiceNo?: InputMaybe<Scalars['String']['input']>;
};

export type StripePayoutCreateWithoutRefundsInput = {
  adjustmentsInCents: Scalars['Int']['input'];
  chargesInCents: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feesInCents: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  netInCents: Scalars['Int']['input'];
  payments?: InputMaybe<PaymentCreateNestedManyWithoutStripePayoutInput>;
  payoutId: Scalars['String']['input'];
  refundsInCents: Scalars['Int']['input'];
  taxInCents: Scalars['Int']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
  xeroSupplierInvoiceNo?: InputMaybe<Scalars['String']['input']>;
};

export type StripePayoutMaxOrderByAggregateInput = {
  adjustmentsInCents?: InputMaybe<SortOrder>;
  chargesInCents?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  feesInCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  payoutId?: InputMaybe<SortOrder>;
  refundsInCents?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
  traceId?: InputMaybe<SortOrder>;
  xeroSupplierInvoiceNo?: InputMaybe<SortOrder>;
};

export type StripePayoutMinOrderByAggregateInput = {
  adjustmentsInCents?: InputMaybe<SortOrder>;
  chargesInCents?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  feesInCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  payoutId?: InputMaybe<SortOrder>;
  refundsInCents?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
  traceId?: InputMaybe<SortOrder>;
  xeroSupplierInvoiceNo?: InputMaybe<SortOrder>;
};

export type StripePayoutNullableScalarRelationFilter = {
  is?: InputMaybe<StripePayoutWhereInput>;
  isNot?: InputMaybe<StripePayoutWhereInput>;
};

export type StripePayoutOrderByWithAggregationInput = {
  _avg?: InputMaybe<StripePayoutAvgOrderByAggregateInput>;
  _count?: InputMaybe<StripePayoutCountOrderByAggregateInput>;
  _max?: InputMaybe<StripePayoutMaxOrderByAggregateInput>;
  _min?: InputMaybe<StripePayoutMinOrderByAggregateInput>;
  _sum?: InputMaybe<StripePayoutSumOrderByAggregateInput>;
  adjustmentsInCents?: InputMaybe<SortOrder>;
  chargesInCents?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  feesInCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  payoutId?: InputMaybe<SortOrder>;
  refundsInCents?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
  traceId?: InputMaybe<SortOrderInput>;
  xeroSupplierInvoiceNo?: InputMaybe<SortOrderInput>;
};

export type StripePayoutOrderByWithRelationInput = {
  adjustmentsInCents?: InputMaybe<SortOrder>;
  chargesInCents?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  feesInCents?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  payments?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  payoutId?: InputMaybe<SortOrder>;
  refunds?: InputMaybe<RefundOrderByRelationAggregateInput>;
  refundsInCents?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
  traceId?: InputMaybe<SortOrderInput>;
  xeroSupplierInvoiceNo?: InputMaybe<SortOrderInput>;
};

export enum StripePayoutScalarFieldEnum {
  AdjustmentsInCents = 'adjustmentsInCents',
  ChargesInCents = 'chargesInCents',
  Created = 'created',
  FeesInCents = 'feesInCents',
  Id = 'id',
  Modified = 'modified',
  NetInCents = 'netInCents',
  PayoutId = 'payoutId',
  RefundsInCents = 'refundsInCents',
  TaxInCents = 'taxInCents',
  TraceId = 'traceId',
  XeroSupplierInvoiceNo = 'xeroSupplierInvoiceNo'
}

export type StripePayoutScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<StripePayoutScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<StripePayoutScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<StripePayoutScalarWhereWithAggregatesInput>>;
  adjustmentsInCents?: InputMaybe<IntWithAggregatesFilter>;
  chargesInCents?: InputMaybe<IntWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  feesInCents?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  netInCents?: InputMaybe<IntWithAggregatesFilter>;
  payoutId?: InputMaybe<StringWithAggregatesFilter>;
  refundsInCents?: InputMaybe<IntWithAggregatesFilter>;
  taxInCents?: InputMaybe<IntWithAggregatesFilter>;
  traceId?: InputMaybe<StringNullableWithAggregatesFilter>;
  xeroSupplierInvoiceNo?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type StripePayoutSumOrderByAggregateInput = {
  adjustmentsInCents?: InputMaybe<SortOrder>;
  chargesInCents?: InputMaybe<SortOrder>;
  feesInCents?: InputMaybe<SortOrder>;
  netInCents?: InputMaybe<SortOrder>;
  refundsInCents?: InputMaybe<SortOrder>;
  taxInCents?: InputMaybe<SortOrder>;
};

export type StripePayoutUpdateInput = {
  adjustmentsInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  chargesInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feesInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  netInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutStripePayoutNestedInput>;
  payoutId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutStripePayoutNestedInput>;
  refundsInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  traceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  xeroSupplierInvoiceNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type StripePayoutUpdateManyMutationInput = {
  adjustmentsInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  chargesInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feesInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  netInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  payoutId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refundsInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  traceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  xeroSupplierInvoiceNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type StripePayoutUpdateOneWithoutPaymentsNestedInput = {
  connect?: InputMaybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StripePayoutCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<StripePayoutCreateWithoutPaymentsInput>;
  delete?: InputMaybe<StripePayoutWhereInput>;
  disconnect?: InputMaybe<StripePayoutWhereInput>;
  update?: InputMaybe<StripePayoutUpdateToOneWithWhereWithoutPaymentsInput>;
  upsert?: InputMaybe<StripePayoutUpsertWithoutPaymentsInput>;
};

export type StripePayoutUpdateOneWithoutRefundsNestedInput = {
  connect?: InputMaybe<StripePayoutWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StripePayoutCreateOrConnectWithoutRefundsInput>;
  create?: InputMaybe<StripePayoutCreateWithoutRefundsInput>;
  delete?: InputMaybe<StripePayoutWhereInput>;
  disconnect?: InputMaybe<StripePayoutWhereInput>;
  update?: InputMaybe<StripePayoutUpdateToOneWithWhereWithoutRefundsInput>;
  upsert?: InputMaybe<StripePayoutUpsertWithoutRefundsInput>;
};

export type StripePayoutUpdateToOneWithWhereWithoutPaymentsInput = {
  data: StripePayoutUpdateWithoutPaymentsInput;
  where?: InputMaybe<StripePayoutWhereInput>;
};

export type StripePayoutUpdateToOneWithWhereWithoutRefundsInput = {
  data: StripePayoutUpdateWithoutRefundsInput;
  where?: InputMaybe<StripePayoutWhereInput>;
};

export type StripePayoutUpdateWithoutPaymentsInput = {
  adjustmentsInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  chargesInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feesInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  netInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  payoutId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutStripePayoutNestedInput>;
  refundsInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  traceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  xeroSupplierInvoiceNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type StripePayoutUpdateWithoutRefundsInput = {
  adjustmentsInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  chargesInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  feesInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  netInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutStripePayoutNestedInput>;
  payoutId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refundsInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  taxInCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  traceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  xeroSupplierInvoiceNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type StripePayoutUpsertWithoutPaymentsInput = {
  create: StripePayoutCreateWithoutPaymentsInput;
  update: StripePayoutUpdateWithoutPaymentsInput;
  where?: InputMaybe<StripePayoutWhereInput>;
};

export type StripePayoutUpsertWithoutRefundsInput = {
  create: StripePayoutCreateWithoutRefundsInput;
  update: StripePayoutUpdateWithoutRefundsInput;
  where?: InputMaybe<StripePayoutWhereInput>;
};

export type StripePayoutWhereInput = {
  AND?: InputMaybe<Array<StripePayoutWhereInput>>;
  NOT?: InputMaybe<Array<StripePayoutWhereInput>>;
  OR?: InputMaybe<Array<StripePayoutWhereInput>>;
  adjustmentsInCents?: InputMaybe<IntFilter>;
  chargesInCents?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeFilter>;
  feesInCents?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  netInCents?: InputMaybe<IntFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  payoutId?: InputMaybe<StringFilter>;
  refunds?: InputMaybe<RefundListRelationFilter>;
  refundsInCents?: InputMaybe<IntFilter>;
  taxInCents?: InputMaybe<IntFilter>;
  traceId?: InputMaybe<StringNullableFilter>;
  xeroSupplierInvoiceNo?: InputMaybe<StringNullableFilter>;
};

export type StripePayoutWhereUniqueInput = {
  AND?: InputMaybe<Array<StripePayoutWhereInput>>;
  NOT?: InputMaybe<Array<StripePayoutWhereInput>>;
  OR?: InputMaybe<Array<StripePayoutWhereInput>>;
  adjustmentsInCents?: InputMaybe<IntFilter>;
  chargesInCents?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeFilter>;
  feesInCents?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  netInCents?: InputMaybe<IntFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  payoutId?: InputMaybe<StringFilter>;
  refunds?: InputMaybe<RefundListRelationFilter>;
  refundsInCents?: InputMaybe<IntFilter>;
  taxInCents?: InputMaybe<IntFilter>;
  traceId?: InputMaybe<StringNullableFilter>;
  xeroSupplierInvoiceNo?: InputMaybe<StringNullableFilter>;
};

export type TagCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type TagCreateInput = {
  articleTags?: InputMaybe<ArticleTagCreateNestedManyWithoutTagInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  programmeTags?: InputMaybe<ProgrammeTagCreateNestedManyWithoutTagInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutTagInput>;
};

export type TagCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
};

export type TagCreateNestedOneWithoutArticleTagsInput = {
  connect?: InputMaybe<TagWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagCreateOrConnectWithoutArticleTagsInput>;
  create?: InputMaybe<TagCreateWithoutArticleTagsInput>;
};

export type TagCreateNestedOneWithoutProgrammeTagsInput = {
  connect?: InputMaybe<TagWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagCreateOrConnectWithoutProgrammeTagsInput>;
  create?: InputMaybe<TagCreateWithoutProgrammeTagsInput>;
};

export type TagCreateNestedOneWithoutUserTagsInput = {
  connect?: InputMaybe<TagWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagCreateOrConnectWithoutUserTagsInput>;
  create?: InputMaybe<TagCreateWithoutUserTagsInput>;
};

export type TagCreateOrConnectWithoutArticleTagsInput = {
  create: TagCreateWithoutArticleTagsInput;
  where: TagWhereUniqueInput;
};

export type TagCreateOrConnectWithoutProgrammeTagsInput = {
  create: TagCreateWithoutProgrammeTagsInput;
  where: TagWhereUniqueInput;
};

export type TagCreateOrConnectWithoutUserTagsInput = {
  create: TagCreateWithoutUserTagsInput;
  where: TagWhereUniqueInput;
};

export type TagCreateWithoutArticleTagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  programmeTags?: InputMaybe<ProgrammeTagCreateNestedManyWithoutTagInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutTagInput>;
};

export type TagCreateWithoutProgrammeTagsInput = {
  articleTags?: InputMaybe<ArticleTagCreateNestedManyWithoutTagInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutTagInput>;
};

export type TagCreateWithoutUserTagsInput = {
  articleTags?: InputMaybe<ArticleTagCreateNestedManyWithoutTagInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  programmeTags?: InputMaybe<ProgrammeTagCreateNestedManyWithoutTagInput>;
};

export type TagMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type TagMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type TagOrderByWithAggregationInput = {
  _count?: InputMaybe<TagCountOrderByAggregateInput>;
  _max?: InputMaybe<TagMaxOrderByAggregateInput>;
  _min?: InputMaybe<TagMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type TagOrderByWithRelationInput = {
  articleTags?: InputMaybe<ArticleTagOrderByRelationAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  programmeTags?: InputMaybe<ProgrammeTagOrderByRelationAggregateInput>;
  userTags?: InputMaybe<UserTagsOrderByRelationAggregateInput>;
};

export enum TagScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  Name = 'name'
}

export type TagScalarRelationFilter = {
  is?: InputMaybe<TagWhereInput>;
  isNot?: InputMaybe<TagWhereInput>;
};

export type TagScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TagScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TagScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TagScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
};

export type TagUpdateInput = {
  articleTags?: InputMaybe<ArticleTagUpdateManyWithoutTagNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  programmeTags?: InputMaybe<ProgrammeTagUpdateManyWithoutTagNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutTagNestedInput>;
};

export type TagUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TagUpdateOneRequiredWithoutArticleTagsNestedInput = {
  connect?: InputMaybe<TagWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagCreateOrConnectWithoutArticleTagsInput>;
  create?: InputMaybe<TagCreateWithoutArticleTagsInput>;
  update?: InputMaybe<TagUpdateToOneWithWhereWithoutArticleTagsInput>;
  upsert?: InputMaybe<TagUpsertWithoutArticleTagsInput>;
};

export type TagUpdateOneRequiredWithoutProgrammeTagsNestedInput = {
  connect?: InputMaybe<TagWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagCreateOrConnectWithoutProgrammeTagsInput>;
  create?: InputMaybe<TagCreateWithoutProgrammeTagsInput>;
  update?: InputMaybe<TagUpdateToOneWithWhereWithoutProgrammeTagsInput>;
  upsert?: InputMaybe<TagUpsertWithoutProgrammeTagsInput>;
};

export type TagUpdateOneRequiredWithoutUserTagsNestedInput = {
  connect?: InputMaybe<TagWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagCreateOrConnectWithoutUserTagsInput>;
  create?: InputMaybe<TagCreateWithoutUserTagsInput>;
  update?: InputMaybe<TagUpdateToOneWithWhereWithoutUserTagsInput>;
  upsert?: InputMaybe<TagUpsertWithoutUserTagsInput>;
};

export type TagUpdateToOneWithWhereWithoutArticleTagsInput = {
  data: TagUpdateWithoutArticleTagsInput;
  where?: InputMaybe<TagWhereInput>;
};

export type TagUpdateToOneWithWhereWithoutProgrammeTagsInput = {
  data: TagUpdateWithoutProgrammeTagsInput;
  where?: InputMaybe<TagWhereInput>;
};

export type TagUpdateToOneWithWhereWithoutUserTagsInput = {
  data: TagUpdateWithoutUserTagsInput;
  where?: InputMaybe<TagWhereInput>;
};

export type TagUpdateWithoutArticleTagsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  programmeTags?: InputMaybe<ProgrammeTagUpdateManyWithoutTagNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutTagNestedInput>;
};

export type TagUpdateWithoutProgrammeTagsInput = {
  articleTags?: InputMaybe<ArticleTagUpdateManyWithoutTagNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutTagNestedInput>;
};

export type TagUpdateWithoutUserTagsInput = {
  articleTags?: InputMaybe<ArticleTagUpdateManyWithoutTagNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  programmeTags?: InputMaybe<ProgrammeTagUpdateManyWithoutTagNestedInput>;
};

export type TagUpsertWithoutArticleTagsInput = {
  create: TagCreateWithoutArticleTagsInput;
  update: TagUpdateWithoutArticleTagsInput;
  where?: InputMaybe<TagWhereInput>;
};

export type TagUpsertWithoutProgrammeTagsInput = {
  create: TagCreateWithoutProgrammeTagsInput;
  update: TagUpdateWithoutProgrammeTagsInput;
  where?: InputMaybe<TagWhereInput>;
};

export type TagUpsertWithoutUserTagsInput = {
  create: TagCreateWithoutUserTagsInput;
  update: TagUpdateWithoutUserTagsInput;
  where?: InputMaybe<TagWhereInput>;
};

export type TagWhereInput = {
  AND?: InputMaybe<Array<TagWhereInput>>;
  NOT?: InputMaybe<Array<TagWhereInput>>;
  OR?: InputMaybe<Array<TagWhereInput>>;
  articleTags?: InputMaybe<ArticleTagListRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  programmeTags?: InputMaybe<ProgrammeTagListRelationFilter>;
  userTags?: InputMaybe<UserTagsListRelationFilter>;
};

export type TagWhereUniqueInput = {
  AND?: InputMaybe<Array<TagWhereInput>>;
  NOT?: InputMaybe<Array<TagWhereInput>>;
  OR?: InputMaybe<Array<TagWhereInput>>;
  articleTags?: InputMaybe<ArticleTagListRelationFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  programmeTags?: InputMaybe<ProgrammeTagListRelationFilter>;
  userTags?: InputMaybe<UserTagsListRelationFilter>;
};

export type TemplateCountOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  emailPreviewText?: InputMaybe<SortOrder>;
  emailSubject?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type TemplateCreateInput = {
  content: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  emailPreviewText?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  product?: InputMaybe<ProductCreateNestedOneWithoutTemplatesInput>;
  type: TemplateType;
};

export type TemplateCreateManyInput = {
  content: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  emailPreviewText?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  type: TemplateType;
};

export type TemplateCreateManyProductInput = {
  content: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  emailPreviewText?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  type: TemplateType;
};

export type TemplateCreateManyProductInputEnvelope = {
  data: Array<TemplateCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<TemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<TemplateCreateWithoutProductInput>>;
  createMany?: InputMaybe<TemplateCreateManyProductInputEnvelope>;
};

export type TemplateCreateOrConnectWithoutProductInput = {
  create: TemplateCreateWithoutProductInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateWithoutProductInput = {
  content: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  emailPreviewText?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  type: TemplateType;
};

export type TemplateListRelationFilter = {
  every?: InputMaybe<TemplateWhereInput>;
  none?: InputMaybe<TemplateWhereInput>;
  some?: InputMaybe<TemplateWhereInput>;
};

export type TemplateMaxOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  emailPreviewText?: InputMaybe<SortOrder>;
  emailSubject?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type TemplateMinOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  emailPreviewText?: InputMaybe<SortOrder>;
  emailSubject?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type TemplateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TemplateOrderByWithAggregationInput = {
  _count?: InputMaybe<TemplateCountOrderByAggregateInput>;
  _max?: InputMaybe<TemplateMaxOrderByAggregateInput>;
  _min?: InputMaybe<TemplateMinOrderByAggregateInput>;
  content?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  emailPreviewText?: InputMaybe<SortOrderInput>;
  emailSubject?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
};

export type TemplateOrderByWithRelationInput = {
  content?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  emailPreviewText?: InputMaybe<SortOrderInput>;
  emailSubject?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
};

export enum TemplateScalarFieldEnum {
  Content = 'content',
  Created = 'created',
  EmailPreviewText = 'emailPreviewText',
  EmailSubject = 'emailSubject',
  Id = 'id',
  Modified = 'modified',
  ProductId = 'productId',
  Type = 'type'
}

export type TemplateScalarWhereInput = {
  AND?: InputMaybe<Array<TemplateScalarWhereInput>>;
  NOT?: InputMaybe<Array<TemplateScalarWhereInput>>;
  OR?: InputMaybe<Array<TemplateScalarWhereInput>>;
  content?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  emailPreviewText?: InputMaybe<StringNullableFilter>;
  emailSubject?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTemplateTypeFilter>;
};

export type TemplateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TemplateScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TemplateScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TemplateScalarWhereWithAggregatesInput>>;
  content?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  emailPreviewText?: InputMaybe<StringNullableWithAggregatesFilter>;
  emailSubject?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  productId?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumTemplateTypeWithAggregatesFilter>;
};

export enum TemplateType {
  ContactForm = 'CONTACT_FORM',
  EventRegistrationCancelledEmail = 'EVENT_REGISTRATION_CANCELLED_EMAIL',
  EventRegistrationConfirmationEmail = 'EVENT_REGISTRATION_CONFIRMATION_EMAIL',
  InvoiceEmail = 'INVOICE_EMAIL',
  InvoicePdf = 'INVOICE_PDF',
  NdcAccreditationCertificatePdf = 'NDC_ACCREDITATION_CERTIFICATE_PDF',
  NdcAccreditationLicencePdf = 'NDC_ACCREDITATION_LICENCE_PDF',
  NdcFellowshipCertificatePdf = 'NDC_FELLOWSHIP_CERTIFICATE_PDF',
  NdcProvidersEducatorsCertificatePdf = 'NDC_PROVIDERS_EDUCATORS_CERTIFICATE_PDF',
  NdcProvidersEducatorsLicencePdf = 'NDC_PROVIDERS_EDUCATORS_LICENCE_PDF',
  SubscriptionCancelledEmail = 'SUBSCRIPTION_CANCELLED_EMAIL',
  SubscriptionExpiredEmail = 'SUBSCRIPTION_EXPIRED_EMAIL',
  SubscriptionExpiringSoonEmail = 'SUBSCRIPTION_EXPIRING_SOON_EMAIL',
  SubscriptionExpiringTomorrowEmail = 'SUBSCRIPTION_EXPIRING_TOMORROW_EMAIL',
  SubscriptionRenewalFailedEmail = 'SUBSCRIPTION_RENEWAL_FAILED_EMAIL',
  SubscriptionRenewedEmail = 'SUBSCRIPTION_RENEWED_EMAIL',
  SubscriptionRenewingSoonEmail = 'SUBSCRIPTION_RENEWING_SOON_EMAIL',
  SubscriptionRenewingTomorrowEmail = 'SUBSCRIPTION_RENEWING_TOMORROW_EMAIL',
  UserRequestReset = 'USER_REQUEST_RESET',
  WelcomeEmail = 'WELCOME_EMAIL'
}

export type TemplateUpdateInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailPreviewText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSubject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutTemplatesNestedInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
};

export type TemplateUpdateManyMutationInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailPreviewText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSubject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
};

export type TemplateUpdateManyWithWhereWithoutProductInput = {
  data: TemplateUpdateManyMutationInput;
  where: TemplateScalarWhereInput;
};

export type TemplateUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<TemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<TemplateCreateWithoutProductInput>>;
  createMany?: InputMaybe<TemplateCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<TemplateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TemplateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TemplateWhereUniqueInput>>;
  set?: InputMaybe<Array<TemplateWhereUniqueInput>>;
  update?: InputMaybe<Array<TemplateUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<TemplateUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<TemplateUpsertWithWhereUniqueWithoutProductInput>>;
};

export type TemplateUpdateWithWhereUniqueWithoutProductInput = {
  data: TemplateUpdateWithoutProductInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateUpdateWithoutProductInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailPreviewText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSubject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
};

export type TemplateUpsertWithWhereUniqueWithoutProductInput = {
  create: TemplateCreateWithoutProductInput;
  update: TemplateUpdateWithoutProductInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateWhereInput = {
  AND?: InputMaybe<Array<TemplateWhereInput>>;
  NOT?: InputMaybe<Array<TemplateWhereInput>>;
  OR?: InputMaybe<Array<TemplateWhereInput>>;
  content?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  emailPreviewText?: InputMaybe<StringNullableFilter>;
  emailSubject?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  product?: InputMaybe<ProductNullableScalarRelationFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTemplateTypeFilter>;
};

export type TemplateWhereUniqueInput = {
  AND?: InputMaybe<Array<TemplateWhereInput>>;
  NOT?: InputMaybe<Array<TemplateWhereInput>>;
  OR?: InputMaybe<Array<TemplateWhereInput>>;
  content?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  emailPreviewText?: InputMaybe<StringNullableFilter>;
  emailSubject?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  product?: InputMaybe<ProductNullableScalarRelationFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTemplateTypeFilter>;
};

/** Controls the dates the new subscription gets when an upgrade path is taken. */
export enum UpgradeDurationMode {
  Convert = 'CONVERT',
  Refresh = 'REFRESH'
}

export type UpgradePathDiscountAvgOrderByAggregateInput = {
  daysAfterPurchaseMax?: InputMaybe<SortOrder>;
  daysAfterPurchaseMin?: InputMaybe<SortOrder>;
  discountAmountInCents?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountCountOrderByAggregateInput = {
  applyCreditForExistingPurchase?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  creditAllPriorPayments?: InputMaybe<SortOrder>;
  daysAfterPurchaseMax?: InputMaybe<SortOrder>;
  daysAfterPurchaseMin?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discountAmountInCents?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
  fromProductSubscriptionTypeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  upgradeDurationMode?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountCreateInput = {
  applyCreditForExistingPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  creditAllPriorPayments?: InputMaybe<Scalars['Boolean']['input']>;
  daysAfterPurchaseMax?: InputMaybe<Scalars['Int']['input']>;
  daysAfterPurchaseMin?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  fromProductSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUpgradePathsFromInput;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUpgradePathDiscountInput>;
  targetProducts?: InputMaybe<UpgradePathDiscountTargetProductCreateNestedManyWithoutUpgradePathDiscountInput>;
  upgradeDurationMode?: InputMaybe<UpgradeDurationMode>;
  upgradePrompts?: InputMaybe<UpgradePromptCreateNestedManyWithoutUpgradePathDiscountInput>;
};

export type UpgradePathDiscountCreateManyFromProductSubscriptionTypeInput = {
  applyCreditForExistingPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  creditAllPriorPayments?: InputMaybe<Scalars['Boolean']['input']>;
  daysAfterPurchaseMax?: InputMaybe<Scalars['Int']['input']>;
  daysAfterPurchaseMin?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  upgradeDurationMode?: InputMaybe<UpgradeDurationMode>;
};

export type UpgradePathDiscountCreateManyFromProductSubscriptionTypeInputEnvelope = {
  data: Array<UpgradePathDiscountCreateManyFromProductSubscriptionTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpgradePathDiscountCreateManyInput = {
  applyCreditForExistingPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  creditAllPriorPayments?: InputMaybe<Scalars['Boolean']['input']>;
  daysAfterPurchaseMax?: InputMaybe<Scalars['Int']['input']>;
  daysAfterPurchaseMin?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  fromProductSubscriptionTypeId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  upgradeDurationMode?: InputMaybe<UpgradeDurationMode>;
};

export type UpgradePathDiscountCreateNestedManyWithoutFromProductSubscriptionTypeInput = {
  connect?: InputMaybe<Array<UpgradePathDiscountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePathDiscountCreateOrConnectWithoutFromProductSubscriptionTypeInput>>;
  create?: InputMaybe<Array<UpgradePathDiscountCreateWithoutFromProductSubscriptionTypeInput>>;
  createMany?: InputMaybe<UpgradePathDiscountCreateManyFromProductSubscriptionTypeInputEnvelope>;
};

export type UpgradePathDiscountCreateNestedOneWithoutPaymentsInput = {
  connect?: InputMaybe<UpgradePathDiscountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UpgradePathDiscountCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<UpgradePathDiscountCreateWithoutPaymentsInput>;
};

export type UpgradePathDiscountCreateNestedOneWithoutTargetProductsInput = {
  connect?: InputMaybe<UpgradePathDiscountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UpgradePathDiscountCreateOrConnectWithoutTargetProductsInput>;
  create?: InputMaybe<UpgradePathDiscountCreateWithoutTargetProductsInput>;
};

export type UpgradePathDiscountCreateNestedOneWithoutUpgradePromptsInput = {
  connect?: InputMaybe<UpgradePathDiscountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UpgradePathDiscountCreateOrConnectWithoutUpgradePromptsInput>;
  create?: InputMaybe<UpgradePathDiscountCreateWithoutUpgradePromptsInput>;
};

export type UpgradePathDiscountCreateOrConnectWithoutFromProductSubscriptionTypeInput = {
  create: UpgradePathDiscountCreateWithoutFromProductSubscriptionTypeInput;
  where: UpgradePathDiscountWhereUniqueInput;
};

export type UpgradePathDiscountCreateOrConnectWithoutPaymentsInput = {
  create: UpgradePathDiscountCreateWithoutPaymentsInput;
  where: UpgradePathDiscountWhereUniqueInput;
};

export type UpgradePathDiscountCreateOrConnectWithoutTargetProductsInput = {
  create: UpgradePathDiscountCreateWithoutTargetProductsInput;
  where: UpgradePathDiscountWhereUniqueInput;
};

export type UpgradePathDiscountCreateOrConnectWithoutUpgradePromptsInput = {
  create: UpgradePathDiscountCreateWithoutUpgradePromptsInput;
  where: UpgradePathDiscountWhereUniqueInput;
};

export type UpgradePathDiscountCreateWithoutFromProductSubscriptionTypeInput = {
  applyCreditForExistingPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  creditAllPriorPayments?: InputMaybe<Scalars['Boolean']['input']>;
  daysAfterPurchaseMax?: InputMaybe<Scalars['Int']['input']>;
  daysAfterPurchaseMin?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUpgradePathDiscountInput>;
  targetProducts?: InputMaybe<UpgradePathDiscountTargetProductCreateNestedManyWithoutUpgradePathDiscountInput>;
  upgradeDurationMode?: InputMaybe<UpgradeDurationMode>;
  upgradePrompts?: InputMaybe<UpgradePromptCreateNestedManyWithoutUpgradePathDiscountInput>;
};

export type UpgradePathDiscountCreateWithoutPaymentsInput = {
  applyCreditForExistingPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  creditAllPriorPayments?: InputMaybe<Scalars['Boolean']['input']>;
  daysAfterPurchaseMax?: InputMaybe<Scalars['Int']['input']>;
  daysAfterPurchaseMin?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  fromProductSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUpgradePathsFromInput;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  targetProducts?: InputMaybe<UpgradePathDiscountTargetProductCreateNestedManyWithoutUpgradePathDiscountInput>;
  upgradeDurationMode?: InputMaybe<UpgradeDurationMode>;
  upgradePrompts?: InputMaybe<UpgradePromptCreateNestedManyWithoutUpgradePathDiscountInput>;
};

export type UpgradePathDiscountCreateWithoutTargetProductsInput = {
  applyCreditForExistingPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  creditAllPriorPayments?: InputMaybe<Scalars['Boolean']['input']>;
  daysAfterPurchaseMax?: InputMaybe<Scalars['Int']['input']>;
  daysAfterPurchaseMin?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  fromProductSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUpgradePathsFromInput;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUpgradePathDiscountInput>;
  upgradeDurationMode?: InputMaybe<UpgradeDurationMode>;
  upgradePrompts?: InputMaybe<UpgradePromptCreateNestedManyWithoutUpgradePathDiscountInput>;
};

export type UpgradePathDiscountCreateWithoutUpgradePromptsInput = {
  applyCreditForExistingPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  creditAllPriorPayments?: InputMaybe<Scalars['Boolean']['input']>;
  daysAfterPurchaseMax?: InputMaybe<Scalars['Int']['input']>;
  daysAfterPurchaseMin?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  fromProductSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUpgradePathsFromInput;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUpgradePathDiscountInput>;
  targetProducts?: InputMaybe<UpgradePathDiscountTargetProductCreateNestedManyWithoutUpgradePathDiscountInput>;
  upgradeDurationMode?: InputMaybe<UpgradeDurationMode>;
};

export type UpgradePathDiscountListRelationFilter = {
  every?: InputMaybe<UpgradePathDiscountWhereInput>;
  none?: InputMaybe<UpgradePathDiscountWhereInput>;
  some?: InputMaybe<UpgradePathDiscountWhereInput>;
};

export type UpgradePathDiscountMaxOrderByAggregateInput = {
  applyCreditForExistingPurchase?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  creditAllPriorPayments?: InputMaybe<SortOrder>;
  daysAfterPurchaseMax?: InputMaybe<SortOrder>;
  daysAfterPurchaseMin?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discountAmountInCents?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
  fromProductSubscriptionTypeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  upgradeDurationMode?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountMinOrderByAggregateInput = {
  applyCreditForExistingPurchase?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  creditAllPriorPayments?: InputMaybe<SortOrder>;
  daysAfterPurchaseMax?: InputMaybe<SortOrder>;
  daysAfterPurchaseMin?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discountAmountInCents?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
  fromProductSubscriptionTypeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  upgradeDurationMode?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountNullableScalarRelationFilter = {
  is?: InputMaybe<UpgradePathDiscountWhereInput>;
  isNot?: InputMaybe<UpgradePathDiscountWhereInput>;
};

export type UpgradePathDiscountOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountOrderByWithAggregationInput = {
  _avg?: InputMaybe<UpgradePathDiscountAvgOrderByAggregateInput>;
  _count?: InputMaybe<UpgradePathDiscountCountOrderByAggregateInput>;
  _max?: InputMaybe<UpgradePathDiscountMaxOrderByAggregateInput>;
  _min?: InputMaybe<UpgradePathDiscountMinOrderByAggregateInput>;
  _sum?: InputMaybe<UpgradePathDiscountSumOrderByAggregateInput>;
  applyCreditForExistingPurchase?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  creditAllPriorPayments?: InputMaybe<SortOrder>;
  daysAfterPurchaseMax?: InputMaybe<SortOrderInput>;
  daysAfterPurchaseMin?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  discountAmountInCents?: InputMaybe<SortOrderInput>;
  discountPercentage?: InputMaybe<SortOrderInput>;
  fromProductSubscriptionTypeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  upgradeDurationMode?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountOrderByWithRelationInput = {
  applyCreditForExistingPurchase?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  creditAllPriorPayments?: InputMaybe<SortOrder>;
  daysAfterPurchaseMax?: InputMaybe<SortOrderInput>;
  daysAfterPurchaseMin?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  discountAmountInCents?: InputMaybe<SortOrderInput>;
  discountPercentage?: InputMaybe<SortOrderInput>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeOrderByWithRelationInput>;
  fromProductSubscriptionTypeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  payments?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  targetProducts?: InputMaybe<UpgradePathDiscountTargetProductOrderByRelationAggregateInput>;
  upgradeDurationMode?: InputMaybe<SortOrder>;
  upgradePrompts?: InputMaybe<UpgradePromptOrderByRelationAggregateInput>;
};

export enum UpgradePathDiscountScalarFieldEnum {
  ApplyCreditForExistingPurchase = 'applyCreditForExistingPurchase',
  Created = 'created',
  CreditAllPriorPayments = 'creditAllPriorPayments',
  DaysAfterPurchaseMax = 'daysAfterPurchaseMax',
  DaysAfterPurchaseMin = 'daysAfterPurchaseMin',
  Description = 'description',
  DiscountAmountInCents = 'discountAmountInCents',
  DiscountPercentage = 'discountPercentage',
  FromProductSubscriptionTypeId = 'fromProductSubscriptionTypeId',
  Id = 'id',
  IsActive = 'isActive',
  Modified = 'modified',
  Name = 'name',
  UpgradeDurationMode = 'upgradeDurationMode'
}

export type UpgradePathDiscountScalarRelationFilter = {
  is?: InputMaybe<UpgradePathDiscountWhereInput>;
  isNot?: InputMaybe<UpgradePathDiscountWhereInput>;
};

export type UpgradePathDiscountScalarWhereInput = {
  AND?: InputMaybe<Array<UpgradePathDiscountScalarWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePathDiscountScalarWhereInput>>;
  OR?: InputMaybe<Array<UpgradePathDiscountScalarWhereInput>>;
  applyCreditForExistingPurchase?: InputMaybe<BoolFilter>;
  created?: InputMaybe<DateTimeFilter>;
  creditAllPriorPayments?: InputMaybe<BoolFilter>;
  daysAfterPurchaseMax?: InputMaybe<IntNullableFilter>;
  daysAfterPurchaseMin?: InputMaybe<IntNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discountAmountInCents?: InputMaybe<IntNullableFilter>;
  discountPercentage?: InputMaybe<FloatNullableFilter>;
  fromProductSubscriptionTypeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  upgradeDurationMode?: InputMaybe<EnumUpgradeDurationModeFilter>;
};

export type UpgradePathDiscountScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UpgradePathDiscountScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UpgradePathDiscountScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UpgradePathDiscountScalarWhereWithAggregatesInput>>;
  applyCreditForExistingPurchase?: InputMaybe<BoolWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  creditAllPriorPayments?: InputMaybe<BoolWithAggregatesFilter>;
  daysAfterPurchaseMax?: InputMaybe<IntNullableWithAggregatesFilter>;
  daysAfterPurchaseMin?: InputMaybe<IntNullableWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  discountAmountInCents?: InputMaybe<IntNullableWithAggregatesFilter>;
  discountPercentage?: InputMaybe<FloatNullableWithAggregatesFilter>;
  fromProductSubscriptionTypeId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isActive?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  upgradeDurationMode?: InputMaybe<EnumUpgradeDurationModeWithAggregatesFilter>;
};

export type UpgradePathDiscountSumOrderByAggregateInput = {
  daysAfterPurchaseMax?: InputMaybe<SortOrder>;
  daysAfterPurchaseMin?: InputMaybe<SortOrder>;
  discountAmountInCents?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountTargetProductCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountTargetProductCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUpgradePathTargetProductsInput;
  upgradePathDiscount: UpgradePathDiscountCreateNestedOneWithoutTargetProductsInput;
};

export type UpgradePathDiscountTargetProductCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productSubscriptionTypeId: Scalars['String']['input'];
  upgradePathDiscountId: Scalars['String']['input'];
};

export type UpgradePathDiscountTargetProductCreateManyProductSubscriptionTypeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  upgradePathDiscountId: Scalars['String']['input'];
};

export type UpgradePathDiscountTargetProductCreateManyProductSubscriptionTypeInputEnvelope = {
  data: Array<UpgradePathDiscountTargetProductCreateManyProductSubscriptionTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpgradePathDiscountTargetProductCreateManyUpgradePathDiscountInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productSubscriptionTypeId: Scalars['String']['input'];
};

export type UpgradePathDiscountTargetProductCreateManyUpgradePathDiscountInputEnvelope = {
  data: Array<UpgradePathDiscountTargetProductCreateManyUpgradePathDiscountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpgradePathDiscountTargetProductCreateNestedManyWithoutProductSubscriptionTypeInput = {
  connect?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePathDiscountTargetProductCreateOrConnectWithoutProductSubscriptionTypeInput>>;
  create?: InputMaybe<Array<UpgradePathDiscountTargetProductCreateWithoutProductSubscriptionTypeInput>>;
  createMany?: InputMaybe<UpgradePathDiscountTargetProductCreateManyProductSubscriptionTypeInputEnvelope>;
};

export type UpgradePathDiscountTargetProductCreateNestedManyWithoutUpgradePathDiscountInput = {
  connect?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePathDiscountTargetProductCreateOrConnectWithoutUpgradePathDiscountInput>>;
  create?: InputMaybe<Array<UpgradePathDiscountTargetProductCreateWithoutUpgradePathDiscountInput>>;
  createMany?: InputMaybe<UpgradePathDiscountTargetProductCreateManyUpgradePathDiscountInputEnvelope>;
};

export type UpgradePathDiscountTargetProductCreateOrConnectWithoutProductSubscriptionTypeInput = {
  create: UpgradePathDiscountTargetProductCreateWithoutProductSubscriptionTypeInput;
  where: UpgradePathDiscountTargetProductWhereUniqueInput;
};

export type UpgradePathDiscountTargetProductCreateOrConnectWithoutUpgradePathDiscountInput = {
  create: UpgradePathDiscountTargetProductCreateWithoutUpgradePathDiscountInput;
  where: UpgradePathDiscountTargetProductWhereUniqueInput;
};

export type UpgradePathDiscountTargetProductCreateWithoutProductSubscriptionTypeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  upgradePathDiscount: UpgradePathDiscountCreateNestedOneWithoutTargetProductsInput;
};

export type UpgradePathDiscountTargetProductCreateWithoutUpgradePathDiscountInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  productSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUpgradePathTargetProductsInput;
};

export type UpgradePathDiscountTargetProductListRelationFilter = {
  every?: InputMaybe<UpgradePathDiscountTargetProductWhereInput>;
  none?: InputMaybe<UpgradePathDiscountTargetProductWhereInput>;
  some?: InputMaybe<UpgradePathDiscountTargetProductWhereInput>;
};

export type UpgradePathDiscountTargetProductMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountTargetProductMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountTargetProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountTargetProductOrderByWithAggregationInput = {
  _count?: InputMaybe<UpgradePathDiscountTargetProductCountOrderByAggregateInput>;
  _max?: InputMaybe<UpgradePathDiscountTargetProductMaxOrderByAggregateInput>;
  _min?: InputMaybe<UpgradePathDiscountTargetProductMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
};

export type UpgradePathDiscountTargetProductOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeOrderByWithRelationInput>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountOrderByWithRelationInput>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
};

export enum UpgradePathDiscountTargetProductScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  ProductSubscriptionTypeId = 'productSubscriptionTypeId',
  UpgradePathDiscountId = 'upgradePathDiscountId'
}

export type UpgradePathDiscountTargetProductScalarWhereInput = {
  AND?: InputMaybe<Array<UpgradePathDiscountTargetProductScalarWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePathDiscountTargetProductScalarWhereInput>>;
  OR?: InputMaybe<Array<UpgradePathDiscountTargetProductScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  productSubscriptionTypeId?: InputMaybe<StringFilter>;
  upgradePathDiscountId?: InputMaybe<StringFilter>;
};

export type UpgradePathDiscountTargetProductScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UpgradePathDiscountTargetProductScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UpgradePathDiscountTargetProductScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UpgradePathDiscountTargetProductScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  productSubscriptionTypeId?: InputMaybe<StringWithAggregatesFilter>;
  upgradePathDiscountId?: InputMaybe<StringWithAggregatesFilter>;
};

export type UpgradePathDiscountTargetProductUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePathTargetProductsNestedInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneRequiredWithoutTargetProductsNestedInput>;
};

export type UpgradePathDiscountTargetProductUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UpgradePathDiscountTargetProductUpdateManyWithWhereWithoutProductSubscriptionTypeInput = {
  data: UpgradePathDiscountTargetProductUpdateManyMutationInput;
  where: UpgradePathDiscountTargetProductScalarWhereInput;
};

export type UpgradePathDiscountTargetProductUpdateManyWithWhereWithoutUpgradePathDiscountInput = {
  data: UpgradePathDiscountTargetProductUpdateManyMutationInput;
  where: UpgradePathDiscountTargetProductScalarWhereInput;
};

export type UpgradePathDiscountTargetProductUpdateManyWithoutProductSubscriptionTypeNestedInput = {
  connect?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePathDiscountTargetProductCreateOrConnectWithoutProductSubscriptionTypeInput>>;
  create?: InputMaybe<Array<UpgradePathDiscountTargetProductCreateWithoutProductSubscriptionTypeInput>>;
  createMany?: InputMaybe<UpgradePathDiscountTargetProductCreateManyProductSubscriptionTypeInputEnvelope>;
  delete?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpgradePathDiscountTargetProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereUniqueInput>>;
  set?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereUniqueInput>>;
  update?: InputMaybe<Array<UpgradePathDiscountTargetProductUpdateWithWhereUniqueWithoutProductSubscriptionTypeInput>>;
  updateMany?: InputMaybe<Array<UpgradePathDiscountTargetProductUpdateManyWithWhereWithoutProductSubscriptionTypeInput>>;
  upsert?: InputMaybe<Array<UpgradePathDiscountTargetProductUpsertWithWhereUniqueWithoutProductSubscriptionTypeInput>>;
};

export type UpgradePathDiscountTargetProductUpdateManyWithoutUpgradePathDiscountNestedInput = {
  connect?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePathDiscountTargetProductCreateOrConnectWithoutUpgradePathDiscountInput>>;
  create?: InputMaybe<Array<UpgradePathDiscountTargetProductCreateWithoutUpgradePathDiscountInput>>;
  createMany?: InputMaybe<UpgradePathDiscountTargetProductCreateManyUpgradePathDiscountInputEnvelope>;
  delete?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpgradePathDiscountTargetProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereUniqueInput>>;
  set?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereUniqueInput>>;
  update?: InputMaybe<Array<UpgradePathDiscountTargetProductUpdateWithWhereUniqueWithoutUpgradePathDiscountInput>>;
  updateMany?: InputMaybe<Array<UpgradePathDiscountTargetProductUpdateManyWithWhereWithoutUpgradePathDiscountInput>>;
  upsert?: InputMaybe<Array<UpgradePathDiscountTargetProductUpsertWithWhereUniqueWithoutUpgradePathDiscountInput>>;
};

export type UpgradePathDiscountTargetProductUpdateWithWhereUniqueWithoutProductSubscriptionTypeInput = {
  data: UpgradePathDiscountTargetProductUpdateWithoutProductSubscriptionTypeInput;
  where: UpgradePathDiscountTargetProductWhereUniqueInput;
};

export type UpgradePathDiscountTargetProductUpdateWithWhereUniqueWithoutUpgradePathDiscountInput = {
  data: UpgradePathDiscountTargetProductUpdateWithoutUpgradePathDiscountInput;
  where: UpgradePathDiscountTargetProductWhereUniqueInput;
};

export type UpgradePathDiscountTargetProductUpdateWithoutProductSubscriptionTypeInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneRequiredWithoutTargetProductsNestedInput>;
};

export type UpgradePathDiscountTargetProductUpdateWithoutUpgradePathDiscountInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePathTargetProductsNestedInput>;
};

export type UpgradePathDiscountTargetProductUpgradePathTargetProduct_UniqueCompoundUniqueInput = {
  productSubscriptionTypeId: Scalars['String']['input'];
  upgradePathDiscountId: Scalars['String']['input'];
};

export type UpgradePathDiscountTargetProductUpsertWithWhereUniqueWithoutProductSubscriptionTypeInput = {
  create: UpgradePathDiscountTargetProductCreateWithoutProductSubscriptionTypeInput;
  update: UpgradePathDiscountTargetProductUpdateWithoutProductSubscriptionTypeInput;
  where: UpgradePathDiscountTargetProductWhereUniqueInput;
};

export type UpgradePathDiscountTargetProductUpsertWithWhereUniqueWithoutUpgradePathDiscountInput = {
  create: UpgradePathDiscountTargetProductCreateWithoutUpgradePathDiscountInput;
  update: UpgradePathDiscountTargetProductUpdateWithoutUpgradePathDiscountInput;
  where: UpgradePathDiscountTargetProductWhereUniqueInput;
};

export type UpgradePathDiscountTargetProductWhereInput = {
  AND?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereInput>>;
  OR?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeScalarRelationFilter>;
  productSubscriptionTypeId?: InputMaybe<StringFilter>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountScalarRelationFilter>;
  upgradePathDiscountId?: InputMaybe<StringFilter>;
};

export type UpgradePathDiscountTargetProductWhereUniqueInput = {
  AND?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereInput>>;
  OR?: InputMaybe<Array<UpgradePathDiscountTargetProductWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeScalarRelationFilter>;
  productSubscriptionTypeId?: InputMaybe<StringFilter>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountScalarRelationFilter>;
  upgradePathDiscountId?: InputMaybe<StringFilter>;
  upgradePathTargetProduct_unique?: InputMaybe<UpgradePathDiscountTargetProductUpgradePathTargetProduct_UniqueCompoundUniqueInput>;
};

export type UpgradePathDiscountUpdateInput = {
  applyCreditForExistingPurchase?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditAllPriorPayments?: InputMaybe<BoolFieldUpdateOperationsInput>;
  daysAfterPurchaseMax?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  daysAfterPurchaseMin?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountAmountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePathsFromNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUpgradePathDiscountNestedInput>;
  targetProducts?: InputMaybe<UpgradePathDiscountTargetProductUpdateManyWithoutUpgradePathDiscountNestedInput>;
  upgradeDurationMode?: InputMaybe<EnumUpgradeDurationModeFieldUpdateOperationsInput>;
  upgradePrompts?: InputMaybe<UpgradePromptUpdateManyWithoutUpgradePathDiscountNestedInput>;
};

export type UpgradePathDiscountUpdateManyMutationInput = {
  applyCreditForExistingPurchase?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditAllPriorPayments?: InputMaybe<BoolFieldUpdateOperationsInput>;
  daysAfterPurchaseMax?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  daysAfterPurchaseMin?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountAmountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  upgradeDurationMode?: InputMaybe<EnumUpgradeDurationModeFieldUpdateOperationsInput>;
};

export type UpgradePathDiscountUpdateManyWithWhereWithoutFromProductSubscriptionTypeInput = {
  data: UpgradePathDiscountUpdateManyMutationInput;
  where: UpgradePathDiscountScalarWhereInput;
};

export type UpgradePathDiscountUpdateManyWithoutFromProductSubscriptionTypeNestedInput = {
  connect?: InputMaybe<Array<UpgradePathDiscountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePathDiscountCreateOrConnectWithoutFromProductSubscriptionTypeInput>>;
  create?: InputMaybe<Array<UpgradePathDiscountCreateWithoutFromProductSubscriptionTypeInput>>;
  createMany?: InputMaybe<UpgradePathDiscountCreateManyFromProductSubscriptionTypeInputEnvelope>;
  delete?: InputMaybe<Array<UpgradePathDiscountWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpgradePathDiscountScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpgradePathDiscountWhereUniqueInput>>;
  set?: InputMaybe<Array<UpgradePathDiscountWhereUniqueInput>>;
  update?: InputMaybe<Array<UpgradePathDiscountUpdateWithWhereUniqueWithoutFromProductSubscriptionTypeInput>>;
  updateMany?: InputMaybe<Array<UpgradePathDiscountUpdateManyWithWhereWithoutFromProductSubscriptionTypeInput>>;
  upsert?: InputMaybe<Array<UpgradePathDiscountUpsertWithWhereUniqueWithoutFromProductSubscriptionTypeInput>>;
};

export type UpgradePathDiscountUpdateOneRequiredWithoutTargetProductsNestedInput = {
  connect?: InputMaybe<UpgradePathDiscountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UpgradePathDiscountCreateOrConnectWithoutTargetProductsInput>;
  create?: InputMaybe<UpgradePathDiscountCreateWithoutTargetProductsInput>;
  update?: InputMaybe<UpgradePathDiscountUpdateToOneWithWhereWithoutTargetProductsInput>;
  upsert?: InputMaybe<UpgradePathDiscountUpsertWithoutTargetProductsInput>;
};

export type UpgradePathDiscountUpdateOneRequiredWithoutUpgradePromptsNestedInput = {
  connect?: InputMaybe<UpgradePathDiscountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UpgradePathDiscountCreateOrConnectWithoutUpgradePromptsInput>;
  create?: InputMaybe<UpgradePathDiscountCreateWithoutUpgradePromptsInput>;
  update?: InputMaybe<UpgradePathDiscountUpdateToOneWithWhereWithoutUpgradePromptsInput>;
  upsert?: InputMaybe<UpgradePathDiscountUpsertWithoutUpgradePromptsInput>;
};

export type UpgradePathDiscountUpdateOneWithoutPaymentsNestedInput = {
  connect?: InputMaybe<UpgradePathDiscountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UpgradePathDiscountCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<UpgradePathDiscountCreateWithoutPaymentsInput>;
  delete?: InputMaybe<UpgradePathDiscountWhereInput>;
  disconnect?: InputMaybe<UpgradePathDiscountWhereInput>;
  update?: InputMaybe<UpgradePathDiscountUpdateToOneWithWhereWithoutPaymentsInput>;
  upsert?: InputMaybe<UpgradePathDiscountUpsertWithoutPaymentsInput>;
};

export type UpgradePathDiscountUpdateToOneWithWhereWithoutPaymentsInput = {
  data: UpgradePathDiscountUpdateWithoutPaymentsInput;
  where?: InputMaybe<UpgradePathDiscountWhereInput>;
};

export type UpgradePathDiscountUpdateToOneWithWhereWithoutTargetProductsInput = {
  data: UpgradePathDiscountUpdateWithoutTargetProductsInput;
  where?: InputMaybe<UpgradePathDiscountWhereInput>;
};

export type UpgradePathDiscountUpdateToOneWithWhereWithoutUpgradePromptsInput = {
  data: UpgradePathDiscountUpdateWithoutUpgradePromptsInput;
  where?: InputMaybe<UpgradePathDiscountWhereInput>;
};

export type UpgradePathDiscountUpdateWithWhereUniqueWithoutFromProductSubscriptionTypeInput = {
  data: UpgradePathDiscountUpdateWithoutFromProductSubscriptionTypeInput;
  where: UpgradePathDiscountWhereUniqueInput;
};

export type UpgradePathDiscountUpdateWithoutFromProductSubscriptionTypeInput = {
  applyCreditForExistingPurchase?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditAllPriorPayments?: InputMaybe<BoolFieldUpdateOperationsInput>;
  daysAfterPurchaseMax?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  daysAfterPurchaseMin?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountAmountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUpgradePathDiscountNestedInput>;
  targetProducts?: InputMaybe<UpgradePathDiscountTargetProductUpdateManyWithoutUpgradePathDiscountNestedInput>;
  upgradeDurationMode?: InputMaybe<EnumUpgradeDurationModeFieldUpdateOperationsInput>;
  upgradePrompts?: InputMaybe<UpgradePromptUpdateManyWithoutUpgradePathDiscountNestedInput>;
};

export type UpgradePathDiscountUpdateWithoutPaymentsInput = {
  applyCreditForExistingPurchase?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditAllPriorPayments?: InputMaybe<BoolFieldUpdateOperationsInput>;
  daysAfterPurchaseMax?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  daysAfterPurchaseMin?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountAmountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePathsFromNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  targetProducts?: InputMaybe<UpgradePathDiscountTargetProductUpdateManyWithoutUpgradePathDiscountNestedInput>;
  upgradeDurationMode?: InputMaybe<EnumUpgradeDurationModeFieldUpdateOperationsInput>;
  upgradePrompts?: InputMaybe<UpgradePromptUpdateManyWithoutUpgradePathDiscountNestedInput>;
};

export type UpgradePathDiscountUpdateWithoutTargetProductsInput = {
  applyCreditForExistingPurchase?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditAllPriorPayments?: InputMaybe<BoolFieldUpdateOperationsInput>;
  daysAfterPurchaseMax?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  daysAfterPurchaseMin?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountAmountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePathsFromNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUpgradePathDiscountNestedInput>;
  upgradeDurationMode?: InputMaybe<EnumUpgradeDurationModeFieldUpdateOperationsInput>;
  upgradePrompts?: InputMaybe<UpgradePromptUpdateManyWithoutUpgradePathDiscountNestedInput>;
};

export type UpgradePathDiscountUpdateWithoutUpgradePromptsInput = {
  applyCreditForExistingPurchase?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditAllPriorPayments?: InputMaybe<BoolFieldUpdateOperationsInput>;
  daysAfterPurchaseMax?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  daysAfterPurchaseMin?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountAmountInCents?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePathsFromNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUpgradePathDiscountNestedInput>;
  targetProducts?: InputMaybe<UpgradePathDiscountTargetProductUpdateManyWithoutUpgradePathDiscountNestedInput>;
  upgradeDurationMode?: InputMaybe<EnumUpgradeDurationModeFieldUpdateOperationsInput>;
};

export type UpgradePathDiscountUpsertWithWhereUniqueWithoutFromProductSubscriptionTypeInput = {
  create: UpgradePathDiscountCreateWithoutFromProductSubscriptionTypeInput;
  update: UpgradePathDiscountUpdateWithoutFromProductSubscriptionTypeInput;
  where: UpgradePathDiscountWhereUniqueInput;
};

export type UpgradePathDiscountUpsertWithoutPaymentsInput = {
  create: UpgradePathDiscountCreateWithoutPaymentsInput;
  update: UpgradePathDiscountUpdateWithoutPaymentsInput;
  where?: InputMaybe<UpgradePathDiscountWhereInput>;
};

export type UpgradePathDiscountUpsertWithoutTargetProductsInput = {
  create: UpgradePathDiscountCreateWithoutTargetProductsInput;
  update: UpgradePathDiscountUpdateWithoutTargetProductsInput;
  where?: InputMaybe<UpgradePathDiscountWhereInput>;
};

export type UpgradePathDiscountUpsertWithoutUpgradePromptsInput = {
  create: UpgradePathDiscountCreateWithoutUpgradePromptsInput;
  update: UpgradePathDiscountUpdateWithoutUpgradePromptsInput;
  where?: InputMaybe<UpgradePathDiscountWhereInput>;
};

export type UpgradePathDiscountWhereInput = {
  AND?: InputMaybe<Array<UpgradePathDiscountWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePathDiscountWhereInput>>;
  OR?: InputMaybe<Array<UpgradePathDiscountWhereInput>>;
  applyCreditForExistingPurchase?: InputMaybe<BoolFilter>;
  created?: InputMaybe<DateTimeFilter>;
  creditAllPriorPayments?: InputMaybe<BoolFilter>;
  daysAfterPurchaseMax?: InputMaybe<IntNullableFilter>;
  daysAfterPurchaseMin?: InputMaybe<IntNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discountAmountInCents?: InputMaybe<IntNullableFilter>;
  discountPercentage?: InputMaybe<FloatNullableFilter>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeScalarRelationFilter>;
  fromProductSubscriptionTypeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  targetProducts?: InputMaybe<UpgradePathDiscountTargetProductListRelationFilter>;
  upgradeDurationMode?: InputMaybe<EnumUpgradeDurationModeFilter>;
  upgradePrompts?: InputMaybe<UpgradePromptListRelationFilter>;
};

export type UpgradePathDiscountWhereUniqueInput = {
  AND?: InputMaybe<Array<UpgradePathDiscountWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePathDiscountWhereInput>>;
  OR?: InputMaybe<Array<UpgradePathDiscountWhereInput>>;
  applyCreditForExistingPurchase?: InputMaybe<BoolFilter>;
  created?: InputMaybe<DateTimeFilter>;
  creditAllPriorPayments?: InputMaybe<BoolFilter>;
  daysAfterPurchaseMax?: InputMaybe<IntNullableFilter>;
  daysAfterPurchaseMin?: InputMaybe<IntNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discountAmountInCents?: InputMaybe<IntNullableFilter>;
  discountPercentage?: InputMaybe<FloatNullableFilter>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeScalarRelationFilter>;
  fromProductSubscriptionTypeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  targetProducts?: InputMaybe<UpgradePathDiscountTargetProductListRelationFilter>;
  upgradeDurationMode?: InputMaybe<EnumUpgradeDurationModeFilter>;
  upgradePrompts?: InputMaybe<UpgradePromptListRelationFilter>;
};

export type UpgradePromptAvgOrderByAggregateInput = {
  priority?: InputMaybe<SortOrder>;
  showFromDayAfterPurchase?: InputMaybe<SortOrder>;
  showUntilDayAfterPurchase?: InputMaybe<SortOrder>;
};

export type UpgradePromptCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  ctaText?: InputMaybe<SortOrder>;
  frequency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  promptType?: InputMaybe<SortOrder>;
  showFromDayAfterPurchase?: InputMaybe<SortOrder>;
  showUntilDayAfterPurchase?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
};

export type UpgradePromptCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  engagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUpgradePromptInput>;
  frequency?: InputMaybe<PromptFrequency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  promptType: UpgradePromptType;
  showFromDayAfterPurchase?: InputMaybe<Scalars['Int']['input']>;
  showUntilDayAfterPurchase?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  upgradePathDiscount: UpgradePathDiscountCreateNestedOneWithoutUpgradePromptsInput;
};

export type UpgradePromptCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<PromptFrequency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  promptType: UpgradePromptType;
  showFromDayAfterPurchase?: InputMaybe<Scalars['Int']['input']>;
  showUntilDayAfterPurchase?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  upgradePathDiscountId: Scalars['String']['input'];
};

export type UpgradePromptCreateManyUpgradePathDiscountInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<PromptFrequency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  promptType: UpgradePromptType;
  showFromDayAfterPurchase?: InputMaybe<Scalars['Int']['input']>;
  showUntilDayAfterPurchase?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradePromptCreateManyUpgradePathDiscountInputEnvelope = {
  data: Array<UpgradePromptCreateManyUpgradePathDiscountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpgradePromptCreateNestedManyWithoutUpgradePathDiscountInput = {
  connect?: InputMaybe<Array<UpgradePromptWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePromptCreateOrConnectWithoutUpgradePathDiscountInput>>;
  create?: InputMaybe<Array<UpgradePromptCreateWithoutUpgradePathDiscountInput>>;
  createMany?: InputMaybe<UpgradePromptCreateManyUpgradePathDiscountInputEnvelope>;
};

export type UpgradePromptCreateNestedOneWithoutEngagementsInput = {
  connect?: InputMaybe<UpgradePromptWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UpgradePromptCreateOrConnectWithoutEngagementsInput>;
  create?: InputMaybe<UpgradePromptCreateWithoutEngagementsInput>;
};

export type UpgradePromptCreateOrConnectWithoutEngagementsInput = {
  create: UpgradePromptCreateWithoutEngagementsInput;
  where: UpgradePromptWhereUniqueInput;
};

export type UpgradePromptCreateOrConnectWithoutUpgradePathDiscountInput = {
  create: UpgradePromptCreateWithoutUpgradePathDiscountInput;
  where: UpgradePromptWhereUniqueInput;
};

export type UpgradePromptCreateWithoutEngagementsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<PromptFrequency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  promptType: UpgradePromptType;
  showFromDayAfterPurchase?: InputMaybe<Scalars['Int']['input']>;
  showUntilDayAfterPurchase?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  upgradePathDiscount: UpgradePathDiscountCreateNestedOneWithoutUpgradePromptsInput;
};

export type UpgradePromptCreateWithoutUpgradePathDiscountInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  engagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUpgradePromptInput>;
  frequency?: InputMaybe<PromptFrequency>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  promptType: UpgradePromptType;
  showFromDayAfterPurchase?: InputMaybe<Scalars['Int']['input']>;
  showUntilDayAfterPurchase?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradePromptEngagementAvgOrderByAggregateInput = {
  daysAfterPurchase?: InputMaybe<SortOrder>;
};

export type UpgradePromptEngagementCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  daysAfterPurchase?: InputMaybe<SortOrder>;
  didConvert?: InputMaybe<SortOrder>;
  fromProductSubscriptionTypeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sessionId?: InputMaybe<SortOrder>;
  upgradePromptId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UpgradePromptEngagementCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  daysAfterPurchase: Scalars['Int']['input'];
  didConvert?: InputMaybe<Scalars['Boolean']['input']>;
  fromProductSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUpgradePromptEngagementsFromInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutUpgradePromptEngagementInput>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  upgradePrompt?: InputMaybe<UpgradePromptCreateNestedOneWithoutEngagementsInput>;
  user: UserCreateNestedOneWithoutUpgradePromptEngagementsInput;
};

export type UpgradePromptEngagementCreateManyFromProductSubscriptionTypeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  daysAfterPurchase: Scalars['Int']['input'];
  didConvert?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  upgradePromptId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpgradePromptEngagementCreateManyFromProductSubscriptionTypeInputEnvelope = {
  data: Array<UpgradePromptEngagementCreateManyFromProductSubscriptionTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpgradePromptEngagementCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  daysAfterPurchase: Scalars['Int']['input'];
  didConvert?: InputMaybe<Scalars['Boolean']['input']>;
  fromProductSubscriptionTypeId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  upgradePromptId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpgradePromptEngagementCreateManyUpgradePromptInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  daysAfterPurchase: Scalars['Int']['input'];
  didConvert?: InputMaybe<Scalars['Boolean']['input']>;
  fromProductSubscriptionTypeId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpgradePromptEngagementCreateManyUpgradePromptInputEnvelope = {
  data: Array<UpgradePromptEngagementCreateManyUpgradePromptInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpgradePromptEngagementCreateManyUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  daysAfterPurchase: Scalars['Int']['input'];
  didConvert?: InputMaybe<Scalars['Boolean']['input']>;
  fromProductSubscriptionTypeId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  upgradePromptId?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradePromptEngagementCreateManyUserInputEnvelope = {
  data: Array<UpgradePromptEngagementCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpgradePromptEngagementCreateNestedManyWithoutFromProductSubscriptionTypeInput = {
  connect?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePromptEngagementCreateOrConnectWithoutFromProductSubscriptionTypeInput>>;
  create?: InputMaybe<Array<UpgradePromptEngagementCreateWithoutFromProductSubscriptionTypeInput>>;
  createMany?: InputMaybe<UpgradePromptEngagementCreateManyFromProductSubscriptionTypeInputEnvelope>;
};

export type UpgradePromptEngagementCreateNestedManyWithoutUpgradePromptInput = {
  connect?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePromptEngagementCreateOrConnectWithoutUpgradePromptInput>>;
  create?: InputMaybe<Array<UpgradePromptEngagementCreateWithoutUpgradePromptInput>>;
  createMany?: InputMaybe<UpgradePromptEngagementCreateManyUpgradePromptInputEnvelope>;
};

export type UpgradePromptEngagementCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePromptEngagementCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UpgradePromptEngagementCreateWithoutUserInput>>;
  createMany?: InputMaybe<UpgradePromptEngagementCreateManyUserInputEnvelope>;
};

export type UpgradePromptEngagementCreateNestedOneWithoutPaymentInput = {
  connect?: InputMaybe<UpgradePromptEngagementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UpgradePromptEngagementCreateOrConnectWithoutPaymentInput>;
  create?: InputMaybe<UpgradePromptEngagementCreateWithoutPaymentInput>;
};

export type UpgradePromptEngagementCreateOrConnectWithoutFromProductSubscriptionTypeInput = {
  create: UpgradePromptEngagementCreateWithoutFromProductSubscriptionTypeInput;
  where: UpgradePromptEngagementWhereUniqueInput;
};

export type UpgradePromptEngagementCreateOrConnectWithoutPaymentInput = {
  create: UpgradePromptEngagementCreateWithoutPaymentInput;
  where: UpgradePromptEngagementWhereUniqueInput;
};

export type UpgradePromptEngagementCreateOrConnectWithoutUpgradePromptInput = {
  create: UpgradePromptEngagementCreateWithoutUpgradePromptInput;
  where: UpgradePromptEngagementWhereUniqueInput;
};

export type UpgradePromptEngagementCreateOrConnectWithoutUserInput = {
  create: UpgradePromptEngagementCreateWithoutUserInput;
  where: UpgradePromptEngagementWhereUniqueInput;
};

export type UpgradePromptEngagementCreateWithoutFromProductSubscriptionTypeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  daysAfterPurchase: Scalars['Int']['input'];
  didConvert?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutUpgradePromptEngagementInput>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  upgradePrompt?: InputMaybe<UpgradePromptCreateNestedOneWithoutEngagementsInput>;
  user: UserCreateNestedOneWithoutUpgradePromptEngagementsInput;
};

export type UpgradePromptEngagementCreateWithoutPaymentInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  daysAfterPurchase: Scalars['Int']['input'];
  didConvert?: InputMaybe<Scalars['Boolean']['input']>;
  fromProductSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUpgradePromptEngagementsFromInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  upgradePrompt?: InputMaybe<UpgradePromptCreateNestedOneWithoutEngagementsInput>;
  user: UserCreateNestedOneWithoutUpgradePromptEngagementsInput;
};

export type UpgradePromptEngagementCreateWithoutUpgradePromptInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  daysAfterPurchase: Scalars['Int']['input'];
  didConvert?: InputMaybe<Scalars['Boolean']['input']>;
  fromProductSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUpgradePromptEngagementsFromInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutUpgradePromptEngagementInput>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  user: UserCreateNestedOneWithoutUpgradePromptEngagementsInput;
};

export type UpgradePromptEngagementCreateWithoutUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  daysAfterPurchase: Scalars['Int']['input'];
  didConvert?: InputMaybe<Scalars['Boolean']['input']>;
  fromProductSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUpgradePromptEngagementsFromInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutUpgradePromptEngagementInput>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  upgradePrompt?: InputMaybe<UpgradePromptCreateNestedOneWithoutEngagementsInput>;
};

export type UpgradePromptEngagementListRelationFilter = {
  every?: InputMaybe<UpgradePromptEngagementWhereInput>;
  none?: InputMaybe<UpgradePromptEngagementWhereInput>;
  some?: InputMaybe<UpgradePromptEngagementWhereInput>;
};

export type UpgradePromptEngagementMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  daysAfterPurchase?: InputMaybe<SortOrder>;
  didConvert?: InputMaybe<SortOrder>;
  fromProductSubscriptionTypeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sessionId?: InputMaybe<SortOrder>;
  upgradePromptId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UpgradePromptEngagementMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  daysAfterPurchase?: InputMaybe<SortOrder>;
  didConvert?: InputMaybe<SortOrder>;
  fromProductSubscriptionTypeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sessionId?: InputMaybe<SortOrder>;
  upgradePromptId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UpgradePromptEngagementNullableScalarRelationFilter = {
  is?: InputMaybe<UpgradePromptEngagementWhereInput>;
  isNot?: InputMaybe<UpgradePromptEngagementWhereInput>;
};

export type UpgradePromptEngagementOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UpgradePromptEngagementOrderByWithAggregationInput = {
  _avg?: InputMaybe<UpgradePromptEngagementAvgOrderByAggregateInput>;
  _count?: InputMaybe<UpgradePromptEngagementCountOrderByAggregateInput>;
  _max?: InputMaybe<UpgradePromptEngagementMaxOrderByAggregateInput>;
  _min?: InputMaybe<UpgradePromptEngagementMinOrderByAggregateInput>;
  _sum?: InputMaybe<UpgradePromptEngagementSumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  daysAfterPurchase?: InputMaybe<SortOrder>;
  didConvert?: InputMaybe<SortOrder>;
  fromProductSubscriptionTypeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  sessionId?: InputMaybe<SortOrder>;
  upgradePromptId?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrder>;
};

export type UpgradePromptEngagementOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  daysAfterPurchase?: InputMaybe<SortOrder>;
  didConvert?: InputMaybe<SortOrder>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeOrderByWithRelationInput>;
  fromProductSubscriptionTypeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  payment?: InputMaybe<PaymentOrderByWithRelationInput>;
  sessionId?: InputMaybe<SortOrder>;
  upgradePrompt?: InputMaybe<UpgradePromptOrderByWithRelationInput>;
  upgradePromptId?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UpgradePromptEngagementScalarFieldEnum {
  Created = 'created',
  DaysAfterPurchase = 'daysAfterPurchase',
  DidConvert = 'didConvert',
  FromProductSubscriptionTypeId = 'fromProductSubscriptionTypeId',
  Id = 'id',
  Modified = 'modified',
  SessionId = 'sessionId',
  UpgradePromptId = 'upgradePromptId',
  UserId = 'userId'
}

export type UpgradePromptEngagementScalarWhereInput = {
  AND?: InputMaybe<Array<UpgradePromptEngagementScalarWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePromptEngagementScalarWhereInput>>;
  OR?: InputMaybe<Array<UpgradePromptEngagementScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  daysAfterPurchase?: InputMaybe<IntFilter>;
  didConvert?: InputMaybe<BoolFilter>;
  fromProductSubscriptionTypeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  sessionId?: InputMaybe<StringFilter>;
  upgradePromptId?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UpgradePromptEngagementScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UpgradePromptEngagementScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UpgradePromptEngagementScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UpgradePromptEngagementScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  daysAfterPurchase?: InputMaybe<IntWithAggregatesFilter>;
  didConvert?: InputMaybe<BoolWithAggregatesFilter>;
  fromProductSubscriptionTypeId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  sessionId?: InputMaybe<StringWithAggregatesFilter>;
  upgradePromptId?: InputMaybe<StringNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type UpgradePromptEngagementSumOrderByAggregateInput = {
  daysAfterPurchase?: InputMaybe<SortOrder>;
};

export type UpgradePromptEngagementUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  daysAfterPurchase?: InputMaybe<IntFieldUpdateOperationsInput>;
  didConvert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePromptEngagementsFromNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutUpgradePromptEngagementNestedInput>;
  sessionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  upgradePrompt?: InputMaybe<UpgradePromptUpdateOneWithoutEngagementsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUpgradePromptEngagementsNestedInput>;
};

export type UpgradePromptEngagementUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  daysAfterPurchase?: InputMaybe<IntFieldUpdateOperationsInput>;
  didConvert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sessionId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UpgradePromptEngagementUpdateManyWithWhereWithoutFromProductSubscriptionTypeInput = {
  data: UpgradePromptEngagementUpdateManyMutationInput;
  where: UpgradePromptEngagementScalarWhereInput;
};

export type UpgradePromptEngagementUpdateManyWithWhereWithoutUpgradePromptInput = {
  data: UpgradePromptEngagementUpdateManyMutationInput;
  where: UpgradePromptEngagementScalarWhereInput;
};

export type UpgradePromptEngagementUpdateManyWithWhereWithoutUserInput = {
  data: UpgradePromptEngagementUpdateManyMutationInput;
  where: UpgradePromptEngagementScalarWhereInput;
};

export type UpgradePromptEngagementUpdateManyWithoutFromProductSubscriptionTypeNestedInput = {
  connect?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePromptEngagementCreateOrConnectWithoutFromProductSubscriptionTypeInput>>;
  create?: InputMaybe<Array<UpgradePromptEngagementCreateWithoutFromProductSubscriptionTypeInput>>;
  createMany?: InputMaybe<UpgradePromptEngagementCreateManyFromProductSubscriptionTypeInputEnvelope>;
  delete?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpgradePromptEngagementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  set?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  update?: InputMaybe<Array<UpgradePromptEngagementUpdateWithWhereUniqueWithoutFromProductSubscriptionTypeInput>>;
  updateMany?: InputMaybe<Array<UpgradePromptEngagementUpdateManyWithWhereWithoutFromProductSubscriptionTypeInput>>;
  upsert?: InputMaybe<Array<UpgradePromptEngagementUpsertWithWhereUniqueWithoutFromProductSubscriptionTypeInput>>;
};

export type UpgradePromptEngagementUpdateManyWithoutUpgradePromptNestedInput = {
  connect?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePromptEngagementCreateOrConnectWithoutUpgradePromptInput>>;
  create?: InputMaybe<Array<UpgradePromptEngagementCreateWithoutUpgradePromptInput>>;
  createMany?: InputMaybe<UpgradePromptEngagementCreateManyUpgradePromptInputEnvelope>;
  delete?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpgradePromptEngagementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  set?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  update?: InputMaybe<Array<UpgradePromptEngagementUpdateWithWhereUniqueWithoutUpgradePromptInput>>;
  updateMany?: InputMaybe<Array<UpgradePromptEngagementUpdateManyWithWhereWithoutUpgradePromptInput>>;
  upsert?: InputMaybe<Array<UpgradePromptEngagementUpsertWithWhereUniqueWithoutUpgradePromptInput>>;
};

export type UpgradePromptEngagementUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePromptEngagementCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UpgradePromptEngagementCreateWithoutUserInput>>;
  createMany?: InputMaybe<UpgradePromptEngagementCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpgradePromptEngagementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  set?: InputMaybe<Array<UpgradePromptEngagementWhereUniqueInput>>;
  update?: InputMaybe<Array<UpgradePromptEngagementUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UpgradePromptEngagementUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UpgradePromptEngagementUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UpgradePromptEngagementUpdateOneWithoutPaymentNestedInput = {
  connect?: InputMaybe<UpgradePromptEngagementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UpgradePromptEngagementCreateOrConnectWithoutPaymentInput>;
  create?: InputMaybe<UpgradePromptEngagementCreateWithoutPaymentInput>;
  delete?: InputMaybe<UpgradePromptEngagementWhereInput>;
  disconnect?: InputMaybe<UpgradePromptEngagementWhereInput>;
  update?: InputMaybe<UpgradePromptEngagementUpdateToOneWithWhereWithoutPaymentInput>;
  upsert?: InputMaybe<UpgradePromptEngagementUpsertWithoutPaymentInput>;
};

export type UpgradePromptEngagementUpdateToOneWithWhereWithoutPaymentInput = {
  data: UpgradePromptEngagementUpdateWithoutPaymentInput;
  where?: InputMaybe<UpgradePromptEngagementWhereInput>;
};

export type UpgradePromptEngagementUpdateWithWhereUniqueWithoutFromProductSubscriptionTypeInput = {
  data: UpgradePromptEngagementUpdateWithoutFromProductSubscriptionTypeInput;
  where: UpgradePromptEngagementWhereUniqueInput;
};

export type UpgradePromptEngagementUpdateWithWhereUniqueWithoutUpgradePromptInput = {
  data: UpgradePromptEngagementUpdateWithoutUpgradePromptInput;
  where: UpgradePromptEngagementWhereUniqueInput;
};

export type UpgradePromptEngagementUpdateWithWhereUniqueWithoutUserInput = {
  data: UpgradePromptEngagementUpdateWithoutUserInput;
  where: UpgradePromptEngagementWhereUniqueInput;
};

export type UpgradePromptEngagementUpdateWithoutFromProductSubscriptionTypeInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  daysAfterPurchase?: InputMaybe<IntFieldUpdateOperationsInput>;
  didConvert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutUpgradePromptEngagementNestedInput>;
  sessionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  upgradePrompt?: InputMaybe<UpgradePromptUpdateOneWithoutEngagementsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUpgradePromptEngagementsNestedInput>;
};

export type UpgradePromptEngagementUpdateWithoutPaymentInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  daysAfterPurchase?: InputMaybe<IntFieldUpdateOperationsInput>;
  didConvert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePromptEngagementsFromNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sessionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  upgradePrompt?: InputMaybe<UpgradePromptUpdateOneWithoutEngagementsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUpgradePromptEngagementsNestedInput>;
};

export type UpgradePromptEngagementUpdateWithoutUpgradePromptInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  daysAfterPurchase?: InputMaybe<IntFieldUpdateOperationsInput>;
  didConvert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePromptEngagementsFromNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutUpgradePromptEngagementNestedInput>;
  sessionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUpgradePromptEngagementsNestedInput>;
};

export type UpgradePromptEngagementUpdateWithoutUserInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  daysAfterPurchase?: InputMaybe<IntFieldUpdateOperationsInput>;
  didConvert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUpgradePromptEngagementsFromNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutUpgradePromptEngagementNestedInput>;
  sessionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  upgradePrompt?: InputMaybe<UpgradePromptUpdateOneWithoutEngagementsNestedInput>;
};

export type UpgradePromptEngagementUpgradePromptEngagement_UniqueCompoundUniqueInput = {
  sessionId: Scalars['String']['input'];
  upgradePromptId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpgradePromptEngagementUpsertWithWhereUniqueWithoutFromProductSubscriptionTypeInput = {
  create: UpgradePromptEngagementCreateWithoutFromProductSubscriptionTypeInput;
  update: UpgradePromptEngagementUpdateWithoutFromProductSubscriptionTypeInput;
  where: UpgradePromptEngagementWhereUniqueInput;
};

export type UpgradePromptEngagementUpsertWithWhereUniqueWithoutUpgradePromptInput = {
  create: UpgradePromptEngagementCreateWithoutUpgradePromptInput;
  update: UpgradePromptEngagementUpdateWithoutUpgradePromptInput;
  where: UpgradePromptEngagementWhereUniqueInput;
};

export type UpgradePromptEngagementUpsertWithWhereUniqueWithoutUserInput = {
  create: UpgradePromptEngagementCreateWithoutUserInput;
  update: UpgradePromptEngagementUpdateWithoutUserInput;
  where: UpgradePromptEngagementWhereUniqueInput;
};

export type UpgradePromptEngagementUpsertWithoutPaymentInput = {
  create: UpgradePromptEngagementCreateWithoutPaymentInput;
  update: UpgradePromptEngagementUpdateWithoutPaymentInput;
  where?: InputMaybe<UpgradePromptEngagementWhereInput>;
};

export type UpgradePromptEngagementWhereInput = {
  AND?: InputMaybe<Array<UpgradePromptEngagementWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePromptEngagementWhereInput>>;
  OR?: InputMaybe<Array<UpgradePromptEngagementWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  daysAfterPurchase?: InputMaybe<IntFilter>;
  didConvert?: InputMaybe<BoolFilter>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeScalarRelationFilter>;
  fromProductSubscriptionTypeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  payment?: InputMaybe<PaymentNullableScalarRelationFilter>;
  sessionId?: InputMaybe<StringFilter>;
  upgradePrompt?: InputMaybe<UpgradePromptNullableScalarRelationFilter>;
  upgradePromptId?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UpgradePromptEngagementWhereUniqueInput = {
  AND?: InputMaybe<Array<UpgradePromptEngagementWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePromptEngagementWhereInput>>;
  OR?: InputMaybe<Array<UpgradePromptEngagementWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  daysAfterPurchase?: InputMaybe<IntFilter>;
  didConvert?: InputMaybe<BoolFilter>;
  fromProductSubscriptionType?: InputMaybe<ProductSubscriptionTypeScalarRelationFilter>;
  fromProductSubscriptionTypeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  payment?: InputMaybe<PaymentNullableScalarRelationFilter>;
  sessionId?: InputMaybe<StringFilter>;
  upgradePrompt?: InputMaybe<UpgradePromptNullableScalarRelationFilter>;
  upgradePromptEngagement_unique?: InputMaybe<UpgradePromptEngagementUpgradePromptEngagement_UniqueCompoundUniqueInput>;
  upgradePromptId?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UpgradePromptListRelationFilter = {
  every?: InputMaybe<UpgradePromptWhereInput>;
  none?: InputMaybe<UpgradePromptWhereInput>;
  some?: InputMaybe<UpgradePromptWhereInput>;
};

export type UpgradePromptMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  ctaText?: InputMaybe<SortOrder>;
  frequency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  promptType?: InputMaybe<SortOrder>;
  showFromDayAfterPurchase?: InputMaybe<SortOrder>;
  showUntilDayAfterPurchase?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
};

export type UpgradePromptMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  ctaText?: InputMaybe<SortOrder>;
  frequency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  promptType?: InputMaybe<SortOrder>;
  showFromDayAfterPurchase?: InputMaybe<SortOrder>;
  showUntilDayAfterPurchase?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
};

export type UpgradePromptNullableScalarRelationFilter = {
  is?: InputMaybe<UpgradePromptWhereInput>;
  isNot?: InputMaybe<UpgradePromptWhereInput>;
};

export type UpgradePromptOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UpgradePromptOrderByWithAggregationInput = {
  _avg?: InputMaybe<UpgradePromptAvgOrderByAggregateInput>;
  _count?: InputMaybe<UpgradePromptCountOrderByAggregateInput>;
  _max?: InputMaybe<UpgradePromptMaxOrderByAggregateInput>;
  _min?: InputMaybe<UpgradePromptMinOrderByAggregateInput>;
  _sum?: InputMaybe<UpgradePromptSumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  ctaText?: InputMaybe<SortOrderInput>;
  frequency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  promptType?: InputMaybe<SortOrder>;
  showFromDayAfterPurchase?: InputMaybe<SortOrder>;
  showUntilDayAfterPurchase?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
};

export type UpgradePromptOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  ctaText?: InputMaybe<SortOrderInput>;
  engagements?: InputMaybe<UpgradePromptEngagementOrderByRelationAggregateInput>;
  frequency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  promptType?: InputMaybe<SortOrder>;
  showFromDayAfterPurchase?: InputMaybe<SortOrder>;
  showUntilDayAfterPurchase?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountOrderByWithRelationInput>;
  upgradePathDiscountId?: InputMaybe<SortOrder>;
};

export enum UpgradePromptScalarFieldEnum {
  Created = 'created',
  CtaText = 'ctaText',
  Frequency = 'frequency',
  Id = 'id',
  IsActive = 'isActive',
  Message = 'message',
  Modified = 'modified',
  Name = 'name',
  Priority = 'priority',
  PromptType = 'promptType',
  ShowFromDayAfterPurchase = 'showFromDayAfterPurchase',
  ShowUntilDayAfterPurchase = 'showUntilDayAfterPurchase',
  Title = 'title',
  UpgradePathDiscountId = 'upgradePathDiscountId'
}

export type UpgradePromptScalarWhereInput = {
  AND?: InputMaybe<Array<UpgradePromptScalarWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePromptScalarWhereInput>>;
  OR?: InputMaybe<Array<UpgradePromptScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  ctaText?: InputMaybe<StringNullableFilter>;
  frequency?: InputMaybe<EnumPromptFrequencyFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  priority?: InputMaybe<IntFilter>;
  promptType?: InputMaybe<EnumUpgradePromptTypeFilter>;
  showFromDayAfterPurchase?: InputMaybe<IntFilter>;
  showUntilDayAfterPurchase?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  upgradePathDiscountId?: InputMaybe<StringFilter>;
};

export type UpgradePromptScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UpgradePromptScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UpgradePromptScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UpgradePromptScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  ctaText?: InputMaybe<StringNullableWithAggregatesFilter>;
  frequency?: InputMaybe<EnumPromptFrequencyWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isActive?: InputMaybe<BoolWithAggregatesFilter>;
  message?: InputMaybe<StringNullableWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  priority?: InputMaybe<IntWithAggregatesFilter>;
  promptType?: InputMaybe<EnumUpgradePromptTypeWithAggregatesFilter>;
  showFromDayAfterPurchase?: InputMaybe<IntWithAggregatesFilter>;
  showUntilDayAfterPurchase?: InputMaybe<IntNullableWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
  upgradePathDiscountId?: InputMaybe<StringWithAggregatesFilter>;
};

export type UpgradePromptSumOrderByAggregateInput = {
  priority?: InputMaybe<SortOrder>;
  showFromDayAfterPurchase?: InputMaybe<SortOrder>;
  showUntilDayAfterPurchase?: InputMaybe<SortOrder>;
};

export enum UpgradePromptType {
  Banner = 'BANNER',
  Modal = 'MODAL',
  Toast = 'TOAST'
}

export type UpgradePromptUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ctaText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  engagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUpgradePromptNestedInput>;
  frequency?: InputMaybe<EnumPromptFrequencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  promptType?: InputMaybe<EnumUpgradePromptTypeFieldUpdateOperationsInput>;
  showFromDayAfterPurchase?: InputMaybe<IntFieldUpdateOperationsInput>;
  showUntilDayAfterPurchase?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneRequiredWithoutUpgradePromptsNestedInput>;
};

export type UpgradePromptUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ctaText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  frequency?: InputMaybe<EnumPromptFrequencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  promptType?: InputMaybe<EnumUpgradePromptTypeFieldUpdateOperationsInput>;
  showFromDayAfterPurchase?: InputMaybe<IntFieldUpdateOperationsInput>;
  showUntilDayAfterPurchase?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpgradePromptUpdateManyWithWhereWithoutUpgradePathDiscountInput = {
  data: UpgradePromptUpdateManyMutationInput;
  where: UpgradePromptScalarWhereInput;
};

export type UpgradePromptUpdateManyWithoutUpgradePathDiscountNestedInput = {
  connect?: InputMaybe<Array<UpgradePromptWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpgradePromptCreateOrConnectWithoutUpgradePathDiscountInput>>;
  create?: InputMaybe<Array<UpgradePromptCreateWithoutUpgradePathDiscountInput>>;
  createMany?: InputMaybe<UpgradePromptCreateManyUpgradePathDiscountInputEnvelope>;
  delete?: InputMaybe<Array<UpgradePromptWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpgradePromptScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpgradePromptWhereUniqueInput>>;
  set?: InputMaybe<Array<UpgradePromptWhereUniqueInput>>;
  update?: InputMaybe<Array<UpgradePromptUpdateWithWhereUniqueWithoutUpgradePathDiscountInput>>;
  updateMany?: InputMaybe<Array<UpgradePromptUpdateManyWithWhereWithoutUpgradePathDiscountInput>>;
  upsert?: InputMaybe<Array<UpgradePromptUpsertWithWhereUniqueWithoutUpgradePathDiscountInput>>;
};

export type UpgradePromptUpdateOneWithoutEngagementsNestedInput = {
  connect?: InputMaybe<UpgradePromptWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UpgradePromptCreateOrConnectWithoutEngagementsInput>;
  create?: InputMaybe<UpgradePromptCreateWithoutEngagementsInput>;
  delete?: InputMaybe<UpgradePromptWhereInput>;
  disconnect?: InputMaybe<UpgradePromptWhereInput>;
  update?: InputMaybe<UpgradePromptUpdateToOneWithWhereWithoutEngagementsInput>;
  upsert?: InputMaybe<UpgradePromptUpsertWithoutEngagementsInput>;
};

export type UpgradePromptUpdateToOneWithWhereWithoutEngagementsInput = {
  data: UpgradePromptUpdateWithoutEngagementsInput;
  where?: InputMaybe<UpgradePromptWhereInput>;
};

export type UpgradePromptUpdateWithWhereUniqueWithoutUpgradePathDiscountInput = {
  data: UpgradePromptUpdateWithoutUpgradePathDiscountInput;
  where: UpgradePromptWhereUniqueInput;
};

export type UpgradePromptUpdateWithoutEngagementsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ctaText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  frequency?: InputMaybe<EnumPromptFrequencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  promptType?: InputMaybe<EnumUpgradePromptTypeFieldUpdateOperationsInput>;
  showFromDayAfterPurchase?: InputMaybe<IntFieldUpdateOperationsInput>;
  showUntilDayAfterPurchase?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountUpdateOneRequiredWithoutUpgradePromptsNestedInput>;
};

export type UpgradePromptUpdateWithoutUpgradePathDiscountInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ctaText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  engagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUpgradePromptNestedInput>;
  frequency?: InputMaybe<EnumPromptFrequencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  promptType?: InputMaybe<EnumUpgradePromptTypeFieldUpdateOperationsInput>;
  showFromDayAfterPurchase?: InputMaybe<IntFieldUpdateOperationsInput>;
  showUntilDayAfterPurchase?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpgradePromptUpsertWithWhereUniqueWithoutUpgradePathDiscountInput = {
  create: UpgradePromptCreateWithoutUpgradePathDiscountInput;
  update: UpgradePromptUpdateWithoutUpgradePathDiscountInput;
  where: UpgradePromptWhereUniqueInput;
};

export type UpgradePromptUpsertWithoutEngagementsInput = {
  create: UpgradePromptCreateWithoutEngagementsInput;
  update: UpgradePromptUpdateWithoutEngagementsInput;
  where?: InputMaybe<UpgradePromptWhereInput>;
};

export type UpgradePromptWhereInput = {
  AND?: InputMaybe<Array<UpgradePromptWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePromptWhereInput>>;
  OR?: InputMaybe<Array<UpgradePromptWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  ctaText?: InputMaybe<StringNullableFilter>;
  engagements?: InputMaybe<UpgradePromptEngagementListRelationFilter>;
  frequency?: InputMaybe<EnumPromptFrequencyFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  priority?: InputMaybe<IntFilter>;
  promptType?: InputMaybe<EnumUpgradePromptTypeFilter>;
  showFromDayAfterPurchase?: InputMaybe<IntFilter>;
  showUntilDayAfterPurchase?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountScalarRelationFilter>;
  upgradePathDiscountId?: InputMaybe<StringFilter>;
};

export type UpgradePromptWhereUniqueInput = {
  AND?: InputMaybe<Array<UpgradePromptWhereInput>>;
  NOT?: InputMaybe<Array<UpgradePromptWhereInput>>;
  OR?: InputMaybe<Array<UpgradePromptWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  ctaText?: InputMaybe<StringNullableFilter>;
  engagements?: InputMaybe<UpgradePromptEngagementListRelationFilter>;
  frequency?: InputMaybe<EnumPromptFrequencyFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringNullableFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  priority?: InputMaybe<IntFilter>;
  promptType?: InputMaybe<EnumUpgradePromptTypeFilter>;
  showFromDayAfterPurchase?: InputMaybe<IntFilter>;
  showUntilDayAfterPurchase?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  upgradePathDiscount?: InputMaybe<UpgradePathDiscountScalarRelationFilter>;
  upgradePathDiscountId?: InputMaybe<StringFilter>;
};

export enum UpgradeType {
  AddDays = 'ADD_DAYS',
  Prorating = 'PRORATING'
}

export enum UserArticleAction {
  Opened = 'OPENED',
  Read = 'READ'
}

export type UserArticleCountOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  articleId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isArchived?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserArticleCreateInput = {
  action?: InputMaybe<UserArticleAction>;
  article: ArticleCreateNestedOneWithoutReadByInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutReadArticlesInput;
};

export type UserArticleCreateManyArticleInput = {
  action?: InputMaybe<UserArticleAction>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type UserArticleCreateManyArticleInputEnvelope = {
  data: Array<UserArticleCreateManyArticleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserArticleCreateManyInput = {
  action?: InputMaybe<UserArticleAction>;
  articleId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type UserArticleCreateManyUserInput = {
  action?: InputMaybe<UserArticleAction>;
  articleId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserArticleCreateManyUserInputEnvelope = {
  data: Array<UserArticleCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserArticleCreateNestedManyWithoutArticleInput = {
  connect?: InputMaybe<Array<UserArticleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserArticleCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<UserArticleCreateWithoutArticleInput>>;
  createMany?: InputMaybe<UserArticleCreateManyArticleInputEnvelope>;
};

export type UserArticleCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserArticleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserArticleCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserArticleCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserArticleCreateManyUserInputEnvelope>;
};

export type UserArticleCreateOrConnectWithoutArticleInput = {
  create: UserArticleCreateWithoutArticleInput;
  where: UserArticleWhereUniqueInput;
};

export type UserArticleCreateOrConnectWithoutUserInput = {
  create: UserArticleCreateWithoutUserInput;
  where: UserArticleWhereUniqueInput;
};

export type UserArticleCreateWithoutArticleInput = {
  action?: InputMaybe<UserArticleAction>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutReadArticlesInput;
};

export type UserArticleCreateWithoutUserInput = {
  action?: InputMaybe<UserArticleAction>;
  article: ArticleCreateNestedOneWithoutReadByInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserArticleListRelationFilter = {
  every?: InputMaybe<UserArticleWhereInput>;
  none?: InputMaybe<UserArticleWhereInput>;
  some?: InputMaybe<UserArticleWhereInput>;
};

export type UserArticleMaxOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  articleId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isArchived?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserArticleMinOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  articleId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isArchived?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserArticleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserArticleOrderByWithAggregationInput = {
  _count?: InputMaybe<UserArticleCountOrderByAggregateInput>;
  _max?: InputMaybe<UserArticleMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserArticleMinOrderByAggregateInput>;
  action?: InputMaybe<SortOrder>;
  articleId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isArchived?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserArticleOrderByWithRelationInput = {
  action?: InputMaybe<SortOrder>;
  article?: InputMaybe<ArticleOrderByWithRelationInput>;
  articleId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isArchived?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserArticleScalarFieldEnum {
  Action = 'action',
  ArticleId = 'articleId',
  Created = 'created',
  Id = 'id',
  IsArchived = 'isArchived',
  Modified = 'modified',
  UserId = 'userId'
}

export type UserArticleScalarWhereInput = {
  AND?: InputMaybe<Array<UserArticleScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserArticleScalarWhereInput>>;
  OR?: InputMaybe<Array<UserArticleScalarWhereInput>>;
  action?: InputMaybe<EnumUserArticleActionFilter>;
  articleId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserArticleScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserArticleScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserArticleScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserArticleScalarWhereWithAggregatesInput>>;
  action?: InputMaybe<EnumUserArticleActionWithAggregatesFilter>;
  articleId?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isArchived?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type UserArticleUpdateInput = {
  action?: InputMaybe<EnumUserArticleActionFieldUpdateOperationsInput>;
  article?: InputMaybe<ArticleUpdateOneRequiredWithoutReadByNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutReadArticlesNestedInput>;
};

export type UserArticleUpdateManyMutationInput = {
  action?: InputMaybe<EnumUserArticleActionFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserArticleUpdateManyWithWhereWithoutArticleInput = {
  data: UserArticleUpdateManyMutationInput;
  where: UserArticleScalarWhereInput;
};

export type UserArticleUpdateManyWithWhereWithoutUserInput = {
  data: UserArticleUpdateManyMutationInput;
  where: UserArticleScalarWhereInput;
};

export type UserArticleUpdateManyWithoutArticleNestedInput = {
  connect?: InputMaybe<Array<UserArticleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserArticleCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<UserArticleCreateWithoutArticleInput>>;
  createMany?: InputMaybe<UserArticleCreateManyArticleInputEnvelope>;
  delete?: InputMaybe<Array<UserArticleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserArticleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserArticleWhereUniqueInput>>;
  set?: InputMaybe<Array<UserArticleWhereUniqueInput>>;
  update?: InputMaybe<Array<UserArticleUpdateWithWhereUniqueWithoutArticleInput>>;
  updateMany?: InputMaybe<Array<UserArticleUpdateManyWithWhereWithoutArticleInput>>;
  upsert?: InputMaybe<Array<UserArticleUpsertWithWhereUniqueWithoutArticleInput>>;
};

export type UserArticleUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserArticleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserArticleCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserArticleCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserArticleCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserArticleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserArticleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserArticleWhereUniqueInput>>;
  set?: InputMaybe<Array<UserArticleWhereUniqueInput>>;
  update?: InputMaybe<Array<UserArticleUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserArticleUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserArticleUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserArticleUpdateWithWhereUniqueWithoutArticleInput = {
  data: UserArticleUpdateWithoutArticleInput;
  where: UserArticleWhereUniqueInput;
};

export type UserArticleUpdateWithWhereUniqueWithoutUserInput = {
  data: UserArticleUpdateWithoutUserInput;
  where: UserArticleWhereUniqueInput;
};

export type UserArticleUpdateWithoutArticleInput = {
  action?: InputMaybe<EnumUserArticleActionFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutReadArticlesNestedInput>;
};

export type UserArticleUpdateWithoutUserInput = {
  action?: InputMaybe<EnumUserArticleActionFieldUpdateOperationsInput>;
  article?: InputMaybe<ArticleUpdateOneRequiredWithoutReadByNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserArticleUpsertWithWhereUniqueWithoutArticleInput = {
  create: UserArticleCreateWithoutArticleInput;
  update: UserArticleUpdateWithoutArticleInput;
  where: UserArticleWhereUniqueInput;
};

export type UserArticleUpsertWithWhereUniqueWithoutUserInput = {
  create: UserArticleCreateWithoutUserInput;
  update: UserArticleUpdateWithoutUserInput;
  where: UserArticleWhereUniqueInput;
};

export type UserArticleUserArticleCompoundUniqueInput = {
  action: UserArticleAction;
  articleId: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  userId: Scalars['String']['input'];
};

export type UserArticleWhereInput = {
  AND?: InputMaybe<Array<UserArticleWhereInput>>;
  NOT?: InputMaybe<Array<UserArticleWhereInput>>;
  OR?: InputMaybe<Array<UserArticleWhereInput>>;
  action?: InputMaybe<EnumUserArticleActionFilter>;
  article?: InputMaybe<ArticleScalarRelationFilter>;
  articleId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserArticleWhereUniqueInput = {
  AND?: InputMaybe<Array<UserArticleWhereInput>>;
  NOT?: InputMaybe<Array<UserArticleWhereInput>>;
  OR?: InputMaybe<Array<UserArticleWhereInput>>;
  action?: InputMaybe<EnumUserArticleActionFilter>;
  article?: InputMaybe<ArticleScalarRelationFilter>;
  articleId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userArticle?: InputMaybe<UserArticleUserArticleCompoundUniqueInput>;
  userId?: InputMaybe<StringFilter>;
};

export type UserAvgOrderByAggregateInput = {
  trialPurchasesUsed?: InputMaybe<SortOrder>;
};

export type UserCountOrderByAggregateInput = {
  billingAddress?: InputMaybe<SortOrder>;
  billingCountryCode?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  fullName?: InputMaybe<SortOrder>;
  healthDiscipline?: InputMaybe<SortOrder>;
  howDidYouHear?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEnabled?: InputMaybe<SortOrder>;
  isProfessional?: InputMaybe<SortOrder>;
  isPublicEnabled?: InputMaybe<SortOrder>;
  klaviyoProfileId?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  passwordHash?: InputMaybe<SortOrder>;
  passwordResetToken?: InputMaybe<SortOrder>;
  passwordSalt?: InputMaybe<SortOrder>;
  photoUrl?: InputMaybe<SortOrder>;
  publicAddresses?: InputMaybe<SortOrder>;
  publicDiscipline?: InputMaybe<SortOrder>;
  publicIsTelehealthAvailable?: InputMaybe<SortOrder>;
  publicName?: InputMaybe<SortOrder>;
  registrationNumber?: InputMaybe<SortOrder>;
  regulatoryBody?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  stripeCustomerId?: InputMaybe<SortOrder>;
  stripePaymentMethodId?: InputMaybe<SortOrder>;
  trialPurchasesUsed?: InputMaybe<SortOrder>;
};

export type UserCreateInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateManyInput = {
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateNestedOneWithoutAttemptedQuizzesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAttemptedQuizzesInput>;
  create?: InputMaybe<UserCreateWithoutAttemptedQuizzesInput>;
};

export type UserCreateNestedOneWithoutDownloadedResourcesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDownloadedResourcesInput>;
  create?: InputMaybe<UserCreateWithoutDownloadedResourcesInput>;
};

export type UserCreateNestedOneWithoutEventAttendancesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutEventAttendancesInput>;
  create?: InputMaybe<UserCreateWithoutEventAttendancesInput>;
};

export type UserCreateNestedOneWithoutEventRegistrationsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutEventRegistrationsInput>;
  create?: InputMaybe<UserCreateWithoutEventRegistrationsInput>;
};

export type UserCreateNestedOneWithoutManualActivitiesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutManualActivitiesInput>;
  create?: InputMaybe<UserCreateWithoutManualActivitiesInput>;
};

export type UserCreateNestedOneWithoutPaymentsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<UserCreateWithoutPaymentsInput>;
};

export type UserCreateNestedOneWithoutPodcastsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPodcastsInput>;
  create?: InputMaybe<UserCreateWithoutPodcastsInput>;
};

export type UserCreateNestedOneWithoutProgrammeProgressionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutProgrammeProgressionsInput>;
  create?: InputMaybe<UserCreateWithoutProgrammeProgressionsInput>;
};

export type UserCreateNestedOneWithoutReadArticlesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutReadArticlesInput>;
  create?: InputMaybe<UserCreateWithoutReadArticlesInput>;
};

export type UserCreateNestedOneWithoutRefundsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutRefundsInput>;
  create?: InputMaybe<UserCreateWithoutRefundsInput>;
};

export type UserCreateNestedOneWithoutSavedForLaterInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSavedForLaterInput>;
  create?: InputMaybe<UserCreateWithoutSavedForLaterInput>;
};

export type UserCreateNestedOneWithoutUpgradePromptEngagementsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUpgradePromptEngagementsInput>;
  create?: InputMaybe<UserCreateWithoutUpgradePromptEngagementsInput>;
};

export type UserCreateNestedOneWithoutUserSubscriptionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserSubscriptionsInput>;
  create?: InputMaybe<UserCreateWithoutUserSubscriptionsInput>;
};

export type UserCreateNestedOneWithoutUserTagsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserTagsInput>;
  create?: InputMaybe<UserCreateWithoutUserTagsInput>;
};

export type UserCreateOrConnectWithoutAttemptedQuizzesInput = {
  create: UserCreateWithoutAttemptedQuizzesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutDownloadedResourcesInput = {
  create: UserCreateWithoutDownloadedResourcesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEventAttendancesInput = {
  create: UserCreateWithoutEventAttendancesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEventRegistrationsInput = {
  create: UserCreateWithoutEventRegistrationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutManualActivitiesInput = {
  create: UserCreateWithoutManualActivitiesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPaymentsInput = {
  create: UserCreateWithoutPaymentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPodcastsInput = {
  create: UserCreateWithoutPodcastsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutProgrammeProgressionsInput = {
  create: UserCreateWithoutProgrammeProgressionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutReadArticlesInput = {
  create: UserCreateWithoutReadArticlesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutRefundsInput = {
  create: UserCreateWithoutRefundsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSavedForLaterInput = {
  create: UserCreateWithoutSavedForLaterInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUpgradePromptEngagementsInput = {
  create: UserCreateWithoutUpgradePromptEngagementsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserSubscriptionsInput = {
  create: UserCreateWithoutUserSubscriptionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserTagsInput = {
  create: UserCreateWithoutUserTagsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutAttemptedQuizzesInput = {
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutDownloadedResourcesInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutEventAttendancesInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutEventRegistrationsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutManualActivitiesInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutPaymentsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutPodcastsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutProgrammeProgressionsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutReadArticlesInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutRefundsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutSavedForLaterInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUpgradePromptEngagementsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserSubscriptionsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userTags?: InputMaybe<UserTagsCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserTagsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizCreateNestedManyWithoutUserInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadedResources?: InputMaybe<UserResourceCreateNestedManyWithoutUserInput>;
  email: Scalars['String']['input'];
  eventAttendances?: InputMaybe<EventAttendanceCreateNestedManyWithoutUserInput>;
  eventRegistrations?: InputMaybe<EventRegistrationCreateNestedManyWithoutUserInput>;
  externalId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  healthDiscipline?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProfessional?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  klaviyoProfileId?: InputMaybe<Scalars['String']['input']>;
  manualActivities?: InputMaybe<UserManualActivityCreateNestedManyWithoutUserInput>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<PodcastUserCreateNestedManyWithoutUserInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionCreateNestedManyWithoutUserInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<Scalars['String']['input']>;
  publicIsTelehealthAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  readArticles?: InputMaybe<UserArticleCreateNestedManyWithoutUserInput>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutUserInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regulatoryBody?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  savedForLater?: InputMaybe<SavedForLaterCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  trialPurchasesUsed?: InputMaybe<Scalars['Int']['input']>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementCreateNestedManyWithoutUserInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
};

export type UserManualActivityAvgOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
};

export type UserManualActivityCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserManualActivityCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutManualActivitiesInput;
};

export type UserManualActivityCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type UserManualActivityCreateManyUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserManualActivityCreateManyUserInputEnvelope = {
  data: Array<UserManualActivityCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserManualActivityCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserManualActivityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserManualActivityCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserManualActivityCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserManualActivityCreateManyUserInputEnvelope>;
};

export type UserManualActivityCreateOrConnectWithoutUserInput = {
  create: UserManualActivityCreateWithoutUserInput;
  where: UserManualActivityWhereUniqueInput;
};

export type UserManualActivityCreateWithoutUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserManualActivityListRelationFilter = {
  every?: InputMaybe<UserManualActivityWhereInput>;
  none?: InputMaybe<UserManualActivityWhereInput>;
  some?: InputMaybe<UserManualActivityWhereInput>;
};

export type UserManualActivityMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserManualActivityMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserManualActivityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserManualActivityOrderByWithAggregationInput = {
  _avg?: InputMaybe<UserManualActivityAvgOrderByAggregateInput>;
  _count?: InputMaybe<UserManualActivityCountOrderByAggregateInput>;
  _max?: InputMaybe<UserManualActivityMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserManualActivityMinOrderByAggregateInput>;
  _sum?: InputMaybe<UserManualActivitySumOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserManualActivityOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserManualActivityScalarFieldEnum {
  Created = 'created',
  Description = 'description',
  Duration = 'duration',
  Id = 'id',
  Modified = 'modified',
  UserId = 'userId'
}

export type UserManualActivityScalarWhereInput = {
  AND?: InputMaybe<Array<UserManualActivityScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserManualActivityScalarWhereInput>>;
  OR?: InputMaybe<Array<UserManualActivityScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserManualActivityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserManualActivityScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserManualActivityScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserManualActivityScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  duration?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type UserManualActivitySumOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
};

export type UserManualActivityUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutManualActivitiesNestedInput>;
};

export type UserManualActivityUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserManualActivityUpdateManyWithWhereWithoutUserInput = {
  data: UserManualActivityUpdateManyMutationInput;
  where: UserManualActivityScalarWhereInput;
};

export type UserManualActivityUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserManualActivityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserManualActivityCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserManualActivityCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserManualActivityCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserManualActivityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserManualActivityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserManualActivityWhereUniqueInput>>;
  set?: InputMaybe<Array<UserManualActivityWhereUniqueInput>>;
  update?: InputMaybe<Array<UserManualActivityUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserManualActivityUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserManualActivityUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserManualActivityUpdateWithWhereUniqueWithoutUserInput = {
  data: UserManualActivityUpdateWithoutUserInput;
  where: UserManualActivityWhereUniqueInput;
};

export type UserManualActivityUpdateWithoutUserInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserManualActivityUpsertWithWhereUniqueWithoutUserInput = {
  create: UserManualActivityCreateWithoutUserInput;
  update: UserManualActivityUpdateWithoutUserInput;
  where: UserManualActivityWhereUniqueInput;
};

export type UserManualActivityWhereInput = {
  AND?: InputMaybe<Array<UserManualActivityWhereInput>>;
  NOT?: InputMaybe<Array<UserManualActivityWhereInput>>;
  OR?: InputMaybe<Array<UserManualActivityWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserManualActivityWhereUniqueInput = {
  AND?: InputMaybe<Array<UserManualActivityWhereInput>>;
  NOT?: InputMaybe<Array<UserManualActivityWhereInput>>;
  OR?: InputMaybe<Array<UserManualActivityWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserMaxOrderByAggregateInput = {
  billingCountryCode?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  fullName?: InputMaybe<SortOrder>;
  healthDiscipline?: InputMaybe<SortOrder>;
  howDidYouHear?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEnabled?: InputMaybe<SortOrder>;
  isProfessional?: InputMaybe<SortOrder>;
  isPublicEnabled?: InputMaybe<SortOrder>;
  klaviyoProfileId?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  passwordHash?: InputMaybe<SortOrder>;
  passwordResetToken?: InputMaybe<SortOrder>;
  passwordSalt?: InputMaybe<SortOrder>;
  photoUrl?: InputMaybe<SortOrder>;
  publicDiscipline?: InputMaybe<SortOrder>;
  publicIsTelehealthAvailable?: InputMaybe<SortOrder>;
  publicName?: InputMaybe<SortOrder>;
  registrationNumber?: InputMaybe<SortOrder>;
  regulatoryBody?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  stripeCustomerId?: InputMaybe<SortOrder>;
  stripePaymentMethodId?: InputMaybe<SortOrder>;
  trialPurchasesUsed?: InputMaybe<SortOrder>;
};

export type UserMinOrderByAggregateInput = {
  billingCountryCode?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  fullName?: InputMaybe<SortOrder>;
  healthDiscipline?: InputMaybe<SortOrder>;
  howDidYouHear?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEnabled?: InputMaybe<SortOrder>;
  isProfessional?: InputMaybe<SortOrder>;
  isPublicEnabled?: InputMaybe<SortOrder>;
  klaviyoProfileId?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  passwordHash?: InputMaybe<SortOrder>;
  passwordResetToken?: InputMaybe<SortOrder>;
  passwordSalt?: InputMaybe<SortOrder>;
  photoUrl?: InputMaybe<SortOrder>;
  publicDiscipline?: InputMaybe<SortOrder>;
  publicIsTelehealthAvailable?: InputMaybe<SortOrder>;
  publicName?: InputMaybe<SortOrder>;
  registrationNumber?: InputMaybe<SortOrder>;
  regulatoryBody?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  stripeCustomerId?: InputMaybe<SortOrder>;
  stripePaymentMethodId?: InputMaybe<SortOrder>;
  trialPurchasesUsed?: InputMaybe<SortOrder>;
};

export type UserOrderByWithAggregationInput = {
  _avg?: InputMaybe<UserAvgOrderByAggregateInput>;
  _count?: InputMaybe<UserCountOrderByAggregateInput>;
  _max?: InputMaybe<UserMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserMinOrderByAggregateInput>;
  _sum?: InputMaybe<UserSumOrderByAggregateInput>;
  billingAddress?: InputMaybe<SortOrderInput>;
  billingCountryCode?: InputMaybe<SortOrderInput>;
  created?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  fullName?: InputMaybe<SortOrder>;
  healthDiscipline?: InputMaybe<SortOrderInput>;
  howDidYouHear?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isEnabled?: InputMaybe<SortOrder>;
  isProfessional?: InputMaybe<SortOrder>;
  isPublicEnabled?: InputMaybe<SortOrder>;
  klaviyoProfileId?: InputMaybe<SortOrderInput>;
  modified?: InputMaybe<SortOrder>;
  passwordHash?: InputMaybe<SortOrderInput>;
  passwordResetToken?: InputMaybe<SortOrderInput>;
  passwordSalt?: InputMaybe<SortOrderInput>;
  photoUrl?: InputMaybe<SortOrderInput>;
  publicAddresses?: InputMaybe<SortOrderInput>;
  publicDiscipline?: InputMaybe<SortOrderInput>;
  publicIsTelehealthAvailable?: InputMaybe<SortOrder>;
  publicName?: InputMaybe<SortOrderInput>;
  registrationNumber?: InputMaybe<SortOrderInput>;
  regulatoryBody?: InputMaybe<SortOrderInput>;
  role?: InputMaybe<SortOrder>;
  stripeCustomerId?: InputMaybe<SortOrderInput>;
  stripePaymentMethodId?: InputMaybe<SortOrderInput>;
  trialPurchasesUsed?: InputMaybe<SortOrderInput>;
};

export type UserOrderByWithRelationInput = {
  attemptedQuizzes?: InputMaybe<UserQuizOrderByRelationAggregateInput>;
  billingAddress?: InputMaybe<SortOrderInput>;
  billingCountryCode?: InputMaybe<SortOrderInput>;
  created?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrderInput>;
  downloadedResources?: InputMaybe<UserResourceOrderByRelationAggregateInput>;
  email?: InputMaybe<SortOrder>;
  eventAttendances?: InputMaybe<EventAttendanceOrderByRelationAggregateInput>;
  eventRegistrations?: InputMaybe<EventRegistrationOrderByRelationAggregateInput>;
  externalId?: InputMaybe<SortOrder>;
  fullName?: InputMaybe<SortOrder>;
  healthDiscipline?: InputMaybe<SortOrderInput>;
  howDidYouHear?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isEnabled?: InputMaybe<SortOrder>;
  isProfessional?: InputMaybe<SortOrder>;
  isPublicEnabled?: InputMaybe<SortOrder>;
  klaviyoProfileId?: InputMaybe<SortOrderInput>;
  manualActivities?: InputMaybe<UserManualActivityOrderByRelationAggregateInput>;
  modified?: InputMaybe<SortOrder>;
  passwordHash?: InputMaybe<SortOrderInput>;
  passwordResetToken?: InputMaybe<SortOrderInput>;
  passwordSalt?: InputMaybe<SortOrderInput>;
  payments?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  photoUrl?: InputMaybe<SortOrderInput>;
  podcasts?: InputMaybe<PodcastUserOrderByRelationAggregateInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionOrderByRelationAggregateInput>;
  publicAddresses?: InputMaybe<SortOrderInput>;
  publicDiscipline?: InputMaybe<SortOrderInput>;
  publicIsTelehealthAvailable?: InputMaybe<SortOrder>;
  publicName?: InputMaybe<SortOrderInput>;
  readArticles?: InputMaybe<UserArticleOrderByRelationAggregateInput>;
  refunds?: InputMaybe<RefundOrderByRelationAggregateInput>;
  registrationNumber?: InputMaybe<SortOrderInput>;
  regulatoryBody?: InputMaybe<SortOrderInput>;
  role?: InputMaybe<SortOrder>;
  savedForLater?: InputMaybe<SavedForLaterOrderByRelationAggregateInput>;
  stripeCustomerId?: InputMaybe<SortOrderInput>;
  stripePaymentMethodId?: InputMaybe<SortOrderInput>;
  trialPurchasesUsed?: InputMaybe<SortOrderInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementOrderByRelationAggregateInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionOrderByRelationAggregateInput>;
  userTags?: InputMaybe<UserTagsOrderByRelationAggregateInput>;
};

export type UserQuizAvgOrderByAggregateInput = {
  score?: InputMaybe<SortOrder>;
  sourceMaxAttempts?: InputMaybe<SortOrder>;
  sourceMinScore?: InputMaybe<SortOrder>;
};

export type UserQuizCountOrderByAggregateInput = {
  answers?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  isPass?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedKlaviyoPassed?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  score?: InputMaybe<SortOrder>;
  sourceMarkdown?: InputMaybe<SortOrder>;
  sourceMaxAttempts?: InputMaybe<SortOrder>;
  sourceMinScore?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserQuizCreateInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  category: CategoryCreateNestedOneWithoutUserQuizzesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isPass?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoPassed?: InputMaybe<Scalars['Boolean']['input']>;
  quiz: QuizCreateNestedOneWithoutAttemptedByInput;
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMarkdown?: InputMaybe<Scalars['String']['input']>;
  sourceMaxAttempts?: InputMaybe<Scalars['Int']['input']>;
  sourceMinScore?: InputMaybe<Scalars['Float']['input']>;
  user: UserCreateNestedOneWithoutAttemptedQuizzesInput;
};

export type UserQuizCreateManyCategoryInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isPass?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoPassed?: InputMaybe<Scalars['Boolean']['input']>;
  quizId: Scalars['String']['input'];
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMarkdown?: InputMaybe<Scalars['String']['input']>;
  sourceMaxAttempts?: InputMaybe<Scalars['Int']['input']>;
  sourceMinScore?: InputMaybe<Scalars['Float']['input']>;
  userId: Scalars['String']['input'];
};

export type UserQuizCreateManyCategoryInputEnvelope = {
  data: Array<UserQuizCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserQuizCreateManyInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isPass?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoPassed?: InputMaybe<Scalars['Boolean']['input']>;
  quizId: Scalars['String']['input'];
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMarkdown?: InputMaybe<Scalars['String']['input']>;
  sourceMaxAttempts?: InputMaybe<Scalars['Int']['input']>;
  sourceMinScore?: InputMaybe<Scalars['Float']['input']>;
  userId: Scalars['String']['input'];
};

export type UserQuizCreateManyQuizInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isPass?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoPassed?: InputMaybe<Scalars['Boolean']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMarkdown?: InputMaybe<Scalars['String']['input']>;
  sourceMaxAttempts?: InputMaybe<Scalars['Int']['input']>;
  sourceMinScore?: InputMaybe<Scalars['Float']['input']>;
  userId: Scalars['String']['input'];
};

export type UserQuizCreateManyQuizInputEnvelope = {
  data: Array<UserQuizCreateManyQuizInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserQuizCreateManyUserInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  categoryId: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isPass?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoPassed?: InputMaybe<Scalars['Boolean']['input']>;
  quizId: Scalars['String']['input'];
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMarkdown?: InputMaybe<Scalars['String']['input']>;
  sourceMaxAttempts?: InputMaybe<Scalars['Int']['input']>;
  sourceMinScore?: InputMaybe<Scalars['Float']['input']>;
};

export type UserQuizCreateManyUserInputEnvelope = {
  data: Array<UserQuizCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserQuizCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserQuizCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<UserQuizCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<UserQuizCreateManyCategoryInputEnvelope>;
};

export type UserQuizCreateNestedManyWithoutQuizInput = {
  connect?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserQuizCreateOrConnectWithoutQuizInput>>;
  create?: InputMaybe<Array<UserQuizCreateWithoutQuizInput>>;
  createMany?: InputMaybe<UserQuizCreateManyQuizInputEnvelope>;
};

export type UserQuizCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserQuizCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserQuizCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserQuizCreateManyUserInputEnvelope>;
};

export type UserQuizCreateOrConnectWithoutCategoryInput = {
  create: UserQuizCreateWithoutCategoryInput;
  where: UserQuizWhereUniqueInput;
};

export type UserQuizCreateOrConnectWithoutQuizInput = {
  create: UserQuizCreateWithoutQuizInput;
  where: UserQuizWhereUniqueInput;
};

export type UserQuizCreateOrConnectWithoutUserInput = {
  create: UserQuizCreateWithoutUserInput;
  where: UserQuizWhereUniqueInput;
};

export type UserQuizCreateWithoutCategoryInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isPass?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoPassed?: InputMaybe<Scalars['Boolean']['input']>;
  quiz: QuizCreateNestedOneWithoutAttemptedByInput;
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMarkdown?: InputMaybe<Scalars['String']['input']>;
  sourceMaxAttempts?: InputMaybe<Scalars['Int']['input']>;
  sourceMinScore?: InputMaybe<Scalars['Float']['input']>;
  user: UserCreateNestedOneWithoutAttemptedQuizzesInput;
};

export type UserQuizCreateWithoutQuizInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  category: CategoryCreateNestedOneWithoutUserQuizzesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isPass?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoPassed?: InputMaybe<Scalars['Boolean']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMarkdown?: InputMaybe<Scalars['String']['input']>;
  sourceMaxAttempts?: InputMaybe<Scalars['Int']['input']>;
  sourceMinScore?: InputMaybe<Scalars['Float']['input']>;
  user: UserCreateNestedOneWithoutAttemptedQuizzesInput;
};

export type UserQuizCreateWithoutUserInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  category: CategoryCreateNestedOneWithoutUserQuizzesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isPass?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedKlaviyoPassed?: InputMaybe<Scalars['Boolean']['input']>;
  quiz: QuizCreateNestedOneWithoutAttemptedByInput;
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMarkdown?: InputMaybe<Scalars['String']['input']>;
  sourceMaxAttempts?: InputMaybe<Scalars['Int']['input']>;
  sourceMinScore?: InputMaybe<Scalars['Float']['input']>;
};

export type UserQuizListRelationFilter = {
  every?: InputMaybe<UserQuizWhereInput>;
  none?: InputMaybe<UserQuizWhereInput>;
  some?: InputMaybe<UserQuizWhereInput>;
};

export type UserQuizMaxOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  isPass?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedKlaviyoPassed?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  score?: InputMaybe<SortOrder>;
  sourceMarkdown?: InputMaybe<SortOrder>;
  sourceMaxAttempts?: InputMaybe<SortOrder>;
  sourceMinScore?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserQuizMinOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  isPass?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedKlaviyoPassed?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  score?: InputMaybe<SortOrder>;
  sourceMarkdown?: InputMaybe<SortOrder>;
  sourceMaxAttempts?: InputMaybe<SortOrder>;
  sourceMinScore?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserQuizOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserQuizOrderByWithAggregationInput = {
  _avg?: InputMaybe<UserQuizAvgOrderByAggregateInput>;
  _count?: InputMaybe<UserQuizCountOrderByAggregateInput>;
  _max?: InputMaybe<UserQuizMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserQuizMinOrderByAggregateInput>;
  _sum?: InputMaybe<UserQuizSumOrderByAggregateInput>;
  answers?: InputMaybe<SortOrderInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  isPass?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedKlaviyoPassed?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  score?: InputMaybe<SortOrderInput>;
  sourceMarkdown?: InputMaybe<SortOrderInput>;
  sourceMaxAttempts?: InputMaybe<SortOrderInput>;
  sourceMinScore?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrder>;
};

export type UserQuizOrderByWithRelationInput = {
  answers?: InputMaybe<SortOrderInput>;
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  isPass?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedKlaviyoPassed?: InputMaybe<SortOrder>;
  quiz?: InputMaybe<QuizOrderByWithRelationInput>;
  quizId?: InputMaybe<SortOrder>;
  score?: InputMaybe<SortOrderInput>;
  sourceMarkdown?: InputMaybe<SortOrderInput>;
  sourceMaxAttempts?: InputMaybe<SortOrderInput>;
  sourceMinScore?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserQuizScalarFieldEnum {
  Answers = 'answers',
  CategoryId = 'categoryId',
  Created = 'created',
  Id = 'id',
  IsCompleted = 'isCompleted',
  IsPass = 'isPass',
  Modified = 'modified',
  NotifiedKlaviyoPassed = 'notifiedKlaviyoPassed',
  QuizId = 'quizId',
  Score = 'score',
  SourceMarkdown = 'sourceMarkdown',
  SourceMaxAttempts = 'sourceMaxAttempts',
  SourceMinScore = 'sourceMinScore',
  UserId = 'userId'
}

export type UserQuizScalarWhereInput = {
  AND?: InputMaybe<Array<UserQuizScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserQuizScalarWhereInput>>;
  OR?: InputMaybe<Array<UserQuizScalarWhereInput>>;
  answers?: InputMaybe<JsonNullableFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isCompleted?: InputMaybe<BoolFilter>;
  isPass?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  notifiedKlaviyoPassed?: InputMaybe<BoolFilter>;
  quizId?: InputMaybe<StringFilter>;
  score?: InputMaybe<FloatNullableFilter>;
  sourceMarkdown?: InputMaybe<StringNullableFilter>;
  sourceMaxAttempts?: InputMaybe<IntNullableFilter>;
  sourceMinScore?: InputMaybe<FloatNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserQuizScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserQuizScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserQuizScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserQuizScalarWhereWithAggregatesInput>>;
  answers?: InputMaybe<JsonNullableWithAggregatesFilter>;
  categoryId?: InputMaybe<StringWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isCompleted?: InputMaybe<BoolWithAggregatesFilter>;
  isPass?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  notifiedKlaviyoPassed?: InputMaybe<BoolWithAggregatesFilter>;
  quizId?: InputMaybe<StringWithAggregatesFilter>;
  score?: InputMaybe<FloatNullableWithAggregatesFilter>;
  sourceMarkdown?: InputMaybe<StringNullableWithAggregatesFilter>;
  sourceMaxAttempts?: InputMaybe<IntNullableWithAggregatesFilter>;
  sourceMinScore?: InputMaybe<FloatNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type UserQuizSumOrderByAggregateInput = {
  score?: InputMaybe<SortOrder>;
  sourceMaxAttempts?: InputMaybe<SortOrder>;
  sourceMinScore?: InputMaybe<SortOrder>;
};

export type UserQuizUpdateInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutUserQuizzesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPass?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedKlaviyoPassed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  quiz?: InputMaybe<QuizUpdateOneRequiredWithoutAttemptedByNestedInput>;
  score?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  sourceMarkdown?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceMaxAttempts?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sourceMinScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAttemptedQuizzesNestedInput>;
};

export type UserQuizUpdateManyMutationInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPass?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedKlaviyoPassed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  sourceMarkdown?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceMaxAttempts?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sourceMinScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type UserQuizUpdateManyWithWhereWithoutCategoryInput = {
  data: UserQuizUpdateManyMutationInput;
  where: UserQuizScalarWhereInput;
};

export type UserQuizUpdateManyWithWhereWithoutQuizInput = {
  data: UserQuizUpdateManyMutationInput;
  where: UserQuizScalarWhereInput;
};

export type UserQuizUpdateManyWithWhereWithoutUserInput = {
  data: UserQuizUpdateManyMutationInput;
  where: UserQuizScalarWhereInput;
};

export type UserQuizUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserQuizCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<UserQuizCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<UserQuizCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserQuizScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  set?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  update?: InputMaybe<Array<UserQuizUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<UserQuizUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<UserQuizUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type UserQuizUpdateManyWithoutQuizNestedInput = {
  connect?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserQuizCreateOrConnectWithoutQuizInput>>;
  create?: InputMaybe<Array<UserQuizCreateWithoutQuizInput>>;
  createMany?: InputMaybe<UserQuizCreateManyQuizInputEnvelope>;
  delete?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserQuizScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  set?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  update?: InputMaybe<Array<UserQuizUpdateWithWhereUniqueWithoutQuizInput>>;
  updateMany?: InputMaybe<Array<UserQuizUpdateManyWithWhereWithoutQuizInput>>;
  upsert?: InputMaybe<Array<UserQuizUpsertWithWhereUniqueWithoutQuizInput>>;
};

export type UserQuizUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserQuizCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserQuizCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserQuizCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserQuizScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  set?: InputMaybe<Array<UserQuizWhereUniqueInput>>;
  update?: InputMaybe<Array<UserQuizUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserQuizUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserQuizUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserQuizUpdateWithWhereUniqueWithoutCategoryInput = {
  data: UserQuizUpdateWithoutCategoryInput;
  where: UserQuizWhereUniqueInput;
};

export type UserQuizUpdateWithWhereUniqueWithoutQuizInput = {
  data: UserQuizUpdateWithoutQuizInput;
  where: UserQuizWhereUniqueInput;
};

export type UserQuizUpdateWithWhereUniqueWithoutUserInput = {
  data: UserQuizUpdateWithoutUserInput;
  where: UserQuizWhereUniqueInput;
};

export type UserQuizUpdateWithoutCategoryInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPass?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedKlaviyoPassed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  quiz?: InputMaybe<QuizUpdateOneRequiredWithoutAttemptedByNestedInput>;
  score?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  sourceMarkdown?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceMaxAttempts?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sourceMinScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAttemptedQuizzesNestedInput>;
};

export type UserQuizUpdateWithoutQuizInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutUserQuizzesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPass?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedKlaviyoPassed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  sourceMarkdown?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceMaxAttempts?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sourceMinScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAttemptedQuizzesNestedInput>;
};

export type UserQuizUpdateWithoutUserInput = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutUserQuizzesNestedInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPass?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedKlaviyoPassed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  quiz?: InputMaybe<QuizUpdateOneRequiredWithoutAttemptedByNestedInput>;
  score?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  sourceMarkdown?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceMaxAttempts?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sourceMinScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type UserQuizUpsertWithWhereUniqueWithoutCategoryInput = {
  create: UserQuizCreateWithoutCategoryInput;
  update: UserQuizUpdateWithoutCategoryInput;
  where: UserQuizWhereUniqueInput;
};

export type UserQuizUpsertWithWhereUniqueWithoutQuizInput = {
  create: UserQuizCreateWithoutQuizInput;
  update: UserQuizUpdateWithoutQuizInput;
  where: UserQuizWhereUniqueInput;
};

export type UserQuizUpsertWithWhereUniqueWithoutUserInput = {
  create: UserQuizCreateWithoutUserInput;
  update: UserQuizUpdateWithoutUserInput;
  where: UserQuizWhereUniqueInput;
};

export type UserQuizWhereInput = {
  AND?: InputMaybe<Array<UserQuizWhereInput>>;
  NOT?: InputMaybe<Array<UserQuizWhereInput>>;
  OR?: InputMaybe<Array<UserQuizWhereInput>>;
  answers?: InputMaybe<JsonNullableFilter>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isCompleted?: InputMaybe<BoolFilter>;
  isPass?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  notifiedKlaviyoPassed?: InputMaybe<BoolFilter>;
  quiz?: InputMaybe<QuizScalarRelationFilter>;
  quizId?: InputMaybe<StringFilter>;
  score?: InputMaybe<FloatNullableFilter>;
  sourceMarkdown?: InputMaybe<StringNullableFilter>;
  sourceMaxAttempts?: InputMaybe<IntNullableFilter>;
  sourceMinScore?: InputMaybe<FloatNullableFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserQuizWhereUniqueInput = {
  AND?: InputMaybe<Array<UserQuizWhereInput>>;
  NOT?: InputMaybe<Array<UserQuizWhereInput>>;
  OR?: InputMaybe<Array<UserQuizWhereInput>>;
  answers?: InputMaybe<JsonNullableFilter>;
  category?: InputMaybe<CategoryScalarRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCompleted?: InputMaybe<BoolFilter>;
  isPass?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  notifiedKlaviyoPassed?: InputMaybe<BoolFilter>;
  quiz?: InputMaybe<QuizScalarRelationFilter>;
  quizId?: InputMaybe<StringFilter>;
  score?: InputMaybe<FloatNullableFilter>;
  sourceMarkdown?: InputMaybe<StringNullableFilter>;
  sourceMaxAttempts?: InputMaybe<IntNullableFilter>;
  sourceMinScore?: InputMaybe<FloatNullableFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserResourceCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserResourceCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resource: ResourceCreateNestedOneWithoutDownloadedByInput;
  user: UserCreateNestedOneWithoutDownloadedResourcesInput;
};

export type UserResourceCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resourceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserResourceCreateManyResourceInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type UserResourceCreateManyResourceInputEnvelope = {
  data: Array<UserResourceCreateManyResourceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserResourceCreateManyUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resourceId: Scalars['String']['input'];
};

export type UserResourceCreateManyUserInputEnvelope = {
  data: Array<UserResourceCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserResourceCreateNestedManyWithoutResourceInput = {
  connect?: InputMaybe<Array<UserResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserResourceCreateOrConnectWithoutResourceInput>>;
  create?: InputMaybe<Array<UserResourceCreateWithoutResourceInput>>;
  createMany?: InputMaybe<UserResourceCreateManyResourceInputEnvelope>;
};

export type UserResourceCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserResourceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserResourceCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserResourceCreateManyUserInputEnvelope>;
};

export type UserResourceCreateOrConnectWithoutResourceInput = {
  create: UserResourceCreateWithoutResourceInput;
  where: UserResourceWhereUniqueInput;
};

export type UserResourceCreateOrConnectWithoutUserInput = {
  create: UserResourceCreateWithoutUserInput;
  where: UserResourceWhereUniqueInput;
};

export type UserResourceCreateWithoutResourceInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutDownloadedResourcesInput;
};

export type UserResourceCreateWithoutUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  resource: ResourceCreateNestedOneWithoutDownloadedByInput;
};

export type UserResourceListRelationFilter = {
  every?: InputMaybe<UserResourceWhereInput>;
  none?: InputMaybe<UserResourceWhereInput>;
  some?: InputMaybe<UserResourceWhereInput>;
};

export type UserResourceMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserResourceMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserResourceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserResourceOrderByWithAggregationInput = {
  _count?: InputMaybe<UserResourceCountOrderByAggregateInput>;
  _max?: InputMaybe<UserResourceMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserResourceMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserResourceOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  resource?: InputMaybe<ResourceOrderByWithRelationInput>;
  resourceId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserResourceScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  Modified = 'modified',
  ResourceId = 'resourceId',
  UserId = 'userId'
}

export type UserResourceScalarWhereInput = {
  AND?: InputMaybe<Array<UserResourceScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserResourceScalarWhereInput>>;
  OR?: InputMaybe<Array<UserResourceScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  resourceId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserResourceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserResourceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserResourceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserResourceScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  resourceId?: InputMaybe<StringWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type UserResourceUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  resource?: InputMaybe<ResourceUpdateOneRequiredWithoutDownloadedByNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutDownloadedResourcesNestedInput>;
};

export type UserResourceUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserResourceUpdateManyWithWhereWithoutResourceInput = {
  data: UserResourceUpdateManyMutationInput;
  where: UserResourceScalarWhereInput;
};

export type UserResourceUpdateManyWithWhereWithoutUserInput = {
  data: UserResourceUpdateManyMutationInput;
  where: UserResourceScalarWhereInput;
};

export type UserResourceUpdateManyWithoutResourceNestedInput = {
  connect?: InputMaybe<Array<UserResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserResourceCreateOrConnectWithoutResourceInput>>;
  create?: InputMaybe<Array<UserResourceCreateWithoutResourceInput>>;
  createMany?: InputMaybe<UserResourceCreateManyResourceInputEnvelope>;
  delete?: InputMaybe<Array<UserResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<UserResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<UserResourceUpdateWithWhereUniqueWithoutResourceInput>>;
  updateMany?: InputMaybe<Array<UserResourceUpdateManyWithWhereWithoutResourceInput>>;
  upsert?: InputMaybe<Array<UserResourceUpsertWithWhereUniqueWithoutResourceInput>>;
};

export type UserResourceUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserResourceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserResourceCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserResourceCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<UserResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<UserResourceUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserResourceUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserResourceUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserResourceUpdateWithWhereUniqueWithoutResourceInput = {
  data: UserResourceUpdateWithoutResourceInput;
  where: UserResourceWhereUniqueInput;
};

export type UserResourceUpdateWithWhereUniqueWithoutUserInput = {
  data: UserResourceUpdateWithoutUserInput;
  where: UserResourceWhereUniqueInput;
};

export type UserResourceUpdateWithoutResourceInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutDownloadedResourcesNestedInput>;
};

export type UserResourceUpdateWithoutUserInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  resource?: InputMaybe<ResourceUpdateOneRequiredWithoutDownloadedByNestedInput>;
};

export type UserResourceUpsertWithWhereUniqueWithoutResourceInput = {
  create: UserResourceCreateWithoutResourceInput;
  update: UserResourceUpdateWithoutResourceInput;
  where: UserResourceWhereUniqueInput;
};

export type UserResourceUpsertWithWhereUniqueWithoutUserInput = {
  create: UserResourceCreateWithoutUserInput;
  update: UserResourceUpdateWithoutUserInput;
  where: UserResourceWhereUniqueInput;
};

export type UserResourceUserResourceCompoundUniqueInput = {
  created: Scalars['DateTime']['input'];
  resourceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserResourceWhereInput = {
  AND?: InputMaybe<Array<UserResourceWhereInput>>;
  NOT?: InputMaybe<Array<UserResourceWhereInput>>;
  OR?: InputMaybe<Array<UserResourceWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  resource?: InputMaybe<ResourceScalarRelationFilter>;
  resourceId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserResourceWhereUniqueInput = {
  AND?: InputMaybe<Array<UserResourceWhereInput>>;
  NOT?: InputMaybe<Array<UserResourceWhereInput>>;
  OR?: InputMaybe<Array<UserResourceWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<DateTimeFilter>;
  resource?: InputMaybe<ResourceScalarRelationFilter>;
  resourceId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  userResource?: InputMaybe<UserResourceUserResourceCompoundUniqueInput>;
};

export enum UserScalarFieldEnum {
  BillingAddress = 'billingAddress',
  BillingCountryCode = 'billingCountryCode',
  Created = 'created',
  DisplayName = 'displayName',
  Email = 'email',
  ExternalId = 'externalId',
  FullName = 'fullName',
  HealthDiscipline = 'healthDiscipline',
  HowDidYouHear = 'howDidYouHear',
  Id = 'id',
  IsEnabled = 'isEnabled',
  IsProfessional = 'isProfessional',
  IsPublicEnabled = 'isPublicEnabled',
  KlaviyoProfileId = 'klaviyoProfileId',
  Modified = 'modified',
  PasswordHash = 'passwordHash',
  PasswordResetToken = 'passwordResetToken',
  PasswordSalt = 'passwordSalt',
  PhotoUrl = 'photoUrl',
  PublicAddresses = 'publicAddresses',
  PublicDiscipline = 'publicDiscipline',
  PublicIsTelehealthAvailable = 'publicIsTelehealthAvailable',
  PublicName = 'publicName',
  RegistrationNumber = 'registrationNumber',
  RegulatoryBody = 'regulatoryBody',
  Role = 'role',
  StripeCustomerId = 'stripeCustomerId',
  StripePaymentMethodId = 'stripePaymentMethodId',
  TrialPurchasesUsed = 'trialPurchasesUsed'
}

export type UserScalarRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
  billingAddress?: InputMaybe<JsonNullableWithAggregatesFilter>;
  billingCountryCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  displayName?: InputMaybe<StringNullableWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  externalId?: InputMaybe<StringWithAggregatesFilter>;
  fullName?: InputMaybe<StringWithAggregatesFilter>;
  healthDiscipline?: InputMaybe<StringNullableWithAggregatesFilter>;
  howDidYouHear?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isEnabled?: InputMaybe<BoolWithAggregatesFilter>;
  isProfessional?: InputMaybe<BoolWithAggregatesFilter>;
  isPublicEnabled?: InputMaybe<BoolWithAggregatesFilter>;
  klaviyoProfileId?: InputMaybe<StringNullableWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  passwordHash?: InputMaybe<StringNullableWithAggregatesFilter>;
  passwordResetToken?: InputMaybe<StringNullableWithAggregatesFilter>;
  passwordSalt?: InputMaybe<StringNullableWithAggregatesFilter>;
  photoUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  publicAddresses?: InputMaybe<JsonNullableWithAggregatesFilter>;
  publicDiscipline?: InputMaybe<StringNullableWithAggregatesFilter>;
  publicIsTelehealthAvailable?: InputMaybe<BoolWithAggregatesFilter>;
  publicName?: InputMaybe<StringNullableWithAggregatesFilter>;
  registrationNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  regulatoryBody?: InputMaybe<StringNullableWithAggregatesFilter>;
  role?: InputMaybe<EnumRoleWithAggregatesFilter>;
  stripeCustomerId?: InputMaybe<StringNullableWithAggregatesFilter>;
  stripePaymentMethodId?: InputMaybe<StringNullableWithAggregatesFilter>;
  trialPurchasesUsed?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type UserSubscriptionCountOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCancelled?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedAccessEnded?: InputMaybe<SortOrder>;
  notifiedExpired?: InputMaybe<SortOrder>;
  notifiedExpiringIn8Weeks?: InputMaybe<SortOrder>;
  notifiedExpiringIn30Days?: InputMaybe<SortOrder>;
  notifiedExpiringSoon?: InputMaybe<SortOrder>;
  notifiedExpiringTomorrow?: InputMaybe<SortOrder>;
  notifiedRenewalFailed?: InputMaybe<SortOrder>;
  notifiedRenewed?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  validFrom?: InputMaybe<SortOrder>;
  validTo?: InputMaybe<SortOrder>;
};

export type UserSubscriptionCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedAccessEnded?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpired?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn8Weeks?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn30Days?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringSoon?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringTomorrow?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewalFailed?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewed?: InputMaybe<Scalars['Boolean']['input']>;
  productSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUserSubscriptionsInput;
  renewedByPayments?: InputMaybe<PaymentItemCreateNestedManyWithoutRenewsSubscriptionInput>;
  user: UserCreateNestedOneWithoutUserSubscriptionsInput;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserSubscriptionCreateManyInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedAccessEnded?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpired?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn8Weeks?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn30Days?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringSoon?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringTomorrow?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewalFailed?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewed?: InputMaybe<Scalars['Boolean']['input']>;
  productSubscriptionTypeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserSubscriptionCreateManyProductSubscriptionTypeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedAccessEnded?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpired?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn8Weeks?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn30Days?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringSoon?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringTomorrow?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewalFailed?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewed?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserSubscriptionCreateManyProductSubscriptionTypeInputEnvelope = {
  data: Array<UserSubscriptionCreateManyProductSubscriptionTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSubscriptionCreateManyUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedAccessEnded?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpired?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn8Weeks?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn30Days?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringSoon?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringTomorrow?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewalFailed?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewed?: InputMaybe<Scalars['Boolean']['input']>;
  productSubscriptionTypeId: Scalars['String']['input'];
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserSubscriptionCreateManyUserInputEnvelope = {
  data: Array<UserSubscriptionCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSubscriptionCreateNestedManyWithoutProductSubscriptionTypeInput = {
  connect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscriptionCreateOrConnectWithoutProductSubscriptionTypeInput>>;
  create?: InputMaybe<Array<UserSubscriptionCreateWithoutProductSubscriptionTypeInput>>;
  createMany?: InputMaybe<UserSubscriptionCreateManyProductSubscriptionTypeInputEnvelope>;
};

export type UserSubscriptionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscriptionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserSubscriptionCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserSubscriptionCreateManyUserInputEnvelope>;
};

export type UserSubscriptionCreateNestedOneWithoutRenewedByPaymentsInput = {
  connect?: InputMaybe<UserSubscriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserSubscriptionCreateOrConnectWithoutRenewedByPaymentsInput>;
  create?: InputMaybe<UserSubscriptionCreateWithoutRenewedByPaymentsInput>;
};

export type UserSubscriptionCreateOrConnectWithoutProductSubscriptionTypeInput = {
  create: UserSubscriptionCreateWithoutProductSubscriptionTypeInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionCreateOrConnectWithoutRenewedByPaymentsInput = {
  create: UserSubscriptionCreateWithoutRenewedByPaymentsInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionCreateOrConnectWithoutUserInput = {
  create: UserSubscriptionCreateWithoutUserInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionCreateWithoutProductSubscriptionTypeInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedAccessEnded?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpired?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn8Weeks?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn30Days?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringSoon?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringTomorrow?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewalFailed?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewed?: InputMaybe<Scalars['Boolean']['input']>;
  renewedByPayments?: InputMaybe<PaymentItemCreateNestedManyWithoutRenewsSubscriptionInput>;
  user: UserCreateNestedOneWithoutUserSubscriptionsInput;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserSubscriptionCreateWithoutRenewedByPaymentsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedAccessEnded?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpired?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn8Weeks?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn30Days?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringSoon?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringTomorrow?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewalFailed?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewed?: InputMaybe<Scalars['Boolean']['input']>;
  productSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUserSubscriptionsInput;
  user: UserCreateNestedOneWithoutUserSubscriptionsInput;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserSubscriptionCreateWithoutUserInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  notifiedAccessEnded?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpired?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn8Weeks?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringIn30Days?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringSoon?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedExpiringTomorrow?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewalFailed?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedRenewed?: InputMaybe<Scalars['Boolean']['input']>;
  productSubscriptionType: ProductSubscriptionTypeCreateNestedOneWithoutUserSubscriptionsInput;
  renewedByPayments?: InputMaybe<PaymentItemCreateNestedManyWithoutRenewsSubscriptionInput>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserSubscriptionListRelationFilter = {
  every?: InputMaybe<UserSubscriptionWhereInput>;
  none?: InputMaybe<UserSubscriptionWhereInput>;
  some?: InputMaybe<UserSubscriptionWhereInput>;
};

export type UserSubscriptionMaxOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCancelled?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedAccessEnded?: InputMaybe<SortOrder>;
  notifiedExpired?: InputMaybe<SortOrder>;
  notifiedExpiringIn8Weeks?: InputMaybe<SortOrder>;
  notifiedExpiringIn30Days?: InputMaybe<SortOrder>;
  notifiedExpiringSoon?: InputMaybe<SortOrder>;
  notifiedExpiringTomorrow?: InputMaybe<SortOrder>;
  notifiedRenewalFailed?: InputMaybe<SortOrder>;
  notifiedRenewed?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  validFrom?: InputMaybe<SortOrder>;
  validTo?: InputMaybe<SortOrder>;
};

export type UserSubscriptionMinOrderByAggregateInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCancelled?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedAccessEnded?: InputMaybe<SortOrder>;
  notifiedExpired?: InputMaybe<SortOrder>;
  notifiedExpiringIn8Weeks?: InputMaybe<SortOrder>;
  notifiedExpiringIn30Days?: InputMaybe<SortOrder>;
  notifiedExpiringSoon?: InputMaybe<SortOrder>;
  notifiedExpiringTomorrow?: InputMaybe<SortOrder>;
  notifiedRenewalFailed?: InputMaybe<SortOrder>;
  notifiedRenewed?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  validFrom?: InputMaybe<SortOrder>;
  validTo?: InputMaybe<SortOrder>;
};

export type UserSubscriptionNullableScalarRelationFilter = {
  is?: InputMaybe<UserSubscriptionWhereInput>;
  isNot?: InputMaybe<UserSubscriptionWhereInput>;
};

export type UserSubscriptionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserSubscriptionOrderByWithAggregationInput = {
  _count?: InputMaybe<UserSubscriptionCountOrderByAggregateInput>;
  _max?: InputMaybe<UserSubscriptionMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserSubscriptionMinOrderByAggregateInput>;
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCancelled?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedAccessEnded?: InputMaybe<SortOrder>;
  notifiedExpired?: InputMaybe<SortOrder>;
  notifiedExpiringIn8Weeks?: InputMaybe<SortOrder>;
  notifiedExpiringIn30Days?: InputMaybe<SortOrder>;
  notifiedExpiringSoon?: InputMaybe<SortOrder>;
  notifiedExpiringTomorrow?: InputMaybe<SortOrder>;
  notifiedRenewalFailed?: InputMaybe<SortOrder>;
  notifiedRenewed?: InputMaybe<SortOrder>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  validFrom?: InputMaybe<SortOrder>;
  validTo?: InputMaybe<SortOrderInput>;
};

export type UserSubscriptionOrderByWithRelationInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCancelled?: InputMaybe<SortOrder>;
  modified?: InputMaybe<SortOrder>;
  notifiedAccessEnded?: InputMaybe<SortOrder>;
  notifiedExpired?: InputMaybe<SortOrder>;
  notifiedExpiringIn8Weeks?: InputMaybe<SortOrder>;
  notifiedExpiringIn30Days?: InputMaybe<SortOrder>;
  notifiedExpiringSoon?: InputMaybe<SortOrder>;
  notifiedExpiringTomorrow?: InputMaybe<SortOrder>;
  notifiedRenewalFailed?: InputMaybe<SortOrder>;
  notifiedRenewed?: InputMaybe<SortOrder>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeOrderByWithRelationInput>;
  productSubscriptionTypeId?: InputMaybe<SortOrder>;
  renewedByPayments?: InputMaybe<PaymentItemOrderByRelationAggregateInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  validFrom?: InputMaybe<SortOrder>;
  validTo?: InputMaybe<SortOrderInput>;
};

export enum UserSubscriptionScalarFieldEnum {
  Created = 'created',
  Id = 'id',
  IsCancelled = 'isCancelled',
  Modified = 'modified',
  NotifiedAccessEnded = 'notifiedAccessEnded',
  NotifiedExpired = 'notifiedExpired',
  NotifiedExpiringIn8Weeks = 'notifiedExpiringIn8Weeks',
  NotifiedExpiringIn30Days = 'notifiedExpiringIn30Days',
  NotifiedExpiringSoon = 'notifiedExpiringSoon',
  NotifiedExpiringTomorrow = 'notifiedExpiringTomorrow',
  NotifiedRenewalFailed = 'notifiedRenewalFailed',
  NotifiedRenewed = 'notifiedRenewed',
  ProductSubscriptionTypeId = 'productSubscriptionTypeId',
  UserId = 'userId',
  ValidFrom = 'validFrom',
  ValidTo = 'validTo'
}

export type UserSubscriptionScalarWhereInput = {
  AND?: InputMaybe<Array<UserSubscriptionScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserSubscriptionScalarWhereInput>>;
  OR?: InputMaybe<Array<UserSubscriptionScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isCancelled?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  notifiedAccessEnded?: InputMaybe<BoolFilter>;
  notifiedExpired?: InputMaybe<BoolFilter>;
  notifiedExpiringIn8Weeks?: InputMaybe<BoolFilter>;
  notifiedExpiringIn30Days?: InputMaybe<BoolFilter>;
  notifiedExpiringSoon?: InputMaybe<BoolFilter>;
  notifiedExpiringTomorrow?: InputMaybe<BoolFilter>;
  notifiedRenewalFailed?: InputMaybe<BoolFilter>;
  notifiedRenewed?: InputMaybe<BoolFilter>;
  productSubscriptionTypeId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
  validFrom?: InputMaybe<DateTimeFilter>;
  validTo?: InputMaybe<DateTimeNullableFilter>;
};

export type UserSubscriptionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserSubscriptionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserSubscriptionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserSubscriptionScalarWhereWithAggregatesInput>>;
  created?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isCancelled?: InputMaybe<BoolWithAggregatesFilter>;
  modified?: InputMaybe<DateTimeWithAggregatesFilter>;
  notifiedAccessEnded?: InputMaybe<BoolWithAggregatesFilter>;
  notifiedExpired?: InputMaybe<BoolWithAggregatesFilter>;
  notifiedExpiringIn8Weeks?: InputMaybe<BoolWithAggregatesFilter>;
  notifiedExpiringIn30Days?: InputMaybe<BoolWithAggregatesFilter>;
  notifiedExpiringSoon?: InputMaybe<BoolWithAggregatesFilter>;
  notifiedExpiringTomorrow?: InputMaybe<BoolWithAggregatesFilter>;
  notifiedRenewalFailed?: InputMaybe<BoolWithAggregatesFilter>;
  notifiedRenewed?: InputMaybe<BoolWithAggregatesFilter>;
  productSubscriptionTypeId?: InputMaybe<StringWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
  validFrom?: InputMaybe<DateTimeWithAggregatesFilter>;
  validTo?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type UserSubscriptionUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCancelled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedAccessEnded?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringIn8Weeks?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringIn30Days?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringSoon?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringTomorrow?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedRenewalFailed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedRenewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUserSubscriptionsNestedInput>;
  renewedByPayments?: InputMaybe<PaymentItemUpdateManyWithoutRenewsSubscriptionNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserSubscriptionsNestedInput>;
  validFrom?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserSubscriptionUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCancelled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedAccessEnded?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringIn8Weeks?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringIn30Days?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringSoon?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringTomorrow?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedRenewalFailed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedRenewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  validFrom?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserSubscriptionUpdateManyWithWhereWithoutProductSubscriptionTypeInput = {
  data: UserSubscriptionUpdateManyMutationInput;
  where: UserSubscriptionScalarWhereInput;
};

export type UserSubscriptionUpdateManyWithWhereWithoutUserInput = {
  data: UserSubscriptionUpdateManyMutationInput;
  where: UserSubscriptionScalarWhereInput;
};

export type UserSubscriptionUpdateManyWithoutProductSubscriptionTypeNestedInput = {
  connect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscriptionCreateOrConnectWithoutProductSubscriptionTypeInput>>;
  create?: InputMaybe<Array<UserSubscriptionCreateWithoutProductSubscriptionTypeInput>>;
  createMany?: InputMaybe<UserSubscriptionCreateManyProductSubscriptionTypeInputEnvelope>;
  delete?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserSubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<UserSubscriptionUpdateWithWhereUniqueWithoutProductSubscriptionTypeInput>>;
  updateMany?: InputMaybe<Array<UserSubscriptionUpdateManyWithWhereWithoutProductSubscriptionTypeInput>>;
  upsert?: InputMaybe<Array<UserSubscriptionUpsertWithWhereUniqueWithoutProductSubscriptionTypeInput>>;
};

export type UserSubscriptionUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscriptionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserSubscriptionCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserSubscriptionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserSubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<UserSubscriptionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserSubscriptionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserSubscriptionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserSubscriptionUpdateOneWithoutRenewedByPaymentsNestedInput = {
  connect?: InputMaybe<UserSubscriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserSubscriptionCreateOrConnectWithoutRenewedByPaymentsInput>;
  create?: InputMaybe<UserSubscriptionCreateWithoutRenewedByPaymentsInput>;
  delete?: InputMaybe<UserSubscriptionWhereInput>;
  disconnect?: InputMaybe<UserSubscriptionWhereInput>;
  update?: InputMaybe<UserSubscriptionUpdateToOneWithWhereWithoutRenewedByPaymentsInput>;
  upsert?: InputMaybe<UserSubscriptionUpsertWithoutRenewedByPaymentsInput>;
};

export type UserSubscriptionUpdateToOneWithWhereWithoutRenewedByPaymentsInput = {
  data: UserSubscriptionUpdateWithoutRenewedByPaymentsInput;
  where?: InputMaybe<UserSubscriptionWhereInput>;
};

export type UserSubscriptionUpdateWithWhereUniqueWithoutProductSubscriptionTypeInput = {
  data: UserSubscriptionUpdateWithoutProductSubscriptionTypeInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionUpdateWithWhereUniqueWithoutUserInput = {
  data: UserSubscriptionUpdateWithoutUserInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionUpdateWithoutProductSubscriptionTypeInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCancelled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedAccessEnded?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringIn8Weeks?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringIn30Days?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringSoon?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringTomorrow?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedRenewalFailed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedRenewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  renewedByPayments?: InputMaybe<PaymentItemUpdateManyWithoutRenewsSubscriptionNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserSubscriptionsNestedInput>;
  validFrom?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserSubscriptionUpdateWithoutRenewedByPaymentsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCancelled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedAccessEnded?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringIn8Weeks?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringIn30Days?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringSoon?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringTomorrow?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedRenewalFailed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedRenewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUserSubscriptionsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserSubscriptionsNestedInput>;
  validFrom?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserSubscriptionUpdateWithoutUserInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCancelled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  notifiedAccessEnded?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringIn8Weeks?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringIn30Days?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringSoon?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedExpiringTomorrow?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedRenewalFailed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notifiedRenewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeUpdateOneRequiredWithoutUserSubscriptionsNestedInput>;
  renewedByPayments?: InputMaybe<PaymentItemUpdateManyWithoutRenewsSubscriptionNestedInput>;
  validFrom?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserSubscriptionUpsertWithWhereUniqueWithoutProductSubscriptionTypeInput = {
  create: UserSubscriptionCreateWithoutProductSubscriptionTypeInput;
  update: UserSubscriptionUpdateWithoutProductSubscriptionTypeInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionUpsertWithWhereUniqueWithoutUserInput = {
  create: UserSubscriptionCreateWithoutUserInput;
  update: UserSubscriptionUpdateWithoutUserInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionUpsertWithoutRenewedByPaymentsInput = {
  create: UserSubscriptionCreateWithoutRenewedByPaymentsInput;
  update: UserSubscriptionUpdateWithoutRenewedByPaymentsInput;
  where?: InputMaybe<UserSubscriptionWhereInput>;
};

export type UserSubscriptionWhereInput = {
  AND?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isCancelled?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  notifiedAccessEnded?: InputMaybe<BoolFilter>;
  notifiedExpired?: InputMaybe<BoolFilter>;
  notifiedExpiringIn8Weeks?: InputMaybe<BoolFilter>;
  notifiedExpiringIn30Days?: InputMaybe<BoolFilter>;
  notifiedExpiringSoon?: InputMaybe<BoolFilter>;
  notifiedExpiringTomorrow?: InputMaybe<BoolFilter>;
  notifiedRenewalFailed?: InputMaybe<BoolFilter>;
  notifiedRenewed?: InputMaybe<BoolFilter>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeScalarRelationFilter>;
  productSubscriptionTypeId?: InputMaybe<StringFilter>;
  renewedByPayments?: InputMaybe<PaymentItemListRelationFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  validFrom?: InputMaybe<DateTimeFilter>;
  validTo?: InputMaybe<DateTimeNullableFilter>;
};

export type UserSubscriptionWhereUniqueInput = {
  AND?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BoolFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  notifiedAccessEnded?: InputMaybe<BoolFilter>;
  notifiedExpired?: InputMaybe<BoolFilter>;
  notifiedExpiringIn8Weeks?: InputMaybe<BoolFilter>;
  notifiedExpiringIn30Days?: InputMaybe<BoolFilter>;
  notifiedExpiringSoon?: InputMaybe<BoolFilter>;
  notifiedExpiringTomorrow?: InputMaybe<BoolFilter>;
  notifiedRenewalFailed?: InputMaybe<BoolFilter>;
  notifiedRenewed?: InputMaybe<BoolFilter>;
  productSubscriptionType?: InputMaybe<ProductSubscriptionTypeScalarRelationFilter>;
  productSubscriptionTypeId?: InputMaybe<StringFilter>;
  renewedByPayments?: InputMaybe<PaymentItemListRelationFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  validFrom?: InputMaybe<DateTimeFilter>;
  validTo?: InputMaybe<DateTimeNullableFilter>;
};

export type UserSumOrderByAggregateInput = {
  trialPurchasesUsed?: InputMaybe<SortOrder>;
};

export type UserTagsCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserTagsCreateInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  tag: TagCreateNestedOneWithoutUserTagsInput;
  user: UserCreateNestedOneWithoutUserTagsInput;
};

export type UserTagsCreateManyInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  tagId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserTagsCreateManyTagInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UserTagsCreateManyTagInputEnvelope = {
  data: Array<UserTagsCreateManyTagInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserTagsCreateManyUserInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  tagId: Scalars['String']['input'];
};

export type UserTagsCreateManyUserInputEnvelope = {
  data: Array<UserTagsCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserTagsCreateNestedManyWithoutTagInput = {
  connect?: InputMaybe<Array<UserTagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTagsCreateOrConnectWithoutTagInput>>;
  create?: InputMaybe<Array<UserTagsCreateWithoutTagInput>>;
  createMany?: InputMaybe<UserTagsCreateManyTagInputEnvelope>;
};

export type UserTagsCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserTagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTagsCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserTagsCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserTagsCreateManyUserInputEnvelope>;
};

export type UserTagsCreateOrConnectWithoutTagInput = {
  create: UserTagsCreateWithoutTagInput;
  where: UserTagsWhereUniqueInput;
};

export type UserTagsCreateOrConnectWithoutUserInput = {
  create: UserTagsCreateWithoutUserInput;
  where: UserTagsWhereUniqueInput;
};

export type UserTagsCreateWithoutTagInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  user: UserCreateNestedOneWithoutUserTagsInput;
};

export type UserTagsCreateWithoutUserInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  tag: TagCreateNestedOneWithoutUserTagsInput;
};

export type UserTagsListRelationFilter = {
  every?: InputMaybe<UserTagsWhereInput>;
  none?: InputMaybe<UserTagsWhereInput>;
  some?: InputMaybe<UserTagsWhereInput>;
};

export type UserTagsMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserTagsMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserTagsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserTagsOrderByWithAggregationInput = {
  _count?: InputMaybe<UserTagsCountOrderByAggregateInput>;
  _max?: InputMaybe<UserTagsMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserTagsMinOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  tagId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserTagsOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  tag?: InputMaybe<TagOrderByWithRelationInput>;
  tagId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserTagsScalarFieldEnum {
  Id = 'id',
  TagId = 'tagId',
  UserId = 'userId'
}

export type UserTagsScalarWhereInput = {
  AND?: InputMaybe<Array<UserTagsScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserTagsScalarWhereInput>>;
  OR?: InputMaybe<Array<UserTagsScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  tagId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserTagsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserTagsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserTagsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserTagsScalarWhereWithAggregatesInput>>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  tagId?: InputMaybe<StringWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type UserTagsUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  tag?: InputMaybe<TagUpdateOneRequiredWithoutUserTagsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserTagsNestedInput>;
};

export type UserTagsUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserTagsUpdateManyWithWhereWithoutTagInput = {
  data: UserTagsUpdateManyMutationInput;
  where: UserTagsScalarWhereInput;
};

export type UserTagsUpdateManyWithWhereWithoutUserInput = {
  data: UserTagsUpdateManyMutationInput;
  where: UserTagsScalarWhereInput;
};

export type UserTagsUpdateManyWithoutTagNestedInput = {
  connect?: InputMaybe<Array<UserTagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTagsCreateOrConnectWithoutTagInput>>;
  create?: InputMaybe<Array<UserTagsCreateWithoutTagInput>>;
  createMany?: InputMaybe<UserTagsCreateManyTagInputEnvelope>;
  delete?: InputMaybe<Array<UserTagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserTagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserTagsWhereUniqueInput>>;
  set?: InputMaybe<Array<UserTagsWhereUniqueInput>>;
  update?: InputMaybe<Array<UserTagsUpdateWithWhereUniqueWithoutTagInput>>;
  updateMany?: InputMaybe<Array<UserTagsUpdateManyWithWhereWithoutTagInput>>;
  upsert?: InputMaybe<Array<UserTagsUpsertWithWhereUniqueWithoutTagInput>>;
};

export type UserTagsUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserTagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTagsCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserTagsCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserTagsCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserTagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserTagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserTagsWhereUniqueInput>>;
  set?: InputMaybe<Array<UserTagsWhereUniqueInput>>;
  update?: InputMaybe<Array<UserTagsUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserTagsUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserTagsUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserTagsUpdateWithWhereUniqueWithoutTagInput = {
  data: UserTagsUpdateWithoutTagInput;
  where: UserTagsWhereUniqueInput;
};

export type UserTagsUpdateWithWhereUniqueWithoutUserInput = {
  data: UserTagsUpdateWithoutUserInput;
  where: UserTagsWhereUniqueInput;
};

export type UserTagsUpdateWithoutTagInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserTagsNestedInput>;
};

export type UserTagsUpdateWithoutUserInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  tag?: InputMaybe<TagUpdateOneRequiredWithoutUserTagsNestedInput>;
};

export type UserTagsUpsertWithWhereUniqueWithoutTagInput = {
  create: UserTagsCreateWithoutTagInput;
  update: UserTagsUpdateWithoutTagInput;
  where: UserTagsWhereUniqueInput;
};

export type UserTagsUpsertWithWhereUniqueWithoutUserInput = {
  create: UserTagsCreateWithoutUserInput;
  update: UserTagsUpdateWithoutUserInput;
  where: UserTagsWhereUniqueInput;
};

export type UserTagsWhereInput = {
  AND?: InputMaybe<Array<UserTagsWhereInput>>;
  NOT?: InputMaybe<Array<UserTagsWhereInput>>;
  OR?: InputMaybe<Array<UserTagsWhereInput>>;
  id?: InputMaybe<StringFilter>;
  tag?: InputMaybe<TagScalarRelationFilter>;
  tagId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserTagsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserTagsWhereInput>>;
  NOT?: InputMaybe<Array<UserTagsWhereInput>>;
  OR?: InputMaybe<Array<UserTagsWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<TagScalarRelationFilter>;
  tagId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserUpdateInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateManyMutationInput = {
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateOneRequiredWithoutAttemptedQuizzesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAttemptedQuizzesInput>;
  create?: InputMaybe<UserCreateWithoutAttemptedQuizzesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutAttemptedQuizzesInput>;
  upsert?: InputMaybe<UserUpsertWithoutAttemptedQuizzesInput>;
};

export type UserUpdateOneRequiredWithoutDownloadedResourcesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDownloadedResourcesInput>;
  create?: InputMaybe<UserCreateWithoutDownloadedResourcesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutDownloadedResourcesInput>;
  upsert?: InputMaybe<UserUpsertWithoutDownloadedResourcesInput>;
};

export type UserUpdateOneRequiredWithoutEventAttendancesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutEventAttendancesInput>;
  create?: InputMaybe<UserCreateWithoutEventAttendancesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutEventAttendancesInput>;
  upsert?: InputMaybe<UserUpsertWithoutEventAttendancesInput>;
};

export type UserUpdateOneRequiredWithoutEventRegistrationsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutEventRegistrationsInput>;
  create?: InputMaybe<UserCreateWithoutEventRegistrationsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutEventRegistrationsInput>;
  upsert?: InputMaybe<UserUpsertWithoutEventRegistrationsInput>;
};

export type UserUpdateOneRequiredWithoutManualActivitiesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutManualActivitiesInput>;
  create?: InputMaybe<UserCreateWithoutManualActivitiesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutManualActivitiesInput>;
  upsert?: InputMaybe<UserUpsertWithoutManualActivitiesInput>;
};

export type UserUpdateOneRequiredWithoutPaymentsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<UserCreateWithoutPaymentsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutPaymentsInput>;
  upsert?: InputMaybe<UserUpsertWithoutPaymentsInput>;
};

export type UserUpdateOneRequiredWithoutPodcastsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPodcastsInput>;
  create?: InputMaybe<UserCreateWithoutPodcastsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutPodcastsInput>;
  upsert?: InputMaybe<UserUpsertWithoutPodcastsInput>;
};

export type UserUpdateOneRequiredWithoutProgrammeProgressionsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutProgrammeProgressionsInput>;
  create?: InputMaybe<UserCreateWithoutProgrammeProgressionsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutProgrammeProgressionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutProgrammeProgressionsInput>;
};

export type UserUpdateOneRequiredWithoutReadArticlesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutReadArticlesInput>;
  create?: InputMaybe<UserCreateWithoutReadArticlesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutReadArticlesInput>;
  upsert?: InputMaybe<UserUpsertWithoutReadArticlesInput>;
};

export type UserUpdateOneRequiredWithoutRefundsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutRefundsInput>;
  create?: InputMaybe<UserCreateWithoutRefundsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutRefundsInput>;
  upsert?: InputMaybe<UserUpsertWithoutRefundsInput>;
};

export type UserUpdateOneRequiredWithoutSavedForLaterNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSavedForLaterInput>;
  create?: InputMaybe<UserCreateWithoutSavedForLaterInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutSavedForLaterInput>;
  upsert?: InputMaybe<UserUpsertWithoutSavedForLaterInput>;
};

export type UserUpdateOneRequiredWithoutUpgradePromptEngagementsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUpgradePromptEngagementsInput>;
  create?: InputMaybe<UserCreateWithoutUpgradePromptEngagementsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutUpgradePromptEngagementsInput>;
  upsert?: InputMaybe<UserUpsertWithoutUpgradePromptEngagementsInput>;
};

export type UserUpdateOneRequiredWithoutUserSubscriptionsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserSubscriptionsInput>;
  create?: InputMaybe<UserCreateWithoutUserSubscriptionsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutUserSubscriptionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserSubscriptionsInput>;
};

export type UserUpdateOneRequiredWithoutUserTagsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserTagsInput>;
  create?: InputMaybe<UserCreateWithoutUserTagsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutUserTagsInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserTagsInput>;
};

export type UserUpdateToOneWithWhereWithoutAttemptedQuizzesInput = {
  data: UserUpdateWithoutAttemptedQuizzesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutDownloadedResourcesInput = {
  data: UserUpdateWithoutDownloadedResourcesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutEventAttendancesInput = {
  data: UserUpdateWithoutEventAttendancesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutEventRegistrationsInput = {
  data: UserUpdateWithoutEventRegistrationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutManualActivitiesInput = {
  data: UserUpdateWithoutManualActivitiesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPaymentsInput = {
  data: UserUpdateWithoutPaymentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPodcastsInput = {
  data: UserUpdateWithoutPodcastsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutProgrammeProgressionsInput = {
  data: UserUpdateWithoutProgrammeProgressionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutReadArticlesInput = {
  data: UserUpdateWithoutReadArticlesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutRefundsInput = {
  data: UserUpdateWithoutRefundsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutSavedForLaterInput = {
  data: UserUpdateWithoutSavedForLaterInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUpgradePromptEngagementsInput = {
  data: UserUpdateWithoutUpgradePromptEngagementsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserSubscriptionsInput = {
  data: UserUpdateWithoutUserSubscriptionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserTagsInput = {
  data: UserUpdateWithoutUserTagsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateWithoutAttemptedQuizzesInput = {
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutDownloadedResourcesInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutEventAttendancesInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutEventRegistrationsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutManualActivitiesInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutPaymentsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutPodcastsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutProgrammeProgressionsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutReadArticlesInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutRefundsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutSavedForLaterInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUpgradePromptEngagementsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserSubscriptionsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userTags?: InputMaybe<UserTagsUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserTagsInput = {
  attemptedQuizzes?: InputMaybe<UserQuizUpdateManyWithoutUserNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']['input']>;
  billingCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  downloadedResources?: InputMaybe<UserResourceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  eventAttendances?: InputMaybe<EventAttendanceUpdateManyWithoutUserNestedInput>;
  eventRegistrations?: InputMaybe<EventRegistrationUpdateManyWithoutUserNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  healthDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howDidYouHear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProfessional?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublicEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  klaviyoProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualActivities?: InputMaybe<UserManualActivityUpdateManyWithoutUserNestedInput>;
  modified?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  passwordHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordResetToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passwordSalt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  photoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  podcasts?: InputMaybe<PodcastUserUpdateManyWithoutUserNestedInput>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionUpdateManyWithoutUserNestedInput>;
  publicAddresses?: InputMaybe<Scalars['JSON']['input']>;
  publicDiscipline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  publicName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readArticles?: InputMaybe<UserArticleUpdateManyWithoutUserNestedInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutUserNestedInput>;
  registrationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regulatoryBody?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  savedForLater?: InputMaybe<SavedForLaterUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trialPurchasesUsed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementUpdateManyWithoutUserNestedInput>;
  userSubscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
};

export type UserUpsertWithoutAttemptedQuizzesInput = {
  create: UserCreateWithoutAttemptedQuizzesInput;
  update: UserUpdateWithoutAttemptedQuizzesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutDownloadedResourcesInput = {
  create: UserCreateWithoutDownloadedResourcesInput;
  update: UserUpdateWithoutDownloadedResourcesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutEventAttendancesInput = {
  create: UserCreateWithoutEventAttendancesInput;
  update: UserUpdateWithoutEventAttendancesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutEventRegistrationsInput = {
  create: UserCreateWithoutEventRegistrationsInput;
  update: UserUpdateWithoutEventRegistrationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutManualActivitiesInput = {
  create: UserCreateWithoutManualActivitiesInput;
  update: UserUpdateWithoutManualActivitiesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutPaymentsInput = {
  create: UserCreateWithoutPaymentsInput;
  update: UserUpdateWithoutPaymentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutPodcastsInput = {
  create: UserCreateWithoutPodcastsInput;
  update: UserUpdateWithoutPodcastsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutProgrammeProgressionsInput = {
  create: UserCreateWithoutProgrammeProgressionsInput;
  update: UserUpdateWithoutProgrammeProgressionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutReadArticlesInput = {
  create: UserCreateWithoutReadArticlesInput;
  update: UserUpdateWithoutReadArticlesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutRefundsInput = {
  create: UserCreateWithoutRefundsInput;
  update: UserUpdateWithoutRefundsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutSavedForLaterInput = {
  create: UserCreateWithoutSavedForLaterInput;
  update: UserUpdateWithoutSavedForLaterInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutUpgradePromptEngagementsInput = {
  create: UserCreateWithoutUpgradePromptEngagementsInput;
  update: UserUpdateWithoutUpgradePromptEngagementsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutUserSubscriptionsInput = {
  create: UserCreateWithoutUserSubscriptionsInput;
  update: UserUpdateWithoutUserSubscriptionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutUserTagsInput = {
  create: UserCreateWithoutUserTagsInput;
  update: UserUpdateWithoutUserTagsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  attemptedQuizzes?: InputMaybe<UserQuizListRelationFilter>;
  billingAddress?: InputMaybe<JsonNullableFilter>;
  billingCountryCode?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  downloadedResources?: InputMaybe<UserResourceListRelationFilter>;
  email?: InputMaybe<StringFilter>;
  eventAttendances?: InputMaybe<EventAttendanceListRelationFilter>;
  eventRegistrations?: InputMaybe<EventRegistrationListRelationFilter>;
  externalId?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  healthDiscipline?: InputMaybe<StringNullableFilter>;
  howDidYouHear?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isEnabled?: InputMaybe<BoolFilter>;
  isProfessional?: InputMaybe<BoolFilter>;
  isPublicEnabled?: InputMaybe<BoolFilter>;
  klaviyoProfileId?: InputMaybe<StringNullableFilter>;
  manualActivities?: InputMaybe<UserManualActivityListRelationFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  passwordHash?: InputMaybe<StringNullableFilter>;
  passwordResetToken?: InputMaybe<StringNullableFilter>;
  passwordSalt?: InputMaybe<StringNullableFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  photoUrl?: InputMaybe<StringNullableFilter>;
  podcasts?: InputMaybe<PodcastUserListRelationFilter>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionListRelationFilter>;
  publicAddresses?: InputMaybe<JsonNullableFilter>;
  publicDiscipline?: InputMaybe<StringNullableFilter>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFilter>;
  publicName?: InputMaybe<StringNullableFilter>;
  readArticles?: InputMaybe<UserArticleListRelationFilter>;
  refunds?: InputMaybe<RefundListRelationFilter>;
  registrationNumber?: InputMaybe<StringNullableFilter>;
  regulatoryBody?: InputMaybe<StringNullableFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  savedForLater?: InputMaybe<SavedForLaterListRelationFilter>;
  stripeCustomerId?: InputMaybe<StringNullableFilter>;
  stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
  trialPurchasesUsed?: InputMaybe<IntNullableFilter>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementListRelationFilter>;
  userSubscriptions?: InputMaybe<UserSubscriptionListRelationFilter>;
  userTags?: InputMaybe<UserTagsListRelationFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  attemptedQuizzes?: InputMaybe<UserQuizListRelationFilter>;
  billingAddress?: InputMaybe<JsonNullableFilter>;
  billingCountryCode?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  downloadedResources?: InputMaybe<UserResourceListRelationFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventAttendances?: InputMaybe<EventAttendanceListRelationFilter>;
  eventRegistrations?: InputMaybe<EventRegistrationListRelationFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<StringFilter>;
  healthDiscipline?: InputMaybe<StringNullableFilter>;
  howDidYouHear?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<BoolFilter>;
  isProfessional?: InputMaybe<BoolFilter>;
  isPublicEnabled?: InputMaybe<BoolFilter>;
  klaviyoProfileId?: InputMaybe<StringNullableFilter>;
  manualActivities?: InputMaybe<UserManualActivityListRelationFilter>;
  modified?: InputMaybe<DateTimeFilter>;
  passwordHash?: InputMaybe<StringNullableFilter>;
  passwordResetToken?: InputMaybe<StringNullableFilter>;
  passwordSalt?: InputMaybe<StringNullableFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  photoUrl?: InputMaybe<StringNullableFilter>;
  podcasts?: InputMaybe<PodcastUserListRelationFilter>;
  programmeProgressions?: InputMaybe<ProgrammeProgressionListRelationFilter>;
  publicAddresses?: InputMaybe<JsonNullableFilter>;
  publicDiscipline?: InputMaybe<StringNullableFilter>;
  publicIsTelehealthAvailable?: InputMaybe<BoolFilter>;
  publicName?: InputMaybe<StringNullableFilter>;
  readArticles?: InputMaybe<UserArticleListRelationFilter>;
  refunds?: InputMaybe<RefundListRelationFilter>;
  registrationNumber?: InputMaybe<StringNullableFilter>;
  regulatoryBody?: InputMaybe<StringNullableFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  savedForLater?: InputMaybe<SavedForLaterListRelationFilter>;
  stripeCustomerId?: InputMaybe<StringNullableFilter>;
  stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
  trialPurchasesUsed?: InputMaybe<IntNullableFilter>;
  upgradePromptEngagements?: InputMaybe<UpgradePromptEngagementListRelationFilter>;
  userSubscriptions?: InputMaybe<UserSubscriptionListRelationFilter>;
  userTags?: InputMaybe<UserTagsListRelationFilter>;
};

export type ArticleTagFragment = { id: string, tag: { id: string, name: string } };

export type ArticleListFragment = { id: string, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }>, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null };

export type ArticleSingleFragment = { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }> };

export type ArticleContentFragment = { content?: { id: string, markdown: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null };

export type ArticleCategorySingleFragment = { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, article: { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }> } };

export type ArticleCategoryListFragment = { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, article: { id: string, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }>, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } };

export type ArticleQueryVariables = Exact<{
  articleId: Scalars['String']['input'];
}>;


export type ArticleQuery = { article?: { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }> } | null };

export type ArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type ArticlesQuery = { articles: Array<{ id: string, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }>, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null }> };

export type SearchArticlesQueryVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type SearchArticlesQuery = { articles: Array<{ id: string, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }>, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null }> };

export type ArticlesByCategoryIdQueryVariables = Exact<{
  categoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ArticlesByCategoryIdQuery = { articleCategories: Array<{ article: { id: string, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }>, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } }> };

export type ArticleWithContentQueryVariables = Exact<{
  articleId: Scalars['String']['input'];
}>;


export type ArticleWithContentQuery = { article?: { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }>, content?: { id: string, markdown: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } | null };

export type OrphanArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrphanArticlesQuery = { articles: Array<{ id: string, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }>, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null }> };

export type ArticleUsageFragment = { id: string, category: { id: string, name: string, programme: { id: string, name: string }, ancestorPath: Array<{ id: string, name: string }> } };

export type ArticleUsagesQueryVariables = Exact<{
  articleId: Scalars['String']['input'];
}>;


export type ArticleUsagesQuery = { articleCategories: Array<{ id: string, category: { id: string, name: string, programme: { id: string, name: string }, ancestorPath: Array<{ id: string, name: string }> } }> };

export type DeleteArticlesMutationVariables = Exact<{
  articleIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteArticlesMutation = { deleteManyArticle: { count: number } };

export type CreateArticleMutationVariables = Exact<{
  article: ArticleCreateInput;
}>;


export type CreateArticleMutation = { createOneArticle: { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }> } };

export type UpdateArticleMutationVariables = Exact<{
  articleId: Scalars['String']['input'];
  article: ArticleUpdateInput;
}>;


export type UpdateArticleMutation = { updateOneArticle?: { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }> } | null };

export type AddArticleToCategoryMutationVariables = Exact<{
  articleId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddArticleToCategoryMutation = { upsertOneArticleCategory: { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, article: { id: string, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }>, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } } };

export type RemoveArticleFromCategoryMutationVariables = Exact<{
  articleId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
}>;


export type RemoveArticleFromCategoryMutation = { deleteOneArticleCategory?: { id: string } | null };

export type UpdateArticleCategoryIsPinnedMutationVariables = Exact<{
  articleCategoryId: Scalars['String']['input'];
  isPinned: Scalars['Boolean']['input'];
}>;


export type UpdateArticleCategoryIsPinnedMutation = { updateOneArticleCategory?: { id: string } | null };

export type UpdateArticleCategoryIsRequiredMutationVariables = Exact<{
  articleCategoryId: Scalars['String']['input'];
  isRequired: Scalars['Boolean']['input'];
}>;


export type UpdateArticleCategoryIsRequiredMutation = { updateOneArticleCategory?: { id: string } | null };

export type CategoryListFragment = { id: string, name: string, slug: string, sortOrder: number, parentId?: string | null };

export type CategorySingleFragment = { id: string, created: any, modified: any, name: string, slug: string, sortOrder: number, parentId?: string | null };

export type CategoryListWithContentFragment = { id: string, name: string, slug: string, sortOrder: number, parentId?: string | null, categoryArticles: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, article: { id: string, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }>, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } }>, categoryQuizzes: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, maxAttempts?: number | null, minScore?: number | null, quiz: { id: string, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } }>, categoryResources: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, resource: { id: string, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null } }>, categoryEvents: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, minHours?: number | null, minContributions?: number | null, contributionName?: string | null, event: { id: string, title: string, slug: string, description: string, maxRegistrations?: number | null } }>, categoryImage?: { id: string, sortOrder: number, sectionImage: { id: string, filename?: string | null, url: string } } | null };

export type CategoryQueryVariables = Exact<{
  categoryId: Scalars['String']['input'];
}>;


export type CategoryQuery = { category?: { id: string, created: any, modified: any, name: string, slug: string, sortOrder: number, parentId?: string | null } | null };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { categories: Array<{ id: string, name: string, slug: string, sortOrder: number, parentId?: string | null }> };

export type ExistingCategoryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  programmeId: Scalars['String']['input'];
}>;


export type ExistingCategoryQuery = { categories: Array<{ id: string }> };

export type DeleteCategoriesMutationVariables = Exact<{
  categoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteCategoriesMutation = { deleteManyCategory: { count: number } };

export type CreateCategoryMutationVariables = Exact<{
  category: CategoryCreateInput;
}>;


export type CreateCategoryMutation = { createOneCategory: { id: string, created: any, modified: any, name: string, slug: string, sortOrder: number, parentId?: string | null } };

export type UpdateCategoryMutationVariables = Exact<{
  categoryId: Scalars['String']['input'];
  category: CategoryUpdateInput;
}>;


export type UpdateCategoryMutation = { updateOneCategory?: { id: string, created: any, modified: any, name: string, slug: string, sortOrder: number, parentId?: string | null } | null };

export type ContentListFragment = { id: string };

export type ContentSingleFragment = { id: string, markdown: string };

export type ContentQueryVariables = Exact<{
  contentId: Scalars['String']['input'];
}>;


export type ContentQuery = { content?: { id: string, markdown: string } | null };

export type ContentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContentsQuery = { contents: Array<{ id: string }> };

export type DeleteContentsMutationVariables = Exact<{
  contentIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteContentsMutation = { deleteManyContent: { count: number } };

export type CreateContentMutationVariables = Exact<{
  content: ContentCreateInput;
}>;


export type CreateContentMutation = { createOneContent: { id: string, markdown: string } };

export type UpdateContentMutationVariables = Exact<{
  contentId: Scalars['String']['input'];
  content: ContentUpdateInput;
}>;


export type UpdateContentMutation = { updateOneContent?: { id: string, markdown: string } | null };

export type CouponProductRestrictionFragment = { id: string, couponId: string, productId: string, product: { name: string, shortName: string } };

export type CouponListFragment = { id: string, isPublished: boolean, isArchived: boolean, code: string, description?: string | null, percentage?: number | null, fixedAmountInCents?: number | null, discountType: CouponDiscountType, validFrom?: any | null, validTo?: any | null, maxUses?: number | null, restrictedToProducts: Array<{ id: string, couponId: string, productId: string, product: { name: string, shortName: string } }> };

export type CouponSingleFragment = { id: string, isPublished: boolean, isArchived: boolean, code: string, description?: string | null, percentage?: number | null, fixedAmountInCents?: number | null, discountType: CouponDiscountType, validFrom?: any | null, validTo?: any | null, maxUses?: number | null, restrictedToProducts: Array<{ id: string, couponId: string, productId: string, product: { name: string, shortName: string } }> };

export type CouponQueryVariables = Exact<{
  couponId: Scalars['String']['input'];
}>;


export type CouponQuery = { coupon?: { id: string, isPublished: boolean, isArchived: boolean, code: string, description?: string | null, percentage?: number | null, fixedAmountInCents?: number | null, discountType: CouponDiscountType, validFrom?: any | null, validTo?: any | null, maxUses?: number | null, restrictedToProducts: Array<{ id: string, couponId: string, productId: string, product: { name: string, shortName: string } }> } | null };

export type CouponByCodeQueryVariables = Exact<{
  couponCode: Scalars['String']['input'];
}>;


export type CouponByCodeQuery = { coupon?: { id: string, isPublished: boolean, isArchived: boolean, code: string, description?: string | null, percentage?: number | null, fixedAmountInCents?: number | null, discountType: CouponDiscountType, validFrom?: any | null, validTo?: any | null, maxUses?: number | null, restrictedToProducts: Array<{ id: string, couponId: string, productId: string, product: { name: string, shortName: string } }> } | null };

export type CouponsQueryVariables = Exact<{ [key: string]: never; }>;


export type CouponsQuery = { coupons: Array<{ id: string, isPublished: boolean, isArchived: boolean, code: string, description?: string | null, percentage?: number | null, fixedAmountInCents?: number | null, discountType: CouponDiscountType, validFrom?: any | null, validTo?: any | null, maxUses?: number | null, restrictedToProducts: Array<{ id: string, couponId: string, productId: string, product: { name: string, shortName: string } }> }> };

export type CouponsFilteredQueryVariables = Exact<{
  where?: InputMaybe<CouponWhereInput>;
}>;


export type CouponsFilteredQuery = { coupons: Array<{ id: string, isPublished: boolean, isArchived: boolean, code: string, description?: string | null, percentage?: number | null, fixedAmountInCents?: number | null, discountType: CouponDiscountType, validFrom?: any | null, validTo?: any | null, maxUses?: number | null, restrictedToProducts: Array<{ id: string, couponId: string, productId: string, product: { name: string, shortName: string } }> }> };

export type CouponUseCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CouponUseCountsQuery = { groupByPayment: Array<{ couponId?: string | null, _count?: { _all: number } | null }> };

export type CouponUsesQueryVariables = Exact<{
  couponId: Scalars['String']['input'];
}>;


export type CouponUsesQuery = { aggregatePayment: { _count?: { _all: number } | null } };

export type DeleteCouponsMutationVariables = Exact<{
  couponIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteCouponsMutation = { deleteManyCoupon: { count: number } };

export type CreateCouponMutationVariables = Exact<{
  coupon: CouponCreateInput;
}>;


export type CreateCouponMutation = { createOneCoupon: { id: string, isPublished: boolean, isArchived: boolean, code: string, description?: string | null, percentage?: number | null, fixedAmountInCents?: number | null, discountType: CouponDiscountType, validFrom?: any | null, validTo?: any | null, maxUses?: number | null, restrictedToProducts: Array<{ id: string, couponId: string, productId: string, product: { name: string, shortName: string } }> } };

export type UpdateCouponMutationVariables = Exact<{
  couponId: Scalars['String']['input'];
  coupon: CouponUpdateInput;
}>;


export type UpdateCouponMutation = { updateOneCoupon?: { id: string, isPublished: boolean, isArchived: boolean, code: string, description?: string | null, percentage?: number | null, fixedAmountInCents?: number | null, discountType: CouponDiscountType, validFrom?: any | null, validTo?: any | null, maxUses?: number | null, restrictedToProducts: Array<{ id: string, couponId: string, productId: string, product: { name: string, shortName: string } }> } | null };

export type EventContentFragmentFragment = { id: string, sortOrder: number, title?: string | null, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventId: string };

export type EventOccurrenceContentFragmentFragment = { id: string, sortOrder: number, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventOccurrenceId: string };

export type EventOccurrenceListFragment = { id: string, start: any, end?: any | null, maxRegistrations?: number | null, eventId: string, eventRegistrations: Array<{ id: string }> };

export type EventOccurrenceSingleFragment = { id: string, created: any, modified: any, start: any, end?: any | null, maxRegistrations?: number | null, title?: string | null, eventId: string, eventRegistrations: Array<{ id: string }>, eventOccurrenceContents: Array<{ id: string, sortOrder: number, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventOccurrenceId: string }> };

export type EventListFragment = { id: string, title: string, slug: string, description: string, maxRegistrations?: number | null };

export type EventSingleFragment = { id: string, created: any, modified: any, title: string, slug: string, description: string, maxRegistrations?: number | null, eventContents: Array<{ id: string, sortOrder: number, title?: string | null, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventId: string }> };

export type EventCategorySingleFragment = { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, minHours?: number | null, minContributions?: number | null, contributionName?: string | null, event: { id: string, created: any, modified: any, title: string, slug: string, description: string, maxRegistrations?: number | null, eventContents: Array<{ id: string, sortOrder: number, title?: string | null, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventId: string }> } };

export type EventCategoryListFragment = { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, minHours?: number | null, minContributions?: number | null, contributionName?: string | null, event: { id: string, title: string, slug: string, description: string, maxRegistrations?: number | null } };

export type ProductEventFragment = { id: string, productId: string, eventId: string, product: { name: string }, event: { title: string } };

export type EventQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type EventQuery = { event?: { id: string, created: any, modified: any, title: string, slug: string, description: string, maxRegistrations?: number | null, eventContents: Array<{ id: string, sortOrder: number, title?: string | null, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventId: string }> } | null };

export type EventWithOccurrencesQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type EventWithOccurrencesQuery = { event?: { id: string, created: any, modified: any, title: string, slug: string, description: string, maxRegistrations?: number | null, eventOccurrences: Array<{ id: string, created: any, modified: any, start: any, end?: any | null, maxRegistrations?: number | null, title?: string | null, eventId: string, eventRegistrations: Array<{ id: string }>, eventOccurrenceContents: Array<{ id: string, sortOrder: number, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventOccurrenceId: string }> }>, eventContents: Array<{ id: string, sortOrder: number, title?: string | null, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventId: string }> } | null };

export type EventsQueryVariables = Exact<{ [key: string]: never; }>;


export type EventsQuery = { events: Array<{ id: string, title: string, slug: string, description: string, maxRegistrations?: number | null }> };

export type SearchEventsQueryVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type SearchEventsQuery = { events: Array<{ id: string, title: string, slug: string, description: string, maxRegistrations?: number | null }> };

export type OrphanEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrphanEventsQuery = { events: Array<{ id: string, title: string, slug: string, description: string, maxRegistrations?: number | null }> };

export type EventUsageFragment = { id: string, category: { id: string, name: string, programme: { id: string, name: string } } };

export type EventUsagesQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type EventUsagesQuery = { eventCategories: Array<{ id: string, category: { id: string, name: string, programme: { id: string, name: string } } }> };

export type EventRegistrationFragment = { id: string, userTimezone?: string | null, user: { id: string, fullName: string, email: string } };

export type EventOccurrenceRegistrationsQueryVariables = Exact<{
  eventOccurrenceId: Scalars['String']['input'];
}>;


export type EventOccurrenceRegistrationsQuery = { eventOccurrence?: { id: string, created: any, modified: any, start: any, end?: any | null, maxRegistrations?: number | null, title?: string | null, eventId: string, event: { id: string, created: any, modified: any, title: string, slug: string, description: string, maxRegistrations?: number | null, eventContents: Array<{ id: string, sortOrder: number, title?: string | null, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventId: string }> }, eventRegistrations: Array<{ id: string, userTimezone?: string | null, user: { id: string, fullName: string, email: string } }>, eventOccurrenceContents: Array<{ id: string, sortOrder: number, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventOccurrenceId: string }> } | null };

export type DeleteEventsMutationVariables = Exact<{
  eventIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteEventsMutation = { deleteManyEvent: { count: number } };

export type CreateEventMutationVariables = Exact<{
  event: EventCreateInput;
}>;


export type CreateEventMutation = { createOneEvent: { id: string, created: any, modified: any, title: string, slug: string, description: string, maxRegistrations?: number | null, eventContents: Array<{ id: string, sortOrder: number, title?: string | null, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventId: string }> } };

export type UpdateEventMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
  event: EventUpdateInput;
}>;


export type UpdateEventMutation = { updateOneEvent?: { id: string, created: any, modified: any, title: string, slug: string, description: string, maxRegistrations?: number | null, eventContents: Array<{ id: string, sortOrder: number, title?: string | null, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventId: string }> } | null };

export type DeleteEventOccurrencesMutationVariables = Exact<{
  eventOccurrenceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteEventOccurrencesMutation = { deleteManyEventOccurrence: { count: number } };

export type CreateEventOccurrenceMutationVariables = Exact<{
  eventOccurrence: EventOccurrenceCreateInput;
}>;


export type CreateEventOccurrenceMutation = { createOneEventOccurrence: { id: string, created: any, modified: any, start: any, end?: any | null, maxRegistrations?: number | null, title?: string | null, eventId: string, eventRegistrations: Array<{ id: string }>, eventOccurrenceContents: Array<{ id: string, sortOrder: number, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventOccurrenceId: string }> } };

export type UpdateEventOccurrenceMutationVariables = Exact<{
  eventOccurrenceId: Scalars['String']['input'];
  eventOccurrence: EventOccurrenceUpdateInput;
}>;


export type UpdateEventOccurrenceMutation = { updateOneEventOccurrence?: { id: string, created: any, modified: any, start: any, end?: any | null, maxRegistrations?: number | null, title?: string | null, eventId: string, eventRegistrations: Array<{ id: string }>, eventOccurrenceContents: Array<{ id: string, sortOrder: number, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventOccurrenceId: string }> } | null };

export type AddEventToCategoryMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddEventToCategoryMutation = { upsertOneEventCategory: { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, minHours?: number | null, minContributions?: number | null, contributionName?: string | null, event: { id: string, title: string, slug: string, description: string, maxRegistrations?: number | null } } };

export type RemoveEventFromCategoryMutationVariables = Exact<{
  eventId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
}>;


export type RemoveEventFromCategoryMutation = { deleteOneEventCategory?: { id: string } | null };

export type UpdateEventCategoryIsPinnedMutationVariables = Exact<{
  eventCategoryId: Scalars['String']['input'];
  isPinned: Scalars['Boolean']['input'];
}>;


export type UpdateEventCategoryIsPinnedMutation = { updateOneEventCategory?: { id: string } | null };

export type UpdateEventCategoryIsRequiredMutationVariables = Exact<{
  eventCategoryId: Scalars['String']['input'];
  isRequired: Scalars['Boolean']['input'];
}>;


export type UpdateEventCategoryIsRequiredMutation = { updateOneEventCategory?: { id: string } | null };

export type UpdateEventCategoryRequirementsMutationVariables = Exact<{
  eventCategoryId: Scalars['String']['input'];
  eventCategory: EventCategoryUpdateInput;
}>;


export type UpdateEventCategoryRequirementsMutation = { updateOneEventCategory?: { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, minHours?: number | null, minContributions?: number | null, contributionName?: string | null, event: { id: string, title: string, slug: string, description: string, maxRegistrations?: number | null } } | null };

export type GetProductEventsQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type GetProductEventsQuery = { productEvents: Array<{ id: string, productId: string, eventId: string, product: { name: string }, event: { title: string } }> };

export type CreateProductEventMutationVariables = Exact<{
  productEvent: ProductEventCreateInput;
}>;


export type CreateProductEventMutation = { createOneProductEvent: { id: string, productId: string, eventId: string, product: { name: string }, event: { title: string } } };

export type DeleteProductEventsMutationVariables = Exact<{
  productEventIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteProductEventsMutation = { deleteManyProductEvent: { count: number } };

export type CreateEventOccurrenceContentMutationVariables = Exact<{
  data: EventOccurrenceContentCreateInput;
}>;


export type CreateEventOccurrenceContentMutation = { createOneEventOccurrenceContent: { id: string, sortOrder: number, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventOccurrenceId: string } };

export type UpdateEventOccurrenceContentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: EventOccurrenceContentUpdateInput;
}>;


export type UpdateEventOccurrenceContentMutation = { updateOneEventOccurrenceContent?: { id: string, sortOrder: number, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventOccurrenceId: string } | null };

export type DeleteEventOccurrenceContentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteEventOccurrenceContentMutation = { deleteOneEventOccurrenceContent?: { id: string } | null };

export type CreateEventContentMutationVariables = Exact<{
  data: EventContentCreateInput;
}>;


export type CreateEventContentMutation = { createOneEventContent: { id: string, sortOrder: number, title?: string | null, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventId: string } };

export type UpdateEventContentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: EventContentUpdateInput;
}>;


export type UpdateEventContentMutation = { updateOneEventContent?: { id: string, sortOrder: number, title?: string | null, subtitle?: string | null, description?: string | null, imageUrl?: string | null, eventId: string } | null };

export type DeleteEventContentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteEventContentMutation = { deleteOneEventContent?: { id: string } | null };

export type PaymentListFragment = { id: string, created: any, modified: any, amountInCents: number, taxInCents: number, couponDiscountAppliedInCents?: number | null, currency: AcceptedCurrency, billingAddress: any, billingCountryCode: string, isInvoiceSent: boolean, xeroInvoiceNumber?: string | null, isLegacyXero: boolean, stripePayoutId?: string | null, coupon?: { code: string, discountType: CouponDiscountType, percentage?: number | null, fixedAmountInCents?: number | null } | null, refunds: Array<{ id: string, created: any, amountInCents: number }>, user: { id: string, email: string, displayName?: string | null }, paymentItems: Array<{ productSubscriptionType?: { id: string, name: string, product?: { id: string, name: string, shortName: string } | null } | null }>, stripePaymentIntents: Array<{ paymentIntentId: string, chargedInCents?: number | null, feesPaidInCents?: number | null, taxPaidInCents?: number | null, netInCents?: number | null }> };

export type PaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentsQuery = { payments: Array<{ id: string, created: any, modified: any, amountInCents: number, taxInCents: number, couponDiscountAppliedInCents?: number | null, currency: AcceptedCurrency, billingAddress: any, billingCountryCode: string, isInvoiceSent: boolean, xeroInvoiceNumber?: string | null, isLegacyXero: boolean, stripePayoutId?: string | null, coupon?: { code: string, discountType: CouponDiscountType, percentage?: number | null, fixedAmountInCents?: number | null } | null, refunds: Array<{ id: string, created: any, amountInCents: number }>, user: { id: string, email: string, displayName?: string | null }, paymentItems: Array<{ productSubscriptionType?: { id: string, name: string, product?: { id: string, name: string, shortName: string } | null } | null }>, stripePaymentIntents: Array<{ paymentIntentId: string, chargedInCents?: number | null, feesPaidInCents?: number | null, taxPaidInCents?: number | null, netInCents?: number | null }> }> };

export type PaymentsPaginatedQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaymentsPaginatedQuery = { payments: Array<{ id: string, created: any, modified: any, amountInCents: number, taxInCents: number, couponDiscountAppliedInCents?: number | null, currency: AcceptedCurrency, billingAddress: any, billingCountryCode: string, isInvoiceSent: boolean, xeroInvoiceNumber?: string | null, isLegacyXero: boolean, stripePayoutId?: string | null, coupon?: { code: string, discountType: CouponDiscountType, percentage?: number | null, fixedAmountInCents?: number | null } | null, refunds: Array<{ id: string, created: any, amountInCents: number }>, user: { id: string, email: string, displayName?: string | null }, paymentItems: Array<{ productSubscriptionType?: { id: string, name: string, product?: { id: string, name: string, shortName: string } | null } | null }>, stripePaymentIntents: Array<{ paymentIntentId: string, chargedInCents?: number | null, feesPaidInCents?: number | null, taxPaidInCents?: number | null, netInCents?: number | null }> }>, aggregatePayment: { _count?: { _all: number } | null } };

export type SearchPaymentsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  excludeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SearchPaymentsQuery = { payments: Array<{ id: string, created: any, modified: any, amountInCents: number, taxInCents: number, couponDiscountAppliedInCents?: number | null, currency: AcceptedCurrency, billingAddress: any, billingCountryCode: string, isInvoiceSent: boolean, xeroInvoiceNumber?: string | null, isLegacyXero: boolean, stripePayoutId?: string | null, coupon?: { code: string, discountType: CouponDiscountType, percentage?: number | null, fixedAmountInCents?: number | null } | null, refunds: Array<{ id: string, created: any, amountInCents: number }>, user: { id: string, email: string, displayName?: string | null }, paymentItems: Array<{ productSubscriptionType?: { id: string, name: string, product?: { id: string, name: string, shortName: string } | null } | null }>, stripePaymentIntents: Array<{ paymentIntentId: string, chargedInCents?: number | null, feesPaidInCents?: number | null, taxPaidInCents?: number | null, netInCents?: number | null }> }> };

export type PodcastListFragment = { id: string, title: string, isManaged: boolean, captivateId: string, captivateFeedUrl: string };

export type PodcastSingleFragment = { id: string, title: string, isManaged: boolean, captivateId: string, captivateFeedUrl: string };

export type PodcastUserFragment = { id: string, captivateFeedUrl: string, userId: string, podcastId: string, user: { fullName: string }, podcast: { title: string, captivateFeedUrl: string } };

export type ProductPodcastFragment = { id: string, productId: string, podcastId: string, product: { name: string }, podcast: { title: string, captivateFeedUrl: string } };

export type PodcastQueryVariables = Exact<{
  podcastId: Scalars['String']['input'];
}>;


export type PodcastQuery = { podcast?: { id: string, title: string, isManaged: boolean, captivateId: string, captivateFeedUrl: string } | null };

export type PodcastsQueryVariables = Exact<{ [key: string]: never; }>;


export type PodcastsQuery = { podcasts: Array<{ id: string, title: string, isManaged: boolean, captivateId: string, captivateFeedUrl: string }> };

export type PodcastUsersQueryVariables = Exact<{
  podcastId: Scalars['String']['input'];
}>;


export type PodcastUsersQuery = { podcastUsers: Array<{ id: string, captivateFeedUrl: string, userId: string, podcastId: string, user: { fullName: string }, podcast: { title: string, captivateFeedUrl: string } }> };

export type ProductPodcastsQueryVariables = Exact<{
  podcastId: Scalars['String']['input'];
}>;


export type ProductPodcastsQuery = { productPodcasts: Array<{ id: string, productId: string, podcastId: string, product: { name: string }, podcast: { title: string, captivateFeedUrl: string } }> };

export type DeletePodcastsMutationVariables = Exact<{
  podcastIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeletePodcastsMutation = { deleteManyPodcast: { count: number } };

export type CreatePodcastMutationVariables = Exact<{
  podcast: PodcastCreateInput;
}>;


export type CreatePodcastMutation = { createOnePodcast: { id: string, title: string, isManaged: boolean, captivateId: string, captivateFeedUrl: string } };

export type DeleteProductPodcastsMutationVariables = Exact<{
  productPodcastIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteProductPodcastsMutation = { deleteManyProductPodcast: { count: number } };

export type CreateProductPodcastMutationVariables = Exact<{
  productPodcast: ProductPodcastCreateInput;
}>;


export type CreateProductPodcastMutation = { createOneProductPodcast: { id: string, productId: string, podcastId: string, product: { name: string }, podcast: { title: string, captivateFeedUrl: string } } };

export type UpdatePodcastMutationVariables = Exact<{
  podcastId: Scalars['String']['input'];
  podcast: PodcastUpdateInput;
}>;


export type UpdatePodcastMutation = { updateOnePodcast?: { id: string, title: string, isManaged: boolean, captivateId: string, captivateFeedUrl: string } | null };

export type ProductListFragment = { id: string, name: string, shortName: string, description: string, slug: string, isPublished: boolean, healthProfessionalOnly: boolean, brandingType: BrandingType };

export type ProductSingleFragment = { id: string, created: any, modified: any, name: string, shortName: string, description: string, slug: string, isPublished: boolean, healthProfessionalOnly: boolean, brandingType: BrandingType };

export type ProductProgrammeFragment = { id: string, productId: string, programmeId: string, programme: { id: string, name: string, shortName: string, description: string, slug: string, sortOrder: number, isPublished: boolean, isHidden: boolean, programmeTags: Array<{ id: string, tag: { id: string, name: string } }> } };

export type ProductSubscriptionTypeListFragment = { id: string, name: string, description?: string | null, isPublished: boolean, automaticRenew: boolean, durationInDays?: number | null, priceInCents: number, xeroAccountCode?: string | null, isTrialSubscription: boolean, trialPurchaseLimit?: number | null, upgradeType?: UpgradeType | null };

export type ProductSubscriptionTypeSingleFragment = { id: string, name: string, description?: string | null, isPublished: boolean, automaticRenew: boolean, durationInDays?: number | null, priceInCents: number, xeroAccountCode?: string | null, isTrialSubscription: boolean, trialPurchaseLimit?: number | null, upgradeType?: UpgradeType | null };

export type ProductProgrammePrerequisiteFragment = { id: string, productId: string, programmeId: string, programme: { isPublished: boolean, name: string } };

export type ProductQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type ProductQuery = { product?: { id: string, created: any, modified: any, name: string, shortName: string, description: string, slug: string, isPublished: boolean, healthProfessionalOnly: boolean, brandingType: BrandingType } | null };

export type ProductWithProgrammesAndSubscriptionTypesQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type ProductWithProgrammesAndSubscriptionTypesQuery = { product?: { id: string, created: any, modified: any, name: string, shortName: string, description: string, slug: string, isPublished: boolean, healthProfessionalOnly: boolean, brandingType: BrandingType, productProgrammes: Array<{ id: string, productId: string, programmeId: string, programme: { id: string, name: string, shortName: string, description: string, slug: string, sortOrder: number, isPublished: boolean, isHidden: boolean, programmeTags: Array<{ id: string, tag: { id: string, name: string } }> } }>, productSubscriptionTypes: Array<{ id: string, name: string, description?: string | null, isPublished: boolean, automaticRenew: boolean, durationInDays?: number | null, priceInCents: number, xeroAccountCode?: string | null, isTrialSubscription: boolean, trialPurchaseLimit?: number | null, upgradeType?: UpgradeType | null }>, prerequisites: Array<{ id: string, productId: string, programmeId: string, programme: { isPublished: boolean, name: string } }> } | null };

export type ProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsQuery = { products: Array<{ id: string, name: string, shortName: string, description: string, slug: string, isPublished: boolean, healthProfessionalOnly: boolean, brandingType: BrandingType }> };

export type ProductsByBrandingTypeQueryVariables = Exact<{
  brandingType: BrandingType;
}>;


export type ProductsByBrandingTypeQuery = { products: Array<{ id: string, name: string, shortName: string, description: string, slug: string, isPublished: boolean, healthProfessionalOnly: boolean, brandingType: BrandingType }> };

export type SearchProductsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  excludeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SearchProductsQuery = { products: Array<{ id: string, name: string, shortName: string, description: string, slug: string, isPublished: boolean, healthProfessionalOnly: boolean, brandingType: BrandingType }> };

export type DeleteProductsMutationVariables = Exact<{
  productIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteProductsMutation = { deleteManyProduct: { count: number } };

export type CreateProductMutationVariables = Exact<{
  product: ProductCreateInput;
}>;


export type CreateProductMutation = { createOneProduct: { id: string, created: any, modified: any, name: string, shortName: string, description: string, slug: string, isPublished: boolean, healthProfessionalOnly: boolean, brandingType: BrandingType } };

export type UpdateProductMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  product: ProductUpdateInput;
}>;


export type UpdateProductMutation = { updateOneProduct?: { id: string, created: any, modified: any, name: string, shortName: string, description: string, slug: string, isPublished: boolean, healthProfessionalOnly: boolean, brandingType: BrandingType } | null };

export type AddProductProgrammeMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  programmeId: Scalars['String']['input'];
}>;


export type AddProductProgrammeMutation = { createOneProductProgramme: { id: string, productId: string, programmeId: string, programme: { id: string, name: string, shortName: string, description: string, slug: string, sortOrder: number, isPublished: boolean, isHidden: boolean, programmeTags: Array<{ id: string, tag: { id: string, name: string } }> } } };

export type DeleteProductProgrammeMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  programmeId: Scalars['String']['input'];
}>;


export type DeleteProductProgrammeMutation = { deleteOneProductProgramme?: { id: string } | null };

export type DeleteProductPrerequisitesMutationVariables = Exact<{
  prerequisiteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteProductPrerequisitesMutation = { deleteManyProductProgrammePrerequisite: { count: number } };

export type DeleteProductSubscriptionTypesMutationVariables = Exact<{
  productSubscriptionTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteProductSubscriptionTypesMutation = { deleteManyProductSubscriptionType: { count: number } };

export type CreateProductSubscriptionTypeMutationVariables = Exact<{
  productSubscriptionType: ProductSubscriptionTypeCreateInput;
}>;


export type CreateProductSubscriptionTypeMutation = { createOneProductSubscriptionType: { id: string, name: string, description?: string | null, isPublished: boolean, automaticRenew: boolean, durationInDays?: number | null, priceInCents: number, xeroAccountCode?: string | null, isTrialSubscription: boolean, trialPurchaseLimit?: number | null, upgradeType?: UpgradeType | null } };

export type UpdateProductSubscriptionTypeMutationVariables = Exact<{
  productSubscriptionTypeId: Scalars['String']['input'];
  productSubscriptionType: ProductSubscriptionTypeUpdateInput;
}>;


export type UpdateProductSubscriptionTypeMutation = { updateOneProductSubscriptionType?: { id: string, name: string, description?: string | null, isPublished: boolean, automaticRenew: boolean, durationInDays?: number | null, priceInCents: number, xeroAccountCode?: string | null, isTrialSubscription: boolean, trialPurchaseLimit?: number | null, upgradeType?: UpgradeType | null } | null };

export type ProgrammeTagFragment = { id: string, tag: { id: string, name: string } };

export type ProgrammeListFragment = { id: string, name: string, shortName: string, description: string, slug: string, sortOrder: number, isPublished: boolean, isHidden: boolean, programmeTags: Array<{ id: string, tag: { id: string, name: string } }> };

export type ProgrammeSingleFragment = { id: string, created: any, modified: any, name: string, shortName: string, description: string, slug: string, sortOrder: number, isPublished: boolean, isHidden: boolean, programmeTags: Array<{ id: string, tag: { id: string, name: string } }> };

export type CategoryListWithContentAndPrerequisitesFragment = { id: string, name: string, slug: string, sortOrder: number, parentId?: string | null, prerequisites: Array<{ categoryId: string, prerequisiteId: string }>, categoryArticles: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, article: { id: string, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }>, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } }>, categoryQuizzes: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, maxAttempts?: number | null, minScore?: number | null, quiz: { id: string, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } }>, categoryResources: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, resource: { id: string, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null } }>, categoryEvents: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, minHours?: number | null, minContributions?: number | null, contributionName?: string | null, event: { id: string, title: string, slug: string, description: string, maxRegistrations?: number | null } }>, categoryImage?: { id: string, sortOrder: number, sectionImage: { id: string, filename?: string | null, url: string } } | null };

export type ProgrammeQueryVariables = Exact<{
  programmeId: Scalars['String']['input'];
}>;


export type ProgrammeQuery = { programme?: { id: string, created: any, modified: any, name: string, shortName: string, description: string, slug: string, sortOrder: number, isPublished: boolean, isHidden: boolean, programmeTags: Array<{ id: string, tag: { id: string, name: string } }> } | null };

export type ProgrammesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgrammesQuery = { programmes: Array<{ id: string, name: string, shortName: string, description: string, slug: string, sortOrder: number, isPublished: boolean, isHidden: boolean, programmeTags: Array<{ id: string, tag: { id: string, name: string } }> }> };

export type SearchProgrammesQueryVariables = Exact<{
  name: Scalars['String']['input'];
  excludeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SearchProgrammesQuery = { programmes: Array<{ id: string, name: string, shortName: string, description: string, slug: string, sortOrder: number, isPublished: boolean, isHidden: boolean, programmeTags: Array<{ id: string, tag: { id: string, name: string } }> }> };

export type DeleteProgrammesMutationVariables = Exact<{
  programmeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteProgrammesMutation = { deleteManyProgramme: { count: number } };

export type CreateProgrammeMutationVariables = Exact<{
  programme: ProgrammeCreateInput;
}>;


export type CreateProgrammeMutation = { createOneProgramme: { id: string, created: any, modified: any, name: string, shortName: string, description: string, slug: string, sortOrder: number, isPublished: boolean, isHidden: boolean, programmeTags: Array<{ id: string, tag: { id: string, name: string } }> } };

export type UpdateProgrammeMutationVariables = Exact<{
  programmeId: Scalars['String']['input'];
  programme: ProgrammeUpdateInput;
}>;


export type UpdateProgrammeMutation = { updateOneProgramme?: { id: string, created: any, modified: any, name: string, shortName: string, description: string, slug: string, sortOrder: number, isPublished: boolean, isHidden: boolean, programmeTags: Array<{ id: string, tag: { id: string, name: string } }> } | null };

export type ProgrammesWithContentQueryVariables = Exact<{
  programmeId: Scalars['String']['input'];
}>;


export type ProgrammesWithContentQuery = { programme?: { id: string, created: any, modified: any, name: string, shortName: string, description: string, slug: string, sortOrder: number, isPublished: boolean, isHidden: boolean, categories: Array<{ id: string, name: string, slug: string, sortOrder: number, parentId?: string | null, prerequisites: Array<{ categoryId: string, prerequisiteId: string }>, categoryArticles: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, article: { id: string, title: string, slug: string, isPublished: boolean, resourceTypeId?: string | null, articleTags: Array<{ id: string, tag: { id: string, name: string } }>, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } }>, categoryQuizzes: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, maxAttempts?: number | null, minScore?: number | null, quiz: { id: string, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } }>, categoryResources: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, resource: { id: string, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null } }>, categoryEvents: Array<{ id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, minHours?: number | null, minContributions?: number | null, contributionName?: string | null, event: { id: string, title: string, slug: string, description: string, maxRegistrations?: number | null } }>, categoryImage?: { id: string, sortOrder: number, sectionImage: { id: string, filename?: string | null, url: string } } | null }>, programmeTags: Array<{ id: string, tag: { id: string, name: string } }> } | null };

export type QuizListFragment = { id: string, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null };

export type QuizSingleFragment = { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, description?: string | null };

export type QuizContentFragment = { content?: { id: string, markdown: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null };

export type QuizCategorySingleFragment = { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, maxAttempts?: number | null, minScore?: number | null, quiz: { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, description?: string | null } };

export type QuizCategoryListFragment = { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, maxAttempts?: number | null, minScore?: number | null, quiz: { id: string, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } };

export type QuizQueryVariables = Exact<{
  quizId: Scalars['String']['input'];
}>;


export type QuizQuery = { quiz?: { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, description?: string | null } | null };

export type QuizzesQueryVariables = Exact<{ [key: string]: never; }>;


export type QuizzesQuery = { quizzes: Array<{ id: string, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null }> };

export type SearchQuizzesQueryVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type SearchQuizzesQuery = { quizzes: Array<{ id: string, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null }> };

export type QuizzesByCategoryIdQueryVariables = Exact<{
  categoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type QuizzesByCategoryIdQuery = { quizCategories: Array<{ quiz: { id: string, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } }> };

export type QuizWithContentQueryVariables = Exact<{
  quizId: Scalars['String']['input'];
}>;


export type QuizWithContentQuery = { quiz?: { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdown: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } | null };

export type OrphanQuizzesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrphanQuizzesQuery = { quizzes: Array<{ id: string, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null }> };

export type QuizUsageFragment = { id: string, category: { id: string, name: string, programme: { id: string, name: string } } };

export type QuizUsagesQueryVariables = Exact<{
  quizId: Scalars['String']['input'];
}>;


export type QuizUsagesQuery = { quizCategories: Array<{ id: string, category: { id: string, name: string, programme: { id: string, name: string } } }> };

export type DeleteQuizzesMutationVariables = Exact<{
  quizIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteQuizzesMutation = { deleteManyQuiz: { count: number } };

export type CreateQuizMutationVariables = Exact<{
  quiz: QuizCreateInput;
}>;


export type CreateQuizMutation = { createOneQuiz: { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, description?: string | null } };

export type UpdateQuizMutationVariables = Exact<{
  quizId: Scalars['String']['input'];
  quiz: QuizUpdateInput;
}>;


export type UpdateQuizMutation = { updateOneQuiz?: { id: string, created: any, modified: any, title: string, slug: string, isPublished: boolean, description?: string | null } | null };

export type AddQuizToCategoryMutationVariables = Exact<{
  quizId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddQuizToCategoryMutation = { upsertOneQuizCategory: { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, maxAttempts?: number | null, minScore?: number | null, quiz: { id: string, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } } };

export type RemoveQuizFromCategoryMutationVariables = Exact<{
  quizId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
}>;


export type RemoveQuizFromCategoryMutation = { deleteOneQuizCategory?: { id: string } | null };

export type UpdateQuizCategoryIsPinnedMutationVariables = Exact<{
  quizCategoryId: Scalars['String']['input'];
  isPinned: Scalars['Boolean']['input'];
}>;


export type UpdateQuizCategoryIsPinnedMutation = { updateOneQuizCategory?: { id: string } | null };

export type UpdateQuizCategoryIsRequiredMutationVariables = Exact<{
  quizCategoryId: Scalars['String']['input'];
  isRequired: Scalars['Boolean']['input'];
}>;


export type UpdateQuizCategoryIsRequiredMutation = { updateOneQuizCategory?: { id: string } | null };

export type UpdateQuizCategoryRequirementsMutationVariables = Exact<{
  quizCategoryId: Scalars['String']['input'];
  quizCategory: QuizCategoryUpdateInput;
}>;


export type UpdateQuizCategoryRequirementsMutation = { updateOneQuizCategory?: { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, maxAttempts?: number | null, minScore?: number | null, quiz: { id: string, title: string, slug: string, isPublished: boolean, description?: string | null, content?: { id: string, markdownHash?: string | null, publishedMarkdownHash?: string | null } | null } } | null };

export type RefundListFragment = { id: string, created: any, modified: any, currency: AcceptedCurrency, amountInCents: number, xeroCreditNoteNumber?: string | null, isLegacyXero: boolean, stripePayoutId?: string | null, paymentId: string, payment: { created: any, amountInCents: number, paymentItems: Array<{ productSubscriptionType?: { id: string, name: string, product?: { id: string, name: string, shortName: string } | null } | null }>, stripePaymentIntents: Array<{ paymentIntentId: string }> }, user: { id: string, email: string, displayName?: string | null } };

export type RefundsQueryVariables = Exact<{ [key: string]: never; }>;


export type RefundsQuery = { refunds: Array<{ id: string, created: any, modified: any, currency: AcceptedCurrency, amountInCents: number, xeroCreditNoteNumber?: string | null, isLegacyXero: boolean, stripePayoutId?: string | null, paymentId: string, payment: { created: any, amountInCents: number, paymentItems: Array<{ productSubscriptionType?: { id: string, name: string, product?: { id: string, name: string, shortName: string } | null } | null }>, stripePaymentIntents: Array<{ paymentIntentId: string }> }, user: { id: string, email: string, displayName?: string | null } }> };

export type RefundsPaginatedQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RefundsPaginatedQuery = { refunds: Array<{ id: string, created: any, modified: any, currency: AcceptedCurrency, amountInCents: number, xeroCreditNoteNumber?: string | null, isLegacyXero: boolean, stripePayoutId?: string | null, paymentId: string, payment: { created: any, amountInCents: number, paymentItems: Array<{ productSubscriptionType?: { id: string, name: string, product?: { id: string, name: string, shortName: string } | null } | null }>, stripePaymentIntents: Array<{ paymentIntentId: string }> }, user: { id: string, email: string, displayName?: string | null } }>, aggregateRefund: { _count?: { _all: number } | null } };

export type SearchRefundsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  excludeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SearchRefundsQuery = { refunds: Array<{ id: string, created: any, modified: any, currency: AcceptedCurrency, amountInCents: number, xeroCreditNoteNumber?: string | null, isLegacyXero: boolean, stripePayoutId?: string | null, paymentId: string, payment: { created: any, amountInCents: number, paymentItems: Array<{ productSubscriptionType?: { id: string, name: string, product?: { id: string, name: string, shortName: string } | null } | null }>, stripePaymentIntents: Array<{ paymentIntentId: string }> }, user: { id: string, email: string, displayName?: string | null } }> };

export type ResourceTypeListFragment = { id: string, name: string };

export type ResourceTypeSingleFragment = { id: string, name: string };

export type ResourceListFragment = { id: string, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null };

export type ResourceSingleFragment = { id: string, created: any, modified: any, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null };

export type ResourceCategorySingleFragment = { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, resource: { id: string, created: any, modified: any, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null } };

export type ResourceCategoryListFragment = { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, resource: { id: string, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null } };

export type ResourceQueryVariables = Exact<{
  resourceId: Scalars['String']['input'];
}>;


export type ResourceQuery = { resource?: { id: string, created: any, modified: any, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null } | null };

export type ResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourcesQuery = { resources: Array<{ id: string, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null }> };

export type ResourceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourceTypesQuery = { resourceTypes: Array<{ id: string, name: string }> };

export type SearchResourcesQueryVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type SearchResourcesQuery = { resources: Array<{ id: string, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null }> };

export type ResourcesByCategoryIdQueryVariables = Exact<{
  categoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ResourcesByCategoryIdQuery = { resourceCategories: Array<{ resource: { id: string, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null } }> };

export type OrphanResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrphanResourcesQuery = { resources: Array<{ id: string, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null }> };

export type ResourceUsageFragment = { id: string, category: { id: string, name: string, programme: { id: string, name: string } } };

export type ResourceUsagesQueryVariables = Exact<{
  resourceId: Scalars['String']['input'];
}>;


export type ResourceUsagesQuery = { resourceCategories: Array<{ id: string, category: { id: string, name: string, programme: { id: string, name: string } } }> };

export type DeleteResourcesMutationVariables = Exact<{
  resourceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteResourcesMutation = { deleteManyResource: { count: number } };

export type DeleteResourceTypesMutationVariables = Exact<{
  resourceTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteResourceTypesMutation = { deleteManyResourceType: { count: number } };

export type CreateResourceMutationVariables = Exact<{
  resource: ResourceCreateInput;
}>;


export type CreateResourceMutation = { createOneResource: { id: string, created: any, modified: any, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null } };

export type CreateResourceTypeMutationVariables = Exact<{
  resourceType: ResourceTypeCreateInput;
}>;


export type CreateResourceTypeMutation = { createOneResourceType: { id: string, name: string } };

export type UpdateResourceMutationVariables = Exact<{
  resourceId: Scalars['String']['input'];
  resource: ResourceUpdateInput;
}>;


export type UpdateResourceMutation = { updateOneResource?: { id: string, created: any, modified: any, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null } | null };

export type UpdateResourceTypeMutationVariables = Exact<{
  resourceTypeId: Scalars['String']['input'];
  resourceType: ResourceTypeUpdateInput;
}>;


export type UpdateResourceTypeMutation = { updateOneResourceType?: { id: string, name: string } | null };

export type AddResourceToCategoryMutationVariables = Exact<{
  resourceId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddResourceToCategoryMutation = { upsertOneResourceCategory: { id: string, isPinned: boolean, sortOrder: number, isRequired: boolean, resource: { id: string, resourceTypeId?: string | null, title: string, slug: string, filename: string, url: string, isPublished: boolean, frontmatter?: any | null, publishedFrontmatter?: any | null } } };

export type RemoveResourceFromCategoryMutationVariables = Exact<{
  resourceId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
}>;


export type RemoveResourceFromCategoryMutation = { deleteOneResourceCategory?: { id: string } | null };

export type UpdateResourceCategoryIsPinnedMutationVariables = Exact<{
  resourceCategoryId: Scalars['String']['input'];
  isPinned: Scalars['Boolean']['input'];
}>;


export type UpdateResourceCategoryIsPinnedMutation = { updateOneResourceCategory?: { id: string } | null };

export type UpdateResourceCategoryIsRequiredMutationVariables = Exact<{
  resourceCategoryId: Scalars['String']['input'];
  isRequired: Scalars['Boolean']['input'];
}>;


export type UpdateResourceCategoryIsRequiredMutation = { updateOneResourceCategory?: { id: string } | null };

export type SectionImageListFragment = { id: string, filename?: string | null, url: string };

export type SectionImageSingleFragment = { id: string, created: any, modified: any, filename?: string | null, url: string };

export type SectionImageCategorySingleFragment = { id: string, sortOrder: number, sectionImage: { id: string, created: any, modified: any, filename?: string | null, url: string } };

export type SectionImageCategoryListFragment = { id: string, sortOrder: number, sectionImage: { id: string, filename?: string | null, url: string } };

export type SectionImageQueryVariables = Exact<{
  sectionImageId: Scalars['String']['input'];
}>;


export type SectionImageQuery = { sectionImage?: { id: string, created: any, modified: any, filename?: string | null, url: string } | null };

export type SectionImagesQueryVariables = Exact<{ [key: string]: never; }>;


export type SectionImagesQuery = { sectionImages: Array<{ id: string, filename?: string | null, url: string }> };

export type DeleteSectionImagesMutationVariables = Exact<{
  sectionImageIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteSectionImagesMutation = { deleteManySectionImage: { count: number } };

export type CreateSectionImageMutationVariables = Exact<{
  sectionImage: SectionImageCreateInput;
}>;


export type CreateSectionImageMutation = { createOneSectionImage: { id: string, created: any, modified: any, filename?: string | null, url: string } };

export type UpdateSectionImageMutationVariables = Exact<{
  sectionImageId: Scalars['String']['input'];
  sectionImage: SectionImageUpdateInput;
}>;


export type UpdateSectionImageMutation = { updateOneSectionImage?: { id: string, created: any, modified: any, filename?: string | null, url: string } | null };

export type AddSectionImageToCategoryMutationVariables = Exact<{
  sectionImageId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddSectionImageToCategoryMutation = { upsertOneSectionImageCategory: { id: string, sortOrder: number, sectionImage: { id: string, filename?: string | null, url: string } } };

export type RemoveSectionImageFromCategoryMutationVariables = Exact<{
  sectionImageId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
}>;


export type RemoveSectionImageFromCategoryMutation = { deleteOneSectionImageCategory?: { id: string } | null };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { tags: Array<{ id: string, name: string }> };

export type TemplateListFragment = { id: string, type: TemplateType, product?: { id: string, name: string } | null };

export type TemplateSingleFragment = { id: string, created: any, modified: any, type: TemplateType, content: string, emailSubject?: string | null, emailPreviewText?: string | null, product?: { id: string, name: string } | null };

export type TemplateQueryVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type TemplateQuery = { template?: { id: string, created: any, modified: any, type: TemplateType, content: string, emailSubject?: string | null, emailPreviewText?: string | null, product?: { id: string, name: string } | null } | null };

export type TemplateForTypeAndProductQueryVariables = Exact<{
  templateType: TemplateType;
  productId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TemplateForTypeAndProductQuery = { findFirstTemplate?: { id: string, created: any, modified: any, type: TemplateType, content: string, emailSubject?: string | null, emailPreviewText?: string | null, product?: { id: string, name: string } | null } | null };

export type TemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplatesQuery = { templates: Array<{ id: string, type: TemplateType, product?: { id: string, name: string } | null }> };

export type TemplatesForTypeQueryVariables = Exact<{
  templateType: TemplateType;
}>;


export type TemplatesForTypeQuery = { templates: Array<{ id: string, type: TemplateType, product?: { id: string, name: string } | null }> };

export type CreateTemplateMutationVariables = Exact<{
  template: TemplateCreateInput;
}>;


export type CreateTemplateMutation = { createOneTemplate: { id: string, created: any, modified: any, type: TemplateType, content: string, emailSubject?: string | null, emailPreviewText?: string | null, product?: { id: string, name: string } | null } };

export type UpdateTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
  template: TemplateUpdateInput;
}>;


export type UpdateTemplateMutation = { updateOneTemplate?: { id: string, created: any, modified: any, type: TemplateType, content: string, emailSubject?: string | null, emailPreviewText?: string | null, product?: { id: string, name: string } | null } | null };

export type DeleteTemplatesMutationVariables = Exact<{
  templateIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteTemplatesMutation = { deleteManyTemplate: { count: number } };

export type UpgradeSubscriptionTypeFragment = { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null };

export type UpgradePathDiscountListFragment = { id: string, name: string, description?: string | null, applyCreditForExistingPurchase: boolean, creditAllPriorPayments: boolean, discountPercentage?: number | null, discountAmountInCents?: number | null, daysAfterPurchaseMin?: number | null, daysAfterPurchaseMax?: number | null, isActive: boolean, upgradeDurationMode: UpgradeDurationMode, fromProductSubscriptionTypeId: string, fromProductSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null }, targetProducts: Array<{ id: string, productSubscriptionTypeId: string, productSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null } }>, _count?: { upgradePrompts: number } | null };

export type UpgradePathDiscountSingleFragment = { id: string, name: string, description?: string | null, applyCreditForExistingPurchase: boolean, creditAllPriorPayments: boolean, discountPercentage?: number | null, discountAmountInCents?: number | null, daysAfterPurchaseMin?: number | null, daysAfterPurchaseMax?: number | null, isActive: boolean, upgradeDurationMode: UpgradeDurationMode, fromProductSubscriptionTypeId: string, fromProductSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null }, targetProducts: Array<{ id: string, productSubscriptionTypeId: string, productSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null } }> };

export type UpgradePromptListFragment = { id: string, name: string, promptType: UpgradePromptType, frequency: PromptFrequency, showFromDayAfterPurchase: number, showUntilDayAfterPurchase?: number | null, isActive: boolean, priority: number, title?: string | null, message?: string | null, ctaText?: string | null, upgradePathDiscountId: string, upgradePathDiscount: { id: string, name: string }, _count?: { engagements: number } | null };

export type UpgradePromptSingleFragment = { id: string, name: string, promptType: UpgradePromptType, frequency: PromptFrequency, showFromDayAfterPurchase: number, showUntilDayAfterPurchase?: number | null, isActive: boolean, priority: number, title?: string | null, message?: string | null, ctaText?: string | null, upgradePathDiscountId: string };

export type UpgradePathDiscountsQueryVariables = Exact<{ [key: string]: never; }>;


export type UpgradePathDiscountsQuery = { upgradePathDiscounts: Array<{ id: string, name: string, description?: string | null, applyCreditForExistingPurchase: boolean, creditAllPriorPayments: boolean, discountPercentage?: number | null, discountAmountInCents?: number | null, daysAfterPurchaseMin?: number | null, daysAfterPurchaseMax?: number | null, isActive: boolean, upgradeDurationMode: UpgradeDurationMode, fromProductSubscriptionTypeId: string, fromProductSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null }, targetProducts: Array<{ id: string, productSubscriptionTypeId: string, productSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null } }>, _count?: { upgradePrompts: number } | null }> };

export type UpgradePathDiscountQueryVariables = Exact<{
  upgradePathDiscountId: Scalars['String']['input'];
}>;


export type UpgradePathDiscountQuery = { upgradePathDiscount?: { id: string, name: string, description?: string | null, applyCreditForExistingPurchase: boolean, creditAllPriorPayments: boolean, discountPercentage?: number | null, discountAmountInCents?: number | null, daysAfterPurchaseMin?: number | null, daysAfterPurchaseMax?: number | null, isActive: boolean, upgradeDurationMode: UpgradeDurationMode, fromProductSubscriptionTypeId: string, fromProductSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null }, targetProducts: Array<{ id: string, productSubscriptionTypeId: string, productSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null } }> } | null };

export type CreateUpgradePathDiscountMutationVariables = Exact<{
  upgradePathDiscount: UpgradePathDiscountCreateInput;
}>;


export type CreateUpgradePathDiscountMutation = { createOneUpgradePathDiscount: { id: string, name: string, description?: string | null, applyCreditForExistingPurchase: boolean, creditAllPriorPayments: boolean, discountPercentage?: number | null, discountAmountInCents?: number | null, daysAfterPurchaseMin?: number | null, daysAfterPurchaseMax?: number | null, isActive: boolean, upgradeDurationMode: UpgradeDurationMode, fromProductSubscriptionTypeId: string, fromProductSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null }, targetProducts: Array<{ id: string, productSubscriptionTypeId: string, productSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null } }> } };

export type UpdateUpgradePathDiscountMutationVariables = Exact<{
  upgradePathDiscountId: Scalars['String']['input'];
  upgradePathDiscount: UpgradePathDiscountUpdateInput;
}>;


export type UpdateUpgradePathDiscountMutation = { updateOneUpgradePathDiscount?: { id: string, name: string, description?: string | null, applyCreditForExistingPurchase: boolean, creditAllPriorPayments: boolean, discountPercentage?: number | null, discountAmountInCents?: number | null, daysAfterPurchaseMin?: number | null, daysAfterPurchaseMax?: number | null, isActive: boolean, upgradeDurationMode: UpgradeDurationMode, fromProductSubscriptionTypeId: string, fromProductSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null }, targetProducts: Array<{ id: string, productSubscriptionTypeId: string, productSubscriptionType: { id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null } }> } | null };

export type DeleteUpgradePathDiscountMutationVariables = Exact<{
  upgradePathDiscountId: Scalars['String']['input'];
}>;


export type DeleteUpgradePathDiscountMutation = { deleteOneUpgradePathDiscount?: { id: string } | null };

export type UpgradePromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type UpgradePromptsQuery = { upgradePrompts: Array<{ id: string, name: string, promptType: UpgradePromptType, frequency: PromptFrequency, showFromDayAfterPurchase: number, showUntilDayAfterPurchase?: number | null, isActive: boolean, priority: number, title?: string | null, message?: string | null, ctaText?: string | null, upgradePathDiscountId: string, upgradePathDiscount: { id: string, name: string }, _count?: { engagements: number } | null }> };

export type UpgradePromptQueryVariables = Exact<{
  upgradePromptId: Scalars['String']['input'];
}>;


export type UpgradePromptQuery = { upgradePrompt?: { id: string, name: string, promptType: UpgradePromptType, frequency: PromptFrequency, showFromDayAfterPurchase: number, showUntilDayAfterPurchase?: number | null, isActive: boolean, priority: number, title?: string | null, message?: string | null, ctaText?: string | null, upgradePathDiscountId: string } | null };

export type CreateUpgradePromptMutationVariables = Exact<{
  upgradePrompt: UpgradePromptCreateInput;
}>;


export type CreateUpgradePromptMutation = { createOneUpgradePrompt: { id: string, name: string, promptType: UpgradePromptType, frequency: PromptFrequency, showFromDayAfterPurchase: number, showUntilDayAfterPurchase?: number | null, isActive: boolean, priority: number, title?: string | null, message?: string | null, ctaText?: string | null, upgradePathDiscountId: string } };

export type UpdateUpgradePromptMutationVariables = Exact<{
  upgradePromptId: Scalars['String']['input'];
  upgradePrompt: UpgradePromptUpdateInput;
}>;


export type UpdateUpgradePromptMutation = { updateOneUpgradePrompt?: { id: string, name: string, promptType: UpgradePromptType, frequency: PromptFrequency, showFromDayAfterPurchase: number, showUntilDayAfterPurchase?: number | null, isActive: boolean, priority: number, title?: string | null, message?: string | null, ctaText?: string | null, upgradePathDiscountId: string } | null };

export type DeleteUpgradePromptMutationVariables = Exact<{
  upgradePromptId: Scalars['String']['input'];
}>;


export type DeleteUpgradePromptMutation = { deleteOneUpgradePrompt?: { id: string } | null };

export type UpgradeSubscriptionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type UpgradeSubscriptionTypesQuery = { productSubscriptionTypes: Array<{ id: string, name: string, productId?: string | null, isTrialSubscription: boolean, durationInDays?: number | null, product?: { id: string, name: string, shortName: string } | null }> };

export type UserSubscriptionListFragment = { id: string, validFrom: any, validTo?: any | null, isCancelled: boolean, userId: string, productSubscriptionTypeId: string, productSubscriptionType: { id: string, name: string, isPublished: boolean, durationInDays?: number | null, priceInCents: number, product?: { id: string, name: string, isPublished: boolean, productProgrammes: Array<{ id: string, programme: { id: string, name: string, isPublished: boolean } }> } | null } };

export type UserSubscriptionSingleFragment = { id: string, validFrom: any, validTo?: any | null, isCancelled: boolean, userId: string, productSubscriptionTypeId: string, productSubscriptionType: { id: string, name: string, isPublished: boolean, durationInDays?: number | null, priceInCents: number, product?: { id: string, name: string, isPublished: boolean, productProgrammes: Array<{ id: string, programme: { id: string, name: string, isPublished: boolean } }> } | null } };

export type UserSubscriptionsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserSubscriptionsQuery = { userSubscriptions: Array<{ id: string, validFrom: any, validTo?: any | null, isCancelled: boolean, userId: string, productSubscriptionTypeId: string, productSubscriptionType: { id: string, name: string, isPublished: boolean, durationInDays?: number | null, priceInCents: number, product?: { id: string, name: string, isPublished: boolean, productProgrammes: Array<{ id: string, programme: { id: string, name: string, isPublished: boolean } }> } | null } }> };

export type DeleteUserSubscriptionsMutationVariables = Exact<{
  userSubscriptionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteUserSubscriptionsMutation = { deleteManyUserSubscription: { count: number } };

export type CreateUserSubscriptionMutationVariables = Exact<{
  userSubscription: UserSubscriptionCreateInput;
}>;


export type CreateUserSubscriptionMutation = { createOneUserSubscription: { id: string, validFrom: any, validTo?: any | null, isCancelled: boolean, userId: string, productSubscriptionTypeId: string, productSubscriptionType: { id: string, name: string, isPublished: boolean, durationInDays?: number | null, priceInCents: number, product?: { id: string, name: string, isPublished: boolean, productProgrammes: Array<{ id: string, programme: { id: string, name: string, isPublished: boolean } }> } | null } } };

export type UpdateUserSubscriptionMutationVariables = Exact<{
  userSubscriptionId: Scalars['String']['input'];
  userSubscription: UserSubscriptionUpdateInput;
}>;


export type UpdateUserSubscriptionMutation = { updateOneUserSubscription?: { id: string, validFrom: any, validTo?: any | null, isCancelled: boolean, userId: string, productSubscriptionTypeId: string, productSubscriptionType: { id: string, name: string, isPublished: boolean, durationInDays?: number | null, priceInCents: number, product?: { id: string, name: string, isPublished: boolean, productProgrammes: Array<{ id: string, programme: { id: string, name: string, isPublished: boolean } }> } | null } } | null };

export const ArticleContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<ArticleContentFragment, unknown>;
export const ArticleTagFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ArticleTagFragment, unknown>;
export const ArticleSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ArticleSingleFragment, unknown>;
export const ArticleCategorySingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCategorySingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}}]}}]} as unknown as DocumentNode<ArticleCategorySingleFragment, unknown>;
export const ArticleUsageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleUsage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ArticleUsageFragment, unknown>;
export const CategorySingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategorySingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}}]} as unknown as DocumentNode<CategorySingleFragment, unknown>;
export const ContentListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<ContentListFragment, unknown>;
export const ContentSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}}]}}]} as unknown as DocumentNode<ContentSingleFragment, unknown>;
export const CouponProductRestrictionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponProductRestriction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CouponProductRestriction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]} as unknown as DocumentNode<CouponProductRestrictionFragment, unknown>;
export const CouponListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"maxUses"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedToProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponProductRestriction"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponProductRestriction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CouponProductRestriction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]} as unknown as DocumentNode<CouponListFragment, unknown>;
export const CouponSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"maxUses"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedToProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponProductRestriction"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponProductRestriction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CouponProductRestriction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]} as unknown as DocumentNode<CouponSingleFragment, unknown>;
export const EventOccurrenceListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventRegistrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EventOccurrenceListFragment, unknown>;
export const EventOccurrenceContentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceId"}}]}}]} as unknown as DocumentNode<EventOccurrenceContentFragmentFragment, unknown>;
export const EventOccurrenceSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventRegistrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventOccurrenceContentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceId"}}]}}]} as unknown as DocumentNode<EventOccurrenceSingleFragment, unknown>;
export const EventContentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}}]} as unknown as DocumentNode<EventContentFragmentFragment, unknown>;
export const EventSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"eventContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventContentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}}]} as unknown as DocumentNode<EventSingleFragment, unknown>;
export const EventCategorySingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventCategorySingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"minHours"}},{"kind":"Field","name":{"kind":"Name","value":"minContributions"}},{"kind":"Field","name":{"kind":"Name","value":"contributionName"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"eventContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventContentFragment"}}]}}]}}]} as unknown as DocumentNode<EventCategorySingleFragment, unknown>;
export const ProductEventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<ProductEventFragment, unknown>;
export const EventUsageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventUsage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<EventUsageFragment, unknown>;
export const EventRegistrationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userTimezone"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<EventRegistrationFragment, unknown>;
export const PaymentListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Payment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxInCents"}},{"kind":"Field","name":{"kind":"Name","value":"couponDiscountAppliedInCents"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"billingCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"isInvoiceSent"}},{"kind":"Field","name":{"kind":"Name","value":"xeroInvoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isLegacyXero"}},{"kind":"Field","name":{"kind":"Name","value":"stripePayoutId"}},{"kind":"Field","name":{"kind":"Name","value":"refunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentIntentId"}},{"kind":"Field","name":{"kind":"Name","value":"chargedInCents"}},{"kind":"Field","name":{"kind":"Name","value":"feesPaidInCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxPaidInCents"}},{"kind":"Field","name":{"kind":"Name","value":"netInCents"}}]}}]}}]} as unknown as DocumentNode<PaymentListFragment, unknown>;
export const PodcastListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Podcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isManaged"}},{"kind":"Field","name":{"kind":"Name","value":"captivateId"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}}]}}]} as unknown as DocumentNode<PodcastListFragment, unknown>;
export const PodcastSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Podcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isManaged"}},{"kind":"Field","name":{"kind":"Name","value":"captivateId"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}}]}}]} as unknown as DocumentNode<PodcastSingleFragment, unknown>;
export const PodcastUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PodcastUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"podcastId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"podcast"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}}]}}]}}]} as unknown as DocumentNode<PodcastUserFragment, unknown>;
export const ProductPodcastFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPodcast"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPodcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"podcastId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"podcast"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}}]}}]}}]} as unknown as DocumentNode<ProductPodcastFragment, unknown>;
export const ProductListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"healthProfessionalOnly"}},{"kind":"Field","name":{"kind":"Name","value":"brandingType"}}]}}]} as unknown as DocumentNode<ProductListFragment, unknown>;
export const ProductSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"healthProfessionalOnly"}},{"kind":"Field","name":{"kind":"Name","value":"brandingType"}}]}}]} as unknown as DocumentNode<ProductSingleFragment, unknown>;
export const ProgrammeTagFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProgrammeTagFragment, unknown>;
export const ProgrammeListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Programme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"programmeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeTag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProgrammeListFragment, unknown>;
export const ProductProgrammeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProgramme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductProgramme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"programmeId"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Programme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"programmeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeTag"}}]}}]}}]} as unknown as DocumentNode<ProductProgrammeFragment, unknown>;
export const ProductSubscriptionTypeListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSubscriptionTypeList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"automaticRenew"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"xeroAccountCode"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"trialPurchaseLimit"}},{"kind":"Field","name":{"kind":"Name","value":"upgradeType"}}]}}]} as unknown as DocumentNode<ProductSubscriptionTypeListFragment, unknown>;
export const ProductSubscriptionTypeSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSubscriptionTypeSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"automaticRenew"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"xeroAccountCode"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"trialPurchaseLimit"}},{"kind":"Field","name":{"kind":"Name","value":"upgradeType"}}]}}]} as unknown as DocumentNode<ProductSubscriptionTypeSingleFragment, unknown>;
export const ProductProgrammePrerequisiteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProgrammePrerequisite"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductProgrammePrerequisite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"programmeId"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductProgrammePrerequisiteFragment, unknown>;
export const ProgrammeSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Programme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"programmeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeTag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProgrammeSingleFragment, unknown>;
export const CategoryListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}}]} as unknown as DocumentNode<CategoryListFragment, unknown>;
export const ArticleListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ArticleListFragment, unknown>;
export const ArticleCategoryListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<ArticleCategoryListFragment, unknown>;
export const QuizListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<QuizListFragment, unknown>;
export const QuizCategoryListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"maxAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"minScore"}},{"kind":"Field","name":{"kind":"Name","value":"quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<QuizCategoryListFragment, unknown>;
export const ResourceListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}}]} as unknown as DocumentNode<ResourceListFragment, unknown>;
export const ResourceCategoryListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}}]} as unknown as DocumentNode<ResourceCategoryListFragment, unknown>;
export const EventListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}}]}}]} as unknown as DocumentNode<EventListFragment, unknown>;
export const EventCategoryListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"minHours"}},{"kind":"Field","name":{"kind":"Name","value":"minContributions"}},{"kind":"Field","name":{"kind":"Name","value":"contributionName"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}}]}}]} as unknown as DocumentNode<EventCategoryListFragment, unknown>;
export const SectionImageListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<SectionImageListFragment, unknown>;
export const SectionImageCategoryListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImageCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"sectionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<SectionImageCategoryListFragment, unknown>;
export const CategoryListWithContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryListWithContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryList"}},{"kind":"Field","name":{"kind":"Name","value":"categoryArticles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryQuizzes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageCategoryList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"maxAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"minScore"}},{"kind":"Field","name":{"kind":"Name","value":"quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"minHours"}},{"kind":"Field","name":{"kind":"Name","value":"minContributions"}},{"kind":"Field","name":{"kind":"Name","value":"contributionName"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImageCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"sectionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageList"}}]}}]}}]} as unknown as DocumentNode<CategoryListWithContentFragment, unknown>;
export const CategoryListWithContentAndPrerequisitesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryListWithContentAndPrerequisites"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryListWithContent"}},{"kind":"Field","name":{"kind":"Name","value":"prerequisites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"prerequisiteId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"maxAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"minScore"}},{"kind":"Field","name":{"kind":"Name","value":"quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"minHours"}},{"kind":"Field","name":{"kind":"Name","value":"minContributions"}},{"kind":"Field","name":{"kind":"Name","value":"contributionName"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImageCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"sectionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryListWithContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryList"}},{"kind":"Field","name":{"kind":"Name","value":"categoryArticles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryQuizzes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageCategoryList"}}]}}]}}]} as unknown as DocumentNode<CategoryListWithContentAndPrerequisitesFragment, unknown>;
export const QuizContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<QuizContentFragment, unknown>;
export const QuizSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<QuizSingleFragment, unknown>;
export const QuizCategorySingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizCategorySingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"maxAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"minScore"}},{"kind":"Field","name":{"kind":"Name","value":"quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<QuizCategorySingleFragment, unknown>;
export const QuizUsageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizUsage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<QuizUsageFragment, unknown>;
export const RefundListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RefundList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Refund"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"xeroCreditNoteNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isLegacyXero"}},{"kind":"Field","name":{"kind":"Name","value":"stripePayoutId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentId"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentIntentId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<RefundListFragment, unknown>;
export const ResourceTypeListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceTypeList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ResourceTypeListFragment, unknown>;
export const ResourceTypeSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceTypeSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ResourceTypeSingleFragment, unknown>;
export const ResourceSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}}]} as unknown as DocumentNode<ResourceSingleFragment, unknown>;
export const ResourceCategorySingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceCategorySingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}}]} as unknown as DocumentNode<ResourceCategorySingleFragment, unknown>;
export const ResourceUsageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceUsage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ResourceUsageFragment, unknown>;
export const SectionImageSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<SectionImageSingleFragment, unknown>;
export const SectionImageCategorySingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageCategorySingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImageCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"sectionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<SectionImageCategorySingleFragment, unknown>;
export const TemplateListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<TemplateListFragment, unknown>;
export const TemplateSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailPreviewText"}}]}}]} as unknown as DocumentNode<TemplateSingleFragment, unknown>;
export const UpgradeSubscriptionTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradeSubscriptionType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]} as unknown as DocumentNode<UpgradeSubscriptionTypeFragment, unknown>;
export const UpgradePathDiscountListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePathDiscountList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePathDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyCreditForExistingPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"creditAllPriorPayments"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMin"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMax"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"upgradeDurationMode"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradePrompts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradeSubscriptionType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]} as unknown as DocumentNode<UpgradePathDiscountListFragment, unknown>;
export const UpgradePathDiscountSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePathDiscountSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePathDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyCreditForExistingPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"creditAllPriorPayments"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMin"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMax"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"upgradeDurationMode"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradeSubscriptionType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]} as unknown as DocumentNode<UpgradePathDiscountSingleFragment, unknown>;
export const UpgradePromptListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePromptList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePrompt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"promptType"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"showFromDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"showUntilDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"upgradePathDiscountId"}},{"kind":"Field","name":{"kind":"Name","value":"upgradePathDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagements"}}]}}]}}]} as unknown as DocumentNode<UpgradePromptListFragment, unknown>;
export const UpgradePromptSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePromptSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePrompt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"promptType"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"showFromDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"showUntilDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"upgradePathDiscountId"}}]}}]} as unknown as DocumentNode<UpgradePromptSingleFragment, unknown>;
export const UserSubscriptionListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSubscriptionList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"isCancelled"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"productProgrammes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserSubscriptionListFragment, unknown>;
export const UserSubscriptionSingleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSubscriptionSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSubscriptionList"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSubscriptionList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"isCancelled"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"productProgrammes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserSubscriptionSingleFragment, unknown>;
export const ArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Article"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}}]}}]} as unknown as DocumentNode<ArticleQuery, ArticleQueryVariables>;
export const ArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<ArticlesQuery, ArticlesQueryVariables>;
export const SearchArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<SearchArticlesQuery, SearchArticlesQueryVariables>;
export const ArticlesByCategoryIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticlesByCategoryId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleList"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<ArticlesByCategoryIdQuery, ArticlesByCategoryIdQueryVariables>;
export const ArticleWithContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleWithContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleSingle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<ArticleWithContentQuery, ArticleWithContentQueryVariables>;
export const OrphanArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrphanArticles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"articleCategories"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"none"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startsWith"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<OrphanArticlesQuery, OrphanArticlesQueryVariables>;
export const ArticleUsagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleUsages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"articleId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleUsage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleUsage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ArticleUsagesQuery, ArticleUsagesQueryVariables>;
export const DeleteArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteArticlesMutation, DeleteArticlesMutationVariables>;
export const CreateArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"article"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"article"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}}]}}]} as unknown as DocumentNode<CreateArticleMutation, CreateArticleMutationVariables>;
export const UpdateArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"article"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"article"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}}]}}]} as unknown as DocumentNode<UpdateArticleMutation, UpdateArticleMutationVariables>;
export const AddArticleToCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddArticleToCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertOneArticleCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"articleCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"articleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"article"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"article"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCategoryList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleList"}}]}}]}}]} as unknown as DocumentNode<AddArticleToCategoryMutation, AddArticleToCategoryMutationVariables>;
export const RemoveArticleFromCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveArticleFromCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneArticleCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"articleCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"articleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveArticleFromCategoryMutation, RemoveArticleFromCategoryMutationVariables>;
export const UpdateArticleCategoryIsPinnedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateArticleCategoryIsPinned"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPinned"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneArticleCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleCategoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isPinned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPinned"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateArticleCategoryIsPinnedMutation, UpdateArticleCategoryIsPinnedMutationVariables>;
export const UpdateArticleCategoryIsRequiredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateArticleCategoryIsRequired"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isRequired"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneArticleCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleCategoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRequired"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateArticleCategoryIsRequiredMutation, UpdateArticleCategoryIsRequiredMutationVariables>;
export const CategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Category"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategorySingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategorySingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}}]} as unknown as DocumentNode<CategoryQuery, CategoryQueryVariables>;
export const CategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}}]} as unknown as DocumentNode<CategoriesQuery, CategoriesQueryVariables>;
export const ExistingCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExistingCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"programmeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ExistingCategoryQuery, ExistingCategoryQueryVariables>;
export const DeleteCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteCategoriesMutation, DeleteCategoriesMutationVariables>;
export const CreateCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategorySingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategorySingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}}]} as unknown as DocumentNode<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategorySingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategorySingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}}]} as unknown as DocumentNode<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const ContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Content"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}}]}}]} as unknown as DocumentNode<ContentQuery, ContentQueryVariables>;
export const ContentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<ContentsQuery, ContentsQueryVariables>;
export const DeleteContentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteContents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteContentsMutation, DeleteContentsMutationVariables>;
export const CreateContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}}]}}]} as unknown as DocumentNode<CreateContentMutation, CreateContentMutationVariables>;
export const UpdateContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}}]}}]} as unknown as DocumentNode<UpdateContentMutation, UpdateContentMutationVariables>;
export const CouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Coupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponProductRestriction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CouponProductRestriction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"maxUses"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedToProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponProductRestriction"}}]}}]}}]} as unknown as DocumentNode<CouponQuery, CouponQueryVariables>;
export const CouponByCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CouponByCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponProductRestriction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CouponProductRestriction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"maxUses"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedToProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponProductRestriction"}}]}}]}}]} as unknown as DocumentNode<CouponByCodeQuery, CouponByCodeQueryVariables>;
export const CouponsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Coupons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponProductRestriction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CouponProductRestriction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"maxUses"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedToProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponProductRestriction"}}]}}]}}]} as unknown as DocumentNode<CouponsQuery, CouponsQueryVariables>;
export const CouponsFilteredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CouponsFiltered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CouponWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponProductRestriction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CouponProductRestriction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"maxUses"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedToProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponProductRestriction"}}]}}]}}]} as unknown as DocumentNode<CouponsFilteredQuery, CouponsFilteredQueryVariables>;
export const CouponUseCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CouponUseCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupByPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"couponId"}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"couponId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"NullValue"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"stripePaymentIntents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<CouponUseCountsQuery, CouponUseCountsQueryVariables>;
export const CouponUsesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CouponUses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregatePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"couponId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"stripePaymentIntents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<CouponUsesQuery, CouponUsesQueryVariables>;
export const DeleteCouponsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCoupons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteCouponsMutation, DeleteCouponsMutationVariables>;
export const CreateCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coupon"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CouponCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coupon"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponProductRestriction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CouponProductRestriction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"maxUses"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedToProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponProductRestriction"}}]}}]}}]} as unknown as DocumentNode<CreateCouponMutation, CreateCouponMutationVariables>;
export const UpdateCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coupon"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CouponUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coupon"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponProductRestriction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CouponProductRestriction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CouponSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"maxUses"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedToProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CouponProductRestriction"}}]}}]}}]} as unknown as DocumentNode<UpdateCouponMutation, UpdateCouponMutationVariables>;
export const EventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Event"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"eventContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventContentFragment"}}]}}]}}]} as unknown as DocumentNode<EventQuery, EventQueryVariables>;
export const EventWithOccurrencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventWithOccurrences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventSingle"}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventOccurrenceSingle"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"eventContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventContentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventRegistrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventOccurrenceContentFragment"}}]}}]}}]} as unknown as DocumentNode<EventWithOccurrencesQuery, EventWithOccurrencesQueryVariables>;
export const EventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}}]}}]} as unknown as DocumentNode<EventsQuery, EventsQueryVariables>;
export const SearchEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}}]}}]} as unknown as DocumentNode<SearchEventsQuery, SearchEventsQueryVariables>;
export const OrphanEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrphanEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventCategories"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"none"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startsWith"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}}]}}]} as unknown as DocumentNode<OrphanEventsQuery, OrphanEventsQueryVariables>;
export const EventUsagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventUsages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventUsage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventUsage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<EventUsagesQuery, EventUsagesQueryVariables>;
export const EventOccurrenceRegistrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventOccurrenceRegistrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventOccurrenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventOccurrence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventOccurrenceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventOccurrenceSingle"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventSingle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventRegistrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventRegistration"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventRegistrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventOccurrenceContentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"eventContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventContentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventRegistration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventRegistration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userTimezone"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<EventOccurrenceRegistrationsQuery, EventOccurrenceRegistrationsQueryVariables>;
export const DeleteEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteEventsMutation, DeleteEventsMutationVariables>;
export const CreateEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"eventContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventContentFragment"}}]}}]}}]} as unknown as DocumentNode<CreateEventMutation, CreateEventMutationVariables>;
export const UpdateEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"eventContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventContentFragment"}}]}}]}}]} as unknown as DocumentNode<UpdateEventMutation, UpdateEventMutationVariables>;
export const DeleteEventOccurrencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEventOccurrences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventOccurrenceIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyEventOccurrence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventOccurrenceIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteEventOccurrencesMutation, DeleteEventOccurrencesMutationVariables>;
export const CreateEventOccurrenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEventOccurrence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventOccurrence"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneEventOccurrence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventOccurrence"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventOccurrenceSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventRegistrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventOccurrenceContentFragment"}}]}}]}}]} as unknown as DocumentNode<CreateEventOccurrenceMutation, CreateEventOccurrenceMutationVariables>;
export const UpdateEventOccurrenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventOccurrence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventOccurrenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventOccurrence"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEventOccurrence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventOccurrenceId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventOccurrence"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventOccurrenceSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventRegistrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventOccurrenceContentFragment"}}]}}]}}]} as unknown as DocumentNode<UpdateEventOccurrenceMutation, UpdateEventOccurrenceMutationVariables>;
export const AddEventToCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddEventToCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertOneEventCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventCategoryList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"minHours"}},{"kind":"Field","name":{"kind":"Name","value":"minContributions"}},{"kind":"Field","name":{"kind":"Name","value":"contributionName"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventList"}}]}}]}}]} as unknown as DocumentNode<AddEventToCategoryMutation, AddEventToCategoryMutationVariables>;
export const RemoveEventFromCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveEventFromCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneEventCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveEventFromCategoryMutation, RemoveEventFromCategoryMutationVariables>;
export const UpdateEventCategoryIsPinnedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventCategoryIsPinned"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPinned"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEventCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventCategoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isPinned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPinned"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateEventCategoryIsPinnedMutation, UpdateEventCategoryIsPinnedMutationVariables>;
export const UpdateEventCategoryIsRequiredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventCategoryIsRequired"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isRequired"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEventCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventCategoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRequired"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateEventCategoryIsRequiredMutation, UpdateEventCategoryIsRequiredMutationVariables>;
export const UpdateEventCategoryRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventCategoryRequirements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventCategory"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventCategoryUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEventCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventCategoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventCategory"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventCategoryList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"minHours"}},{"kind":"Field","name":{"kind":"Name","value":"minContributions"}},{"kind":"Field","name":{"kind":"Name","value":"contributionName"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventList"}}]}}]}}]} as unknown as DocumentNode<UpdateEventCategoryRequirementsMutation, UpdateEventCategoryRequirementsMutationVariables>;
export const GetProductEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductEvent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetProductEventsQuery, GetProductEventsQueryVariables>;
export const CreateProductEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProductEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productEvent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductEventCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneProductEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productEvent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductEvent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<CreateProductEventMutation, CreateProductEventMutationVariables>;
export const DeleteProductEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProductEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productEventIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyProductEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productEventIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteProductEventsMutation, DeleteProductEventsMutationVariables>;
export const CreateEventOccurrenceContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEventOccurrenceContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceContentCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneEventOccurrenceContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventOccurrenceContentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceId"}}]}}]} as unknown as DocumentNode<CreateEventOccurrenceContentMutation, CreateEventOccurrenceContentMutationVariables>;
export const UpdateEventOccurrenceContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventOccurrenceContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceContentUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEventOccurrenceContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventOccurrenceContentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventOccurrenceContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventOccurrenceContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventOccurrenceId"}}]}}]} as unknown as DocumentNode<UpdateEventOccurrenceContentMutation, UpdateEventOccurrenceContentMutationVariables>;
export const DeleteEventOccurrenceContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEventOccurrenceContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneEventOccurrenceContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteEventOccurrenceContentMutation, DeleteEventOccurrenceContentMutationVariables>;
export const CreateEventContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEventContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventContentCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneEventContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventContentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}}]} as unknown as DocumentNode<CreateEventContentMutation, CreateEventContentMutationVariables>;
export const UpdateEventContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventContentUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEventContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventContentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}}]} as unknown as DocumentNode<UpdateEventContentMutation, UpdateEventContentMutationVariables>;
export const DeleteEventContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEventContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneEventContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteEventContentMutation, DeleteEventContentMutationVariables>;
export const PaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stripePaymentIntents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"chargedInCents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Payment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxInCents"}},{"kind":"Field","name":{"kind":"Name","value":"couponDiscountAppliedInCents"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"billingCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"isInvoiceSent"}},{"kind":"Field","name":{"kind":"Name","value":"xeroInvoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isLegacyXero"}},{"kind":"Field","name":{"kind":"Name","value":"stripePayoutId"}},{"kind":"Field","name":{"kind":"Name","value":"refunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentIntentId"}},{"kind":"Field","name":{"kind":"Name","value":"chargedInCents"}},{"kind":"Field","name":{"kind":"Name","value":"feesPaidInCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxPaidInCents"}},{"kind":"Field","name":{"kind":"Name","value":"netInCents"}}]}}]}}]} as unknown as DocumentNode<PaymentsQuery, PaymentsQueryVariables>;
export const PaymentsPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentsPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stripePaymentIntents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"chargedInCents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Payment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxInCents"}},{"kind":"Field","name":{"kind":"Name","value":"couponDiscountAppliedInCents"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"billingCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"isInvoiceSent"}},{"kind":"Field","name":{"kind":"Name","value":"xeroInvoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isLegacyXero"}},{"kind":"Field","name":{"kind":"Name","value":"stripePayoutId"}},{"kind":"Field","name":{"kind":"Name","value":"refunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentIntentId"}},{"kind":"Field","name":{"kind":"Name","value":"chargedInCents"}},{"kind":"Field","name":{"kind":"Name","value":"feesPaidInCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxPaidInCents"}},{"kind":"Field","name":{"kind":"Name","value":"netInCents"}}]}}]}}]} as unknown as DocumentNode<PaymentsPaginatedQuery, PaymentsPaginatedQueryVariables>;
export const SearchPaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchPayments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"stripePaymentIntents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"chargedInCents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"xeroInvoiceNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentItems"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productSubscriptionType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shortName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}]}}]}}]}}]}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Payment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxInCents"}},{"kind":"Field","name":{"kind":"Name","value":"couponDiscountAppliedInCents"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountInCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"billingCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"isInvoiceSent"}},{"kind":"Field","name":{"kind":"Name","value":"xeroInvoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isLegacyXero"}},{"kind":"Field","name":{"kind":"Name","value":"stripePayoutId"}},{"kind":"Field","name":{"kind":"Name","value":"refunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentIntentId"}},{"kind":"Field","name":{"kind":"Name","value":"chargedInCents"}},{"kind":"Field","name":{"kind":"Name","value":"feesPaidInCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxPaidInCents"}},{"kind":"Field","name":{"kind":"Name","value":"netInCents"}}]}}]}}]} as unknown as DocumentNode<SearchPaymentsQuery, SearchPaymentsQueryVariables>;
export const PodcastDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Podcast"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"podcastId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"podcast"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"podcastId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PodcastSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Podcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isManaged"}},{"kind":"Field","name":{"kind":"Name","value":"captivateId"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}}]}}]} as unknown as DocumentNode<PodcastQuery, PodcastQueryVariables>;
export const PodcastsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Podcasts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"podcasts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PodcastList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Podcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isManaged"}},{"kind":"Field","name":{"kind":"Name","value":"captivateId"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}}]}}]} as unknown as DocumentNode<PodcastsQuery, PodcastsQueryVariables>;
export const PodcastUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PodcastUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"podcastId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"podcastUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"podcastId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"podcastId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PodcastUser"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PodcastUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"podcastId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"podcast"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}}]}}]}}]} as unknown as DocumentNode<PodcastUsersQuery, PodcastUsersQueryVariables>;
export const ProductPodcastsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductPodcasts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"podcastId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productPodcasts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"podcastId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"podcastId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPodcast"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPodcast"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPodcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"podcastId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"podcast"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}}]}}]}}]} as unknown as DocumentNode<ProductPodcastsQuery, ProductPodcastsQueryVariables>;
export const DeletePodcastsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePodcasts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"podcastIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyPodcast"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"podcastIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeletePodcastsMutation, DeletePodcastsMutationVariables>;
export const CreatePodcastDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePodcast"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"podcast"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PodcastCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOnePodcast"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"podcast"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PodcastSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Podcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isManaged"}},{"kind":"Field","name":{"kind":"Name","value":"captivateId"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}}]}}]} as unknown as DocumentNode<CreatePodcastMutation, CreatePodcastMutationVariables>;
export const DeleteProductPodcastsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProductPodcasts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productPodcastIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyProductPodcast"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productPodcastIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteProductPodcastsMutation, DeleteProductPodcastsMutationVariables>;
export const CreateProductPodcastDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProductPodcast"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productPodcast"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPodcastCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneProductPodcast"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productPodcast"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPodcast"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductPodcast"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPodcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"podcastId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"podcast"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}}]}}]}}]} as unknown as DocumentNode<CreateProductPodcastMutation, CreateProductPodcastMutationVariables>;
export const UpdatePodcastDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePodcast"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"podcastId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"podcast"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PodcastUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOnePodcast"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"podcastId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"podcast"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PodcastSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Podcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isManaged"}},{"kind":"Field","name":{"kind":"Name","value":"captivateId"}},{"kind":"Field","name":{"kind":"Name","value":"captivateFeedUrl"}}]}}]} as unknown as DocumentNode<UpdatePodcastMutation, UpdatePodcastMutationVariables>;
export const ProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Product"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"healthProfessionalOnly"}},{"kind":"Field","name":{"kind":"Name","value":"brandingType"}}]}}]} as unknown as DocumentNode<ProductQuery, ProductQueryVariables>;
export const ProductWithProgrammesAndSubscriptionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductWithProgrammesAndSubscriptionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSingle"}},{"kind":"Field","name":{"kind":"Name","value":"productProgrammes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProgramme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSubscriptionTypeList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prerequisites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProgrammePrerequisite"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Programme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"programmeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeTag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"healthProfessionalOnly"}},{"kind":"Field","name":{"kind":"Name","value":"brandingType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProgramme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductProgramme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"programmeId"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSubscriptionTypeList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"automaticRenew"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"xeroAccountCode"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"trialPurchaseLimit"}},{"kind":"Field","name":{"kind":"Name","value":"upgradeType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProgrammePrerequisite"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductProgrammePrerequisite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"programmeId"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductWithProgrammesAndSubscriptionTypesQuery, ProductWithProgrammesAndSubscriptionTypesQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"healthProfessionalOnly"}},{"kind":"Field","name":{"kind":"Name","value":"brandingType"}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const ProductsByBrandingTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsByBrandingType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandingType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandingType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandingType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"healthProfessionalOnly"}},{"kind":"Field","name":{"kind":"Name","value":"brandingType"}}]}}]} as unknown as DocumentNode<ProductsByBrandingTypeQuery, ProductsByBrandingTypeQueryVariables>;
export const SearchProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"healthProfessionalOnly"}},{"kind":"Field","name":{"kind":"Name","value":"brandingType"}}]}}]} as unknown as DocumentNode<SearchProductsQuery, SearchProductsQueryVariables>;
export const DeleteProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteProductsMutation, DeleteProductsMutationVariables>;
export const CreateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"healthProfessionalOnly"}},{"kind":"Field","name":{"kind":"Name","value":"brandingType"}}]}}]} as unknown as DocumentNode<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"healthProfessionalOnly"}},{"kind":"Field","name":{"kind":"Name","value":"brandingType"}}]}}]} as unknown as DocumentNode<UpdateProductMutation, UpdateProductMutationVariables>;
export const AddProductProgrammeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddProductProgramme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneProductProgramme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"programme"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductProgramme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Programme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"programmeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeTag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductProgramme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductProgramme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"programmeId"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeList"}}]}}]}}]} as unknown as DocumentNode<AddProductProgrammeMutation, AddProductProgrammeMutationVariables>;
export const DeleteProductProgrammeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProductProgramme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneProductProgramme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productProgramme"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"programmeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProductProgrammeMutation, DeleteProductProgrammeMutationVariables>;
export const DeleteProductPrerequisitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProductPrerequisites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prerequisiteIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyProductProgrammePrerequisite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prerequisiteIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteProductPrerequisitesMutation, DeleteProductPrerequisitesMutationVariables>;
export const DeleteProductSubscriptionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProductSubscriptionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productSubscriptionTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyProductSubscriptionType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productSubscriptionTypeIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteProductSubscriptionTypesMutation, DeleteProductSubscriptionTypesMutationVariables>;
export const CreateProductSubscriptionTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProductSubscriptionType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productSubscriptionType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionTypeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneProductSubscriptionType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productSubscriptionType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSubscriptionTypeSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSubscriptionTypeSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"automaticRenew"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"xeroAccountCode"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"trialPurchaseLimit"}},{"kind":"Field","name":{"kind":"Name","value":"upgradeType"}}]}}]} as unknown as DocumentNode<CreateProductSubscriptionTypeMutation, CreateProductSubscriptionTypeMutationVariables>;
export const UpdateProductSubscriptionTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProductSubscriptionType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productSubscriptionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productSubscriptionType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionTypeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneProductSubscriptionType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productSubscriptionTypeId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productSubscriptionType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSubscriptionTypeSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSubscriptionTypeSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"automaticRenew"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"xeroAccountCode"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"trialPurchaseLimit"}},{"kind":"Field","name":{"kind":"Name","value":"upgradeType"}}]}}]} as unknown as DocumentNode<UpdateProductSubscriptionTypeMutation, UpdateProductSubscriptionTypeMutationVariables>;
export const ProgrammeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Programme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Programme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"programmeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeTag"}}]}}]}}]} as unknown as DocumentNode<ProgrammeQuery, ProgrammeQueryVariables>;
export const ProgrammesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Programmes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Programme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"programmeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeTag"}}]}}]}}]} as unknown as DocumentNode<ProgrammesQuery, ProgrammesQueryVariables>;
export const SearchProgrammesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchProgrammes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shortName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Programme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"programmeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeTag"}}]}}]}}]} as unknown as DocumentNode<SearchProgrammesQuery, SearchProgrammesQueryVariables>;
export const DeleteProgrammesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProgrammes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programmeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyProgramme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programmeIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteProgrammesMutation, DeleteProgrammesMutationVariables>;
export const CreateProgrammeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProgramme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programme"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneProgramme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programme"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Programme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"programmeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeTag"}}]}}]}}]} as unknown as DocumentNode<CreateProgrammeMutation, CreateProgrammeMutationVariables>;
export const UpdateProgrammeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programme"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneProgramme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programme"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Programme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"programmeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeTag"}}]}}]}}]} as unknown as DocumentNode<UpdateProgrammeMutation, UpdateProgrammeMutationVariables>;
export const ProgrammesWithContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgrammesWithContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programmeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeSingle"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryListWithContentAndPrerequisites"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgrammeTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleTag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleTag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"maxAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"minScore"}},{"kind":"Field","name":{"kind":"Name","value":"quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"maxRegistrations"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"minHours"}},{"kind":"Field","name":{"kind":"Name","value":"minContributions"}},{"kind":"Field","name":{"kind":"Name","value":"contributionName"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImageCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"sectionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryListWithContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryList"}},{"kind":"Field","name":{"kind":"Name","value":"categoryArticles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryQuizzes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventCategoryList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageCategoryList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgrammeSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Programme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"programmeTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgrammeTag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryListWithContentAndPrerequisites"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryListWithContent"}},{"kind":"Field","name":{"kind":"Name","value":"prerequisites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"prerequisiteId"}}]}}]}}]} as unknown as DocumentNode<ProgrammesWithContentQuery, ProgrammesWithContentQueryVariables>;
export const QuizDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Quiz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quiz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<QuizQuery, QuizQueryVariables>;
export const QuizzesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Quizzes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quizzes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<QuizzesQuery, QuizzesQueryVariables>;
export const SearchQuizzesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchQuizzes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quizzes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<SearchQuizzesQuery, SearchQuizzesQueryVariables>;
export const QuizzesByCategoryIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuizzesByCategoryId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quizCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizList"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<QuizzesByCategoryIdQuery, QuizzesByCategoryIdQueryVariables>;
export const QuizWithContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuizWithContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quiz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizSingle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<QuizWithContentQuery, QuizWithContentQueryVariables>;
export const OrphanQuizzesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrphanQuizzes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quizzes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"quizCategories"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"none"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startsWith"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}}]} as unknown as DocumentNode<OrphanQuizzesQuery, OrphanQuizzesQueryVariables>;
export const QuizUsagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuizUsages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quizCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"quizId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizUsage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizUsage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<QuizUsagesQuery, QuizUsagesQueryVariables>;
export const DeleteQuizzesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteQuizzes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyQuiz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteQuizzesMutation, DeleteQuizzesMutationVariables>;
export const CreateQuizDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateQuiz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quiz"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneQuiz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quiz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<CreateQuizMutation, CreateQuizMutationVariables>;
export const UpdateQuizDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQuiz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quiz"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneQuiz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quiz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<UpdateQuizMutation, UpdateQuizMutationVariables>;
export const AddQuizToCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddQuizToCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertOneQuizCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"quizCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"quizId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"quiz"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"quiz"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizCategoryList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"maxAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"minScore"}},{"kind":"Field","name":{"kind":"Name","value":"quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizList"}}]}}]}}]} as unknown as DocumentNode<AddQuizToCategoryMutation, AddQuizToCategoryMutationVariables>;
export const RemoveQuizFromCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveQuizFromCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneQuizCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"quizCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"quizId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveQuizFromCategoryMutation, RemoveQuizFromCategoryMutationVariables>;
export const UpdateQuizCategoryIsPinnedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQuizCategoryIsPinned"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPinned"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneQuizCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizCategoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isPinned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPinned"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateQuizCategoryIsPinnedMutation, UpdateQuizCategoryIsPinnedMutationVariables>;
export const UpdateQuizCategoryIsRequiredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQuizCategoryIsRequired"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isRequired"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneQuizCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizCategoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRequired"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateQuizCategoryIsRequiredMutation, UpdateQuizCategoryIsRequiredMutationVariables>;
export const UpdateQuizCategoryRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQuizCategoryRequirements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizCategory"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCategoryUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneQuizCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizCategoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizCategory"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizCategoryList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quiz"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"markdownHash"}},{"kind":"Field","name":{"kind":"Name","value":"publishedMarkdownHash"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuizCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"maxAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"minScore"}},{"kind":"Field","name":{"kind":"Name","value":"quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuizList"}}]}}]}}]} as unknown as DocumentNode<UpdateQuizCategoryRequirementsMutation, UpdateQuizCategoryRequirementsMutationVariables>;
export const RefundsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Refunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refunds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RefundList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RefundList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Refund"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"xeroCreditNoteNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isLegacyXero"}},{"kind":"Field","name":{"kind":"Name","value":"stripePayoutId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentId"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentIntentId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<RefundsQuery, RefundsQueryVariables>;
export const RefundsPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefundsPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refunds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RefundList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateRefund"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RefundList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Refund"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"xeroCreditNoteNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isLegacyXero"}},{"kind":"Field","name":{"kind":"Name","value":"stripePayoutId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentId"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentIntentId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<RefundsPaginatedQuery, RefundsPaginatedQueryVariables>;
export const SearchRefundsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchRefunds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refunds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"xeroCreditNoteNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentItems"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productSubscriptionType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shortName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RefundList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RefundList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Refund"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"xeroCreditNoteNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isLegacyXero"}},{"kind":"Field","name":{"kind":"Name","value":"stripePayoutId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentId"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"SUCCEEDED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentIntentId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<SearchRefundsQuery, SearchRefundsQueryVariables>;
export const ResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Resource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}}]} as unknown as DocumentNode<ResourceQuery, ResourceQueryVariables>;
export const ResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}}]} as unknown as DocumentNode<ResourcesQuery, ResourcesQueryVariables>;
export const ResourceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ResourceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceTypeList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceTypeList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ResourceTypesQuery, ResourceTypesQueryVariables>;
export const SearchResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}}]} as unknown as DocumentNode<SearchResourcesQuery, SearchResourcesQueryVariables>;
export const ResourcesByCategoryIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ResourcesByCategoryId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceList"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}}]} as unknown as DocumentNode<ResourcesByCategoryIdQuery, ResourcesByCategoryIdQueryVariables>;
export const OrphanResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrphanResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resourceCategories"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"none"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startsWith"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}}]} as unknown as DocumentNode<OrphanResourcesQuery, OrphanResourcesQueryVariables>;
export const ResourceUsagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ResourceUsages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resourceId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceUsage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceUsage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ResourceUsagesQuery, ResourceUsagesQueryVariables>;
export const DeleteResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteResourcesMutation, DeleteResourcesMutationVariables>;
export const DeleteResourceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteResourceTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyResourceType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceTypeIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteResourceTypesMutation, DeleteResourceTypesMutationVariables>;
export const CreateResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}}]} as unknown as DocumentNode<CreateResourceMutation, CreateResourceMutationVariables>;
export const CreateResourceTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateResourceType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceTypeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneResourceType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceTypeSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceTypeSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<CreateResourceTypeMutation, CreateResourceTypeMutationVariables>;
export const UpdateResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}}]} as unknown as DocumentNode<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const UpdateResourceTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateResourceType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceTypeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneResourceType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceTypeId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceTypeSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceTypeSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<UpdateResourceTypeMutation, UpdateResourceTypeMutationVariables>;
export const AddResourceToCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddResourceToCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertOneResourceCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resourceCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resource"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resource"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCategoryList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"frontmatter"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrontmatter"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceList"}}]}}]}}]} as unknown as DocumentNode<AddResourceToCategoryMutation, AddResourceToCategoryMutationVariables>;
export const RemoveResourceFromCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveResourceFromCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneResourceCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resourceCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveResourceFromCategoryMutation, RemoveResourceFromCategoryMutationVariables>;
export const UpdateResourceCategoryIsPinnedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateResourceCategoryIsPinned"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPinned"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneResourceCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceCategoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isPinned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPinned"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateResourceCategoryIsPinnedMutation, UpdateResourceCategoryIsPinnedMutationVariables>;
export const UpdateResourceCategoryIsRequiredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateResourceCategoryIsRequired"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isRequired"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneResourceCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceCategoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRequired"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateResourceCategoryIsRequiredMutation, UpdateResourceCategoryIsRequiredMutationVariables>;
export const SectionImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SectionImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<SectionImageQuery, SectionImageQueryVariables>;
export const SectionImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SectionImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<SectionImagesQuery, SectionImagesQueryVariables>;
export const DeleteSectionImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSectionImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManySectionImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteSectionImagesMutation, DeleteSectionImagesMutationVariables>;
export const CreateSectionImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSectionImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sectionImage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImageCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneSectionImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionImage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<CreateSectionImageMutation, CreateSectionImageMutationVariables>;
export const UpdateSectionImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSectionImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sectionImage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImageUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneSectionImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionImage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<UpdateSectionImageMutation, UpdateSectionImageMutationVariables>;
export const AddSectionImageToCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddSectionImageToCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertOneSectionImageCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sectionImageCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sectionImageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sectionImage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sectionImage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageCategoryList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SectionImageCategoryList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SectionImageCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"sectionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionImageList"}}]}}]}}]} as unknown as DocumentNode<AddSectionImageToCategoryMutation, AddSectionImageToCategoryMutationVariables>;
export const RemoveSectionImageFromCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveSectionImageFromCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneSectionImageCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sectionImageCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sectionImageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sectionImageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveSectionImageFromCategoryMutation, RemoveSectionImageFromCategoryMutationVariables>;
export const TagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<TagsQuery, TagsQueryVariables>;
export const TemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Template"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TemplateSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailPreviewText"}}]}}]} as unknown as DocumentNode<TemplateQuery, TemplateQueryVariables>;
export const TemplateForTypeAndProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplateForTypeAndProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findFirstTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateType"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TemplateSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailPreviewText"}}]}}]} as unknown as DocumentNode<TemplateForTypeAndProductQuery, TemplateForTypeAndProductQueryVariables>;
export const TemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TemplateList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<TemplatesQuery, TemplatesQueryVariables>;
export const TemplatesForTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplatesForType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TemplateList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<TemplatesForTypeQuery, TemplatesForTypeQueryVariables>;
export const CreateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TemplateSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailPreviewText"}}]}}]} as unknown as DocumentNode<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const UpdateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TemplateSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailPreviewText"}}]}}]} as unknown as DocumentNode<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const DeleteTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteTemplatesMutation, DeleteTemplatesMutationVariables>;
export const UpgradePathDiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpgradePathDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradePathDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradePathDiscountList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradeSubscriptionType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePathDiscountList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePathDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyCreditForExistingPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"creditAllPriorPayments"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMin"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMax"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"upgradeDurationMode"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradePrompts"}}]}}]}}]} as unknown as DocumentNode<UpgradePathDiscountsQuery, UpgradePathDiscountsQueryVariables>;
export const UpgradePathDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpgradePathDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upgradePathDiscountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradePathDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upgradePathDiscountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradePathDiscountSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradeSubscriptionType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePathDiscountSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePathDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyCreditForExistingPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"creditAllPriorPayments"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMin"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMax"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"upgradeDurationMode"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}}]}}]}}]} as unknown as DocumentNode<UpgradePathDiscountQuery, UpgradePathDiscountQueryVariables>;
export const CreateUpgradePathDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUpgradePathDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upgradePathDiscount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePathDiscountCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneUpgradePathDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upgradePathDiscount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradePathDiscountSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradeSubscriptionType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePathDiscountSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePathDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyCreditForExistingPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"creditAllPriorPayments"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMin"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMax"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"upgradeDurationMode"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUpgradePathDiscountMutation, CreateUpgradePathDiscountMutationVariables>;
export const UpdateUpgradePathDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUpgradePathDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upgradePathDiscountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upgradePathDiscount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePathDiscountUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneUpgradePathDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upgradePathDiscountId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upgradePathDiscount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradePathDiscountSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradeSubscriptionType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePathDiscountSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePathDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyCreditForExistingPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"creditAllPriorPayments"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMin"}},{"kind":"Field","name":{"kind":"Name","value":"daysAfterPurchaseMax"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"upgradeDurationMode"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"fromProductSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUpgradePathDiscountMutation, UpdateUpgradePathDiscountMutationVariables>;
export const DeleteUpgradePathDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUpgradePathDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upgradePathDiscountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneUpgradePathDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upgradePathDiscountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteUpgradePathDiscountMutation, DeleteUpgradePathDiscountMutationVariables>;
export const UpgradePromptsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpgradePrompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradePrompts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradePromptList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePromptList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePrompt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"promptType"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"showFromDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"showUntilDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"upgradePathDiscountId"}},{"kind":"Field","name":{"kind":"Name","value":"upgradePathDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagements"}}]}}]}}]} as unknown as DocumentNode<UpgradePromptsQuery, UpgradePromptsQueryVariables>;
export const UpgradePromptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpgradePrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upgradePromptId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradePrompt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upgradePromptId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradePromptSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePromptSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePrompt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"promptType"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"showFromDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"showUntilDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"upgradePathDiscountId"}}]}}]} as unknown as DocumentNode<UpgradePromptQuery, UpgradePromptQueryVariables>;
export const CreateUpgradePromptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUpgradePrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upgradePrompt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePromptCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneUpgradePrompt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upgradePrompt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradePromptSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePromptSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePrompt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"promptType"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"showFromDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"showUntilDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"upgradePathDiscountId"}}]}}]} as unknown as DocumentNode<CreateUpgradePromptMutation, CreateUpgradePromptMutationVariables>;
export const UpdateUpgradePromptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUpgradePrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upgradePromptId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upgradePrompt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePromptUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneUpgradePrompt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upgradePromptId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upgradePrompt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradePromptSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradePromptSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePrompt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"promptType"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"showFromDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"showUntilDayAfterPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"upgradePathDiscountId"}}]}}]} as unknown as DocumentNode<UpdateUpgradePromptMutation, UpdateUpgradePromptMutationVariables>;
export const DeleteUpgradePromptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUpgradePrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upgradePromptId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneUpgradePrompt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upgradePromptId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteUpgradePromptMutation, DeleteUpgradePromptMutationVariables>;
export const UpgradeSubscriptionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpgradeSubscriptionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpgradeSubscriptionType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpgradeSubscriptionType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"isTrialSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]} as unknown as DocumentNode<UpgradeSubscriptionTypesQuery, UpgradeSubscriptionTypesQueryVariables>;
export const UserSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validFrom"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSubscriptionList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSubscriptionList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"isCancelled"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"productProgrammes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>;
export const DeleteUserSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSubscriptionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyUserSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSubscriptionIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteUserSubscriptionsMutation, DeleteUserSubscriptionsMutationVariables>;
export const CreateUserSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSubscription"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSubscriptionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneUserSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSubscription"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSubscriptionSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSubscriptionList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"isCancelled"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"productProgrammes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSubscriptionSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSubscriptionList"}}]}}]} as unknown as DocumentNode<CreateUserSubscriptionMutation, CreateUserSubscriptionMutationVariables>;
export const UpdateUserSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSubscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSubscription"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSubscriptionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneUserSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSubscriptionId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSubscription"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSubscriptionSingle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSubscriptionList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"isCancelled"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"productSubscriptionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"durationInDays"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"productProgrammes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSubscriptionSingle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSubscriptionList"}}]}}]} as unknown as DocumentNode<UpdateUserSubscriptionMutation, UpdateUserSubscriptionMutationVariables>;